
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb02c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb02c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4I5pX", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $36df7955fd32ef3f$export$ffb0004e005737fa; }, function (v) { return $36df7955fd32ef3f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $36df7955fd32ef3f$export$34b9dba7ce09269b; }, function (v) { return $36df7955fd32ef3f$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $36df7955fd32ef3f$export$25062201e9e25d76; }, function (v) { return $36df7955fd32ef3f$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $36df7955fd32ef3f$export$ffb0004e005737fa;
var $36df7955fd32ef3f$export$34b9dba7ce09269b;
var $36df7955fd32ef3f$export$25062201e9e25d76;
'use strict';
parcelRequire("17cHO");

var $9Cg25 = parcelRequire("9Cg25");
var $36df7955fd32ef3f$var$g = 60103;
$36df7955fd32ef3f$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $36df7955fd32ef3f$var$h = Symbol.for;
    $36df7955fd32ef3f$var$g = $36df7955fd32ef3f$var$h("react.element");
    $36df7955fd32ef3f$export$ffb0004e005737fa = $36df7955fd32ef3f$var$h("react.fragment");
}
var $36df7955fd32ef3f$var$m = $9Cg25.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $36df7955fd32ef3f$var$n = Object.prototype.hasOwnProperty, $36df7955fd32ef3f$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $36df7955fd32ef3f$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$36df7955fd32ef3f$var$n.call(a, b) && !$36df7955fd32ef3f$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $36df7955fd32ef3f$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $36df7955fd32ef3f$var$m.current
    };
}
$36df7955fd32ef3f$export$34b9dba7ce09269b = $36df7955fd32ef3f$var$q;
$36df7955fd32ef3f$export$25062201e9e25d76 = $36df7955fd32ef3f$var$q;

});
parcelRegister("17cHO", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $0d004cfbfd2ba57a$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $0d004cfbfd2ba57a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $0d004cfbfd2ba57a$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $0d004cfbfd2ba57a$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $0d004cfbfd2ba57a$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $0d004cfbfd2ba57a$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $0d004cfbfd2ba57a$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($0d004cfbfd2ba57a$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($0d004cfbfd2ba57a$var$getOwnPropertySymbols) {
            symbols = $0d004cfbfd2ba57a$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($0d004cfbfd2ba57a$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("9Cg25", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9i6OR"));

});
parcelRegister("9i6OR", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $6c3b15b2e6a8a3cc$export$ffb0004e005737fa; }, function (v) { return $6c3b15b2e6a8a3cc$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $6c3b15b2e6a8a3cc$export$5f8d39834fd61797; }, function (v) { return $6c3b15b2e6a8a3cc$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $6c3b15b2e6a8a3cc$export$e2c29f18771995cb; }, function (v) { return $6c3b15b2e6a8a3cc$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $6c3b15b2e6a8a3cc$export$74bf444e3cd11ea5; }, function (v) { return $6c3b15b2e6a8a3cc$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $6c3b15b2e6a8a3cc$export$dca3b0875bd9a954; }, function (v) { return $6c3b15b2e6a8a3cc$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $6c3b15b2e6a8a3cc$export$16fa2f45be04daa8; }, function (v) { return $6c3b15b2e6a8a3cc$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $6c3b15b2e6a8a3cc$export$221d75b3f55bb0bd; }, function (v) { return $6c3b15b2e6a8a3cc$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $6c3b15b2e6a8a3cc$export$ae55be85d98224ed; }, function (v) { return $6c3b15b2e6a8a3cc$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $6c3b15b2e6a8a3cc$export$e530037191fcd5d7; }, function (v) { return $6c3b15b2e6a8a3cc$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $6c3b15b2e6a8a3cc$export$fd42f52fd3ae1109; }, function (v) { return $6c3b15b2e6a8a3cc$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $6c3b15b2e6a8a3cc$export$c8a8987d4410bf2d; }, function (v) { return $6c3b15b2e6a8a3cc$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $6c3b15b2e6a8a3cc$export$d38cd72104c1f0e9; }, function (v) { return $6c3b15b2e6a8a3cc$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $6c3b15b2e6a8a3cc$export$7d1e3a5e95ceca43; }, function (v) { return $6c3b15b2e6a8a3cc$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $6c3b15b2e6a8a3cc$export$257a8862b851cb5b; }, function (v) { return $6c3b15b2e6a8a3cc$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $6c3b15b2e6a8a3cc$export$a8257692ac88316c; }, function (v) { return $6c3b15b2e6a8a3cc$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $6c3b15b2e6a8a3cc$export$488013bae63b21da; }, function (v) { return $6c3b15b2e6a8a3cc$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $6c3b15b2e6a8a3cc$export$7c73462e0d25e514; }, function (v) { return $6c3b15b2e6a8a3cc$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $6c3b15b2e6a8a3cc$export$35808ee640e87ca7; }, function (v) { return $6c3b15b2e6a8a3cc$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $6c3b15b2e6a8a3cc$export$fae74005e78b1a27; }, function (v) { return $6c3b15b2e6a8a3cc$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $6c3b15b2e6a8a3cc$export$dc8fbce3eb94dc1e; }, function (v) { return $6c3b15b2e6a8a3cc$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $6c3b15b2e6a8a3cc$export$6d9c69b0de29b591; }, function (v) { return $6c3b15b2e6a8a3cc$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $6c3b15b2e6a8a3cc$export$d5a552a76deda3c2; }, function (v) { return $6c3b15b2e6a8a3cc$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $6c3b15b2e6a8a3cc$export$e5c5a5f917a5871c; }, function (v) { return $6c3b15b2e6a8a3cc$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $6c3b15b2e6a8a3cc$export$1538c33de8887b59; }, function (v) { return $6c3b15b2e6a8a3cc$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $6c3b15b2e6a8a3cc$export$13e3392192263954; }, function (v) { return $6c3b15b2e6a8a3cc$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $6c3b15b2e6a8a3cc$export$b8f5890fc79d6aca; }, function (v) { return $6c3b15b2e6a8a3cc$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $6c3b15b2e6a8a3cc$export$60241385465d0a34; }, function (v) { return $6c3b15b2e6a8a3cc$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $6c3b15b2e6a8a3cc$export$83d89fbfd8236492; }, function (v) { return $6c3b15b2e6a8a3cc$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6c3b15b2e6a8a3cc$export$ffb0004e005737fa;
var $6c3b15b2e6a8a3cc$export$5f8d39834fd61797;
var $6c3b15b2e6a8a3cc$export$e2c29f18771995cb;
var $6c3b15b2e6a8a3cc$export$74bf444e3cd11ea5;
var $6c3b15b2e6a8a3cc$export$dca3b0875bd9a954;
var $6c3b15b2e6a8a3cc$export$16fa2f45be04daa8;
var $6c3b15b2e6a8a3cc$export$221d75b3f55bb0bd;
var $6c3b15b2e6a8a3cc$export$ae55be85d98224ed;
var $6c3b15b2e6a8a3cc$export$e530037191fcd5d7;
var $6c3b15b2e6a8a3cc$export$fd42f52fd3ae1109;
var $6c3b15b2e6a8a3cc$export$c8a8987d4410bf2d;
var $6c3b15b2e6a8a3cc$export$d38cd72104c1f0e9;
var $6c3b15b2e6a8a3cc$export$7d1e3a5e95ceca43;
var $6c3b15b2e6a8a3cc$export$257a8862b851cb5b;
var $6c3b15b2e6a8a3cc$export$a8257692ac88316c;
var $6c3b15b2e6a8a3cc$export$488013bae63b21da;
var $6c3b15b2e6a8a3cc$export$7c73462e0d25e514;
var $6c3b15b2e6a8a3cc$export$35808ee640e87ca7;
var $6c3b15b2e6a8a3cc$export$fae74005e78b1a27;
var $6c3b15b2e6a8a3cc$export$dc8fbce3eb94dc1e;
var $6c3b15b2e6a8a3cc$export$6d9c69b0de29b591;
var $6c3b15b2e6a8a3cc$export$d5a552a76deda3c2;
var $6c3b15b2e6a8a3cc$export$e5c5a5f917a5871c;
var $6c3b15b2e6a8a3cc$export$1538c33de8887b59;
var $6c3b15b2e6a8a3cc$export$13e3392192263954;
var $6c3b15b2e6a8a3cc$export$b8f5890fc79d6aca;
var $6c3b15b2e6a8a3cc$export$60241385465d0a34;
var $6c3b15b2e6a8a3cc$export$83d89fbfd8236492;
'use strict';

var $17cHO = parcelRequire("17cHO");
var $6c3b15b2e6a8a3cc$var$n = 60103, $6c3b15b2e6a8a3cc$var$p = 60106;
$6c3b15b2e6a8a3cc$export$ffb0004e005737fa = 60107;
$6c3b15b2e6a8a3cc$export$5f8d39834fd61797 = 60108;
$6c3b15b2e6a8a3cc$export$e2c29f18771995cb = 60114;
var $6c3b15b2e6a8a3cc$var$q = 60109, $6c3b15b2e6a8a3cc$var$r = 60110, $6c3b15b2e6a8a3cc$var$t = 60112;
$6c3b15b2e6a8a3cc$export$74bf444e3cd11ea5 = 60113;
var $6c3b15b2e6a8a3cc$var$u = 60115, $6c3b15b2e6a8a3cc$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $6c3b15b2e6a8a3cc$var$w = Symbol.for;
    $6c3b15b2e6a8a3cc$var$n = $6c3b15b2e6a8a3cc$var$w("react.element");
    $6c3b15b2e6a8a3cc$var$p = $6c3b15b2e6a8a3cc$var$w("react.portal");
    $6c3b15b2e6a8a3cc$export$ffb0004e005737fa = $6c3b15b2e6a8a3cc$var$w("react.fragment");
    $6c3b15b2e6a8a3cc$export$5f8d39834fd61797 = $6c3b15b2e6a8a3cc$var$w("react.strict_mode");
    $6c3b15b2e6a8a3cc$export$e2c29f18771995cb = $6c3b15b2e6a8a3cc$var$w("react.profiler");
    $6c3b15b2e6a8a3cc$var$q = $6c3b15b2e6a8a3cc$var$w("react.provider");
    $6c3b15b2e6a8a3cc$var$r = $6c3b15b2e6a8a3cc$var$w("react.context");
    $6c3b15b2e6a8a3cc$var$t = $6c3b15b2e6a8a3cc$var$w("react.forward_ref");
    $6c3b15b2e6a8a3cc$export$74bf444e3cd11ea5 = $6c3b15b2e6a8a3cc$var$w("react.suspense");
    $6c3b15b2e6a8a3cc$var$u = $6c3b15b2e6a8a3cc$var$w("react.memo");
    $6c3b15b2e6a8a3cc$var$v = $6c3b15b2e6a8a3cc$var$w("react.lazy");
}
var $6c3b15b2e6a8a3cc$var$x = "function" === typeof Symbol && Symbol.iterator;
function $6c3b15b2e6a8a3cc$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $6c3b15b2e6a8a3cc$var$x && a[$6c3b15b2e6a8a3cc$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $6c3b15b2e6a8a3cc$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $6c3b15b2e6a8a3cc$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $6c3b15b2e6a8a3cc$var$B = {};
function $6c3b15b2e6a8a3cc$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $6c3b15b2e6a8a3cc$var$B;
    this.updater = c || $6c3b15b2e6a8a3cc$var$A;
}
$6c3b15b2e6a8a3cc$var$C.prototype.isReactComponent = {};
$6c3b15b2e6a8a3cc$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($6c3b15b2e6a8a3cc$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$6c3b15b2e6a8a3cc$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $6c3b15b2e6a8a3cc$var$D() {}
$6c3b15b2e6a8a3cc$var$D.prototype = $6c3b15b2e6a8a3cc$var$C.prototype;
function $6c3b15b2e6a8a3cc$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $6c3b15b2e6a8a3cc$var$B;
    this.updater = c || $6c3b15b2e6a8a3cc$var$A;
}
var $6c3b15b2e6a8a3cc$var$F = $6c3b15b2e6a8a3cc$var$E.prototype = new $6c3b15b2e6a8a3cc$var$D;
$6c3b15b2e6a8a3cc$var$F.constructor = $6c3b15b2e6a8a3cc$var$E;
$17cHO($6c3b15b2e6a8a3cc$var$F, $6c3b15b2e6a8a3cc$var$C.prototype);
$6c3b15b2e6a8a3cc$var$F.isPureReactComponent = !0;
var $6c3b15b2e6a8a3cc$var$G = {
    current: null
}, $6c3b15b2e6a8a3cc$var$H = Object.prototype.hasOwnProperty, $6c3b15b2e6a8a3cc$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $6c3b15b2e6a8a3cc$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$6c3b15b2e6a8a3cc$var$H.call(b, e) && !$6c3b15b2e6a8a3cc$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $6c3b15b2e6a8a3cc$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $6c3b15b2e6a8a3cc$var$G.current
    };
}
function $6c3b15b2e6a8a3cc$var$K(a, b) {
    return {
        $$typeof: $6c3b15b2e6a8a3cc$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $6c3b15b2e6a8a3cc$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6c3b15b2e6a8a3cc$var$n;
}
function $6c3b15b2e6a8a3cc$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $6c3b15b2e6a8a3cc$var$M = /\/+/g;
function $6c3b15b2e6a8a3cc$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $6c3b15b2e6a8a3cc$var$escape("" + a.key) : b.toString(36);
}
function $6c3b15b2e6a8a3cc$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $6c3b15b2e6a8a3cc$var$n:
                case $6c3b15b2e6a8a3cc$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $6c3b15b2e6a8a3cc$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($6c3b15b2e6a8a3cc$var$M, "$&/") + "/"), $6c3b15b2e6a8a3cc$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($6c3b15b2e6a8a3cc$var$L(d) && (d = $6c3b15b2e6a8a3cc$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($6c3b15b2e6a8a3cc$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $6c3b15b2e6a8a3cc$var$N(k, g);
        h += $6c3b15b2e6a8a3cc$var$O(k, b, c, f, d);
    }
    else if (f = $6c3b15b2e6a8a3cc$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $6c3b15b2e6a8a3cc$var$N(k, g++), h += $6c3b15b2e6a8a3cc$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($6c3b15b2e6a8a3cc$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $6c3b15b2e6a8a3cc$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $6c3b15b2e6a8a3cc$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $6c3b15b2e6a8a3cc$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $6c3b15b2e6a8a3cc$var$R = {
    current: null
};
function $6c3b15b2e6a8a3cc$var$S() {
    var a = $6c3b15b2e6a8a3cc$var$R.current;
    if (null === a) throw Error($6c3b15b2e6a8a3cc$var$z(321));
    return a;
}
var $6c3b15b2e6a8a3cc$var$T = {
    ReactCurrentDispatcher: $6c3b15b2e6a8a3cc$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $6c3b15b2e6a8a3cc$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $17cHO
};
$6c3b15b2e6a8a3cc$export$dca3b0875bd9a954 = {
    map: $6c3b15b2e6a8a3cc$var$P,
    forEach: function(a, b, c) {
        $6c3b15b2e6a8a3cc$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $6c3b15b2e6a8a3cc$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $6c3b15b2e6a8a3cc$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$6c3b15b2e6a8a3cc$var$L(a)) throw Error($6c3b15b2e6a8a3cc$var$z(143));
        return a;
    }
};
$6c3b15b2e6a8a3cc$export$16fa2f45be04daa8 = $6c3b15b2e6a8a3cc$var$C;
$6c3b15b2e6a8a3cc$export$221d75b3f55bb0bd = $6c3b15b2e6a8a3cc$var$E;
$6c3b15b2e6a8a3cc$export$ae55be85d98224ed = $6c3b15b2e6a8a3cc$var$T;
$6c3b15b2e6a8a3cc$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($6c3b15b2e6a8a3cc$var$z(267, a));
    var e = $17cHO({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $6c3b15b2e6a8a3cc$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$6c3b15b2e6a8a3cc$var$H.call(b, f) && !$6c3b15b2e6a8a3cc$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $6c3b15b2e6a8a3cc$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$6c3b15b2e6a8a3cc$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $6c3b15b2e6a8a3cc$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $6c3b15b2e6a8a3cc$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$6c3b15b2e6a8a3cc$export$c8a8987d4410bf2d = $6c3b15b2e6a8a3cc$var$J;
$6c3b15b2e6a8a3cc$export$d38cd72104c1f0e9 = function(a) {
    var b = $6c3b15b2e6a8a3cc$var$J.bind(null, a);
    b.type = a;
    return b;
};
$6c3b15b2e6a8a3cc$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$6c3b15b2e6a8a3cc$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $6c3b15b2e6a8a3cc$var$t,
        render: a
    };
};
$6c3b15b2e6a8a3cc$export$a8257692ac88316c = $6c3b15b2e6a8a3cc$var$L;
$6c3b15b2e6a8a3cc$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $6c3b15b2e6a8a3cc$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $6c3b15b2e6a8a3cc$var$Q
    };
};
$6c3b15b2e6a8a3cc$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $6c3b15b2e6a8a3cc$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$6c3b15b2e6a8a3cc$export$35808ee640e87ca7 = function(a, b) {
    return $6c3b15b2e6a8a3cc$var$S().useCallback(a, b);
};
$6c3b15b2e6a8a3cc$export$fae74005e78b1a27 = function(a, b) {
    return $6c3b15b2e6a8a3cc$var$S().useContext(a, b);
};
$6c3b15b2e6a8a3cc$export$dc8fbce3eb94dc1e = function() {};
$6c3b15b2e6a8a3cc$export$6d9c69b0de29b591 = function(a, b) {
    return $6c3b15b2e6a8a3cc$var$S().useEffect(a, b);
};
$6c3b15b2e6a8a3cc$export$d5a552a76deda3c2 = function(a, b, c) {
    return $6c3b15b2e6a8a3cc$var$S().useImperativeHandle(a, b, c);
};
$6c3b15b2e6a8a3cc$export$e5c5a5f917a5871c = function(a, b) {
    return $6c3b15b2e6a8a3cc$var$S().useLayoutEffect(a, b);
};
$6c3b15b2e6a8a3cc$export$1538c33de8887b59 = function(a, b) {
    return $6c3b15b2e6a8a3cc$var$S().useMemo(a, b);
};
$6c3b15b2e6a8a3cc$export$13e3392192263954 = function(a, b, c) {
    return $6c3b15b2e6a8a3cc$var$S().useReducer(a, b, c);
};
$6c3b15b2e6a8a3cc$export$b8f5890fc79d6aca = function(a) {
    return $6c3b15b2e6a8a3cc$var$S().useRef(a);
};
$6c3b15b2e6a8a3cc$export$60241385465d0a34 = function(a) {
    return $6c3b15b2e6a8a3cc$var$S().useState(a);
};
$6c3b15b2e6a8a3cc$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("cW8ks", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $9Cg25 = parcelRequire("9Cg25");

var $17cHO = parcelRequire("17cHO");

var $19fYw = parcelRequire("19fYw");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$9Cg25) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $9Cg25.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $17cHO({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $9Cg25.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $17cHO({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $17cHO({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $17cHO({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $19fYw.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $19fYw.unstable_scheduleCallback($19fYw.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $19fYw.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $19fYw.unstable_UserBlockingPriority, ed = $19fYw.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $17cHO(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $17cHO({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $17cHO({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $17cHO({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $17cHO({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $17cHO({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $17cHO({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $17cHO({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $17cHO({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $17cHO({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $17cHO({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $17cHO({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $17cHO({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $17cHO({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $19fYw.unstable_runWithPriority, Of = $19fYw.unstable_scheduleCallback, Pf = $19fYw.unstable_cancelCallback, Qf = $19fYw.unstable_shouldYield, Rf = $19fYw.unstable_requestPaint, Sf = $19fYw.unstable_now, Tf = $19fYw.unstable_getCurrentPriorityLevel, Uf = $19fYw.unstable_ImmediatePriority, Vf = $19fYw.unstable_UserBlockingPriority, Wf = $19fYw.unstable_NormalPriority, Xf = $19fYw.unstable_LowPriority, Yf = $19fYw.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $17cHO({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $17cHO({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $9Cg25.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $17cHO({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $17cHO({}, e, {
                    value: void 0
                });
                d = $17cHO({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $17cHO({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("19fYw", function(module, exports) {
'use strict';

module.exports = (parcelRequire("i7rEc"));

});
parcelRegister("i7rEc", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $d30e539ef1b592bc$export$c4744153514ff05d; }, function (v) { return $d30e539ef1b592bc$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $d30e539ef1b592bc$export$b5836b71941fa3ed; }, function (v) { return $d30e539ef1b592bc$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $d30e539ef1b592bc$export$d66a1c1c77bd778b; }, function (v) { return $d30e539ef1b592bc$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $d30e539ef1b592bc$export$3e506c1ccc9cc1a7; }, function (v) { return $d30e539ef1b592bc$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $d30e539ef1b592bc$export$e26fe2ed2fa76875; }, function (v) { return $d30e539ef1b592bc$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $d30e539ef1b592bc$export$502329bbf4b505b1; }, function (v) { return $d30e539ef1b592bc$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $d30e539ef1b592bc$export$6e3807111c4874c4; }, function (v) { return $d30e539ef1b592bc$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $d30e539ef1b592bc$export$c27134553091fb3a; }, function (v) { return $d30e539ef1b592bc$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $d30e539ef1b592bc$export$33ee1acdc04fd2a2; }, function (v) { return $d30e539ef1b592bc$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $d30e539ef1b592bc$export$b00a404bbd5edef2; }, function (v) { return $d30e539ef1b592bc$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $d30e539ef1b592bc$export$8352ce38b91d0c62; }, function (v) { return $d30e539ef1b592bc$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $d30e539ef1b592bc$export$d3dfb8e4810cb555; }, function (v) { return $d30e539ef1b592bc$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $d30e539ef1b592bc$export$839f9183b0465a69; }, function (v) { return $d30e539ef1b592bc$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $d30e539ef1b592bc$export$72fdf0e06517287b; }, function (v) { return $d30e539ef1b592bc$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $d30e539ef1b592bc$export$4b844e58a3e414b4; }, function (v) { return $d30e539ef1b592bc$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $d30e539ef1b592bc$export$816d2913ae6b83b1; }, function (v) { return $d30e539ef1b592bc$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $d30e539ef1b592bc$export$61bcfe829111a1d0; }, function (v) { return $d30e539ef1b592bc$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $d30e539ef1b592bc$export$7ee8c9beb337bc3f; }, function (v) { return $d30e539ef1b592bc$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $d30e539ef1b592bc$export$cf845f2c119da08a; }, function (v) { return $d30e539ef1b592bc$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d30e539ef1b592bc$export$c4744153514ff05d;
var $d30e539ef1b592bc$export$b5836b71941fa3ed;
var $d30e539ef1b592bc$export$d66a1c1c77bd778b;
var $d30e539ef1b592bc$export$3e506c1ccc9cc1a7;
var $d30e539ef1b592bc$export$e26fe2ed2fa76875;
var $d30e539ef1b592bc$export$502329bbf4b505b1;
var $d30e539ef1b592bc$export$6e3807111c4874c4;
var $d30e539ef1b592bc$export$c27134553091fb3a;
var $d30e539ef1b592bc$export$33ee1acdc04fd2a2;
var $d30e539ef1b592bc$export$b00a404bbd5edef2;
var $d30e539ef1b592bc$export$8352ce38b91d0c62;
var $d30e539ef1b592bc$export$d3dfb8e4810cb555;
var $d30e539ef1b592bc$export$839f9183b0465a69;
var $d30e539ef1b592bc$export$72fdf0e06517287b;
var $d30e539ef1b592bc$export$4b844e58a3e414b4;
var $d30e539ef1b592bc$export$816d2913ae6b83b1;
var $d30e539ef1b592bc$export$61bcfe829111a1d0;
var $d30e539ef1b592bc$export$7ee8c9beb337bc3f;
var $d30e539ef1b592bc$export$cf845f2c119da08a;
'use strict';
var $d30e539ef1b592bc$var$f, $d30e539ef1b592bc$var$g, $d30e539ef1b592bc$var$h, $d30e539ef1b592bc$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $d30e539ef1b592bc$var$l = performance;
    $d30e539ef1b592bc$export$c4744153514ff05d = function() {
        return $d30e539ef1b592bc$var$l.now();
    };
} else {
    var $d30e539ef1b592bc$var$p = Date, $d30e539ef1b592bc$var$q = $d30e539ef1b592bc$var$p.now();
    $d30e539ef1b592bc$export$c4744153514ff05d = function() {
        return $d30e539ef1b592bc$var$p.now() - $d30e539ef1b592bc$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $d30e539ef1b592bc$var$t = null, $d30e539ef1b592bc$var$u = null, $d30e539ef1b592bc$var$w = function() {
        if (null !== $d30e539ef1b592bc$var$t) try {
            var a = $d30e539ef1b592bc$export$c4744153514ff05d();
            $d30e539ef1b592bc$var$t(!0, a);
            $d30e539ef1b592bc$var$t = null;
        } catch (b) {
            throw setTimeout($d30e539ef1b592bc$var$w, 0), b;
        }
    };
    $d30e539ef1b592bc$var$f = function(a) {
        null !== $d30e539ef1b592bc$var$t ? setTimeout($d30e539ef1b592bc$var$f, 0, a) : ($d30e539ef1b592bc$var$t = a, setTimeout($d30e539ef1b592bc$var$w, 0));
    };
    $d30e539ef1b592bc$var$g = function(a, b) {
        $d30e539ef1b592bc$var$u = setTimeout(a, b);
    };
    $d30e539ef1b592bc$var$h = function() {
        clearTimeout($d30e539ef1b592bc$var$u);
    };
    $d30e539ef1b592bc$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $d30e539ef1b592bc$var$k = $d30e539ef1b592bc$export$d66a1c1c77bd778b = function() {};
} else {
    var $d30e539ef1b592bc$var$x = window.setTimeout, $d30e539ef1b592bc$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $d30e539ef1b592bc$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $d30e539ef1b592bc$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $d30e539ef1b592bc$var$A = !1, $d30e539ef1b592bc$var$B = null, $d30e539ef1b592bc$var$C = -1, $d30e539ef1b592bc$var$D = 5, $d30e539ef1b592bc$var$E = 0;
    $d30e539ef1b592bc$export$b5836b71941fa3ed = function() {
        return $d30e539ef1b592bc$export$c4744153514ff05d() >= $d30e539ef1b592bc$var$E;
    };
    $d30e539ef1b592bc$var$k = function() {};
    $d30e539ef1b592bc$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $d30e539ef1b592bc$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $d30e539ef1b592bc$var$F = new MessageChannel, $d30e539ef1b592bc$var$G = $d30e539ef1b592bc$var$F.port2;
    $d30e539ef1b592bc$var$F.port1.onmessage = function() {
        if (null !== $d30e539ef1b592bc$var$B) {
            var a = $d30e539ef1b592bc$export$c4744153514ff05d();
            $d30e539ef1b592bc$var$E = a + $d30e539ef1b592bc$var$D;
            try {
                $d30e539ef1b592bc$var$B(!0, a) ? $d30e539ef1b592bc$var$G.postMessage(null) : ($d30e539ef1b592bc$var$A = !1, $d30e539ef1b592bc$var$B = null);
            } catch (b) {
                throw $d30e539ef1b592bc$var$G.postMessage(null), b;
            }
        } else $d30e539ef1b592bc$var$A = !1;
    };
    $d30e539ef1b592bc$var$f = function(a) {
        $d30e539ef1b592bc$var$B = a;
        $d30e539ef1b592bc$var$A || ($d30e539ef1b592bc$var$A = !0, $d30e539ef1b592bc$var$G.postMessage(null));
    };
    $d30e539ef1b592bc$var$g = function(a, b) {
        $d30e539ef1b592bc$var$C = $d30e539ef1b592bc$var$x(function() {
            a($d30e539ef1b592bc$export$c4744153514ff05d());
        }, b);
    };
    $d30e539ef1b592bc$var$h = function() {
        $d30e539ef1b592bc$var$y($d30e539ef1b592bc$var$C);
        $d30e539ef1b592bc$var$C = -1;
    };
}
function $d30e539ef1b592bc$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $d30e539ef1b592bc$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $d30e539ef1b592bc$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $d30e539ef1b592bc$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $d30e539ef1b592bc$var$I(n, c)) void 0 !== r && 0 > $d30e539ef1b592bc$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $d30e539ef1b592bc$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $d30e539ef1b592bc$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $d30e539ef1b592bc$var$L = [], $d30e539ef1b592bc$var$M = [], $d30e539ef1b592bc$var$N = 1, $d30e539ef1b592bc$var$O = null, $d30e539ef1b592bc$var$P = 3, $d30e539ef1b592bc$var$Q = !1, $d30e539ef1b592bc$var$R = !1, $d30e539ef1b592bc$var$S = !1;
function $d30e539ef1b592bc$var$T(a) {
    for(var b = $d30e539ef1b592bc$var$J($d30e539ef1b592bc$var$M); null !== b;){
        if (null === b.callback) $d30e539ef1b592bc$var$K($d30e539ef1b592bc$var$M);
        else if (b.startTime <= a) $d30e539ef1b592bc$var$K($d30e539ef1b592bc$var$M), b.sortIndex = b.expirationTime, $d30e539ef1b592bc$var$H($d30e539ef1b592bc$var$L, b);
        else break;
        b = $d30e539ef1b592bc$var$J($d30e539ef1b592bc$var$M);
    }
}
function $d30e539ef1b592bc$var$U(a) {
    $d30e539ef1b592bc$var$S = !1;
    $d30e539ef1b592bc$var$T(a);
    if (!$d30e539ef1b592bc$var$R) {
        if (null !== $d30e539ef1b592bc$var$J($d30e539ef1b592bc$var$L)) $d30e539ef1b592bc$var$R = !0, $d30e539ef1b592bc$var$f($d30e539ef1b592bc$var$V);
        else {
            var b = $d30e539ef1b592bc$var$J($d30e539ef1b592bc$var$M);
            null !== b && $d30e539ef1b592bc$var$g($d30e539ef1b592bc$var$U, b.startTime - a);
        }
    }
}
function $d30e539ef1b592bc$var$V(a, b) {
    $d30e539ef1b592bc$var$R = !1;
    $d30e539ef1b592bc$var$S && ($d30e539ef1b592bc$var$S = !1, $d30e539ef1b592bc$var$h());
    $d30e539ef1b592bc$var$Q = !0;
    var c = $d30e539ef1b592bc$var$P;
    try {
        $d30e539ef1b592bc$var$T(b);
        for($d30e539ef1b592bc$var$O = $d30e539ef1b592bc$var$J($d30e539ef1b592bc$var$L); null !== $d30e539ef1b592bc$var$O && (!($d30e539ef1b592bc$var$O.expirationTime > b) || a && !$d30e539ef1b592bc$export$b5836b71941fa3ed());){
            var d = $d30e539ef1b592bc$var$O.callback;
            if ("function" === typeof d) {
                $d30e539ef1b592bc$var$O.callback = null;
                $d30e539ef1b592bc$var$P = $d30e539ef1b592bc$var$O.priorityLevel;
                var e = d($d30e539ef1b592bc$var$O.expirationTime <= b);
                b = $d30e539ef1b592bc$export$c4744153514ff05d();
                "function" === typeof e ? $d30e539ef1b592bc$var$O.callback = e : $d30e539ef1b592bc$var$O === $d30e539ef1b592bc$var$J($d30e539ef1b592bc$var$L) && $d30e539ef1b592bc$var$K($d30e539ef1b592bc$var$L);
                $d30e539ef1b592bc$var$T(b);
            } else $d30e539ef1b592bc$var$K($d30e539ef1b592bc$var$L);
            $d30e539ef1b592bc$var$O = $d30e539ef1b592bc$var$J($d30e539ef1b592bc$var$L);
        }
        if (null !== $d30e539ef1b592bc$var$O) var m = !0;
        else {
            var n = $d30e539ef1b592bc$var$J($d30e539ef1b592bc$var$M);
            null !== n && $d30e539ef1b592bc$var$g($d30e539ef1b592bc$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $d30e539ef1b592bc$var$O = null, $d30e539ef1b592bc$var$P = c, $d30e539ef1b592bc$var$Q = !1;
    }
}
var $d30e539ef1b592bc$var$W = $d30e539ef1b592bc$var$k;
$d30e539ef1b592bc$export$3e506c1ccc9cc1a7 = 5;
$d30e539ef1b592bc$export$e26fe2ed2fa76875 = 1;
$d30e539ef1b592bc$export$502329bbf4b505b1 = 4;
$d30e539ef1b592bc$export$6e3807111c4874c4 = 3;
$d30e539ef1b592bc$export$c27134553091fb3a = null;
$d30e539ef1b592bc$export$33ee1acdc04fd2a2 = 2;
$d30e539ef1b592bc$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$d30e539ef1b592bc$export$8352ce38b91d0c62 = function() {
    $d30e539ef1b592bc$var$R || $d30e539ef1b592bc$var$Q || ($d30e539ef1b592bc$var$R = !0, $d30e539ef1b592bc$var$f($d30e539ef1b592bc$var$V));
};
$d30e539ef1b592bc$export$d3dfb8e4810cb555 = function() {
    return $d30e539ef1b592bc$var$P;
};
$d30e539ef1b592bc$export$839f9183b0465a69 = function() {
    return $d30e539ef1b592bc$var$J($d30e539ef1b592bc$var$L);
};
$d30e539ef1b592bc$export$72fdf0e06517287b = function(a) {
    switch($d30e539ef1b592bc$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $d30e539ef1b592bc$var$P;
    }
    var c = $d30e539ef1b592bc$var$P;
    $d30e539ef1b592bc$var$P = b;
    try {
        return a();
    } finally{
        $d30e539ef1b592bc$var$P = c;
    }
};
$d30e539ef1b592bc$export$4b844e58a3e414b4 = function() {};
$d30e539ef1b592bc$export$816d2913ae6b83b1 = $d30e539ef1b592bc$var$W;
$d30e539ef1b592bc$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $d30e539ef1b592bc$var$P;
    $d30e539ef1b592bc$var$P = a;
    try {
        return b();
    } finally{
        $d30e539ef1b592bc$var$P = c;
    }
};
$d30e539ef1b592bc$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $d30e539ef1b592bc$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $d30e539ef1b592bc$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $d30e539ef1b592bc$var$H($d30e539ef1b592bc$var$M, a), null === $d30e539ef1b592bc$var$J($d30e539ef1b592bc$var$L) && a === $d30e539ef1b592bc$var$J($d30e539ef1b592bc$var$M) && ($d30e539ef1b592bc$var$S ? $d30e539ef1b592bc$var$h() : $d30e539ef1b592bc$var$S = !0, $d30e539ef1b592bc$var$g($d30e539ef1b592bc$var$U, c - d))) : (a.sortIndex = e, $d30e539ef1b592bc$var$H($d30e539ef1b592bc$var$L, a), $d30e539ef1b592bc$var$R || $d30e539ef1b592bc$var$Q || ($d30e539ef1b592bc$var$R = !0, $d30e539ef1b592bc$var$f($d30e539ef1b592bc$var$V)));
    return a;
};
$d30e539ef1b592bc$export$cf845f2c119da08a = function(a) {
    var b = $d30e539ef1b592bc$var$P;
    return function() {
        var c = $d30e539ef1b592bc$var$P;
        $d30e539ef1b592bc$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $d30e539ef1b592bc$var$P = c;
        }
    };
};

});



parcelRegister("k8obU", function(module, exports) {
/** @license React v0.26.2
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 


module.exports = function $$$reconciler($$$hostConfig) {
    var exports = {};
    'use strict';
    var aa = (parcelRequire("17cHO")), ba = (parcelRequire("9Cg25")), m = (parcelRequire("19fYw"));
    function q(a) {
        for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
        return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var ca = ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, da = 60103, ea = 60106, fa = 60107, ha = 60108, ia = 60114, ja = 60109, ka = 60110, la = 60112, ma = 60113, na = 60120, oa = 60115, pa = 60116, qa = 60121, ra = 60129, sa = 60130, ta = 60131;
    if ("function" === typeof Symbol && Symbol.for) {
        var r = Symbol.for;
        da = r("react.element");
        ea = r("react.portal");
        fa = r("react.fragment");
        ha = r("react.strict_mode");
        ia = r("react.profiler");
        ja = r("react.provider");
        ka = r("react.context");
        la = r("react.forward_ref");
        ma = r("react.suspense");
        na = r("react.suspense_list");
        oa = r("react.memo");
        pa = r("react.lazy");
        qa = r("react.block");
        r("react.scope");
        ra = r("react.debug_trace_mode");
        sa = r("react.offscreen");
        ta = r("react.legacy_hidden");
    }
    var ua = "function" === typeof Symbol && Symbol.iterator;
    function va(a) {
        if (null === a || "object" !== typeof a) return null;
        a = ua && a[ua] || a["@@iterator"];
        return "function" === typeof a ? a : null;
    }
    function wa(a) {
        if (null == a) return null;
        if ("function" === typeof a) return a.displayName || a.name || null;
        if ("string" === typeof a) return a;
        switch(a){
            case fa:
                return "Fragment";
            case ea:
                return "Portal";
            case ia:
                return "Profiler";
            case ha:
                return "StrictMode";
            case ma:
                return "Suspense";
            case na:
                return "SuspenseList";
        }
        if ("object" === typeof a) switch(a.$$typeof){
            case ka:
                return (a.displayName || "Context") + ".Consumer";
            case ja:
                return (a._context.displayName || "Context") + ".Provider";
            case la:
                var b = a.render;
                b = b.displayName || b.name || "";
                return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
            case oa:
                return wa(a.type);
            case qa:
                return wa(a._render);
            case pa:
                b = a._payload;
                a = a._init;
                try {
                    return wa(a(b));
                } catch (c) {}
        }
        return null;
    }
    function xa(a) {
        var b = a, c = a;
        if (a.alternate) for(; b.return;)b = b.return;
        else {
            a = b;
            do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
            while (a);
        }
        return 3 === b.tag ? c : null;
    }
    function ya(a) {
        if (xa(a) !== a) throw Error(q(188));
    }
    function za(a) {
        var b = a.alternate;
        if (!b) {
            b = xa(a);
            if (null === b) throw Error(q(188));
            return b !== a ? null : a;
        }
        for(var c = a, d = b;;){
            var e = c.return;
            if (null === e) break;
            var f = e.alternate;
            if (null === f) {
                d = e.return;
                if (null !== d) {
                    c = d;
                    continue;
                }
                break;
            }
            if (e.child === f.child) {
                for(f = e.child; f;){
                    if (f === c) return ya(e), a;
                    if (f === d) return ya(e), b;
                    f = f.sibling;
                }
                throw Error(q(188));
            }
            if (c.return !== d.return) c = e, d = f;
            else {
                for(var g = !1, h = e.child; h;){
                    if (h === c) {
                        g = !0;
                        c = e;
                        d = f;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = e;
                        c = f;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) {
                    for(h = f.child; h;){
                        if (h === c) {
                            g = !0;
                            c = f;
                            d = e;
                            break;
                        }
                        if (h === d) {
                            g = !0;
                            d = f;
                            c = e;
                            break;
                        }
                        h = h.sibling;
                    }
                    if (!g) throw Error(q(189));
                }
            }
            if (c.alternate !== d) throw Error(q(190));
        }
        if (3 !== c.tag) throw Error(q(188));
        return c.stateNode.current === c ? a : b;
    }
    function Aa(a) {
        a = za(a);
        if (!a) return null;
        for(var b = a;;){
            if (5 === b.tag || 6 === b.tag) return b;
            if (b.child) b.child.return = b, b = b.child;
            else {
                if (b === a) break;
                for(; !b.sibling;){
                    if (!b.return || b.return === a) return null;
                    b = b.return;
                }
                b.sibling.return = b.return;
                b = b.sibling;
            }
        }
        return null;
    }
    function Ba(a) {
        a = za(a);
        if (!a) return null;
        for(var b = a;;){
            if (5 === b.tag || 6 === b.tag) return b;
            if (b.child && 4 !== b.tag) b.child.return = b, b = b.child;
            else {
                if (b === a) break;
                for(; !b.sibling;){
                    if (!b.return || b.return === a) return null;
                    b = b.return;
                }
                b.sibling.return = b.return;
                b = b.sibling;
            }
        }
        return null;
    }
    function Ca(a, b) {
        for(var c = a.alternate; null !== b;){
            if (b === a || b === c) return !0;
            b = b.return;
        }
        return !1;
    }
    var Da = $$$hostConfig.getPublicInstance, Ea = $$$hostConfig.getRootHostContext, Fa = $$$hostConfig.getChildHostContext, Ga = $$$hostConfig.prepareForCommit, Ha = $$$hostConfig.resetAfterCommit, Ia = $$$hostConfig.createInstance, Ja = $$$hostConfig.appendInitialChild, Ka = $$$hostConfig.finalizeInitialChildren, La = $$$hostConfig.prepareUpdate, Ma = $$$hostConfig.shouldSetTextContent, Na = $$$hostConfig.createTextInstance, Pa = $$$hostConfig.scheduleTimeout, Qa = $$$hostConfig.cancelTimeout, Ra = $$$hostConfig.noTimeout, Sa = $$$hostConfig.isPrimaryRenderer, Ta = $$$hostConfig.supportsMutation, Ua = $$$hostConfig.supportsPersistence, Va = $$$hostConfig.supportsHydration, Wa = $$$hostConfig.getInstanceFromNode, Xa = $$$hostConfig.makeOpaqueHydratingObject, Ya = $$$hostConfig.makeClientId, Za = $$$hostConfig.beforeActiveInstanceBlur, $a = $$$hostConfig.afterActiveInstanceBlur, ab = $$$hostConfig.preparePortalMount, bb = $$$hostConfig.supportsTestSelectors, cb = $$$hostConfig.findFiberRoot, db = $$$hostConfig.getBoundingRect, eb = $$$hostConfig.getTextContent, fb = $$$hostConfig.isHiddenSubtree, gb = $$$hostConfig.matchAccessibilityRole, hb = $$$hostConfig.setFocusIfFocusable, ib = $$$hostConfig.setupIntersectionObserver, jb = $$$hostConfig.appendChild, kb = $$$hostConfig.appendChildToContainer, lb = $$$hostConfig.commitTextUpdate, mb = $$$hostConfig.commitMount, nb = $$$hostConfig.commitUpdate, ob = $$$hostConfig.insertBefore, pb = $$$hostConfig.insertInContainerBefore, qb = $$$hostConfig.removeChild, rb = $$$hostConfig.removeChildFromContainer, sb = $$$hostConfig.resetTextContent, tb = $$$hostConfig.hideInstance, ub = $$$hostConfig.hideTextInstance, vb = $$$hostConfig.unhideInstance, wb = $$$hostConfig.unhideTextInstance, xb = $$$hostConfig.clearContainer, yb = $$$hostConfig.cloneInstance, zb = $$$hostConfig.createContainerChildSet, Ab = $$$hostConfig.appendChildToContainerChildSet, Bb = $$$hostConfig.finalizeContainerChildren, Cb = $$$hostConfig.replaceContainerChildren, Db = $$$hostConfig.cloneHiddenInstance, Eb = $$$hostConfig.cloneHiddenTextInstance, Fb = $$$hostConfig.canHydrateInstance, Gb = $$$hostConfig.canHydrateTextInstance, Hb = $$$hostConfig.isSuspenseInstancePending, Ib = $$$hostConfig.isSuspenseInstanceFallback, Jb = $$$hostConfig.getNextHydratableSibling, Kb = $$$hostConfig.getFirstHydratableChild, Lb = $$$hostConfig.hydrateInstance, Mb = $$$hostConfig.hydrateTextInstance, Nb = $$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance, Ob = $$$hostConfig.commitHydratedContainer, Pb = $$$hostConfig.commitHydratedSuspenseInstance, Qb;
    function Rb(a) {
        if (void 0 === Qb) try {
            throw Error();
        } catch (c) {
            var b = c.stack.trim().match(/\n( *(at )?)/);
            Qb = b && b[1] || "";
        }
        return "\n" + Qb + a;
    }
    var Sb = !1;
    function Tb(a, b) {
        if (!a || Sb) return "";
        Sb = !0;
        var c = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        try {
            if (b) {
                if (b = function() {
                    throw Error();
                }, Object.defineProperty(b.prototype, "props", {
                    set: function() {
                        throw Error();
                    }
                }), "object" === typeof Reflect && Reflect.construct) {
                    try {
                        Reflect.construct(b, []);
                    } catch (k) {
                        var d = k;
                    }
                    Reflect.construct(a, [], b);
                } else {
                    try {
                        b.call();
                    } catch (k) {
                        d = k;
                    }
                    a.call(b.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (k) {
                    d = k;
                }
                a();
            }
        } catch (k) {
            if (k && d && "string" === typeof k.stack) {
                for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
                for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                    if (1 !== g || 1 !== h) {
                        do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                        while (1 <= g && 0 <= h);
                    }
                    break;
                }
            }
        } finally{
            Sb = !1, Error.prepareStackTrace = c;
        }
        return (a = a ? a.displayName || a.name : "") ? Rb(a) : "";
    }
    var Ub = [], Vb = -1;
    function Wb(a) {
        return {
            current: a
        };
    }
    function z(a) {
        0 > Vb || (a.current = Ub[Vb], Ub[Vb] = null, Vb--);
    }
    function A(a, b) {
        Vb++;
        Ub[Vb] = a.current;
        a.current = b;
    }
    var Xb = {}, B = Wb(Xb), D = Wb(!1), Yb = Xb;
    function Zb(a, b) {
        var c = a.type.contextTypes;
        if (!c) return Xb;
        var d = a.stateNode;
        if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
        var e = {}, f;
        for(f in c)e[f] = b[f];
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
        return e;
    }
    function E(a) {
        a = a.childContextTypes;
        return null !== a && void 0 !== a;
    }
    function $b() {
        z(D);
        z(B);
    }
    function ac(a, b, c) {
        if (B.current !== Xb) throw Error(q(168));
        A(B, b);
        A(D, c);
    }
    function bc(a, b, c) {
        var d = a.stateNode;
        a = b.childContextTypes;
        if ("function" !== typeof d.getChildContext) return c;
        d = d.getChildContext();
        for(var e in d)if (!(e in a)) throw Error(q(108, wa(b) || "Unknown", e));
        return aa({}, c, d);
    }
    function cc(a) {
        a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Xb;
        Yb = B.current;
        A(B, a);
        A(D, D.current);
        return !0;
    }
    function dc(a, b, c) {
        var d = a.stateNode;
        if (!d) throw Error(q(169));
        c ? (a = bc(a, b, Yb), d.__reactInternalMemoizedMergedChildContext = a, z(D), z(B), A(B, a)) : z(D);
        A(D, c);
    }
    var ec = null, fc = null, gc = m.unstable_now;
    gc();
    var hc = 0, F = 8;
    function ic(a) {
        if (0 !== (1 & a)) return F = 15, 1;
        if (0 !== (2 & a)) return F = 14, 2;
        if (0 !== (4 & a)) return F = 13, 4;
        var b = 24 & a;
        if (0 !== b) return F = 12, b;
        if (0 !== (a & 32)) return F = 11, 32;
        b = 192 & a;
        if (0 !== b) return F = 10, b;
        if (0 !== (a & 256)) return F = 9, 256;
        b = 3584 & a;
        if (0 !== b) return F = 8, b;
        if (0 !== (a & 4096)) return F = 7, 4096;
        b = 4186112 & a;
        if (0 !== b) return F = 6, b;
        b = 62914560 & a;
        if (0 !== b) return F = 5, b;
        if (a & 67108864) return F = 4, 67108864;
        if (0 !== (a & 134217728)) return F = 3, 134217728;
        b = 805306368 & a;
        if (0 !== b) return F = 2, b;
        if (0 !== (1073741824 & a)) return F = 1, 1073741824;
        F = 8;
        return a;
    }
    function jc(a) {
        switch(a){
            case 99:
                return 15;
            case 98:
                return 10;
            case 97:
            case 96:
                return 8;
            case 95:
                return 2;
            default:
                return 0;
        }
    }
    function kc(a) {
        switch(a){
            case 15:
            case 14:
                return 99;
            case 13:
            case 12:
            case 11:
            case 10:
                return 98;
            case 9:
            case 8:
            case 7:
            case 6:
            case 4:
            case 5:
                return 97;
            case 3:
            case 2:
            case 1:
                return 95;
            case 0:
                return 90;
            default:
                throw Error(q(358, a));
        }
    }
    function lc(a, b) {
        var c = a.pendingLanes;
        if (0 === c) return F = 0;
        var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
        if (0 !== f) d = f, e = F = 15;
        else if (f = c & 134217727, 0 !== f) {
            var k = f & ~g;
            0 !== k ? (d = ic(k), e = F) : (h &= f, 0 !== h && (d = ic(h), e = F));
        } else f = c & ~g, 0 !== f ? (d = ic(f), e = F) : 0 !== h && (d = ic(h), e = F);
        if (0 === d) return 0;
        d = 31 - mc(d);
        d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
        if (0 !== b && b !== d && 0 === (b & g)) {
            ic(b);
            if (e <= F) return b;
            F = e;
        }
        b = a.entangledLanes;
        if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - mc(b), e = 1 << c, d |= a[c], b &= ~e;
        return d;
    }
    function nc(a) {
        a = a.pendingLanes & -1073741825;
        return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
    }
    function oc(a, b) {
        switch(a){
            case 15:
                return 1;
            case 14:
                return 2;
            case 12:
                return a = pc(24 & ~b), 0 === a ? oc(10, b) : a;
            case 10:
                return a = pc(192 & ~b), 0 === a ? oc(8, b) : a;
            case 8:
                return a = pc(3584 & ~b), 0 === a && (a = pc(4186112 & ~b), 0 === a && (a = 512)), a;
            case 2:
                return b = pc(805306368 & ~b), 0 === b && (b = 268435456), b;
        }
        throw Error(q(358, a));
    }
    function pc(a) {
        return a & -a;
    }
    function qc(a) {
        for(var b = [], c = 0; 31 > c; c++)b.push(a);
        return b;
    }
    function rc(a, b, c) {
        a.pendingLanes |= b;
        var d = b - 1;
        a.suspendedLanes &= d;
        a.pingedLanes &= d;
        a = a.eventTimes;
        b = 31 - mc(b);
        a[b] = c;
    }
    var mc = Math.clz32 ? Math.clz32 : sc, tc = Math.log, uc = Math.LN2;
    function sc(a) {
        return 0 === a ? 32 : 31 - (tc(a) / uc | 0) | 0;
    }
    var vc = m.unstable_runWithPriority, wc = m.unstable_scheduleCallback, xc = m.unstable_cancelCallback, yc = m.unstable_shouldYield, zc = m.unstable_requestPaint, Ac = m.unstable_now, Bc = m.unstable_getCurrentPriorityLevel, Cc = m.unstable_ImmediatePriority, Dc = m.unstable_UserBlockingPriority, Ec = m.unstable_NormalPriority, Fc = m.unstable_LowPriority, Gc = m.unstable_IdlePriority, Hc = {}, Ic = void 0 !== zc ? zc : function() {}, Jc = null, Kc = null, Lc = !1, Mc = Ac(), G = 1E4 > Mc ? Ac : function() {
        return Ac() - Mc;
    };
    function Nc() {
        switch(Bc()){
            case Cc:
                return 99;
            case Dc:
                return 98;
            case Ec:
                return 97;
            case Fc:
                return 96;
            case Gc:
                return 95;
            default:
                throw Error(q(332));
        }
    }
    function Oc(a) {
        switch(a){
            case 99:
                return Cc;
            case 98:
                return Dc;
            case 97:
                return Ec;
            case 96:
                return Fc;
            case 95:
                return Gc;
            default:
                throw Error(q(332));
        }
    }
    function Pc(a, b) {
        a = Oc(a);
        return vc(a, b);
    }
    function Qc(a, b, c) {
        a = Oc(a);
        return wc(a, b, c);
    }
    function H() {
        if (null !== Kc) {
            var a = Kc;
            Kc = null;
            xc(a);
        }
        Rc();
    }
    function Rc() {
        if (!Lc && null !== Jc) {
            Lc = !0;
            var a = 0;
            try {
                var b = Jc;
                Pc(99, function() {
                    for(; a < b.length; a++){
                        var c = b[a];
                        do c = c(!0);
                        while (null !== c);
                    }
                });
                Jc = null;
            } catch (c) {
                throw null !== Jc && (Jc = Jc.slice(a + 1)), wc(Cc, H), c;
            } finally{
                Lc = !1;
            }
        }
    }
    var Sc = ca.ReactCurrentBatchConfig;
    function Tc(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    }
    var I = "function" === typeof Object.is ? Object.is : Tc, Uc = Object.prototype.hasOwnProperty;
    function Vc(a, b) {
        if (I(a, b)) return !0;
        if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
        var c = Object.keys(a), d = Object.keys(b);
        if (c.length !== d.length) return !1;
        for(d = 0; d < c.length; d++)if (!Uc.call(b, c[d]) || !I(a[c[d]], b[c[d]])) return !1;
        return !0;
    }
    function Wc(a) {
        switch(a.tag){
            case 5:
                return Rb(a.type);
            case 16:
                return Rb("Lazy");
            case 13:
                return Rb("Suspense");
            case 19:
                return Rb("SuspenseList");
            case 0:
            case 2:
            case 15:
                return a = Tb(a.type, !1), a;
            case 11:
                return a = Tb(a.type.render, !1), a;
            case 22:
                return a = Tb(a.type._render, !1), a;
            case 1:
                return a = Tb(a.type, !0), a;
            default:
                return "";
        }
    }
    function Xc(a, b) {
        if (a && a.defaultProps) {
            b = aa({}, b);
            a = a.defaultProps;
            for(var c in a)void 0 === b[c] && (b[c] = a[c]);
            return b;
        }
        return b;
    }
    var Yc = Wb(null), Zc = null, $c = null, ad = null;
    function bd() {
        ad = $c = Zc = null;
    }
    function cd(a, b) {
        a = a.type._context;
        Sa ? (A(Yc, a._currentValue), a._currentValue = b) : (A(Yc, a._currentValue2), a._currentValue2 = b);
    }
    function dd(a) {
        var b = Yc.current;
        z(Yc);
        a = a.type._context;
        Sa ? a._currentValue = b : a._currentValue2 = b;
    }
    function ed(a, b) {
        for(; null !== a;){
            var c = a.alternate;
            if ((a.childLanes & b) === b) {
                if (null === c || (c.childLanes & b) === b) break;
                else c.childLanes |= b;
            } else a.childLanes |= b, null !== c && (c.childLanes |= b);
            a = a.return;
        }
    }
    function fd(a, b) {
        Zc = a;
        ad = $c = null;
        a = a.dependencies;
        null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (gd = !0), a.firstContext = null);
    }
    function J(a, b) {
        if (ad !== a && !1 !== b && 0 !== b) {
            if ("number" !== typeof b || 1073741823 === b) ad = a, b = 1073741823;
            b = {
                context: a,
                observedBits: b,
                next: null
            };
            if (null === $c) {
                if (null === Zc) throw Error(q(308));
                $c = b;
                Zc.dependencies = {
                    lanes: 0,
                    firstContext: b,
                    responders: null
                };
            } else $c = $c.next = b;
        }
        return Sa ? a._currentValue : a._currentValue2;
    }
    var hd = !1;
    function id(a) {
        a.updateQueue = {
            baseState: a.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null
            },
            effects: null
        };
    }
    function jd(a, b) {
        a = a.updateQueue;
        b.updateQueue === a && (b.updateQueue = {
            baseState: a.baseState,
            firstBaseUpdate: a.firstBaseUpdate,
            lastBaseUpdate: a.lastBaseUpdate,
            shared: a.shared,
            effects: a.effects
        });
    }
    function kd(a, b) {
        return {
            eventTime: a,
            lane: b,
            tag: 0,
            payload: null,
            callback: null,
            next: null
        };
    }
    function md(a, b) {
        a = a.updateQueue;
        if (null !== a) {
            a = a.shared;
            var c = a.pending;
            null === c ? b.next = b : (b.next = c.next, c.next = b);
            a.pending = b;
        }
    }
    function nd(a, b) {
        var c = a.updateQueue, d = a.alternate;
        if (null !== d && (d = d.updateQueue, c === d)) {
            var e = null, f = null;
            c = c.firstBaseUpdate;
            if (null !== c) {
                do {
                    var g = {
                        eventTime: c.eventTime,
                        lane: c.lane,
                        tag: c.tag,
                        payload: c.payload,
                        callback: c.callback,
                        next: null
                    };
                    null === f ? e = f = g : f = f.next = g;
                    c = c.next;
                }while (null !== c);
                null === f ? e = f = b : f = f.next = b;
            } else e = f = b;
            c = {
                baseState: d.baseState,
                firstBaseUpdate: e,
                lastBaseUpdate: f,
                shared: d.shared,
                effects: d.effects
            };
            a.updateQueue = c;
            return;
        }
        a = c.lastBaseUpdate;
        null === a ? c.firstBaseUpdate = b : a.next = b;
        c.lastBaseUpdate = b;
    }
    function od(a, b, c, d) {
        var e = a.updateQueue;
        hd = !1;
        var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
        if (null !== h) {
            e.shared.pending = null;
            var k = h, l = k.next;
            k.next = null;
            null === g ? f = l : g.next = l;
            g = k;
            var n = a.alternate;
            if (null !== n) {
                n = n.updateQueue;
                var t = n.lastBaseUpdate;
                t !== g && (null === t ? n.firstBaseUpdate = l : t.next = l, n.lastBaseUpdate = k);
            }
        }
        if (null !== f) {
            t = e.baseState;
            g = 0;
            n = l = k = null;
            do {
                h = f.lane;
                var p = f.eventTime;
                if ((d & h) === h) {
                    null !== n && (n = n.next = {
                        eventTime: p,
                        lane: 0,
                        tag: f.tag,
                        payload: f.payload,
                        callback: f.callback,
                        next: null
                    });
                    a: {
                        var y = a, x = f;
                        h = b;
                        p = c;
                        switch(x.tag){
                            case 1:
                                y = x.payload;
                                if ("function" === typeof y) {
                                    t = y.call(p, t, h);
                                    break a;
                                }
                                t = y;
                                break a;
                            case 3:
                                y.flags = y.flags & -4097 | 64;
                            case 0:
                                y = x.payload;
                                h = "function" === typeof y ? y.call(p, t, h) : y;
                                if (null === h || void 0 === h) break a;
                                t = aa({}, t, h);
                                break a;
                            case 2:
                                hd = !0;
                        }
                    }
                    null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                        f
                    ] : h.push(f));
                } else p = {
                    eventTime: p,
                    lane: h,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                }, null === n ? (l = n = p, k = t) : n = n.next = p, g |= h;
                f = f.next;
                if (null === f) {
                    if (h = e.shared.pending, null === h) break;
                    else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
                }
            }while (1);
            null === n && (k = t);
            e.baseState = k;
            e.firstBaseUpdate = l;
            e.lastBaseUpdate = n;
            pd |= g;
            a.lanes = g;
            a.memoizedState = t;
        }
    }
    function qd(a, b, c) {
        a = b.effects;
        b.effects = null;
        if (null !== a) for(b = 0; b < a.length; b++){
            var d = a[b], e = d.callback;
            if (null !== e) {
                d.callback = null;
                d = c;
                if ("function" !== typeof e) throw Error(q(191, e));
                e.call(d);
            }
        }
    }
    var rd = (new ba.Component).refs;
    function sd(a, b, c, d) {
        b = a.memoizedState;
        c = c(d, b);
        c = null === c || void 0 === c ? b : aa({}, b, c);
        a.memoizedState = c;
        0 === a.lanes && (a.updateQueue.baseState = c);
    }
    var vd = {
        isMounted: function(a) {
            return (a = a._reactInternals) ? xa(a) === a : !1;
        },
        enqueueSetState: function(a, b, c) {
            a = a._reactInternals;
            var d = K(), e = td(a), f = kd(d, e);
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            md(a, f);
            ud(a, e, d);
        },
        enqueueReplaceState: function(a, b, c) {
            a = a._reactInternals;
            var d = K(), e = td(a), f = kd(d, e);
            f.tag = 1;
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            md(a, f);
            ud(a, e, d);
        },
        enqueueForceUpdate: function(a, b) {
            a = a._reactInternals;
            var c = K(), d = td(a), e = kd(c, d);
            e.tag = 2;
            void 0 !== b && null !== b && (e.callback = b);
            md(a, e);
            ud(a, d, c);
        }
    };
    function wd(a, b, c, d, e, f, g) {
        a = a.stateNode;
        return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Vc(c, d) || !Vc(e, f) : !0;
    }
    function xd(a, b, c) {
        var d = !1, e = Xb;
        var f = b.contextType;
        "object" === typeof f && null !== f ? f = J(f) : (e = E(b) ? Yb : B.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Zb(a, e) : Xb);
        b = new b(c, f);
        a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
        b.updater = vd;
        a.stateNode = b;
        b._reactInternals = a;
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
        return b;
    }
    function yd(a, b, c, d) {
        a = b.state;
        "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
        "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
        b.state !== a && vd.enqueueReplaceState(b, b.state, null);
    }
    function zd(a, b, c, d) {
        var e = a.stateNode;
        e.props = c;
        e.state = a.memoizedState;
        e.refs = rd;
        id(a);
        var f = b.contextType;
        "object" === typeof f && null !== f ? e.context = J(f) : (f = E(b) ? Yb : B.current, e.context = Zb(a, f));
        od(a, c, e, d);
        e.state = a.memoizedState;
        f = b.getDerivedStateFromProps;
        "function" === typeof f && (sd(a, b, f, c), e.state = a.memoizedState);
        "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && vd.enqueueReplaceState(e, e.state, null), od(a, c, e, d), e.state = a.memoizedState);
        "function" === typeof e.componentDidMount && (a.flags |= 4);
    }
    var Ad = Array.isArray;
    function Bd(a, b, c) {
        a = c.ref;
        if (null !== a && "function" !== typeof a && "object" !== typeof a) {
            if (c._owner) {
                c = c._owner;
                if (c) {
                    if (1 !== c.tag) throw Error(q(309));
                    var d = c.stateNode;
                }
                if (!d) throw Error(q(147, a));
                var e = "" + a;
                if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
                b = function(a) {
                    var b = d.refs;
                    b === rd && (b = d.refs = {});
                    null === a ? delete b[e] : b[e] = a;
                };
                b._stringRef = e;
                return b;
            }
            if ("string" !== typeof a) throw Error(q(284));
            if (!c._owner) throw Error(q(290, a));
        }
        return a;
    }
    function Cd(a, b) {
        if ("textarea" !== a.type) throw Error(q(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
    }
    function Dd(a) {
        function b(b, c) {
            if (a) {
                var d = b.lastEffect;
                null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
                c.nextEffect = null;
                c.flags = 8;
            }
        }
        function c(c, d) {
            if (!a) return null;
            for(; null !== d;)b(c, d), d = d.sibling;
            return null;
        }
        function d(a, b) {
            for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
            return a;
        }
        function e(a, b) {
            a = Ed(a, b);
            a.index = 0;
            a.sibling = null;
            return a;
        }
        function f(b, c, d) {
            b.index = d;
            if (!a) return c;
            d = b.alternate;
            if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
            b.flags = 2;
            return c;
        }
        function g(b) {
            a && null === b.alternate && (b.flags = 2);
            return b;
        }
        function h(a, b, c, d) {
            if (null === b || 6 !== b.tag) return b = Fd(c, a.mode, d), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function k(a, b, c, d) {
            if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Bd(a, b, c), d.return = a, d;
            d = Gd(c.type, c.key, c.props, null, a.mode, d);
            d.ref = Bd(a, b, c);
            d.return = a;
            return d;
        }
        function l(a, b, c, d) {
            if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Hd(c, a.mode, d), b.return = a, b;
            b = e(b, c.children || []);
            b.return = a;
            return b;
        }
        function n(a, b, c, d, f) {
            if (null === b || 7 !== b.tag) return b = Id(c, a.mode, d, f), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function t(a, b, c) {
            if ("string" === typeof b || "number" === typeof b) return b = Fd("" + b, a.mode, c), b.return = a, b;
            if ("object" === typeof b && null !== b) {
                switch(b.$$typeof){
                    case da:
                        return c = Gd(b.type, b.key, b.props, null, a.mode, c), c.ref = Bd(a, null, b), c.return = a, c;
                    case ea:
                        return b = Hd(b, a.mode, c), b.return = a, b;
                }
                if (Ad(b) || va(b)) return b = Id(b, a.mode, c, null), b.return = a, b;
                Cd(a, b);
            }
            return null;
        }
        function p(a, b, c, d) {
            var e = null !== b ? b.key : null;
            if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
            if ("object" === typeof c && null !== c) {
                switch(c.$$typeof){
                    case da:
                        return c.key === e ? c.type === fa ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                    case ea:
                        return c.key === e ? l(a, b, c, d) : null;
                }
                if (Ad(c) || va(c)) return null !== e ? null : n(a, b, c, d, null);
                Cd(a, c);
            }
            return null;
        }
        function y(a, b, c, d, e) {
            if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
            if ("object" === typeof d && null !== d) {
                switch(d.$$typeof){
                    case da:
                        return a = a.get(null === d.key ? c : d.key) || null, d.type === fa ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                    case ea:
                        return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                }
                if (Ad(d) || va(d)) return a = a.get(c) || null, n(b, a, d, e, null);
                Cd(b, d);
            }
            return null;
        }
        function x(e, g, h, k) {
            for(var l = null, v = null, u = g, C = g = 0, n = null; null !== u && C < h.length; C++){
                u.index > C ? (n = u, u = null) : n = u.sibling;
                var w = p(e, u, h[C], k);
                if (null === w) {
                    null === u && (u = n);
                    break;
                }
                a && u && null === w.alternate && b(e, u);
                g = f(w, g, C);
                null === v ? l = w : v.sibling = w;
                v = w;
                u = n;
            }
            if (C === h.length) return c(e, u), l;
            if (null === u) {
                for(; C < h.length; C++)u = t(e, h[C], k), null !== u && (g = f(u, g, C), null === v ? l = u : v.sibling = u, v = u);
                return l;
            }
            for(u = d(e, u); C < h.length; C++)n = y(u, e, C, h[C], k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? C : n.key), g = f(n, g, C), null === v ? l = n : v.sibling = n, v = n);
            a && u.forEach(function(a) {
                return b(e, a);
            });
            return l;
        }
        function Y(e, g, h, k) {
            var l = va(h);
            if ("function" !== typeof l) throw Error(q(150));
            h = l.call(h);
            if (null == h) throw Error(q(151));
            for(var u = l = null, v = g, n = g = 0, C = null, w = h.next(); null !== v && !w.done; n++, w = h.next()){
                v.index > n ? (C = v, v = null) : C = v.sibling;
                var x = p(e, v, w.value, k);
                if (null === x) {
                    null === v && (v = C);
                    break;
                }
                a && v && null === x.alternate && b(e, v);
                g = f(x, g, n);
                null === u ? l = x : u.sibling = x;
                u = x;
                v = C;
            }
            if (w.done) return c(e, v), l;
            if (null === v) {
                for(; !w.done; n++, w = h.next())w = t(e, w.value, k), null !== w && (g = f(w, g, n), null === u ? l = w : u.sibling = w, u = w);
                return l;
            }
            for(v = d(e, v); !w.done; n++, w = h.next())w = y(v, e, n, w.value, k), null !== w && (a && null !== w.alternate && v.delete(null === w.key ? n : w.key), g = f(w, g, n), null === u ? l = w : u.sibling = w, u = w);
            a && v.forEach(function(a) {
                return b(e, a);
            });
            return l;
        }
        return function(a, d, f, h) {
            var k = "object" === typeof f && null !== f && f.type === fa && null === f.key;
            k && (f = f.props.children);
            var l = "object" === typeof f && null !== f;
            if (l) switch(f.$$typeof){
                case da:
                    a: {
                        l = f.key;
                        for(k = d; null !== k;){
                            if (k.key === l) {
                                switch(k.tag){
                                    case 7:
                                        if (f.type === fa) {
                                            c(a, k.sibling);
                                            d = e(k, f.props.children);
                                            d.return = a;
                                            a = d;
                                            break a;
                                        }
                                        break;
                                    default:
                                        if (k.elementType === f.type) {
                                            c(a, k.sibling);
                                            d = e(k, f.props);
                                            d.ref = Bd(a, k, f);
                                            d.return = a;
                                            a = d;
                                            break a;
                                        }
                                }
                                c(a, k);
                                break;
                            } else b(a, k);
                            k = k.sibling;
                        }
                        f.type === fa ? (d = Id(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Gd(f.type, f.key, f.props, null, a.mode, h), h.ref = Bd(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case ea:
                    a: {
                        for(k = f.key; null !== d;){
                            if (d.key === k) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Hd(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
            }
            if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Fd(f, a.mode, h), d.return = a, a = d), g(a);
            if (Ad(f)) return x(a, d, f, h);
            if (va(f)) return Y(a, d, f, h);
            l && Cd(a, f);
            if ("undefined" === typeof f && !k) switch(a.tag){
                case 1:
                case 22:
                case 0:
                case 11:
                case 15:
                    throw Error(q(152, wa(a.type) || "Component"));
            }
            return c(a, d);
        };
    }
    var Jd = Dd(!0), Kd = Dd(!1), Ld = {}, L = Wb(Ld), Md = Wb(Ld), Nd = Wb(Ld);
    function Od(a) {
        if (a === Ld) throw Error(q(174));
        return a;
    }
    function Pd(a, b) {
        A(Nd, b);
        A(Md, a);
        A(L, Ld);
        a = Ea(b);
        z(L);
        A(L, a);
    }
    function Qd() {
        z(L);
        z(Md);
        z(Nd);
    }
    function Rd(a) {
        var b = Od(Nd.current), c = Od(L.current);
        b = Fa(c, a.type, b);
        c !== b && (A(Md, a), A(L, b));
    }
    function Sd(a) {
        Md.current === a && (z(L), z(Md));
    }
    var M = Wb(0);
    function Td(a) {
        for(var b = a; null !== b;){
            if (13 === b.tag) {
                var c = b.memoizedState;
                if (null !== c && (c = c.dehydrated, null === c || Hb(c) || Ib(c))) return b;
            } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
                if (0 !== (b.flags & 64)) return b;
            } else if (null !== b.child) {
                b.child.return = b;
                b = b.child;
                continue;
            }
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
        return null;
    }
    var Ud = null, Vd = null, Wd = !1;
    function Xd(a, b) {
        var c = Yd(5, null, null, 0);
        c.elementType = "DELETED";
        c.type = "DELETED";
        c.stateNode = b;
        c.return = a;
        c.flags = 8;
        null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
    }
    function Zd(a, b) {
        switch(a.tag){
            case 5:
                return b = Fb(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;
            case 6:
                return b = Gb(b, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;
            case 13:
                return !1;
            default:
                return !1;
        }
    }
    function $d(a) {
        if (Wd) {
            var b = Vd;
            if (b) {
                var c = b;
                if (!Zd(a, b)) {
                    b = Jb(c);
                    if (!b || !Zd(a, b)) {
                        a.flags = a.flags & -1025 | 2;
                        Wd = !1;
                        Ud = a;
                        return;
                    }
                    Xd(Ud, c);
                }
                Ud = a;
                Vd = Kb(b);
            } else a.flags = a.flags & -1025 | 2, Wd = !1, Ud = a;
        }
    }
    function ae(a) {
        for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
        Ud = a;
    }
    function be(a) {
        if (!Va || a !== Ud) return !1;
        if (!Wd) return ae(a), Wd = !0, !1;
        var b = a.type;
        if (5 !== a.tag || "head" !== b && "body" !== b && !Ma(b, a.memoizedProps)) for(b = Vd; b;)Xd(a, b), b = Jb(b);
        ae(a);
        if (13 === a.tag) {
            if (!Va) throw Error(q(316));
            a = a.memoizedState;
            a = null !== a ? a.dehydrated : null;
            if (!a) throw Error(q(317));
            Vd = Nb(a);
        } else Vd = Ud ? Jb(a.stateNode) : null;
        return !0;
    }
    function ce() {
        Va && (Vd = Ud = null, Wd = !1);
    }
    var de = [];
    function ee() {
        for(var a = 0; a < de.length; a++){
            var b = de[a];
            Sa ? b._workInProgressVersionPrimary = null : b._workInProgressVersionSecondary = null;
        }
        de.length = 0;
    }
    var fe = ca.ReactCurrentDispatcher, ge = ca.ReactCurrentBatchConfig, he = 0, N = null, O = null, P = null, ie = !1, je = !1;
    function Q() {
        throw Error(q(321));
    }
    function ke(a, b) {
        if (null === b) return !1;
        for(var c = 0; c < b.length && c < a.length; c++)if (!I(a[c], b[c])) return !1;
        return !0;
    }
    function le(a, b, c, d, e, f) {
        he = f;
        N = b;
        b.memoizedState = null;
        b.updateQueue = null;
        b.lanes = 0;
        fe.current = null === a || null === a.memoizedState ? me : ne;
        a = c(d, e);
        if (je) {
            f = 0;
            do {
                je = !1;
                if (!(25 > f)) throw Error(q(301));
                f += 1;
                P = O = null;
                b.updateQueue = null;
                fe.current = oe;
                a = c(d, e);
            }while (je);
        }
        fe.current = pe;
        b = null !== O && null !== O.next;
        he = 0;
        P = O = N = null;
        ie = !1;
        if (b) throw Error(q(300));
        return a;
    }
    function qe() {
        var a = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
        return P;
    }
    function re() {
        if (null === O) {
            var a = N.alternate;
            a = null !== a ? a.memoizedState : null;
        } else a = O.next;
        var b = null === P ? N.memoizedState : P.next;
        if (null !== b) P = b, O = a;
        else {
            if (null === a) throw Error(q(310));
            O = a;
            a = {
                memoizedState: O.memoizedState,
                baseState: O.baseState,
                baseQueue: O.baseQueue,
                queue: O.queue,
                next: null
            };
            null === P ? N.memoizedState = P = a : P = P.next = a;
        }
        return P;
    }
    function se(a, b) {
        return "function" === typeof b ? b(a) : b;
    }
    function te(a) {
        var b = re(), c = b.queue;
        if (null === c) throw Error(q(311));
        c.lastRenderedReducer = a;
        var d = O, e = d.baseQueue, f = c.pending;
        if (null !== f) {
            if (null !== e) {
                var g = e.next;
                e.next = f.next;
                f.next = g;
            }
            d.baseQueue = e = f;
            c.pending = null;
        }
        if (null !== e) {
            e = e.next;
            d = d.baseState;
            var h = g = f = null, k = e;
            do {
                var l = k.lane;
                if ((he & l) === l) null !== h && (h = h.next = {
                    lane: 0,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
                else {
                    var n = {
                        lane: l,
                        action: k.action,
                        eagerReducer: k.eagerReducer,
                        eagerState: k.eagerState,
                        next: null
                    };
                    null === h ? (g = h = n, f = d) : h = h.next = n;
                    N.lanes |= l;
                    pd |= l;
                }
                k = k.next;
            }while (null !== k && k !== e);
            null === h ? f = d : h.next = g;
            I(d, b.memoizedState) || (gd = !0);
            b.memoizedState = d;
            b.baseState = f;
            b.baseQueue = h;
            c.lastRenderedState = d;
        }
        return [
            b.memoizedState,
            c.dispatch
        ];
    }
    function ue(a) {
        var b = re(), c = b.queue;
        if (null === c) throw Error(q(311));
        c.lastRenderedReducer = a;
        var d = c.dispatch, e = c.pending, f = b.memoizedState;
        if (null !== e) {
            c.pending = null;
            var g = e = e.next;
            do f = a(f, g.action), g = g.next;
            while (g !== e);
            I(f, b.memoizedState) || (gd = !0);
            b.memoizedState = f;
            null === b.baseQueue && (b.baseState = f);
            c.lastRenderedState = f;
        }
        return [
            f,
            d
        ];
    }
    function ve(a, b, c) {
        var d = b._getVersion;
        d = d(b._source);
        var e = Sa ? b._workInProgressVersionPrimary : b._workInProgressVersionSecondary;
        if (null !== e) a = e === d;
        else if (a = a.mutableReadLanes, a = (he & a) === a) Sa ? b._workInProgressVersionPrimary = d : b._workInProgressVersionSecondary = d, de.push(b);
        if (a) return c(b._source);
        de.push(b);
        throw Error(q(350));
    }
    function we(a, b, c, d) {
        var e = R;
        if (null === e) throw Error(q(349));
        var f = b._getVersion, g = f(b._source), h = fe.current, k = h.useState(function() {
            return ve(e, b, c);
        }), l = k[1], n = k[0];
        k = P;
        var t = a.memoizedState, p = t.refs, y = p.getSnapshot, x = t.source;
        t = t.subscribe;
        var Y = N;
        a.memoizedState = {
            refs: p,
            source: b,
            subscribe: d
        };
        h.useEffect(function() {
            p.getSnapshot = c;
            p.setSnapshot = l;
            var a = f(b._source);
            if (!I(g, a)) {
                a = c(b._source);
                I(n, a) || (l(a), a = td(Y), e.mutableReadLanes |= a & e.pendingLanes);
                a = e.mutableReadLanes;
                e.entangledLanes |= a;
                for(var d = e.entanglements, h = a; 0 < h;){
                    var k = 31 - mc(h), t = 1 << k;
                    d[k] |= a;
                    h &= ~t;
                }
            }
        }, [
            c,
            b,
            d
        ]);
        h.useEffect(function() {
            return d(b._source, function() {
                var a = p.getSnapshot, c = p.setSnapshot;
                try {
                    c(a(b._source));
                    var d = td(Y);
                    e.mutableReadLanes |= d & e.pendingLanes;
                } catch (Oa) {
                    c(function() {
                        throw Oa;
                    });
                }
            });
        }, [
            b,
            d
        ]);
        I(y, c) && I(x, b) && I(t, d) || (a = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: se,
            lastRenderedState: n
        }, a.dispatch = l = xe.bind(null, N, a), k.queue = a, k.baseQueue = null, n = ve(e, b, c), k.memoizedState = k.baseState = n);
        return n;
    }
    function ye(a, b, c) {
        var d = re();
        return we(d, a, b, c);
    }
    function ze(a) {
        var b = qe();
        "function" === typeof a && (a = a());
        b.memoizedState = b.baseState = a;
        a = b.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: se,
            lastRenderedState: a
        };
        a = a.dispatch = xe.bind(null, N, a);
        return [
            b.memoizedState,
            a
        ];
    }
    function Ae(a, b, c, d) {
        a = {
            tag: a,
            create: b,
            destroy: c,
            deps: d,
            next: null
        };
        b = N.updateQueue;
        null === b ? (b = {
            lastEffect: null
        }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
        return a;
    }
    function Be(a) {
        var b = qe();
        a = {
            current: a
        };
        return b.memoizedState = a;
    }
    function Ce() {
        return re().memoizedState;
    }
    function De(a, b, c, d) {
        var e = qe();
        N.flags |= a;
        e.memoizedState = Ae(1 | b, c, void 0, void 0 === d ? null : d);
    }
    function Ee(a, b, c, d) {
        var e = re();
        d = void 0 === d ? null : d;
        var f = void 0;
        if (null !== O) {
            var g = O.memoizedState;
            f = g.destroy;
            if (null !== d && ke(d, g.deps)) {
                Ae(b, c, f, d);
                return;
            }
        }
        N.flags |= a;
        e.memoizedState = Ae(1 | b, c, f, d);
    }
    function Fe(a, b) {
        return De(516, 4, a, b);
    }
    function Ge(a, b) {
        return Ee(516, 4, a, b);
    }
    function He(a, b) {
        return Ee(4, 2, a, b);
    }
    function Ie(a, b) {
        if ("function" === typeof b) return a = a(), b(a), function() {
            b(null);
        };
        if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
            b.current = null;
        };
    }
    function Je(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ee(4, 2, Ie.bind(null, b, a), c);
    }
    function Ke() {}
    function Le(a, b) {
        var c = re();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && ke(b, d[1])) return d[0];
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function Me(a, b) {
        var c = re();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && ke(b, d[1])) return d[0];
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function Ne(a, b) {
        var c = Nc();
        Pc(98 > c ? 98 : c, function() {
            a(!0);
        });
        Pc(97 < c ? 97 : c, function() {
            var c = ge.transition;
            ge.transition = 1;
            try {
                a(!1), b();
            } finally{
                ge.transition = c;
            }
        });
    }
    function xe(a, b, c) {
        var d = K(), e = td(a), f = {
            lane: e,
            action: c,
            eagerReducer: null,
            eagerState: null,
            next: null
        }, g = b.pending;
        null === g ? f.next = f : (f.next = g.next, g.next = f);
        b.pending = f;
        g = a.alternate;
        if (a === N || null !== g && g === N) je = ie = !0;
        else {
            if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
                var h = b.lastRenderedState, k = g(h, c);
                f.eagerReducer = g;
                f.eagerState = k;
                if (I(k, h)) return;
            } catch (l) {} finally{}
            ud(a, e, d);
        }
    }
    var pe = {
        readContext: J,
        useCallback: Q,
        useContext: Q,
        useEffect: Q,
        useImperativeHandle: Q,
        useLayoutEffect: Q,
        useMemo: Q,
        useReducer: Q,
        useRef: Q,
        useState: Q,
        useDebugValue: Q,
        useDeferredValue: Q,
        useTransition: Q,
        useMutableSource: Q,
        useOpaqueIdentifier: Q,
        unstable_isNewReconciler: !1
    }, me = {
        readContext: J,
        useCallback: function(a, b) {
            qe().memoizedState = [
                a,
                void 0 === b ? null : b
            ];
            return a;
        },
        useContext: J,
        useEffect: Fe,
        useImperativeHandle: function(a, b, c) {
            c = null !== c && void 0 !== c ? c.concat([
                a
            ]) : null;
            return De(4, 2, Ie.bind(null, b, a), c);
        },
        useLayoutEffect: function(a, b) {
            return De(4, 2, a, b);
        },
        useMemo: function(a, b) {
            var c = qe();
            b = void 0 === b ? null : b;
            a = a();
            c.memoizedState = [
                a,
                b
            ];
            return a;
        },
        useReducer: function(a, b, c) {
            var d = qe();
            b = void 0 !== c ? c(b) : b;
            d.memoizedState = d.baseState = b;
            a = d.queue = {
                pending: null,
                dispatch: null,
                lastRenderedReducer: a,
                lastRenderedState: b
            };
            a = a.dispatch = xe.bind(null, N, a);
            return [
                d.memoizedState,
                a
            ];
        },
        useRef: Be,
        useState: ze,
        useDebugValue: Ke,
        useDeferredValue: function(a) {
            var b = ze(a), c = b[0], d = b[1];
            Fe(function() {
                var b = ge.transition;
                ge.transition = 1;
                try {
                    d(a);
                } finally{
                    ge.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = ze(!1), b = a[0];
            a = Ne.bind(null, a[1]);
            Be(a);
            return [
                a,
                b
            ];
        },
        useMutableSource: function(a, b, c) {
            var d = qe();
            d.memoizedState = {
                refs: {
                    getSnapshot: b,
                    setSnapshot: null
                },
                source: a,
                subscribe: c
            };
            return we(d, a, b, c);
        },
        useOpaqueIdentifier: function() {
            if (Wd) {
                var a = !1, b = Xa(function() {
                    a || (a = !0, c(Ya()));
                    throw Error(q(355));
                }), c = ze(b)[1];
                0 === (N.mode & 2) && (N.flags |= 516, Ae(5, function() {
                    c(Ya());
                }, void 0, null));
                return b;
            }
            b = Ya();
            ze(b);
            return b;
        },
        unstable_isNewReconciler: !1
    }, ne = {
        readContext: J,
        useCallback: Le,
        useContext: J,
        useEffect: Ge,
        useImperativeHandle: Je,
        useLayoutEffect: He,
        useMemo: Me,
        useReducer: te,
        useRef: Ce,
        useState: function() {
            return te(se);
        },
        useDebugValue: Ke,
        useDeferredValue: function(a) {
            var b = te(se), c = b[0], d = b[1];
            Ge(function() {
                var b = ge.transition;
                ge.transition = 1;
                try {
                    d(a);
                } finally{
                    ge.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = te(se)[0];
            return [
                Ce().current,
                a
            ];
        },
        useMutableSource: ye,
        useOpaqueIdentifier: function() {
            return te(se)[0];
        },
        unstable_isNewReconciler: !1
    }, oe = {
        readContext: J,
        useCallback: Le,
        useContext: J,
        useEffect: Ge,
        useImperativeHandle: Je,
        useLayoutEffect: He,
        useMemo: Me,
        useReducer: ue,
        useRef: Ce,
        useState: function() {
            return ue(se);
        },
        useDebugValue: Ke,
        useDeferredValue: function(a) {
            var b = ue(se), c = b[0], d = b[1];
            Ge(function() {
                var b = ge.transition;
                ge.transition = 1;
                try {
                    d(a);
                } finally{
                    ge.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = ue(se)[0];
            return [
                Ce().current,
                a
            ];
        },
        useMutableSource: ye,
        useOpaqueIdentifier: function() {
            return ue(se)[0];
        },
        unstable_isNewReconciler: !1
    }, Oe = ca.ReactCurrentOwner, gd = !1;
    function S(a, b, c, d) {
        b.child = null === a ? Kd(b, null, c, d) : Jd(b, a.child, c, d);
    }
    function Pe(a, b, c, d, e) {
        c = c.render;
        var f = b.ref;
        fd(b, e);
        d = le(a, b, c, d, f, e);
        if (null !== a && !gd) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, Re(a, b, e);
        b.flags |= 1;
        S(a, b, d, e);
        return b.child;
    }
    function Se(a, b, c, d, e, f) {
        if (null === a) {
            var g = c.type;
            if ("function" === typeof g && !Te(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, Ue(a, b, g, d, e, f);
            a = Gd(c.type, null, d, b, b.mode, f);
            a.ref = b.ref;
            a.return = b;
            return b.child = a;
        }
        g = a.child;
        if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Vc, c(e, d) && a.ref === b.ref)) return Re(a, b, f);
        b.flags |= 1;
        a = Ed(g, d);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    function Ue(a, b, c, d, e, f) {
        if (null !== a && Vc(a.memoizedProps, d) && a.ref === b.ref) {
            if (gd = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (gd = !0);
            else return b.lanes = a.lanes, Re(a, b, f);
        }
        return Ve(a, b, c, d, f);
    }
    function We(a, b, c) {
        var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
        if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
            if (0 === (b.mode & 4)) b.memoizedState = {
                baseLanes: 0
            }, Xe(b, c);
            else if (0 !== (c & 1073741824)) b.memoizedState = {
                baseLanes: 0
            }, Xe(b, null !== f ? f.baseLanes : c);
            else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a
            }, Xe(b, a), null;
        } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, Xe(b, d);
        S(a, b, e, c);
        return b.child;
    }
    function Ye(a, b) {
        var c = b.ref;
        if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
    }
    function Ve(a, b, c, d, e) {
        var f = E(c) ? Yb : B.current;
        f = Zb(b, f);
        fd(b, e);
        c = le(a, b, c, d, f, e);
        if (null !== a && !gd) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, Re(a, b, e);
        b.flags |= 1;
        S(a, b, c, e);
        return b.child;
    }
    function Ze(a, b, c, d, e) {
        if (E(c)) {
            var f = !0;
            cc(b);
        } else f = !1;
        fd(b, e);
        if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), xd(b, c, d), zd(b, c, d, e), d = !0;
        else if (null === a) {
            var g = b.stateNode, h = b.memoizedProps;
            g.props = h;
            var k = g.context, l = c.contextType;
            "object" === typeof l && null !== l ? l = J(l) : (l = E(c) ? Yb : B.current, l = Zb(b, l));
            var n = c.getDerivedStateFromProps, t = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
            t || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && yd(b, g, d, l);
            hd = !1;
            var p = b.memoizedState;
            g.state = p;
            od(b, d, g, e);
            k = b.memoizedState;
            h !== d || p !== k || D.current || hd ? ("function" === typeof n && (sd(b, c, n, d), k = b.memoizedState), (h = hd || wd(b, c, h, d, p, k, l)) ? (t || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
        } else {
            g = b.stateNode;
            jd(a, b);
            h = b.memoizedProps;
            l = b.type === b.elementType ? h : Xc(b.type, h);
            g.props = l;
            t = b.pendingProps;
            p = g.context;
            k = c.contextType;
            "object" === typeof k && null !== k ? k = J(k) : (k = E(c) ? Yb : B.current, k = Zb(b, k));
            var y = c.getDerivedStateFromProps;
            (n = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== t || p !== k) && yd(b, g, d, k);
            hd = !1;
            p = b.memoizedState;
            g.state = p;
            od(b, d, g, e);
            var x = b.memoizedState;
            h !== t || p !== x || D.current || hd ? ("function" === typeof y && (sd(b, c, y, d), x = b.memoizedState), (l = hd || wd(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
        }
        return $e(a, b, c, d, f, e);
    }
    function $e(a, b, c, d, e, f) {
        Ye(a, b);
        var g = 0 !== (b.flags & 64);
        if (!d && !g) return e && dc(b, c, !1), Re(a, b, f);
        d = b.stateNode;
        Oe.current = b;
        var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
        b.flags |= 1;
        null !== a && g ? (b.child = Jd(b, a.child, null, f), b.child = Jd(b, null, h, f)) : S(a, b, h, f);
        b.memoizedState = d.state;
        e && dc(b, c, !0);
        return b.child;
    }
    function af(a) {
        var b = a.stateNode;
        b.pendingContext ? ac(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ac(a, b.context, !1);
        Pd(a, b.containerInfo);
    }
    var bf = {
        dehydrated: null,
        retryLane: 0
    };
    function cf(a, b, c) {
        var d = b.pendingProps, e = M.current, f = !1, g;
        (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
        g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
        A(M, e & 1);
        if (null === a) {
            void 0 !== d.fallback && $d(b);
            a = d.children;
            e = d.fallback;
            if (f) return a = df(b, a, e, c), b.child.memoizedState = {
                baseLanes: c
            }, b.memoizedState = bf, a;
            if ("number" === typeof d.unstable_expectedLoadTime) return a = df(b, a, e, c), b.child.memoizedState = {
                baseLanes: c
            }, b.memoizedState = bf, b.lanes = 33554432, a;
            c = ef({
                mode: "visible",
                children: a
            }, b.mode, c, null);
            c.return = b;
            return b.child = c;
        }
        if (null !== a.memoizedState) {
            if (f) return d = ff(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
                baseLanes: c
            } : {
                baseLanes: e.baseLanes | c
            }, f.childLanes = a.childLanes & ~c, b.memoizedState = bf, d;
            c = gf(a, b, d.children, c);
            b.memoizedState = null;
            return c;
        }
        if (f) return d = ff(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = bf, d;
        c = gf(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    function df(a, b, c, d) {
        var e = a.mode, f = a.child;
        b = {
            mode: "hidden",
            children: b
        };
        0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = ef(b, e, 0, null);
        c = Id(c, e, d, null);
        f.return = a;
        c.return = a;
        f.sibling = c;
        a.child = f;
        return c;
    }
    function gf(a, b, c, d) {
        var e = a.child;
        a = e.sibling;
        c = Ed(e, {
            mode: "visible",
            children: c
        });
        0 === (b.mode & 2) && (c.lanes = d);
        c.return = b;
        c.sibling = null;
        null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
        return b.child = c;
    }
    function ff(a, b, c, d, e) {
        var f = b.mode, g = a.child;
        a = g.sibling;
        var h = {
            mode: "hidden",
            children: c
        };
        0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Ed(g, h);
        null !== a ? d = Ed(a, d) : (d = Id(d, f, e, null), d.flags |= 2);
        d.return = b;
        c.return = b;
        c.sibling = d;
        b.child = c;
        return d;
    }
    function hf(a, b) {
        a.lanes |= b;
        var c = a.alternate;
        null !== c && (c.lanes |= b);
        ed(a.return, b);
    }
    function jf(a, b, c, d, e, f) {
        var g = a.memoizedState;
        null === g ? a.memoizedState = {
            isBackwards: b,
            rendering: null,
            renderingStartTime: 0,
            last: d,
            tail: c,
            tailMode: e,
            lastEffect: f
        } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
    }
    function kf(a, b, c) {
        var d = b.pendingProps, e = d.revealOrder, f = d.tail;
        S(a, b, d.children, c);
        d = M.current;
        if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
        else {
            if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
                if (13 === a.tag) null !== a.memoizedState && hf(a, c);
                else if (19 === a.tag) hf(a, c);
                else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === b) break a;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === b) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            d &= 1;
        }
        A(M, d);
        if (0 === (b.mode & 2)) b.memoizedState = null;
        else switch(e){
            case "forwards":
                c = b.child;
                for(e = null; null !== c;)a = c.alternate, null !== a && null === Td(a) && (e = c), c = c.sibling;
                c = e;
                null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
                jf(b, !1, e, c, f, b.lastEffect);
                break;
            case "backwards":
                c = null;
                e = b.child;
                for(b.child = null; null !== e;){
                    a = e.alternate;
                    if (null !== a && null === Td(a)) {
                        b.child = e;
                        break;
                    }
                    a = e.sibling;
                    e.sibling = c;
                    c = e;
                    e = a;
                }
                jf(b, !0, c, null, f, b.lastEffect);
                break;
            case "together":
                jf(b, !1, null, null, void 0, b.lastEffect);
                break;
            default:
                b.memoizedState = null;
        }
        return b.child;
    }
    function Re(a, b, c) {
        null !== a && (b.dependencies = a.dependencies);
        pd |= b.lanes;
        if (0 !== (c & b.childLanes)) {
            if (null !== a && b.child !== a.child) throw Error(q(153));
            if (null !== b.child) {
                a = b.child;
                c = Ed(a, a.pendingProps);
                b.child = c;
                for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Ed(a, a.pendingProps), c.return = b;
                c.sibling = null;
            }
            return b.child;
        }
        return null;
    }
    function lf(a) {
        a.flags |= 4;
    }
    var mf, nf, of, pf;
    if (Ta) mf = function(a, b) {
        for(var c = b.child; null !== c;){
            if (5 === c.tag || 6 === c.tag) Ja(a, c.stateNode);
            else if (4 !== c.tag && null !== c.child) {
                c.child.return = c;
                c = c.child;
                continue;
            }
            if (c === b) break;
            for(; null === c.sibling;){
                if (null === c.return || c.return === b) return;
                c = c.return;
            }
            c.sibling.return = c.return;
            c = c.sibling;
        }
    }, nf = function() {}, of = function(a, b, c, d, e) {
        a = a.memoizedProps;
        if (a !== d) {
            var f = b.stateNode, g = Od(L.current);
            c = La(f, c, a, d, e, g);
            (b.updateQueue = c) && lf(b);
        }
    }, pf = function(a, b, c, d) {
        c !== d && lf(b);
    };
    else if (Ua) {
        mf = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Db(f, e.type, e.memoizedProps, e));
                    Ja(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Eb(f, e.memoizedProps, e)), Ja(a, f);
                else if (4 !== e.tag) {
                    if (13 === e.tag && 0 !== (e.flags & 4) && (f = null !== e.memoizedState)) {
                        var g = e.child;
                        if (null !== g && (null !== g.child && (g.child.return = g, mf(a, g, !0, f)), f = g.sibling, null !== f)) {
                            f.return = e;
                            e = f;
                            continue;
                        }
                    }
                    if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        var qf = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Db(f, e.type, e.memoizedProps, e));
                    Ab(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Eb(f, e.memoizedProps, e)), Ab(a, f);
                else if (4 !== e.tag) {
                    if (13 === e.tag && 0 !== (e.flags & 4) && (f = null !== e.memoizedState)) {
                        var g = e.child;
                        if (null !== g && (null !== g.child && (g.child.return = g, qf(a, g, !0, f)), f = g.sibling, null !== f)) {
                            f.return = e;
                            e = f;
                            continue;
                        }
                    }
                    if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        nf = function(a) {
            var b = a.stateNode;
            if (null !== a.firstEffect) {
                var c = b.containerInfo, d = zb(c);
                qf(d, a, !1, !1);
                b.pendingChildren = d;
                lf(a);
                Bb(c, d);
            }
        };
        of = function(a, b, c, d, e) {
            var f = a.stateNode, g = a.memoizedProps;
            if ((a = null === b.firstEffect) && g === d) b.stateNode = f;
            else {
                var h = b.stateNode, k = Od(L.current), l = null;
                g !== d && (l = La(h, c, g, d, e, k));
                a && null === l ? b.stateNode = f : (f = yb(f, l, c, g, d, b, a, h), Ka(f, c, d, e, k) && lf(b), b.stateNode = f, a ? lf(b) : mf(f, b, !1, !1));
            }
        };
        pf = function(a, b, c, d) {
            c !== d ? (a = Od(Nd.current), c = Od(L.current), b.stateNode = Na(d, a, c, b), lf(b)) : b.stateNode = a.stateNode;
        };
    } else nf = function() {}, of = function() {}, pf = function() {};
    function rf(a, b) {
        if (!Wd) switch(a.tailMode){
            case "hidden":
                b = a.tail;
                for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
                null === c ? a.tail = null : c.sibling = null;
                break;
            case "collapsed":
                c = a.tail;
                for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
                null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
        }
    }
    function sf(a, b, c) {
        var d = b.pendingProps;
        switch(b.tag){
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return null;
            case 1:
                return E(b.type) && $b(), null;
            case 3:
                Qd();
                z(D);
                z(B);
                ee();
                d = b.stateNode;
                d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
                if (null === a || null === a.child) be(b) ? lf(b) : d.hydrate || (b.flags |= 256);
                nf(b);
                return null;
            case 5:
                Sd(b);
                var e = Od(Nd.current);
                c = b.type;
                if (null !== a && null != b.stateNode) of(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
                else {
                    if (!d) {
                        if (null === b.stateNode) throw Error(q(166));
                        return null;
                    }
                    a = Od(L.current);
                    if (be(b)) {
                        if (!Va) throw Error(q(175));
                        a = Lb(b.stateNode, b.type, b.memoizedProps, e, a, b);
                        b.updateQueue = a;
                        null !== a && lf(b);
                    } else {
                        var f = Ia(c, d, e, a, b);
                        mf(f, b, !1, !1);
                        b.stateNode = f;
                        Ka(f, c, d, e, a) && lf(b);
                    }
                    null !== b.ref && (b.flags |= 128);
                }
                return null;
            case 6:
                if (a && null != b.stateNode) pf(a, b, a.memoizedProps, d);
                else {
                    if ("string" !== typeof d && null === b.stateNode) throw Error(q(166));
                    a = Od(Nd.current);
                    e = Od(L.current);
                    if (be(b)) {
                        if (!Va) throw Error(q(176));
                        Mb(b.stateNode, b.memoizedProps, b) && lf(b);
                    } else b.stateNode = Na(d, a, e, b);
                }
                return null;
            case 13:
                z(M);
                d = b.memoizedState;
                if (0 !== (b.flags & 64)) return b.lanes = c, b;
                d = null !== d;
                e = !1;
                null === a ? void 0 !== b.memoizedProps.fallback && be(b) : e = null !== a.memoizedState;
                if (d && !e && 0 !== (b.mode & 2)) {
                    if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) 0 === T && (T = 3);
                    else {
                        if (0 === T || 3 === T) T = 4;
                        null === R || 0 === (pd & 134217727) && 0 === (tf & 134217727) || uf(R, U);
                    }
                }
                Ua && d && (b.flags |= 4);
                Ta && (d || e) && (b.flags |= 4);
                return null;
            case 4:
                return Qd(), nf(b), null === a && ab(b.stateNode.containerInfo), null;
            case 10:
                return dd(b), null;
            case 17:
                return E(b.type) && $b(), null;
            case 19:
                z(M);
                d = b.memoizedState;
                if (null === d) return null;
                e = 0 !== (b.flags & 64);
                f = d.rendering;
                if (null === f) {
                    if (e) rf(d, !1);
                    else {
                        if (0 !== T || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                            f = Td(a);
                            if (null !== f) {
                                b.flags |= 64;
                                rf(d, !1);
                                a = f.updateQueue;
                                null !== a && (b.updateQueue = a, b.flags |= 4);
                                null === d.lastEffect && (b.firstEffect = null);
                                b.lastEffect = d.lastEffect;
                                a = c;
                                for(d = b.child; null !== d;)e = d, c = a, e.flags &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, f = e.alternate, null === f ? (e.childLanes = 0, e.lanes = c, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = f.childLanes, e.lanes = f.lanes, e.child = f.child, e.memoizedProps = f.memoizedProps, e.memoizedState = f.memoizedState, e.updateQueue = f.updateQueue, e.type = f.type, c = f.dependencies, e.dependencies = null === c ? null : {
                                    lanes: c.lanes,
                                    firstContext: c.firstContext
                                }), d = d.sibling;
                                A(M, M.current & 1 | 2);
                                return b.child;
                            }
                            a = a.sibling;
                        }
                        null !== d.tail && G() > vf && (b.flags |= 64, e = !0, rf(d, !1), b.lanes = 33554432);
                    }
                } else {
                    if (!e) {
                        if (a = Td(f), null !== a) {
                            if (b.flags |= 64, e = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), rf(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate && !Wd) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                        } else 2 * G() - d.renderingStartTime > vf && 1073741824 !== c && (b.flags |= 64, e = !0, rf(d, !1), b.lanes = 33554432);
                    }
                    d.isBackwards ? (f.sibling = b.child, b.child = f) : (a = d.last, null !== a ? a.sibling = f : b.child = f, d.last = f);
                }
                return null !== d.tail ? (a = d.tail, d.rendering = a, d.tail = a.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = G(), a.sibling = null, b = M.current, A(M, e ? b & 1 | 2 : b & 1), a) : null;
            case 23:
            case 24:
                return wf(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
        }
        throw Error(q(156, b.tag));
    }
    function xf(a) {
        switch(a.tag){
            case 1:
                E(a.type) && $b();
                var b = a.flags;
                return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
            case 3:
                Qd();
                z(D);
                z(B);
                ee();
                b = a.flags;
                if (0 !== (b & 64)) throw Error(q(285));
                a.flags = b & -4097 | 64;
                return a;
            case 5:
                return Sd(a), null;
            case 13:
                return z(M), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
            case 19:
                return z(M), null;
            case 4:
                return Qd(), null;
            case 10:
                return dd(a), null;
            case 23:
            case 24:
                return wf(), null;
            default:
                return null;
        }
    }
    function yf(a, b) {
        try {
            var c = "", d = b;
            do c += Wc(d), d = d.return;
            while (d);
            var e = c;
        } catch (f) {
            e = "\nError generating stack: " + f.message + "\n" + f.stack;
        }
        return {
            value: a,
            source: b,
            stack: e
        };
    }
    function zf(a, b) {
        try {
            console.error(b.value);
        } catch (c) {
            setTimeout(function() {
                throw c;
            });
        }
    }
    var Af = "function" === typeof WeakMap ? WeakMap : Map;
    function Bf(a, b, c) {
        c = kd(-1, c);
        c.tag = 3;
        c.payload = {
            element: null
        };
        var d = b.value;
        c.callback = function() {
            Cf || (Cf = !0, Df = d);
            zf(a, b);
        };
        return c;
    }
    function Ef(a, b, c) {
        c = kd(-1, c);
        c.tag = 3;
        var d = a.type.getDerivedStateFromError;
        if ("function" === typeof d) {
            var e = b.value;
            c.payload = function() {
                zf(a, b);
                return d(e);
            };
        }
        var f = a.stateNode;
        null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
            "function" !== typeof d && (null === Ff ? Ff = new Set([
                this
            ]) : Ff.add(this), zf(a, b));
            var c = b.stack;
            this.componentDidCatch(b.value, {
                componentStack: null !== c ? c : ""
            });
        });
        return c;
    }
    var Gf = "function" === typeof WeakSet ? WeakSet : Set;
    function Hf(a) {
        var b = a.ref;
        if (null !== b) {
            if ("function" === typeof b) try {
                b(null);
            } catch (c) {
                If(a, c);
            }
            else b.current = null;
        }
    }
    function Jf(a, b) {
        switch(b.tag){
            case 0:
            case 11:
            case 15:
            case 22:
                return;
            case 1:
                if (b.flags & 256 && null !== a) {
                    var c = a.memoizedProps, d = a.memoizedState;
                    a = b.stateNode;
                    b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : Xc(b.type, c), d);
                    a.__reactInternalSnapshotBeforeUpdate = b;
                }
                return;
            case 3:
                Ta && b.flags & 256 && xb(b.stateNode.containerInfo);
                return;
            case 5:
            case 6:
            case 4:
            case 17:
                return;
        }
        throw Error(q(163));
    }
    function Kf(a, b) {
        b = b.updateQueue;
        b = null !== b ? b.lastEffect : null;
        if (null !== b) {
            var c = b = b.next;
            do {
                if ((c.tag & a) === a) {
                    var d = c.destroy;
                    c.destroy = void 0;
                    void 0 !== d && d();
                }
                c = c.next;
            }while (c !== b);
        }
    }
    function Lf(a, b, c) {
        switch(c.tag){
            case 0:
            case 11:
            case 15:
            case 22:
                b = c.updateQueue;
                b = null !== b ? b.lastEffect : null;
                if (null !== b) {
                    a = b = b.next;
                    do {
                        if (3 === (a.tag & 3)) {
                            var d = a.create;
                            a.destroy = d();
                        }
                        a = a.next;
                    }while (a !== b);
                }
                b = c.updateQueue;
                b = null !== b ? b.lastEffect : null;
                if (null !== b) {
                    a = b = b.next;
                    do {
                        var e = a;
                        d = e.next;
                        e = e.tag;
                        0 !== (e & 4) && 0 !== (e & 1) && (Mf(c, a), Nf(c, a));
                        a = d;
                    }while (a !== b);
                }
                return;
            case 1:
                a = c.stateNode;
                c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : Xc(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
                b = c.updateQueue;
                null !== b && qd(c, b, a);
                return;
            case 3:
                b = c.updateQueue;
                if (null !== b) {
                    a = null;
                    if (null !== c.child) switch(c.child.tag){
                        case 5:
                            a = Da(c.child.stateNode);
                            break;
                        case 1:
                            a = c.child.stateNode;
                    }
                    qd(c, b, a);
                }
                return;
            case 5:
                a = c.stateNode;
                null === b && c.flags & 4 && mb(a, c.type, c.memoizedProps, c);
                return;
            case 6:
                return;
            case 4:
                return;
            case 12:
                return;
            case 13:
                Va && null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Pb(c))));
                return;
            case 19:
            case 17:
            case 20:
            case 21:
            case 23:
            case 24:
                return;
        }
        throw Error(q(163));
    }
    function Of(a, b) {
        if (Ta) for(var c = a;;){
            if (5 === c.tag) {
                var d = c.stateNode;
                b ? tb(d) : vb(c.stateNode, c.memoizedProps);
            } else if (6 === c.tag) d = c.stateNode, b ? ub(d) : wb(d, c.memoizedProps);
            else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
                c.child.return = c;
                c = c.child;
                continue;
            }
            if (c === a) break;
            for(; null === c.sibling;){
                if (null === c.return || c.return === a) return;
                c = c.return;
            }
            c.sibling.return = c.return;
            c = c.sibling;
        }
    }
    function Pf(a, b) {
        if (fc && "function" === typeof fc.onCommitFiberUnmount) try {
            fc.onCommitFiberUnmount(ec, b);
        } catch (f) {}
        switch(b.tag){
            case 0:
            case 11:
            case 14:
            case 15:
            case 22:
                a = b.updateQueue;
                if (null !== a && (a = a.lastEffect, null !== a)) {
                    var c = a = a.next;
                    do {
                        var d = c, e = d.destroy;
                        d = d.tag;
                        if (void 0 !== e) {
                            if (0 !== (d & 4)) Mf(b, c);
                            else {
                                d = b;
                                try {
                                    e();
                                } catch (f) {
                                    If(d, f);
                                }
                            }
                        }
                        c = c.next;
                    }while (c !== a);
                }
                break;
            case 1:
                Hf(b);
                a = b.stateNode;
                if ("function" === typeof a.componentWillUnmount) try {
                    a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
                } catch (f) {
                    If(b, f);
                }
                break;
            case 5:
                Hf(b);
                break;
            case 4:
                Ta ? Qf(a, b) : Ua && Ua && (b = b.stateNode.containerInfo, a = zb(b), Cb(b, a));
        }
    }
    function Rf(a, b) {
        for(var c = b;;)if (Pf(a, c), null === c.child || Ta && 4 === c.tag) {
            if (c === b) break;
            for(; null === c.sibling;){
                if (null === c.return || c.return === b) return;
                c = c.return;
            }
            c.sibling.return = c.return;
            c = c.sibling;
        } else c.child.return = c, c = c.child;
    }
    function Sf(a) {
        a.alternate = null;
        a.child = null;
        a.dependencies = null;
        a.firstEffect = null;
        a.lastEffect = null;
        a.memoizedProps = null;
        a.memoizedState = null;
        a.pendingProps = null;
        a.return = null;
        a.updateQueue = null;
    }
    function Tf(a) {
        return 5 === a.tag || 3 === a.tag || 4 === a.tag;
    }
    function Uf(a) {
        if (Ta) {
            a: {
                for(var b = a.return; null !== b;){
                    if (Tf(b)) break a;
                    b = b.return;
                }
                throw Error(q(160));
            }
            var c = b;
            b = c.stateNode;
            switch(c.tag){
                case 5:
                    var d = !1;
                    break;
                case 3:
                    b = b.containerInfo;
                    d = !0;
                    break;
                case 4:
                    b = b.containerInfo;
                    d = !0;
                    break;
                default:
                    throw Error(q(161));
            }
            c.flags & 16 && (sb(b), c.flags &= -17);
            a: b: for(c = a;;){
                for(; null === c.sibling;){
                    if (null === c.return || Tf(c.return)) {
                        c = null;
                        break a;
                    }
                    c = c.return;
                }
                c.sibling.return = c.return;
                for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
                    if (c.flags & 2) continue b;
                    if (null === c.child || 4 === c.tag) continue b;
                    else c.child.return = c, c = c.child;
                }
                if (!(c.flags & 2)) {
                    c = c.stateNode;
                    break a;
                }
            }
            d ? Vf(a, c, b) : Wf(a, c, b);
        }
    }
    function Vf(a, b, c) {
        var d = a.tag, e = 5 === d || 6 === d;
        if (e) a = e ? a.stateNode : a.stateNode.instance, b ? pb(c, a, b) : kb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Vf(a, b, c), a = a.sibling; null !== a;)Vf(a, b, c), a = a.sibling;
    }
    function Wf(a, b, c) {
        var d = a.tag, e = 5 === d || 6 === d;
        if (e) a = e ? a.stateNode : a.stateNode.instance, b ? ob(c, a, b) : jb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Wf(a, b, c), a = a.sibling; null !== a;)Wf(a, b, c), a = a.sibling;
    }
    function Qf(a, b) {
        for(var c = b, d = !1, e, f;;){
            if (!d) {
                d = c.return;
                a: for(;;){
                    if (null === d) throw Error(q(160));
                    e = d.stateNode;
                    switch(d.tag){
                        case 5:
                            f = !1;
                            break a;
                        case 3:
                            e = e.containerInfo;
                            f = !0;
                            break a;
                        case 4:
                            e = e.containerInfo;
                            f = !0;
                            break a;
                    }
                    d = d.return;
                }
                d = !0;
            }
            if (5 === c.tag || 6 === c.tag) Rf(a, c), f ? rb(e, c.stateNode) : qb(e, c.stateNode);
            else if (4 === c.tag) {
                if (null !== c.child) {
                    e = c.stateNode.containerInfo;
                    f = !0;
                    c.child.return = c;
                    c = c.child;
                    continue;
                }
            } else if (Pf(a, c), null !== c.child) {
                c.child.return = c;
                c = c.child;
                continue;
            }
            if (c === b) break;
            for(; null === c.sibling;){
                if (null === c.return || c.return === b) return;
                c = c.return;
                4 === c.tag && (d = !1);
            }
            c.sibling.return = c.return;
            c = c.sibling;
        }
    }
    function Xf(a, b) {
        if (Ta) {
            switch(b.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                case 22:
                    Kf(3, b);
                    return;
                case 1:
                    return;
                case 5:
                    var c = b.stateNode;
                    if (null != c) {
                        var d = b.memoizedProps;
                        a = null !== a ? a.memoizedProps : d;
                        var e = b.type, f = b.updateQueue;
                        b.updateQueue = null;
                        null !== f && nb(c, f, e, a, d, b);
                    }
                    return;
                case 6:
                    if (null === b.stateNode) throw Error(q(162));
                    c = b.memoizedProps;
                    lb(b.stateNode, null !== a ? a.memoizedProps : c, c);
                    return;
                case 3:
                    Va && (b = b.stateNode, b.hydrate && (b.hydrate = !1, Ob(b.containerInfo)));
                    return;
                case 12:
                    return;
                case 13:
                    Yf(b);
                    Zf(b);
                    return;
                case 19:
                    Zf(b);
                    return;
                case 17:
                    return;
                case 23:
                case 24:
                    Of(b, null !== b.memoizedState);
                    return;
            }
            throw Error(q(163));
        }
        switch(b.tag){
            case 0:
            case 11:
            case 14:
            case 15:
            case 22:
                Kf(3, b);
                return;
            case 12:
                return;
            case 13:
                Yf(b);
                Zf(b);
                return;
            case 19:
                Zf(b);
                return;
            case 3:
                Va && (c = b.stateNode, c.hydrate && (c.hydrate = !1, Ob(c.containerInfo)));
                break;
            case 23:
            case 24:
                return;
        }
        a: if (Ua) {
            switch(b.tag){
                case 1:
                case 5:
                case 6:
                case 20:
                    break a;
                case 3:
                case 4:
                    b = b.stateNode;
                    Cb(b.containerInfo, b.pendingChildren);
                    break a;
            }
            throw Error(q(163));
        }
    }
    function Yf(a) {
        null !== a.memoizedState && ($f = G(), Ta && Of(a.child, !0));
    }
    function Zf(a) {
        var b = a.updateQueue;
        if (null !== b) {
            a.updateQueue = null;
            var c = a.stateNode;
            null === c && (c = a.stateNode = new Gf);
            b.forEach(function(b) {
                var d = ag.bind(null, a, b);
                c.has(b) || (c.add(b), b.then(d, d));
            });
        }
    }
    function bg(a, b) {
        return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
    }
    var cg = 0, dg = 1, eg = 2, fg = 3, gg = 4;
    if ("function" === typeof Symbol && Symbol.for) {
        var hg = Symbol.for;
        cg = hg("selector.component");
        dg = hg("selector.has_pseudo_class");
        eg = hg("selector.role");
        fg = hg("selector.test_id");
        gg = hg("selector.text");
    }
    function ig(a) {
        var b = Wa(a);
        if (null != b) {
            if ("string" !== typeof b.memoizedProps["data-testname"]) throw Error(q(364));
            return b;
        }
        a = cb(a);
        if (null === a) throw Error(q(362));
        return a.stateNode.current;
    }
    function jg(a, b) {
        switch(b.$$typeof){
            case cg:
                if (a.type === b.value) return !0;
                break;
            case dg:
                a: {
                    b = b.value;
                    a = [
                        a,
                        0
                    ];
                    for(var c = 0; c < a.length;){
                        var d = a[c++], e = a[c++], f = b[e];
                        if (5 !== d.tag || !fb(d)) {
                            for(; null != f && jg(d, f);)e++, f = b[e];
                            if (e === b.length) {
                                b = !0;
                                break a;
                            } else for(d = d.child; null !== d;)a.push(d, e), d = d.sibling;
                        }
                    }
                    b = !1;
                }
                return b;
            case eg:
                if (5 === a.tag && gb(a.stateNode, b.value)) return !0;
                break;
            case gg:
                if (5 === a.tag || 6 === a.tag) {
                    if (a = eb(a), null !== a && 0 <= a.indexOf(b.value)) return !0;
                }
                break;
            case fg:
                if (5 === a.tag && (a = a.memoizedProps["data-testname"], "string" === typeof a && a.toLowerCase() === b.value.toLowerCase())) return !0;
                break;
            default:
                throw Error(q(365, b));
        }
        return !1;
    }
    function kg(a) {
        switch(a.$$typeof){
            case cg:
                return "<" + (wa(a.value) || "Unknown") + ">";
            case dg:
                return ":has(" + (kg(a) || "") + ")";
            case eg:
                return '[role="' + a.value + '"]';
            case gg:
                return '"' + a.value + '"';
            case fg:
                return '[data-testname="' + a.value + '"]';
            default:
                throw Error(q(365, a));
        }
    }
    function lg(a, b) {
        var c = [];
        a = [
            a,
            0
        ];
        for(var d = 0; d < a.length;){
            var e = a[d++], f = a[d++], g = b[f];
            if (5 !== e.tag || !fb(e)) {
                for(; null != g && jg(e, g);)f++, g = b[f];
                if (f === b.length) c.push(e);
                else for(e = e.child; null !== e;)a.push(e, f), e = e.sibling;
            }
        }
        return c;
    }
    function mg(a, b) {
        if (!bb) throw Error(q(363));
        a = ig(a);
        a = lg(a, b);
        b = [];
        a = Array.from(a);
        for(var c = 0; c < a.length;){
            var d = a[c++];
            if (5 === d.tag) fb(d) || b.push(d.stateNode);
            else for(d = d.child; null !== d;)a.push(d), d = d.sibling;
        }
        return b;
    }
    var ng = null;
    function og(a) {
        if (null === ng) try {
            var b = ("require" + Math.random()).slice(0, 7);
            ng = (module && module[b]).call(module, "timers").setImmediate;
        } catch (c) {
            ng = function(a) {
                var b = new MessageChannel;
                b.port1.onmessage = a;
                b.port2.postMessage(void 0);
            };
        }
        return ng(a);
    }
    var pg = Math.ceil, qg = ca.ReactCurrentDispatcher, rg = ca.ReactCurrentOwner, sg = ca.IsSomeRendererActing, V = 0, R = null, W = null, U = 0, tg = 0, ug = Wb(0), T = 0, vg = null, wg = 0, pd = 0, tf = 0, xg = 0, yg = null, $f = 0, vf = Infinity;
    function zg() {
        vf = G() + 500;
    }
    var X = null, Cf = !1, Df = null, Ff = null, Ag = !1, Bg = null, Cg = 90, Dg = [], Eg = [], Fg = null, Gg = 0, Hg = null, Ig = -1, Jg = 0, Kg = 0, Lg = null, Mg = !1;
    function K() {
        return 0 !== (V & 48) ? G() : -1 !== Ig ? Ig : Ig = G();
    }
    function td(a) {
        a = a.mode;
        if (0 === (a & 2)) return 1;
        if (0 === (a & 4)) return 99 === Nc() ? 1 : 2;
        0 === Jg && (Jg = wg);
        if (0 !== Sc.transition) {
            0 !== Kg && (Kg = null !== yg ? yg.pendingLanes : 0);
            a = Jg;
            var b = 4186112 & ~Kg;
            b &= -b;
            0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
            return b;
        }
        a = Nc();
        0 !== (V & 4) && 98 === a ? a = oc(12, Jg) : (a = jc(a), a = oc(a, Jg));
        return a;
    }
    function ud(a, b, c) {
        if (50 < Gg) throw Gg = 0, Hg = null, Error(q(185));
        a = Ng(a, b);
        if (null === a) return null;
        rc(a, b, c);
        a === R && (tf |= b, 4 === T && uf(a, U));
        var d = Nc();
        1 === b ? 0 !== (V & 8) && 0 === (V & 48) ? Og(a) : (Z(a, c), 0 === V && (zg(), H())) : (0 === (V & 4) || 98 !== d && 99 !== d || (null === Fg ? Fg = new Set([
            a
        ]) : Fg.add(a)), Z(a, c));
        yg = a;
    }
    function Ng(a, b) {
        a.lanes |= b;
        var c = a.alternate;
        null !== c && (c.lanes |= b);
        c = a;
        for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
        return 3 === c.tag ? c.stateNode : null;
    }
    function Z(a, b) {
        for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
            var h = 31 - mc(g), k = 1 << h, l = f[h];
            if (-1 === l) {
                if (0 === (k & d) || 0 !== (k & e)) {
                    l = b;
                    ic(k);
                    var n = F;
                    f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
                }
            } else l <= b && (a.expiredLanes |= k);
            g &= ~k;
        }
        d = lc(a, a === R ? U : 0);
        b = F;
        if (0 === d) null !== c && (c !== Hc && xc(c), a.callbackNode = null, a.callbackPriority = 0);
        else {
            if (null !== c) {
                if (a.callbackPriority === b) return;
                c !== Hc && xc(c);
            }
            15 === b ? (c = Og.bind(null, a), null === Jc ? (Jc = [
                c
            ], Kc = wc(Cc, Rc)) : Jc.push(c), c = Hc) : 14 === b ? c = Qc(99, Og.bind(null, a)) : (c = kc(b), c = Qc(c, Pg.bind(null, a)));
            a.callbackPriority = b;
            a.callbackNode = c;
        }
    }
    function Pg(a) {
        Ig = -1;
        Kg = Jg = 0;
        if (0 !== (V & 48)) throw Error(q(327));
        var b = a.callbackNode;
        if (Qg() && a.callbackNode !== b) return null;
        var c = lc(a, a === R ? U : 0);
        if (0 === c) return null;
        var d = c;
        var e = V;
        V |= 16;
        var f = Rg();
        if (R !== a || U !== d) zg(), Sg(a, d);
        for(;;)try {
            Tg();
            break;
        } catch (h) {
            Ug(a, h);
        }
        bd();
        qg.current = f;
        V = e;
        null !== W ? d = 0 : (R = null, U = 0, d = T);
        if (0 !== (wg & tf)) Sg(a, 0);
        else if (0 !== d) {
            2 === d && (V |= 64, a.hydrate && (a.hydrate = !1, xb(a.containerInfo)), c = nc(a), 0 !== c && (d = Vg(a, c)));
            if (1 === d) throw b = vg, Sg(a, 0), uf(a, c), Z(a, G()), b;
            a.finishedWork = a.current.alternate;
            a.finishedLanes = c;
            switch(d){
                case 0:
                case 1:
                    throw Error(q(345));
                case 2:
                    Zg(a);
                    break;
                case 3:
                    uf(a, c);
                    if ((c & 62914560) === c && (d = $f + 500 - G(), 10 < d)) {
                        if (0 !== lc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & c) !== c) {
                            K();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Pa(Zg.bind(null, a), d);
                        break;
                    }
                    Zg(a);
                    break;
                case 4:
                    uf(a, c);
                    if ((c & 4186112) === c) break;
                    d = a.eventTimes;
                    for(e = -1; 0 < c;){
                        var g = 31 - mc(c);
                        f = 1 << g;
                        g = d[g];
                        g > e && (e = g);
                        c &= ~f;
                    }
                    c = e;
                    c = G() - c;
                    c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * pg(c / 1960)) - c;
                    if (10 < c) {
                        a.timeoutHandle = Pa(Zg.bind(null, a), c);
                        break;
                    }
                    Zg(a);
                    break;
                case 5:
                    Zg(a);
                    break;
                default:
                    throw Error(q(329));
            }
        }
        Z(a, G());
        return a.callbackNode === b ? Pg.bind(null, a) : null;
    }
    function uf(a, b) {
        b &= ~xg;
        b &= ~tf;
        a.suspendedLanes |= b;
        a.pingedLanes &= ~b;
        for(a = a.expirationTimes; 0 < b;){
            var c = 31 - mc(b), d = 1 << c;
            a[c] = -1;
            b &= ~d;
        }
    }
    function Og(a) {
        if (0 !== (V & 48)) throw Error(q(327));
        Qg();
        if (a === R && 0 !== (a.expiredLanes & U)) {
            var b = U;
            var c = Vg(a, b);
            0 !== (wg & tf) && (b = lc(a, b), c = Vg(a, b));
        } else b = lc(a, 0), c = Vg(a, b);
        0 !== a.tag && 2 === c && (V |= 64, a.hydrate && (a.hydrate = !1, xb(a.containerInfo)), b = nc(a), 0 !== b && (c = Vg(a, b)));
        if (1 === c) throw c = vg, Sg(a, 0), uf(a, b), Z(a, G()), c;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = b;
        Zg(a);
        Z(a, G());
        return null;
    }
    function $g() {
        if (null !== Fg) {
            var a = Fg;
            Fg = null;
            a.forEach(function(a) {
                a.expiredLanes |= 24 & a.pendingLanes;
                Z(a, G());
            });
        }
        H();
    }
    function ah(a, b) {
        var c = V;
        V |= 1;
        try {
            return a(b);
        } finally{
            V = c, 0 === V && (zg(), H());
        }
    }
    function bh(a, b) {
        var c = V;
        if (0 !== (c & 48)) return a(b);
        V |= 1;
        try {
            if (a) return Pc(99, a.bind(null, b));
        } finally{
            V = c, H();
        }
    }
    function Xe(a, b) {
        A(ug, tg);
        tg |= b;
        wg |= b;
    }
    function wf() {
        tg = ug.current;
        z(ug);
    }
    function Sg(a, b) {
        a.finishedWork = null;
        a.finishedLanes = 0;
        var c = a.timeoutHandle;
        c !== Ra && (a.timeoutHandle = Ra, Qa(c));
        if (null !== W) for(c = W.return; null !== c;){
            var d = c;
            switch(d.tag){
                case 1:
                    d = d.type.childContextTypes;
                    null !== d && void 0 !== d && $b();
                    break;
                case 3:
                    Qd();
                    z(D);
                    z(B);
                    ee();
                    break;
                case 5:
                    Sd(d);
                    break;
                case 4:
                    Qd();
                    break;
                case 13:
                    z(M);
                    break;
                case 19:
                    z(M);
                    break;
                case 10:
                    dd(d);
                    break;
                case 23:
                case 24:
                    wf();
            }
            c = c.return;
        }
        R = a;
        W = Ed(a.current, null);
        U = tg = wg = b;
        T = 0;
        vg = null;
        xg = tf = pd = 0;
    }
    function Ug(a, b) {
        do {
            var c = W;
            try {
                bd();
                fe.current = pe;
                if (ie) {
                    for(var d = N.memoizedState; null !== d;){
                        var e = d.queue;
                        null !== e && (e.pending = null);
                        d = d.next;
                    }
                    ie = !1;
                }
                he = 0;
                P = O = N = null;
                je = !1;
                rg.current = null;
                if (null === c || null === c.return) {
                    T = 1;
                    vg = b;
                    W = null;
                    break;
                }
                a: {
                    var f = a, g = c.return, h = c, k = b;
                    b = U;
                    h.flags |= 2048;
                    h.firstEffect = h.lastEffect = null;
                    if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                        var l = k;
                        if (0 === (h.mode & 2)) {
                            var n = h.alternate;
                            n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                        }
                        var t = 0 !== (M.current & 1), p = g;
                        do {
                            var y;
                            if (y = 13 === p.tag) {
                                var x = p.memoizedState;
                                if (null !== x) y = null !== x.dehydrated ? !0 : !1;
                                else {
                                    var Y = p.memoizedProps;
                                    y = void 0 === Y.fallback ? !1 : !0 !== Y.unstable_avoidThisFallback ? !0 : t ? !1 : !0;
                                }
                            }
                            if (y) {
                                var u = p.updateQueue;
                                if (null === u) {
                                    var v = new Set;
                                    v.add(l);
                                    p.updateQueue = v;
                                } else u.add(l);
                                if (0 === (p.mode & 2)) {
                                    p.flags |= 64;
                                    h.flags |= 16384;
                                    h.flags &= -2981;
                                    if (1 === h.tag) {
                                        if (null === h.alternate) h.tag = 17;
                                        else {
                                            var C = kd(-1, 1);
                                            C.tag = 2;
                                            md(h, C);
                                        }
                                    }
                                    h.lanes |= 1;
                                    break a;
                                }
                                k = void 0;
                                h = b;
                                var Oa = f.pingCache;
                                null === Oa ? (Oa = f.pingCache = new Af, k = new Set, Oa.set(l, k)) : (k = Oa.get(l), void 0 === k && (k = new Set, Oa.set(l, k)));
                                if (!k.has(h)) {
                                    k.add(h);
                                    var Qe = ch.bind(null, f, l, h);
                                    l.then(Qe, Qe);
                                }
                                p.flags |= 4096;
                                p.lanes = b;
                                break a;
                            }
                            p = p.return;
                        }while (null !== p);
                        k = Error((wa(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                    }
                    5 !== T && (T = 2);
                    k = yf(k, h);
                    p = g;
                    do {
                        switch(p.tag){
                            case 3:
                                f = k;
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var Wg = Bf(p, f, b);
                                nd(p, Wg);
                                break a;
                            case 1:
                                f = k;
                                var Xg = p.type, ld = p.stateNode;
                                if (0 === (p.flags & 64) && ("function" === typeof Xg.getDerivedStateFromError || null !== ld && "function" === typeof ld.componentDidCatch && (null === Ff || !Ff.has(ld)))) {
                                    p.flags |= 4096;
                                    b &= -b;
                                    p.lanes |= b;
                                    var Yg = Ef(p, f, b);
                                    nd(p, Yg);
                                    break a;
                                }
                        }
                        p = p.return;
                    }while (null !== p);
                }
                dh(c);
            } catch (w) {
                b = w;
                W === c && null !== c && (W = c = c.return);
                continue;
            }
            break;
        }while (1);
    }
    function Rg() {
        var a = qg.current;
        qg.current = pe;
        return null === a ? pe : a;
    }
    function Vg(a, b) {
        var c = V;
        V |= 16;
        var d = Rg();
        R === a && U === b || Sg(a, b);
        for(;;)try {
            eh();
            break;
        } catch (e) {
            Ug(a, e);
        }
        bd();
        V = c;
        qg.current = d;
        if (null !== W) throw Error(q(261));
        R = null;
        U = 0;
        return T;
    }
    function eh() {
        for(; null !== W;)fh(W);
    }
    function Tg() {
        for(; null !== W && !yc();)fh(W);
    }
    function fh(a) {
        var b = gh(a.alternate, a, tg);
        a.memoizedProps = a.pendingProps;
        null === b ? dh(a) : W = b;
        rg.current = null;
    }
    function dh(a) {
        var b = a;
        do {
            var c = b.alternate;
            a = b.return;
            if (0 === (b.flags & 2048)) {
                c = sf(c, b, tg);
                if (null !== c) {
                    W = c;
                    return;
                }
                c = b;
                if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (tg & 1073741824) || 0 === (c.mode & 4)) {
                    for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                    c.childLanes = d;
                }
                null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
            } else {
                c = xf(b);
                if (null !== c) {
                    c.flags &= 2047;
                    W = c;
                    return;
                }
                null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
            }
            b = b.sibling;
            if (null !== b) {
                W = b;
                return;
            }
            W = b = a;
        }while (null !== b);
        0 === T && (T = 5);
    }
    function Zg(a) {
        var b = Nc();
        Pc(99, hh.bind(null, a, b));
        return null;
    }
    function hh(a, b) {
        do Qg();
        while (null !== Bg);
        if (0 !== (V & 48)) throw Error(q(327));
        var c = a.finishedWork;
        if (null === c) return null;
        a.finishedWork = null;
        a.finishedLanes = 0;
        if (c === a.current) throw Error(q(177));
        a.callbackNode = null;
        var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
        a.pendingLanes = e;
        a.suspendedLanes = 0;
        a.pingedLanes = 0;
        a.expiredLanes &= e;
        a.mutableReadLanes &= e;
        a.entangledLanes &= e;
        e = a.entanglements;
        for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
            var k = 31 - mc(f), l = 1 << k;
            e[k] = 0;
            g[k] = -1;
            h[k] = -1;
            f &= ~l;
        }
        null !== Fg && 0 === (d & 24) && Fg.has(a) && Fg.delete(a);
        a === R && (W = R = null, U = 0);
        1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
        if (null !== d) {
            e = V;
            V |= 32;
            rg.current = null;
            Lg = Ga(a.containerInfo);
            Mg = !1;
            X = d;
            do try {
                ih();
            } catch (v) {
                if (null === X) throw Error(q(330));
                If(X, v);
                X = X.nextEffect;
            }
            while (null !== X);
            Lg = null;
            X = d;
            do try {
                for(g = a; null !== X;){
                    var n = X.flags;
                    n & 16 && Ta && sb(X.stateNode);
                    if (n & 128) {
                        var t = X.alternate;
                        if (null !== t) {
                            var p = t.ref;
                            null !== p && ("function" === typeof p ? p(null) : p.current = null);
                        }
                    }
                    switch(n & 1038){
                        case 2:
                            Uf(X);
                            X.flags &= -3;
                            break;
                        case 6:
                            Uf(X);
                            X.flags &= -3;
                            Xf(X.alternate, X);
                            break;
                        case 1024:
                            X.flags &= -1025;
                            break;
                        case 1028:
                            X.flags &= -1025;
                            Xf(X.alternate, X);
                            break;
                        case 4:
                            Xf(X.alternate, X);
                            break;
                        case 8:
                            h = g;
                            f = X;
                            Ta ? Qf(h, f) : Rf(h, f);
                            var y = f.alternate;
                            Sf(f);
                            null !== y && Sf(y);
                    }
                    X = X.nextEffect;
                }
            } catch (v) {
                if (null === X) throw Error(q(330));
                If(X, v);
                X = X.nextEffect;
            }
            while (null !== X);
            Mg && $a();
            Ha(a.containerInfo);
            a.current = c;
            X = d;
            do try {
                for(n = a; null !== X;){
                    var x = X.flags;
                    x & 36 && Lf(n, X.alternate, X);
                    if (x & 128) {
                        t = void 0;
                        var Y = X.ref;
                        if (null !== Y) {
                            var u = X.stateNode;
                            switch(X.tag){
                                case 5:
                                    t = Da(u);
                                    break;
                                default:
                                    t = u;
                            }
                            "function" === typeof Y ? Y(t) : Y.current = t;
                        }
                    }
                    X = X.nextEffect;
                }
            } catch (v) {
                if (null === X) throw Error(q(330));
                If(X, v);
                X = X.nextEffect;
            }
            while (null !== X);
            X = null;
            Ic();
            V = e;
        } else a.current = c;
        if (Ag) Ag = !1, Bg = a, Cg = b;
        else for(X = d; null !== X;)b = X.nextEffect, X.nextEffect = null, X.flags & 8 && (x = X, x.sibling = null, x.stateNode = null), X = b;
        d = a.pendingLanes;
        0 === d && (Ff = null);
        1 === d ? a === Hg ? Gg++ : (Gg = 0, Hg = a) : Gg = 0;
        c = c.stateNode;
        if (fc && "function" === typeof fc.onCommitFiberRoot) try {
            fc.onCommitFiberRoot(ec, c, void 0, 64 === (c.current.flags & 64));
        } catch (v) {}
        Z(a, G());
        if (Cf) throw Cf = !1, a = Df, Df = null, a;
        if (0 !== (V & 8)) return null;
        H();
        return null;
    }
    function ih() {
        for(; null !== X;){
            var a = X.alternate;
            Mg || null === Lg || (0 !== (X.flags & 8) ? Ca(X, Lg) && (Mg = !0, Za()) : 13 === X.tag && bg(a, X) && Ca(X, Lg) && (Mg = !0, Za()));
            var b = X.flags;
            0 !== (b & 256) && Jf(a, X);
            0 === (b & 512) || Ag || (Ag = !0, Qc(97, function() {
                Qg();
                return null;
            }));
            X = X.nextEffect;
        }
    }
    function Qg() {
        if (90 !== Cg) {
            var a = 97 < Cg ? 97 : Cg;
            Cg = 90;
            return Pc(a, jh);
        }
        return !1;
    }
    function Nf(a, b) {
        Dg.push(b, a);
        Ag || (Ag = !0, Qc(97, function() {
            Qg();
            return null;
        }));
    }
    function Mf(a, b) {
        Eg.push(b, a);
        Ag || (Ag = !0, Qc(97, function() {
            Qg();
            return null;
        }));
    }
    function jh() {
        if (null === Bg) return !1;
        var a = Bg;
        Bg = null;
        if (0 !== (V & 48)) throw Error(q(331));
        var b = V;
        V |= 32;
        var c = Eg;
        Eg = [];
        for(var d = 0; d < c.length; d += 2){
            var e = c[d], f = c[d + 1], g = e.destroy;
            e.destroy = void 0;
            if ("function" === typeof g) try {
                g();
            } catch (k) {
                if (null === f) throw Error(q(330));
                If(f, k);
            }
        }
        c = Dg;
        Dg = [];
        for(d = 0; d < c.length; d += 2){
            e = c[d];
            f = c[d + 1];
            try {
                var h = e.create;
                e.destroy = h();
            } catch (k) {
                if (null === f) throw Error(q(330));
                If(f, k);
            }
        }
        for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
        V = b;
        H();
        return !0;
    }
    function kh(a, b, c) {
        b = yf(c, b);
        b = Bf(a, b, 1);
        md(a, b);
        b = K();
        a = Ng(a, 1);
        null !== a && (rc(a, 1, b), Z(a, b));
    }
    function If(a, b) {
        if (3 === a.tag) kh(a, a, b);
        else for(var c = a.return; null !== c;){
            if (3 === c.tag) {
                kh(c, a, b);
                break;
            } else if (1 === c.tag) {
                var d = c.stateNode;
                if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ff || !Ff.has(d))) {
                    a = yf(b, a);
                    var e = Ef(c, a, 1);
                    md(c, e);
                    e = K();
                    c = Ng(c, 1);
                    if (null !== c) rc(c, 1, e), Z(c, e);
                    else if ("function" === typeof d.componentDidCatch && (null === Ff || !Ff.has(d))) try {
                        d.componentDidCatch(b, a);
                    } catch (f) {}
                    break;
                }
            }
            c = c.return;
        }
    }
    function ch(a, b, c) {
        var d = a.pingCache;
        null !== d && d.delete(b);
        b = K();
        a.pingedLanes |= a.suspendedLanes & c;
        R === a && (U & c) === c && (4 === T || 3 === T && (U & 62914560) === U && 500 > G() - $f ? Sg(a, 0) : xg |= c);
        Z(a, b);
    }
    function ag(a, b) {
        var c = a.stateNode;
        null !== c && c.delete(b);
        b = 0;
        0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === Nc() ? 1 : 2 : (0 === Jg && (Jg = wg), b = pc(62914560 & ~Jg), 0 === b && (b = 4194304)));
        c = K();
        a = Ng(a, b);
        null !== a && (rc(a, b, c), Z(a, c));
    }
    var gh;
    gh = function(a, b, c) {
        var d = b.lanes;
        if (null !== a) {
            if (a.memoizedProps !== b.pendingProps || D.current) gd = !0;
            else if (0 !== (c & d)) gd = 0 !== (a.flags & 16384) ? !0 : !1;
            else {
                gd = !1;
                switch(b.tag){
                    case 3:
                        af(b);
                        ce();
                        break;
                    case 5:
                        Rd(b);
                        break;
                    case 1:
                        E(b.type) && cc(b);
                        break;
                    case 4:
                        Pd(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        cd(b, b.memoizedProps.value);
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            if (0 !== (c & b.child.childLanes)) return cf(a, b, c);
                            A(M, M.current & 1);
                            b = Re(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        A(M, M.current & 1);
                        break;
                    case 19:
                        d = 0 !== (c & b.childLanes);
                        if (0 !== (a.flags & 64)) {
                            if (d) return kf(a, b, c);
                            b.flags |= 64;
                        }
                        var e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                        A(M, M.current);
                        if (d) break;
                        else return null;
                    case 23:
                    case 24:
                        return b.lanes = 0, We(a, b, c);
                }
                return Re(a, b, c);
            }
        } else gd = !1;
        b.lanes = 0;
        switch(b.tag){
            case 2:
                d = b.type;
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                e = Zb(b, B.current);
                fd(b, c);
                e = le(null, b, d, a, e, c);
                b.flags |= 1;
                if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                    b.tag = 1;
                    b.memoizedState = null;
                    b.updateQueue = null;
                    if (E(d)) {
                        var f = !0;
                        cc(b);
                    } else f = !1;
                    b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                    id(b);
                    var g = d.getDerivedStateFromProps;
                    "function" === typeof g && sd(b, d, g, a);
                    e.updater = vd;
                    b.stateNode = e;
                    e._reactInternals = b;
                    zd(b, d, a, c);
                    b = $e(null, b, d, !0, f, c);
                } else b.tag = 0, S(null, b, e, c), b = b.child;
                return b;
            case 16:
                e = b.elementType;
                a: {
                    null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                    a = b.pendingProps;
                    f = e._init;
                    e = f(e._payload);
                    b.type = e;
                    f = b.tag = lh(e);
                    a = Xc(e, a);
                    switch(f){
                        case 0:
                            b = Ve(null, b, e, a, c);
                            break a;
                        case 1:
                            b = Ze(null, b, e, a, c);
                            break a;
                        case 11:
                            b = Pe(null, b, e, a, c);
                            break a;
                        case 14:
                            b = Se(null, b, e, Xc(e.type, a), d, c);
                            break a;
                    }
                    throw Error(q(306, e, ""));
                }
                return b;
            case 0:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Xc(d, e), Ve(a, b, d, e, c);
            case 1:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Xc(d, e), Ze(a, b, d, e, c);
            case 3:
                af(b);
                d = b.updateQueue;
                if (null === a || null === d) throw Error(q(282));
                d = b.pendingProps;
                e = b.memoizedState;
                e = null !== e ? e.element : null;
                jd(a, b);
                od(b, d, null, c);
                d = b.memoizedState.element;
                if (d === e) ce(), b = Re(a, b, c);
                else {
                    e = b.stateNode;
                    if (f = e.hydrate) Va ? (Vd = Kb(b.stateNode.containerInfo), Ud = b, f = Wd = !0) : f = !1;
                    if (f) {
                        if (Va && (a = e.mutableSourceEagerHydrationData, null != a)) for(e = 0; e < a.length; e += 2)f = a[e], g = a[e + 1], Sa ? f._workInProgressVersionPrimary = g : f._workInProgressVersionSecondary = g, de.push(f);
                        c = Kd(b, null, d, c);
                        for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                    } else S(a, b, d, c), ce();
                    b = b.child;
                }
                return b;
            case 5:
                return Rd(b), null === a && $d(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ma(d, e) ? g = null : null !== f && Ma(d, f) && (b.flags |= 16), Ye(a, b), S(a, b, g, c), b.child;
            case 6:
                return null === a && $d(b), null;
            case 13:
                return cf(a, b, c);
            case 4:
                return Pd(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Jd(b, null, d, c) : S(a, b, d, c), b.child;
            case 11:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Xc(d, e), Pe(a, b, d, e, c);
            case 7:
                return S(a, b, b.pendingProps, c), b.child;
            case 8:
                return S(a, b, b.pendingProps.children, c), b.child;
            case 12:
                return S(a, b, b.pendingProps.children, c), b.child;
            case 10:
                a: {
                    d = b.type._context;
                    e = b.pendingProps;
                    g = b.memoizedProps;
                    f = e.value;
                    cd(b, f);
                    if (null !== g) {
                        var h = g.value;
                        f = I(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0;
                        if (0 === f) {
                            if (g.children === e.children && !D.current) {
                                b = Re(a, b, c);
                                break a;
                            }
                        } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                            var k = h.dependencies;
                            if (null !== k) {
                                g = h.child;
                                for(var l = k.firstContext; null !== l;){
                                    if (l.context === d && 0 !== (l.observedBits & f)) {
                                        1 === h.tag && (l = kd(-1, c & -c), l.tag = 2, md(h, l));
                                        h.lanes |= c;
                                        l = h.alternate;
                                        null !== l && (l.lanes |= c);
                                        ed(h.return, c);
                                        k.lanes |= c;
                                        break;
                                    }
                                    l = l.next;
                                }
                            } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                            if (null !== g) g.return = h;
                            else for(g = h; null !== g;){
                                if (g === b) {
                                    g = null;
                                    break;
                                }
                                h = g.sibling;
                                if (null !== h) {
                                    h.return = g.return;
                                    g = h;
                                    break;
                                }
                                g = g.return;
                            }
                            h = g;
                        }
                    }
                    S(a, b, e.children, c);
                    b = b.child;
                }
                return b;
            case 9:
                return e = b.type, f = b.pendingProps, d = f.children, fd(b, c), e = J(e, f.unstable_observedBits), d = d(e), b.flags |= 1, S(a, b, d, c), b.child;
            case 14:
                return e = b.type, f = Xc(e, b.pendingProps), f = Xc(e.type, f), Se(a, b, e, f, d, c);
            case 15:
                return Ue(a, b, b.type, b.pendingProps, d, c);
            case 17:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Xc(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, E(d) ? (a = !0, cc(b)) : a = !1, fd(b, c), xd(b, d, e), zd(b, d, e, c), $e(null, b, d, !0, a, c);
            case 19:
                return kf(a, b, c);
            case 23:
                return We(a, b, c);
            case 24:
                return We(a, b, c);
        }
        throw Error(q(156, b.tag));
    };
    var mh = {
        current: !1
    }, nh = m.unstable_flushAllWithoutAsserting, oh = "function" === typeof nh;
    function ph() {
        if (void 0 !== nh) return nh();
        for(var a = !1; Qg();)a = !0;
        return a;
    }
    function qh(a) {
        try {
            ph(), og(function() {
                ph() ? qh(a) : a();
            });
        } catch (b) {
            a(b);
        }
    }
    var rh = 0, sh = !1;
    function th(a, b, c, d) {
        this.tag = a;
        this.key = c;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = b;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = d;
        this.flags = 0;
        this.lastEffect = this.firstEffect = this.nextEffect = null;
        this.childLanes = this.lanes = 0;
        this.alternate = null;
    }
    function Yd(a, b, c, d) {
        return new th(a, b, c, d);
    }
    function Te(a) {
        a = a.prototype;
        return !(!a || !a.isReactComponent);
    }
    function lh(a) {
        if ("function" === typeof a) return Te(a) ? 1 : 0;
        if (void 0 !== a && null !== a) {
            a = a.$$typeof;
            if (a === la) return 11;
            if (a === oa) return 14;
        }
        return 2;
    }
    function Ed(a, b) {
        var c = a.alternate;
        null === c ? (c = Yd(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
        c.childLanes = a.childLanes;
        c.lanes = a.lanes;
        c.child = a.child;
        c.memoizedProps = a.memoizedProps;
        c.memoizedState = a.memoizedState;
        c.updateQueue = a.updateQueue;
        b = a.dependencies;
        c.dependencies = null === b ? null : {
            lanes: b.lanes,
            firstContext: b.firstContext
        };
        c.sibling = a.sibling;
        c.index = a.index;
        c.ref = a.ref;
        return c;
    }
    function Gd(a, b, c, d, e, f) {
        var g = 2;
        d = a;
        if ("function" === typeof a) Te(a) && (g = 1);
        else if ("string" === typeof a) g = 5;
        else a: switch(a){
            case fa:
                return Id(c.children, e, f, b);
            case ra:
                g = 8;
                e |= 16;
                break;
            case ha:
                g = 8;
                e |= 1;
                break;
            case ia:
                return a = Yd(12, c, b, e | 8), a.elementType = ia, a.type = ia, a.lanes = f, a;
            case ma:
                return a = Yd(13, c, b, e), a.type = ma, a.elementType = ma, a.lanes = f, a;
            case na:
                return a = Yd(19, c, b, e), a.elementType = na, a.lanes = f, a;
            case sa:
                return ef(c, e, f, b);
            case ta:
                return a = Yd(24, c, b, e), a.elementType = ta, a.lanes = f, a;
            default:
                if ("object" === typeof a && null !== a) switch(a.$$typeof){
                    case ja:
                        g = 10;
                        break a;
                    case ka:
                        g = 9;
                        break a;
                    case la:
                        g = 11;
                        break a;
                    case oa:
                        g = 14;
                        break a;
                    case pa:
                        g = 16;
                        d = null;
                        break a;
                    case qa:
                        g = 22;
                        break a;
                }
                throw Error(q(130, null == a ? a : typeof a, ""));
        }
        b = Yd(g, c, b, e);
        b.elementType = a;
        b.type = d;
        b.lanes = f;
        return b;
    }
    function Id(a, b, c, d) {
        a = Yd(7, a, d, b);
        a.lanes = c;
        return a;
    }
    function ef(a, b, c, d) {
        a = Yd(23, a, d, b);
        a.elementType = sa;
        a.lanes = c;
        return a;
    }
    function Fd(a, b, c) {
        a = Yd(6, a, null, b);
        a.lanes = c;
        return a;
    }
    function Hd(a, b, c) {
        b = Yd(4, null !== a.children ? a.children : [], a.key, b);
        b.lanes = c;
        b.stateNode = {
            containerInfo: a.containerInfo,
            pendingChildren: null,
            implementation: a.implementation
        };
        return b;
    }
    function uh(a, b, c) {
        this.tag = b;
        this.containerInfo = a;
        this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
        this.timeoutHandle = Ra;
        this.pendingContext = this.context = null;
        this.hydrate = c;
        this.callbackNode = null;
        this.callbackPriority = 0;
        this.eventTimes = qc(0);
        this.expirationTimes = qc(-1);
        this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
        this.entanglements = qc(0);
        Va && (this.mutableSourceEagerHydrationData = null);
    }
    function vh(a) {
        var b = a._reactInternals;
        if (void 0 === b) {
            if ("function" === typeof a.render) throw Error(q(188));
            throw Error(q(268, Object.keys(a)));
        }
        a = Aa(b);
        return null === a ? null : a.stateNode;
    }
    function wh(a, b) {
        a = a.memoizedState;
        if (null !== a && null !== a.dehydrated) {
            var c = a.retryLane;
            a.retryLane = 0 !== c && c < b ? c : b;
        }
    }
    function xh(a, b) {
        wh(a, b);
        (a = a.alternate) && wh(a, b);
    }
    function yh(a) {
        a = Aa(a);
        return null === a ? null : a.stateNode;
    }
    function zh() {
        return null;
    }
    exports.IsThisRendererActing = mh;
    exports.act = function(a) {
        function b() {
            rh--;
            sg.current = c;
            mh.current = d;
        }
        !1 === sh && (sh = !0, console.error("act(...) is not supported in production builds of React, and might not behave as expected."));
        rh++;
        var c = sg.current, d = mh.current;
        sg.current = !0;
        mh.current = !0;
        try {
            var e = ah(a);
        } catch (f) {
            throw b(), f;
        }
        if (null !== e && "object" === typeof e && "function" === typeof e.then) return {
            then: function(a, d) {
                e.then(function() {
                    1 < rh || !0 === oh && !0 === c ? (b(), a()) : qh(function(c) {
                        b();
                        c ? d(c) : a();
                    });
                }, function(a) {
                    b();
                    d(a);
                });
            }
        };
        try {
            1 !== rh || !1 !== oh && !1 !== c || ph(), b();
        } catch (f) {
            throw b(), f;
        }
        return {
            then: function(a) {
                a();
            }
        };
    };
    exports.attemptContinuousHydration = function(a) {
        if (13 === a.tag) {
            var b = K();
            ud(a, 67108864, b);
            xh(a, 67108864);
        }
    };
    exports.attemptHydrationAtCurrentPriority = function(a) {
        if (13 === a.tag) {
            var b = K(), c = td(a);
            ud(a, c, b);
            xh(a, c);
        }
    };
    exports.attemptSynchronousHydration = function(a) {
        switch(a.tag){
            case 3:
                var b = a.stateNode;
                if (b.hydrate) {
                    var c = ic(b.pendingLanes);
                    b.expiredLanes |= c & b.pendingLanes;
                    Z(b, G());
                    0 === (V & 48) && (zg(), H());
                }
                break;
            case 13:
                var d = K();
                bh(function() {
                    return ud(a, 1, d);
                });
                xh(a, 4);
        }
    };
    exports.attemptUserBlockingHydration = function(a) {
        if (13 === a.tag) {
            var b = K();
            ud(a, 4, b);
            xh(a, 4);
        }
    };
    exports.batchedEventUpdates = function(a, b) {
        var c = V;
        V |= 2;
        try {
            return a(b);
        } finally{
            V = c, 0 === V && (zg(), H());
        }
    };
    exports.batchedUpdates = ah;
    exports.createComponentSelector = function(a) {
        return {
            $$typeof: cg,
            value: a
        };
    };
    exports.createContainer = function(a, b, c) {
        a = new uh(a, b, c);
        b = Yd(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
        a.current = b;
        b.stateNode = a;
        id(b);
        return a;
    };
    exports.createHasPsuedoClassSelector = function(a) {
        return {
            $$typeof: dg,
            value: a
        };
    };
    exports.createPortal = function(a, b, c) {
        var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        return {
            $$typeof: ea,
            key: null == d ? null : "" + d,
            children: a,
            containerInfo: b,
            implementation: c
        };
    };
    exports.createRoleSelector = function(a) {
        return {
            $$typeof: eg,
            value: a
        };
    };
    exports.createTestNameSelector = function(a) {
        return {
            $$typeof: fg,
            value: a
        };
    };
    exports.createTextSelector = function(a) {
        return {
            $$typeof: gg,
            value: a
        };
    };
    exports.deferredUpdates = function(a) {
        return Pc(97, a);
    };
    exports.discreteUpdates = function(a, b, c, d, e) {
        var f = V;
        V |= 4;
        try {
            return Pc(98, a.bind(null, b, c, d, e));
        } finally{
            V = f, 0 === V && (zg(), H());
        }
    };
    exports.findAllNodes = mg;
    exports.findBoundingRects = function(a, b) {
        if (!bb) throw Error(q(363));
        b = mg(a, b);
        a = [];
        for(var c = 0; c < b.length; c++)a.push(db(b[c]));
        for(b = a.length - 1; 0 < b; b--){
            c = a[b];
            for(var d = c.x, e = d + c.width, f = c.y, g = f + c.height, h = b - 1; 0 <= h; h--)if (b !== h) {
                var k = a[h], l = k.x, n = l + k.width, t = k.y, p = t + k.height;
                if (d >= l && f >= t && e <= n && g <= p) {
                    a.splice(b, 1);
                    break;
                } else if (!(d !== l || c.width !== k.width || p < f || t > g)) {
                    t > f && (k.height += t - f, k.y = f);
                    p < g && (k.height = g - t);
                    a.splice(b, 1);
                    break;
                } else if (!(f !== t || c.height !== k.height || n < d || l > e)) {
                    l > d && (k.width += l - d, k.x = d);
                    n < e && (k.width = e - l);
                    a.splice(b, 1);
                    break;
                }
            }
        }
        return a;
    };
    exports.findHostInstance = vh;
    exports.findHostInstanceWithNoPortals = function(a) {
        a = Ba(a);
        return null === a ? null : 20 === a.tag ? a.stateNode.instance : a.stateNode;
    };
    exports.findHostInstanceWithWarning = function(a) {
        return vh(a);
    };
    exports.flushControlled = function(a) {
        var b = V;
        V |= 1;
        try {
            Pc(99, a);
        } finally{
            V = b, 0 === V && (zg(), H());
        }
    };
    exports.flushDiscreteUpdates = function() {
        0 === (V & 49) && ($g(), Qg());
    };
    exports.flushPassiveEffects = Qg;
    exports.flushSync = bh;
    exports.focusWithin = function(a, b) {
        if (!bb) throw Error(q(363));
        a = ig(a);
        b = lg(a, b);
        b = Array.from(b);
        for(a = 0; a < b.length;){
            var c = b[a++];
            if (!fb(c)) {
                if (5 === c.tag && hb(c.stateNode)) return !0;
                for(c = c.child; null !== c;)b.push(c), c = c.sibling;
            }
        }
        return !1;
    };
    exports.getCurrentUpdateLanePriority = function() {
        return hc;
    };
    exports.getFindAllNodesFailureDescription = function(a, b) {
        if (!bb) throw Error(q(363));
        var c = 0, d = [];
        a = [
            ig(a),
            0
        ];
        for(var e = 0; e < a.length;){
            var f = a[e++], g = a[e++], h = b[g];
            if (5 !== f.tag || !fb(f)) {
                if (jg(f, h) && (d.push(kg(h)), g++, g > c && (c = g)), g < b.length) for(f = f.child; null !== f;)a.push(f, g), f = f.sibling;
            }
        }
        if (c < b.length) {
            for(a = []; c < b.length; c++)a.push(kg(b[c]));
            return "findAllNodes was able to match part of the selector:\n  " + (d.join(" > ") + "\n\nNo matching component was found for:\n  ") + a.join(" > ");
        }
        return null;
    };
    exports.getPublicRootInstance = function(a) {
        a = a.current;
        if (!a.child) return null;
        switch(a.child.tag){
            case 5:
                return Da(a.child.stateNode);
            default:
                return a.child.stateNode;
        }
    };
    exports.injectIntoDevTools = function(a) {
        a = {
            bundleType: a.bundleType,
            version: a.version,
            rendererPackageName: a.rendererPackageName,
            rendererConfig: a.rendererConfig,
            overrideHookState: null,
            overrideHookStateDeletePath: null,
            overrideHookStateRenamePath: null,
            overrideProps: null,
            overridePropsDeletePath: null,
            overridePropsRenamePath: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: ca.ReactCurrentDispatcher,
            findHostInstanceByFiber: yh,
            findFiberByHostInstance: a.findFiberByHostInstance || zh,
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null
        };
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) a = !1;
        else {
            var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
            if (!b.isDisabled && b.supportsFiber) try {
                ec = b.inject(a), fc = b;
            } catch (c) {}
            a = !0;
        }
        return a;
    };
    exports.observeVisibleRects = function(a, b, c, d) {
        if (!bb) throw Error(q(363));
        a = mg(a, b);
        var e = ib(a, c, d).disconnect;
        return {
            disconnect: function() {
                e();
            }
        };
    };
    exports.registerMutableSourceForHydration = function(a, b) {
        var c = b._getVersion;
        c = c(b._source);
        null == a.mutableSourceEagerHydrationData ? a.mutableSourceEagerHydrationData = [
            b,
            c
        ] : a.mutableSourceEagerHydrationData.push(b, c);
    };
    exports.runWithPriority = function(a, b) {
        var c = hc;
        try {
            return hc = a, b();
        } finally{
            hc = c;
        }
    };
    exports.shouldSuspend = function() {
        return !1;
    };
    exports.unbatchedUpdates = function(a, b) {
        var c = V;
        V &= -2;
        V |= 8;
        try {
            return a(b);
        } finally{
            V = c, 0 === V && (zg(), H());
        }
    };
    exports.updateContainer = function(a, b, c, d) {
        var e = b.current, f = K(), g = td(e);
        a: if (c) {
            c = c._reactInternals;
            b: {
                if (xa(c) !== c || 1 !== c.tag) throw Error(q(170));
                var h = c;
                do {
                    switch(h.tag){
                        case 3:
                            h = h.stateNode.context;
                            break b;
                        case 1:
                            if (E(h.type)) {
                                h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                                break b;
                            }
                    }
                    h = h.return;
                }while (null !== h);
                throw Error(q(171));
            }
            if (1 === c.tag) {
                var k = c.type;
                if (E(k)) {
                    c = bc(c, k, h);
                    break a;
                }
            }
            c = h;
        } else c = Xb;
        null === b.context ? b.context = c : b.pendingContext = c;
        b = kd(f, g);
        b.payload = {
            element: a
        };
        d = void 0 === d ? null : d;
        null !== d && (b.callback = d);
        md(e, b);
        ud(e, g, f);
        return g;
    };
    return exports;
};

});

var $b5997b26a6e91596$exports = {};
$parcel$extendImportMap({
    "6vguH": "md-logo.c17f4cbe.png",
    "iH9av": "glass-beach.1ddc32ca.jpg",
    "leb6W": "dogleg.143dbd86.jpg",
    "hDu9G": "somewhere-city.99d3ebc1.jpg",
    "3o4gF": "somoku-hodo.d2415a3b.jpg",
    "3Zviu": "three-cheers.eaebb867.jpg",
    "jM2pI": "implementation.7f55dea8.jpg",
    "859BQ": "crap-shit.32285363.jpg",
    "fvf69": "unhappy-refrain.3d520614.jpg",
    "hk4s8": "cutiemarks.6b094e23.jpg",
    "eu5oN": "neo-wax-bloom.f0a32ba6.jpg",
    "dY1tW": "cmiygl.b6424ce4.jpg",
    "bh1uW": "ultrapop.d2eb5712.jpg",
    "41n10": "service-worker.js"
});

var $765b458b54c3e9e8$exports = {};
'use strict';

$765b458b54c3e9e8$exports = (parcelRequire("4I5pX"));



var $9Cg25 = parcelRequire("9Cg25");
var $cc58425f8308e536$exports = {};
'use strict';
function $cc58425f8308e536$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($cc58425f8308e536$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$cc58425f8308e536$var$checkDCE();

$cc58425f8308e536$exports = (parcelRequire("cW8ks"));




var $9Cg25 = parcelRequire("9Cg25");


var $9Cg25 = parcelRequire("9Cg25");
/**
 * Based on ReactArt.js
 * Copyright (c) 2017-present Lavrenov Anton.
 * All rights reserved.
 *
 * MIT
 */ var $e310d2d3cbfa4cef$var$PI_OVER_180 = Math.PI / 180;
function $e310d2d3cbfa4cef$var$detectBrowser() {
    return typeof window !== 'undefined' && (({}).toString.call(window) === '[object Window]' || ({}).toString.call(window) === '[object global]');
}
const $e310d2d3cbfa4cef$export$442f1a04865e4790 = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof WorkerGlobalScope !== 'undefined' ? self : {};
const $e310d2d3cbfa4cef$export$b9f99057a3c7692 = {
    _global: $e310d2d3cbfa4cef$export$442f1a04865e4790,
    version: '8.4.3',
    isBrowser: $e310d2d3cbfa4cef$var$detectBrowser(),
    isUnminified: /param/.test((function(param) {}).toString()),
    dblClickWindow: 400,
    getAngle (angle) {
        return $e310d2d3cbfa4cef$export$b9f99057a3c7692.angleDeg ? angle * $e310d2d3cbfa4cef$var$PI_OVER_180 : angle;
    },
    enableTrace: false,
    pointerEventsEnabled: true,
    autoDrawEnabled: true,
    hitOnDragEnabled: false,
    capturePointerEventsEnabled: false,
    _mouseListenClick: false,
    _touchListenClick: false,
    _pointerListenClick: false,
    _mouseInDblClickWindow: false,
    _touchInDblClickWindow: false,
    _pointerInDblClickWindow: false,
    _mouseDblClickPointerId: null,
    _touchDblClickPointerId: null,
    _pointerDblClickPointerId: null,
    pixelRatio: typeof window !== 'undefined' && window.devicePixelRatio || 1,
    dragDistance: 3,
    angleDeg: true,
    showWarnings: true,
    dragButtons: [
        0,
        1
    ],
    isDragging () {
        return $e310d2d3cbfa4cef$export$b9f99057a3c7692['DD'].isDragging;
    },
    isDragReady () {
        return !!$e310d2d3cbfa4cef$export$b9f99057a3c7692['DD'].node;
    },
    releaseCanvasOnDestroy: true,
    document: $e310d2d3cbfa4cef$export$442f1a04865e4790.document,
    _injectGlobal (Konva) {
        $e310d2d3cbfa4cef$export$442f1a04865e4790.Konva = Konva;
    }
};
const $e310d2d3cbfa4cef$export$f7a70d87a5e829eb = (NodeClass)=>{
    $e310d2d3cbfa4cef$export$b9f99057a3c7692[NodeClass.prototype.getClassName()] = NodeClass;
};
$e310d2d3cbfa4cef$export$b9f99057a3c7692._injectGlobal($e310d2d3cbfa4cef$export$b9f99057a3c7692);



class $87c9acccd58fa09f$export$563a914cafbdc389 {
    constructor(m = [
        1,
        0,
        0,
        1,
        0,
        0
    ]){
        this.dirty = false;
        this.m = m && m.slice() || [
            1,
            0,
            0,
            1,
            0,
            0
        ];
    }
    reset() {
        this.m[0] = 1;
        this.m[1] = 0;
        this.m[2] = 0;
        this.m[3] = 1;
        this.m[4] = 0;
        this.m[5] = 0;
    }
    copy() {
        return new $87c9acccd58fa09f$export$563a914cafbdc389(this.m);
    }
    copyInto(tr) {
        tr.m[0] = this.m[0];
        tr.m[1] = this.m[1];
        tr.m[2] = this.m[2];
        tr.m[3] = this.m[3];
        tr.m[4] = this.m[4];
        tr.m[5] = this.m[5];
    }
    point(point) {
        var m = this.m;
        return {
            x: m[0] * point.x + m[2] * point.y + m[4],
            y: m[1] * point.x + m[3] * point.y + m[5]
        };
    }
    translate(x, y) {
        this.m[4] += this.m[0] * x + this.m[2] * y;
        this.m[5] += this.m[1] * x + this.m[3] * y;
        return this;
    }
    scale(sx, sy) {
        this.m[0] *= sx;
        this.m[1] *= sx;
        this.m[2] *= sy;
        this.m[3] *= sy;
        return this;
    }
    rotate(rad) {
        var c = Math.cos(rad);
        var s = Math.sin(rad);
        var m11 = this.m[0] * c + this.m[2] * s;
        var m12 = this.m[1] * c + this.m[3] * s;
        var m21 = this.m[0] * -s + this.m[2] * c;
        var m22 = this.m[1] * -s + this.m[3] * c;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    getTranslation() {
        return {
            x: this.m[4],
            y: this.m[5]
        };
    }
    skew(sx, sy) {
        var m11 = this.m[0] + this.m[2] * sy;
        var m12 = this.m[1] + this.m[3] * sy;
        var m21 = this.m[2] + this.m[0] * sx;
        var m22 = this.m[3] + this.m[1] * sx;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    multiply(matrix) {
        var m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
        var m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
        var m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
        var m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
        var dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
        var dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        this.m[4] = dx;
        this.m[5] = dy;
        return this;
    }
    invert() {
        var d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
        var m0 = this.m[3] * d;
        var m1 = -this.m[1] * d;
        var m2 = -this.m[2] * d;
        var m3 = this.m[0] * d;
        var m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
        var m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
        this.m[0] = m0;
        this.m[1] = m1;
        this.m[2] = m2;
        this.m[3] = m3;
        this.m[4] = m4;
        this.m[5] = m5;
        return this;
    }
    getMatrix() {
        return this.m;
    }
    decompose() {
        var a = this.m[0];
        var b = this.m[1];
        var c = this.m[2];
        var d = this.m[3];
        var e = this.m[4];
        var f = this.m[5];
        var delta = a * d - b * c;
        let result = {
            x: e,
            y: f,
            rotation: 0,
            scaleX: 0,
            scaleY: 0,
            skewX: 0,
            skewY: 0
        };
        if (a != 0 || b != 0) {
            var r = Math.sqrt(a * a + b * b);
            result.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
            result.scaleX = r;
            result.scaleY = delta / r;
            result.skewX = (a * c + b * d) / delta;
            result.skewY = 0;
        } else if (c != 0 || d != 0) {
            var s = Math.sqrt(c * c + d * d);
            result.rotation = Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
            result.scaleX = delta / s;
            result.scaleY = s;
            result.skewX = 0;
            result.skewY = (a * c + b * d) / delta;
        }
        result.rotation = $87c9acccd58fa09f$export$f8f26dd395d7e1bd._getRotation(result.rotation);
        return result;
    }
}
var $87c9acccd58fa09f$var$OBJECT_ARRAY = '[object Array]', $87c9acccd58fa09f$var$OBJECT_NUMBER = '[object Number]', $87c9acccd58fa09f$var$OBJECT_STRING = '[object String]', $87c9acccd58fa09f$var$OBJECT_BOOLEAN = '[object Boolean]', $87c9acccd58fa09f$var$PI_OVER_DEG180 = Math.PI / 180, $87c9acccd58fa09f$var$DEG180_OVER_PI = 180 / Math.PI, $87c9acccd58fa09f$var$HASH = '#', $87c9acccd58fa09f$var$EMPTY_STRING = '', $87c9acccd58fa09f$var$ZERO = '0', $87c9acccd58fa09f$var$KONVA_WARNING = 'Konva warning: ', $87c9acccd58fa09f$var$KONVA_ERROR = 'Konva error: ', $87c9acccd58fa09f$var$RGB_PAREN = 'rgb(', $87c9acccd58fa09f$var$COLORS = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        132,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        255,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        203
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        119,
        128,
        144
    ],
    slategrey: [
        119,
        128,
        144
    ],
    snow: [
        255,
        255,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    transparent: [
        255,
        255,
        255,
        0
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        5
    ]
}, $87c9acccd58fa09f$var$RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/, $87c9acccd58fa09f$var$animQueue = [];
const $87c9acccd58fa09f$var$req = typeof requestAnimationFrame !== 'undefined' && requestAnimationFrame || function(f) {
    setTimeout(f, 60);
};
const $87c9acccd58fa09f$export$f8f26dd395d7e1bd = {
    _isElement (obj) {
        return !!(obj && obj.nodeType == 1);
    },
    _isFunction (obj) {
        return !!(obj && obj.constructor && obj.call && obj.apply);
    },
    _isPlainObject (obj) {
        return !!obj && obj.constructor === Object;
    },
    _isArray (obj) {
        return Object.prototype.toString.call(obj) === $87c9acccd58fa09f$var$OBJECT_ARRAY;
    },
    _isNumber (obj) {
        return Object.prototype.toString.call(obj) === $87c9acccd58fa09f$var$OBJECT_NUMBER && !isNaN(obj) && isFinite(obj);
    },
    _isString (obj) {
        return Object.prototype.toString.call(obj) === $87c9acccd58fa09f$var$OBJECT_STRING;
    },
    _isBoolean (obj) {
        return Object.prototype.toString.call(obj) === $87c9acccd58fa09f$var$OBJECT_BOOLEAN;
    },
    isObject (val) {
        return val instanceof Object;
    },
    isValidSelector (selector) {
        if (typeof selector !== 'string') return false;
        var firstChar = selector[0];
        return firstChar === '#' || firstChar === '.' || firstChar === firstChar.toUpperCase();
    },
    _sign (number) {
        if (number === 0) return 1;
        if (number > 0) return 1;
        else return -1;
    },
    requestAnimFrame (callback) {
        $87c9acccd58fa09f$var$animQueue.push(callback);
        if ($87c9acccd58fa09f$var$animQueue.length === 1) $87c9acccd58fa09f$var$req(function() {
            const queue = $87c9acccd58fa09f$var$animQueue;
            $87c9acccd58fa09f$var$animQueue = [];
            queue.forEach(function(cb) {
                cb();
            });
        });
    },
    createCanvasElement () {
        var canvas = document.createElement('canvas');
        try {
            canvas.style = canvas.style || {};
        } catch (e) {}
        return canvas;
    },
    createImageElement () {
        return document.createElement('img');
    },
    _isInDocument (el) {
        while(el = el.parentNode){
            if (el == document) return true;
        }
        return false;
    },
    _urlToImage (url, callback) {
        var imageObj = $87c9acccd58fa09f$export$f8f26dd395d7e1bd.createImageElement();
        imageObj.onload = function() {
            callback(imageObj);
        };
        imageObj.src = url;
    },
    _rgbToHex (r, g, b) {
        return (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },
    _hexToRgb (hex) {
        hex = hex.replace($87c9acccd58fa09f$var$HASH, $87c9acccd58fa09f$var$EMPTY_STRING);
        var bigint = parseInt(hex, 16);
        return {
            r: bigint >> 16 & 255,
            g: bigint >> 8 & 255,
            b: bigint & 255
        };
    },
    getRandomColor () {
        var randColor = (Math.random() * 0xffffff << 0).toString(16);
        while(randColor.length < 6)randColor = $87c9acccd58fa09f$var$ZERO + randColor;
        return $87c9acccd58fa09f$var$HASH + randColor;
    },
    getRGB (color) {
        var rgb;
        if (color in $87c9acccd58fa09f$var$COLORS) {
            rgb = $87c9acccd58fa09f$var$COLORS[color];
            return {
                r: rgb[0],
                g: rgb[1],
                b: rgb[2]
            };
        } else if (color[0] === $87c9acccd58fa09f$var$HASH) return this._hexToRgb(color.substring(1));
        else if (color.substr(0, 4) === $87c9acccd58fa09f$var$RGB_PAREN) {
            rgb = $87c9acccd58fa09f$var$RGB_REGEX.exec(color.replace(/ /g, ''));
            return {
                r: parseInt(rgb[1], 10),
                g: parseInt(rgb[2], 10),
                b: parseInt(rgb[3], 10)
            };
        } else return {
            r: 0,
            g: 0,
            b: 0
        };
    },
    colorToRGBA (str) {
        str = str || 'black';
        return $87c9acccd58fa09f$export$f8f26dd395d7e1bd._namedColorToRBA(str) || $87c9acccd58fa09f$export$f8f26dd395d7e1bd._hex3ColorToRGBA(str) || $87c9acccd58fa09f$export$f8f26dd395d7e1bd._hex4ColorToRGBA(str) || $87c9acccd58fa09f$export$f8f26dd395d7e1bd._hex6ColorToRGBA(str) || $87c9acccd58fa09f$export$f8f26dd395d7e1bd._hex8ColorToRGBA(str) || $87c9acccd58fa09f$export$f8f26dd395d7e1bd._rgbColorToRGBA(str) || $87c9acccd58fa09f$export$f8f26dd395d7e1bd._rgbaColorToRGBA(str) || $87c9acccd58fa09f$export$f8f26dd395d7e1bd._hslColorToRGBA(str);
    },
    _namedColorToRBA (str) {
        var c = $87c9acccd58fa09f$var$COLORS[str.toLowerCase()];
        if (!c) return null;
        return {
            r: c[0],
            g: c[1],
            b: c[2],
            a: 1
        };
    },
    _rgbColorToRGBA (str) {
        if (str.indexOf('rgb(') === 0) {
            str = str.match(/rgb\(([^)]+)\)/)[1];
            var parts = str.split(/ *, */).map(Number);
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: 1
            };
        }
    },
    _rgbaColorToRGBA (str) {
        if (str.indexOf('rgba(') === 0) {
            str = str.match(/rgba\(([^)]+)\)/)[1];
            var parts = str.split(/ *, */).map((n, index)=>{
                if (n.slice(-1) === '%') return index === 3 ? parseInt(n) / 100 : parseInt(n) / 100 * 255;
                return Number(n);
            });
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: parts[3]
            };
        }
    },
    _hex8ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 9) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: parseInt(str.slice(7, 9), 16) / 0xff
        };
    },
    _hex6ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 7) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: 1
        };
    },
    _hex4ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 5) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: parseInt(str[4] + str[4], 16) / 0xff
        };
    },
    _hex3ColorToRGBA (str) {
        if (str[0] === '#' && str.length === 4) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: 1
        };
    },
    _hslColorToRGBA (str) {
        if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(str)) {
            const [_, ...hsl] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(str);
            const h = Number(hsl[0]) / 360;
            const s = Number(hsl[1]) / 100;
            const l = Number(hsl[2]) / 100;
            let t2;
            let t3;
            let val;
            if (s === 0) {
                val = l * 255;
                return {
                    r: Math.round(val),
                    g: Math.round(val),
                    b: Math.round(val),
                    a: 1
                };
            }
            if (l < 0.5) t2 = l * (1 + s);
            else t2 = l + s - l * s;
            const t1 = 2 * l - t2;
            const rgb = [
                0,
                0,
                0
            ];
            for(let i = 0; i < 3; i++){
                t3 = h + 1 / 3 * -(i - 1);
                if (t3 < 0) t3++;
                if (t3 > 1) t3--;
                if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1) val = t2;
                else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else val = t1;
                rgb[i] = val * 255;
            }
            return {
                r: Math.round(rgb[0]),
                g: Math.round(rgb[1]),
                b: Math.round(rgb[2]),
                a: 1
            };
        }
    },
    haveIntersection (r1, r2) {
        return !(r2.x > r1.x + r1.width || r2.x + r2.width < r1.x || r2.y > r1.y + r1.height || r2.y + r2.height < r1.y);
    },
    cloneObject (obj) {
        var retObj = {};
        for(var key in obj){
            if (this._isPlainObject(obj[key])) retObj[key] = this.cloneObject(obj[key]);
            else if (this._isArray(obj[key])) retObj[key] = this.cloneArray(obj[key]);
            else retObj[key] = obj[key];
        }
        return retObj;
    },
    cloneArray (arr) {
        return arr.slice(0);
    },
    degToRad (deg) {
        return deg * $87c9acccd58fa09f$var$PI_OVER_DEG180;
    },
    radToDeg (rad) {
        return rad * $87c9acccd58fa09f$var$DEG180_OVER_PI;
    },
    _degToRad (deg) {
        $87c9acccd58fa09f$export$f8f26dd395d7e1bd.warn('Util._degToRad is removed. Please use public Util.degToRad instead.');
        return $87c9acccd58fa09f$export$f8f26dd395d7e1bd.degToRad(deg);
    },
    _radToDeg (rad) {
        $87c9acccd58fa09f$export$f8f26dd395d7e1bd.warn('Util._radToDeg is removed. Please use public Util.radToDeg instead.');
        return $87c9acccd58fa09f$export$f8f26dd395d7e1bd.radToDeg(rad);
    },
    _getRotation (radians) {
        return (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).angleDeg ? $87c9acccd58fa09f$export$f8f26dd395d7e1bd.radToDeg(radians) : radians;
    },
    _capitalize (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    throw (str) {
        throw new Error($87c9acccd58fa09f$var$KONVA_ERROR + str);
    },
    error (str) {
        console.error($87c9acccd58fa09f$var$KONVA_ERROR + str);
    },
    warn (str) {
        if (!(0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).showWarnings) return;
        console.warn($87c9acccd58fa09f$var$KONVA_WARNING + str);
    },
    each (obj, func) {
        for(var key in obj)func(key, obj[key]);
    },
    _inRange (val, left, right) {
        return left <= val && val < right;
    },
    _getProjectionToSegment (x1, y1, x2, y2, x3, y3) {
        var x, y, dist;
        var pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
        if (pd2 == 0) {
            x = x1;
            y = y1;
            dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
        } else {
            var u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
            if (u < 0) {
                x = x1;
                y = y1;
                dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
            } else if (u > 1.0) {
                x = x2;
                y = y2;
                dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
            } else {
                x = x1 + u * (x2 - x1);
                y = y1 + u * (y2 - y1);
                dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
            }
        }
        return [
            x,
            y,
            dist
        ];
    },
    _getProjectionToLine (pt, line, isClosed) {
        var pc = $87c9acccd58fa09f$export$f8f26dd395d7e1bd.cloneObject(pt);
        var dist = Number.MAX_VALUE;
        line.forEach(function(p1, i) {
            if (!isClosed && i === line.length - 1) return;
            var p2 = line[(i + 1) % line.length];
            var proj = $87c9acccd58fa09f$export$f8f26dd395d7e1bd._getProjectionToSegment(p1.x, p1.y, p2.x, p2.y, pt.x, pt.y);
            var px = proj[0], py = proj[1], pdist = proj[2];
            if (pdist < dist) {
                pc.x = px;
                pc.y = py;
                dist = pdist;
            }
        });
        return pc;
    },
    _prepareArrayForTween (startArray, endArray, isClosed) {
        var n, start = [], end = [];
        if (startArray.length > endArray.length) {
            var temp = endArray;
            endArray = startArray;
            startArray = temp;
        }
        for(n = 0; n < startArray.length; n += 2)start.push({
            x: startArray[n],
            y: startArray[n + 1]
        });
        for(n = 0; n < endArray.length; n += 2)end.push({
            x: endArray[n],
            y: endArray[n + 1]
        });
        var newStart = [];
        end.forEach(function(point) {
            var pr = $87c9acccd58fa09f$export$f8f26dd395d7e1bd._getProjectionToLine(point, start, isClosed);
            newStart.push(pr.x);
            newStart.push(pr.y);
        });
        return newStart;
    },
    _prepareToStringify (obj) {
        var desc;
        obj.visitedByCircularReferenceRemoval = true;
        for(var key in obj){
            if (!(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == 'object')) continue;
            desc = Object.getOwnPropertyDescriptor(obj, key);
            if (obj[key].visitedByCircularReferenceRemoval || $87c9acccd58fa09f$export$f8f26dd395d7e1bd._isElement(obj[key])) {
                if (desc.configurable) delete obj[key];
                else return null;
            } else if ($87c9acccd58fa09f$export$f8f26dd395d7e1bd._prepareToStringify(obj[key]) === null) {
                if (desc.configurable) delete obj[key];
                else return null;
            }
        }
        delete obj.visitedByCircularReferenceRemoval;
        return obj;
    },
    _assign (target, source) {
        for(var key in source)target[key] = source[key];
        return target;
    },
    _getFirstPointerId (evt) {
        if (!evt.touches) return evt.pointerId || 999;
        else return evt.changedTouches[0].identifier;
    },
    releaseCanvas (...canvases) {
        if (!(0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).releaseCanvasOnDestroy) return;
        canvases.forEach((c)=>{
            c.width = 0;
            c.height = 0;
        });
    },
    drawRoundedRectPath (context, width, height, cornerRadius) {
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === 'number') topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.moveTo(topLeft, 0);
        context.lineTo(width - topRight, 0);
        context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
        context.lineTo(width, height - bottomRight);
        context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        context.lineTo(bottomLeft, height);
        context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        context.lineTo(0, topLeft);
        context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
    }
};






function $0e51c174430907a2$var$_formatValue(val) {
    if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isString(val)) return '"' + val + '"';
    if (Object.prototype.toString.call(val) === '[object Number]') return val;
    if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isBoolean(val)) return val;
    return Object.prototype.toString.call(val);
}
function $0e51c174430907a2$export$af51e4581c640b27(val) {
    if (val > 255) return 255;
    else if (val < 0) return 0;
    return Math.round(val);
}
function $0e51c174430907a2$export$7078afdc21938e7(val) {
    if (val > 1) return 1;
    else if (val < 0.0001) return 0.0001;
    return val;
}
function $0e51c174430907a2$export$6b1205b9fbe7de2c() {
    if ((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isNumber(val)) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn($0e51c174430907a2$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number.');
        return val;
    };
}
function $0e51c174430907a2$export$7d4ab1842c1b264b(noOfElements) {
    if ((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        let isNumber = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isNumber(val);
        let isValidArray = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isArray(val) && val.length == noOfElements;
        if (!isNumber && !isValidArray) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn($0e51c174430907a2$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or Array<number>(' + noOfElements + ')');
        return val;
    };
}
function $0e51c174430907a2$export$3b7df2720ef33404() {
    if ((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        var isNumber = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isNumber(val);
        var isAuto = val === 'auto';
        if (!(isNumber || isAuto)) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn($0e51c174430907a2$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or "auto".');
        return val;
    };
}
function $0e51c174430907a2$export$5837c5b6cc5b4d63() {
    if ((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isString(val)) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn($0e51c174430907a2$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string.');
        return val;
    };
}
function $0e51c174430907a2$export$9c72f966a828cc68() {
    if ((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const isString = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isString(val);
        const isGradient = Object.prototype.toString.call(val) === '[object CanvasGradient]' || val && val.addColorStop;
        if (!(isString || isGradient)) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn($0e51c174430907a2$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string or a native gradient.');
        return val;
    };
}
function $0e51c174430907a2$export$61d6863134de1cd() {
    if ((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isFunction(val)) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn($0e51c174430907a2$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a function.');
        return val;
    };
}
function $0e51c174430907a2$export$42b6f8f340e9a165() {
    if ((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const TypedArray = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
        if (TypedArray && val instanceof TypedArray) return val;
        if (!(0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isArray(val)) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn($0e51c174430907a2$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a array of numbers.');
        else val.forEach(function(item) {
            if (!(0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isNumber(item)) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('"' + attr + '" attribute has non numeric element ' + item + '. Make sure that all elements are numbers.');
        });
        return val;
    };
}
function $0e51c174430907a2$export$147fc8b6cd20fda1() {
    if ((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        var isBool = val === true || val === false;
        if (!isBool) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn($0e51c174430907a2$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a boolean.');
        return val;
    };
}
function $0e51c174430907a2$export$5c1978fb8431d4a1(components) {
    if ((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (val === undefined || val === null) return val;
        if (!(0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).isObject(val)) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn($0e51c174430907a2$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be an object with properties ' + components);
        return val;
    };
}


var $765dacbd3f0ba182$var$GET = 'get', $765dacbd3f0ba182$var$SET = 'set';
const $765dacbd3f0ba182$export$8354032f3852ec50 = {
    addGetterSetter (constructor, attr, def, validator, after) {
        $765dacbd3f0ba182$export$8354032f3852ec50.addGetter(constructor, attr, def);
        $765dacbd3f0ba182$export$8354032f3852ec50.addSetter(constructor, attr, validator, after);
        $765dacbd3f0ba182$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    addGetter (constructor, attr, def) {
        var method = $765dacbd3f0ba182$var$GET + (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._capitalize(attr);
        constructor.prototype[method] = constructor.prototype[method] || function() {
            var val = this.attrs[attr];
            return val === undefined ? def : val;
        };
    },
    addSetter (constructor, attr, validator, after) {
        var method = $765dacbd3f0ba182$var$SET + (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._capitalize(attr);
        if (!constructor.prototype[method]) $765dacbd3f0ba182$export$8354032f3852ec50.overWriteSetter(constructor, attr, validator, after);
    },
    overWriteSetter (constructor, attr, validator, after) {
        var method = $765dacbd3f0ba182$var$SET + (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._capitalize(attr);
        constructor.prototype[method] = function(val) {
            if (validator && val !== undefined && val !== null) val = validator.call(this, val, attr);
            this._setAttr(attr, val);
            if (after) after.call(this);
            return this;
        };
    },
    addComponentsGetterSetter (constructor, attr, components, validator, after) {
        var len = components.length, capitalize = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._capitalize, getter = $765dacbd3f0ba182$var$GET + capitalize(attr), setter = $765dacbd3f0ba182$var$SET + capitalize(attr), n, component;
        constructor.prototype[getter] = function() {
            var ret = {};
            for(n = 0; n < len; n++){
                component = components[n];
                ret[component] = this.getAttr(attr + capitalize(component));
            }
            return ret;
        };
        var basicValidator = (0, $0e51c174430907a2$export$5c1978fb8431d4a1)(components);
        constructor.prototype[setter] = function(val) {
            var oldVal = this.attrs[attr], key;
            if (validator) val = validator.call(this, val);
            if (basicValidator) basicValidator.call(this, val, attr);
            for(key in val){
                if (!val.hasOwnProperty(key)) continue;
                this._setAttr(attr + capitalize(key), val[key]);
            }
            if (!val) components.forEach((component)=>{
                this._setAttr(attr + capitalize(component), undefined);
            });
            this._fireChangeEvent(attr, oldVal, val);
            if (after) after.call(this);
            return this;
        };
        $765dacbd3f0ba182$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    addOverloadedGetterSetter (constructor, attr) {
        var capitalizedAttr = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._capitalize(attr), setter = $765dacbd3f0ba182$var$SET + capitalizedAttr, getter = $765dacbd3f0ba182$var$GET + capitalizedAttr;
        constructor.prototype[attr] = function() {
            if (arguments.length) {
                this[setter](arguments[0]);
                return this;
            }
            return this[getter]();
        };
    },
    addDeprecatedGetterSetter (constructor, attr, def, validator) {
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).error('Adding deprecated ' + attr);
        var method = $765dacbd3f0ba182$var$GET + (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._capitalize(attr);
        var message = attr + ' property is deprecated and will be removed soon. Look at Konva change log for more information.';
        constructor.prototype[method] = function() {
            (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).error(message);
            var val = this.attrs[attr];
            return val === undefined ? def : val;
        };
        $765dacbd3f0ba182$export$8354032f3852ec50.addSetter(constructor, attr, validator, function() {
            (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).error(message);
        });
        $765dacbd3f0ba182$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    backCompat (constructor, methods) {
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).each(methods, function(oldMethodName, newMethodName) {
            var method = constructor.prototype[newMethodName];
            var oldGetter = $765dacbd3f0ba182$var$GET + (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._capitalize(oldMethodName);
            var oldSetter = $765dacbd3f0ba182$var$SET + (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._capitalize(oldMethodName);
            function deprecated() {
                method.apply(this, arguments);
                (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).error('"' + oldMethodName + '" method is deprecated and will be removed soon. Use ""' + newMethodName + '" instead.');
            }
            constructor.prototype[oldMethodName] = deprecated;
            constructor.prototype[oldGetter] = deprecated;
            constructor.prototype[oldSetter] = deprecated;
        });
    },
    afterSetFilter () {
        this._filterUpToDate = false;
    }
};





function $a876609bfdb739fd$var$simplifyArray(arr) {
    var retArr = [], len = arr.length, util = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd), n, val;
    for(n = 0; n < len; n++){
        val = arr[n];
        if (util._isNumber(val)) val = Math.round(val * 1000) / 1000;
        else if (!util._isString(val)) val = val + '';
        retArr.push(val);
    }
    return retArr;
}
var $a876609bfdb739fd$var$COMMA = ',', $a876609bfdb739fd$var$OPEN_PAREN = '(', $a876609bfdb739fd$var$CLOSE_PAREN = ')', $a876609bfdb739fd$var$OPEN_PAREN_BRACKET = '([', $a876609bfdb739fd$var$CLOSE_BRACKET_PAREN = '])', $a876609bfdb739fd$var$SEMICOLON = ';', $a876609bfdb739fd$var$DOUBLE_PAREN = '()', $a876609bfdb739fd$var$EQUALS = '=', $a876609bfdb739fd$var$CONTEXT_METHODS = [
    'arc',
    'arcTo',
    'beginPath',
    'bezierCurveTo',
    'clearRect',
    'clip',
    'closePath',
    'createLinearGradient',
    'createPattern',
    'createRadialGradient',
    'drawImage',
    'ellipse',
    'fill',
    'fillText',
    'getImageData',
    'createImageData',
    'lineTo',
    'moveTo',
    'putImageData',
    'quadraticCurveTo',
    'rect',
    'restore',
    'rotate',
    'save',
    'scale',
    'setLineDash',
    'setTransform',
    'stroke',
    'strokeText',
    'transform',
    'translate'
];
var $a876609bfdb739fd$var$CONTEXT_PROPERTIES = [
    'fillStyle',
    'strokeStyle',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'lineCap',
    'lineDashOffset',
    'lineJoin',
    'lineWidth',
    'miterLimit',
    'font',
    'textAlign',
    'textBaseline',
    'globalAlpha',
    'globalCompositeOperation',
    'imageSmoothingEnabled'
];
const $a876609bfdb739fd$var$traceArrMax = 100;
class $a876609bfdb739fd$export$841858b892ce1f4c {
    constructor(canvas){
        this.canvas = canvas;
        if ((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).enableTrace) {
            this.traceArr = [];
            this._enableTrace();
        }
    }
    fillShape(shape) {
        if (shape.fillEnabled()) this._fill(shape);
    }
    _fill(shape) {}
    strokeShape(shape) {
        if (shape.hasStroke()) this._stroke(shape);
    }
    _stroke(shape) {}
    fillStrokeShape(shape) {
        if (shape.attrs.fillAfterStrokeEnabled) {
            this.strokeShape(shape);
            this.fillShape(shape);
        } else {
            this.fillShape(shape);
            this.strokeShape(shape);
        }
    }
    getTrace(relaxed, rounded) {
        var traceArr = this.traceArr, len = traceArr.length, str = '', n, trace, method, args;
        for(n = 0; n < len; n++){
            trace = traceArr[n];
            method = trace.method;
            if (method) {
                args = trace.args;
                str += method;
                if (relaxed) str += $a876609bfdb739fd$var$DOUBLE_PAREN;
                else if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isArray(args[0])) str += $a876609bfdb739fd$var$OPEN_PAREN_BRACKET + args.join($a876609bfdb739fd$var$COMMA) + $a876609bfdb739fd$var$CLOSE_BRACKET_PAREN;
                else {
                    if (rounded) args = args.map((a)=>typeof a === 'number' ? Math.floor(a) : a);
                    str += $a876609bfdb739fd$var$OPEN_PAREN + args.join($a876609bfdb739fd$var$COMMA) + $a876609bfdb739fd$var$CLOSE_PAREN;
                }
            } else {
                str += trace.property;
                if (!relaxed) str += $a876609bfdb739fd$var$EQUALS + trace.val;
            }
            str += $a876609bfdb739fd$var$SEMICOLON;
        }
        return str;
    }
    clearTrace() {
        this.traceArr = [];
    }
    _trace(str) {
        var traceArr = this.traceArr, len;
        traceArr.push(str);
        len = traceArr.length;
        if (len >= $a876609bfdb739fd$var$traceArrMax) traceArr.shift();
    }
    reset() {
        var pixelRatio = this.getCanvas().getPixelRatio();
        this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
    }
    getCanvas() {
        return this.canvas;
    }
    clear(bounds) {
        var canvas = this.getCanvas();
        if (bounds) this.clearRect(bounds.x || 0, bounds.y || 0, bounds.width || 0, bounds.height || 0);
        else this.clearRect(0, 0, canvas.getWidth() / canvas.pixelRatio, canvas.getHeight() / canvas.pixelRatio);
    }
    _applyLineCap(shape) {
        const lineCap = shape.attrs.lineCap;
        if (lineCap) this.setAttr('lineCap', lineCap);
    }
    _applyOpacity(shape) {
        var absOpacity = shape.getAbsoluteOpacity();
        if (absOpacity !== 1) this.setAttr('globalAlpha', absOpacity);
    }
    _applyLineJoin(shape) {
        const lineJoin = shape.attrs.lineJoin;
        if (lineJoin) this.setAttr('lineJoin', lineJoin);
    }
    setAttr(attr, val) {
        this._context[attr] = val;
    }
    arc(a0, a1, a2, a3, a4, a5) {
        this._context.arc(a0, a1, a2, a3, a4, a5);
    }
    arcTo(a0, a1, a2, a3, a4) {
        this._context.arcTo(a0, a1, a2, a3, a4);
    }
    beginPath() {
        this._context.beginPath();
    }
    bezierCurveTo(a0, a1, a2, a3, a4, a5) {
        this._context.bezierCurveTo(a0, a1, a2, a3, a4, a5);
    }
    clearRect(a0, a1, a2, a3) {
        this._context.clearRect(a0, a1, a2, a3);
    }
    clip() {
        this._context.clip();
    }
    closePath() {
        this._context.closePath();
    }
    createImageData(a0, a1) {
        var a = arguments;
        if (a.length === 2) return this._context.createImageData(a0, a1);
        else if (a.length === 1) return this._context.createImageData(a0);
    }
    createLinearGradient(a0, a1, a2, a3) {
        return this._context.createLinearGradient(a0, a1, a2, a3);
    }
    createPattern(a0, a1) {
        return this._context.createPattern(a0, a1);
    }
    createRadialGradient(a0, a1, a2, a3, a4, a5) {
        return this._context.createRadialGradient(a0, a1, a2, a3, a4, a5);
    }
    drawImage(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        var a = arguments, _context = this._context;
        if (a.length === 3) _context.drawImage(a0, a1, a2);
        else if (a.length === 5) _context.drawImage(a0, a1, a2, a3, a4);
        else if (a.length === 9) _context.drawImage(a0, a1, a2, a3, a4, a5, a6, a7, a8);
    }
    ellipse(a0, a1, a2, a3, a4, a5, a6, a7) {
        this._context.ellipse(a0, a1, a2, a3, a4, a5, a6, a7);
    }
    isPointInPath(x, y, path, fillRule) {
        if (path) return this._context.isPointInPath(path, x, y, fillRule);
        return this._context.isPointInPath(x, y, fillRule);
    }
    fill(path2d) {
        if (path2d) this._context.fill(path2d);
        else this._context.fill();
    }
    fillRect(x, y, width, height) {
        this._context.fillRect(x, y, width, height);
    }
    strokeRect(x, y, width, height) {
        this._context.strokeRect(x, y, width, height);
    }
    fillText(text, x, y, maxWidth) {
        if (maxWidth) this._context.fillText(text, x, y, maxWidth);
        else this._context.fillText(text, x, y);
    }
    measureText(text) {
        return this._context.measureText(text);
    }
    getImageData(a0, a1, a2, a3) {
        return this._context.getImageData(a0, a1, a2, a3);
    }
    lineTo(a0, a1) {
        this._context.lineTo(a0, a1);
    }
    moveTo(a0, a1) {
        this._context.moveTo(a0, a1);
    }
    rect(a0, a1, a2, a3) {
        this._context.rect(a0, a1, a2, a3);
    }
    putImageData(a0, a1, a2) {
        this._context.putImageData(a0, a1, a2);
    }
    quadraticCurveTo(a0, a1, a2, a3) {
        this._context.quadraticCurveTo(a0, a1, a2, a3);
    }
    restore() {
        this._context.restore();
    }
    rotate(a0) {
        this._context.rotate(a0);
    }
    save() {
        this._context.save();
    }
    scale(a0, a1) {
        this._context.scale(a0, a1);
    }
    setLineDash(a0) {
        if (this._context.setLineDash) this._context.setLineDash(a0);
        else if ('mozDash' in this._context) this._context['mozDash'] = a0;
        else if ('webkitLineDash' in this._context) this._context['webkitLineDash'] = a0;
    }
    getLineDash() {
        return this._context.getLineDash();
    }
    setTransform(a0, a1, a2, a3, a4, a5) {
        this._context.setTransform(a0, a1, a2, a3, a4, a5);
    }
    stroke(path2d) {
        if (path2d) this._context.stroke(path2d);
        else this._context.stroke();
    }
    strokeText(a0, a1, a2, a3) {
        this._context.strokeText(a0, a1, a2, a3);
    }
    transform(a0, a1, a2, a3, a4, a5) {
        this._context.transform(a0, a1, a2, a3, a4, a5);
    }
    translate(a0, a1) {
        this._context.translate(a0, a1);
    }
    _enableTrace() {
        var that = this, len = $a876609bfdb739fd$var$CONTEXT_METHODS.length, origSetter = this.setAttr, n, args;
        var func = function(methodName) {
            var origMethod = that[methodName], ret;
            that[methodName] = function() {
                args = $a876609bfdb739fd$var$simplifyArray(Array.prototype.slice.call(arguments, 0));
                ret = origMethod.apply(that, arguments);
                that._trace({
                    method: methodName,
                    args: args
                });
                return ret;
            };
        };
        for(n = 0; n < len; n++)func($a876609bfdb739fd$var$CONTEXT_METHODS[n]);
        that.setAttr = function() {
            origSetter.apply(that, arguments);
            var prop = arguments[0];
            var val = arguments[1];
            if (prop === 'shadowOffsetX' || prop === 'shadowOffsetY' || prop === 'shadowBlur') val = val / this.canvas.getPixelRatio();
            that._trace({
                property: prop,
                val: val
            });
        };
    }
    _applyGlobalCompositeOperation(node) {
        const op = node.attrs.globalCompositeOperation;
        var def = !op || op === 'source-over';
        if (!def) this.setAttr('globalCompositeOperation', op);
    }
}
$a876609bfdb739fd$var$CONTEXT_PROPERTIES.forEach(function(prop) {
    Object.defineProperty($a876609bfdb739fd$export$841858b892ce1f4c.prototype, prop, {
        get () {
            return this._context[prop];
        },
        set (val) {
            this._context[prop] = val;
        }
    });
});
class $a876609bfdb739fd$export$576380cfa99ddf20 extends $a876609bfdb739fd$export$841858b892ce1f4c {
    constructor(canvas){
        super(canvas);
        this._context = canvas._canvas.getContext('2d');
    }
    _fillColor(shape) {
        var fill = shape.fill();
        this.setAttr('fillStyle', fill);
        shape._fillFunc(this);
    }
    _fillPattern(shape) {
        this.setAttr('fillStyle', shape._getFillPattern());
        shape._fillFunc(this);
    }
    _fillLinearGradient(shape) {
        var grd = shape._getLinearGradient();
        if (grd) {
            this.setAttr('fillStyle', grd);
            shape._fillFunc(this);
        }
    }
    _fillRadialGradient(shape) {
        const grd = shape._getRadialGradient();
        if (grd) {
            this.setAttr('fillStyle', grd);
            shape._fillFunc(this);
        }
    }
    _fill(shape) {
        const hasColor = shape.fill(), fillPriority = shape.getFillPriority();
        if (hasColor && fillPriority === 'color') {
            this._fillColor(shape);
            return;
        }
        const hasPattern = shape.getFillPatternImage();
        if (hasPattern && fillPriority === 'pattern') {
            this._fillPattern(shape);
            return;
        }
        const hasLinearGradient = shape.getFillLinearGradientColorStops();
        if (hasLinearGradient && fillPriority === 'linear-gradient') {
            this._fillLinearGradient(shape);
            return;
        }
        const hasRadialGradient = shape.getFillRadialGradientColorStops();
        if (hasRadialGradient && fillPriority === 'radial-gradient') {
            this._fillRadialGradient(shape);
            return;
        }
        if (hasColor) this._fillColor(shape);
        else if (hasPattern) this._fillPattern(shape);
        else if (hasLinearGradient) this._fillLinearGradient(shape);
        else if (hasRadialGradient) this._fillRadialGradient(shape);
    }
    _strokeLinearGradient(shape) {
        const start = shape.getStrokeLinearGradientStartPoint(), end = shape.getStrokeLinearGradientEndPoint(), colorStops = shape.getStrokeLinearGradientColorStops(), grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
        if (colorStops) {
            for(var n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            this.setAttr('strokeStyle', grd);
        }
    }
    _stroke(shape) {
        var dash = shape.dash(), strokeScaleEnabled = shape.getStrokeScaleEnabled();
        if (shape.hasStroke()) {
            if (!strokeScaleEnabled) {
                this.save();
                var pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            if (dash && shape.dashEnabled()) {
                this.setLineDash(dash);
                this.setAttr('lineDashOffset', shape.dashOffset());
            }
            this.setAttr('lineWidth', shape.strokeWidth());
            if (!shape.getShadowForStrokeEnabled()) this.setAttr('shadowColor', 'rgba(0,0,0,0)');
            var hasLinearGradient = shape.getStrokeLinearGradientColorStops();
            if (hasLinearGradient) this._strokeLinearGradient(shape);
            else this.setAttr('strokeStyle', shape.stroke());
            shape._strokeFunc(this);
            if (!strokeScaleEnabled) this.restore();
        }
    }
    _applyShadow(shape) {
        var _a, _b, _c;
        var color = (_a = shape.getShadowRGBA()) !== null && _a !== void 0 ? _a : 'black', blur = (_b = shape.getShadowBlur()) !== null && _b !== void 0 ? _b : 5, offset = (_c = shape.getShadowOffset()) !== null && _c !== void 0 ? _c : {
            x: 0,
            y: 0
        }, scale = shape.getAbsoluteScale(), ratio = this.canvas.getPixelRatio(), scaleX = scale.x * ratio, scaleY = scale.y * ratio;
        this.setAttr('shadowColor', color);
        this.setAttr('shadowBlur', blur * Math.min(Math.abs(scaleX), Math.abs(scaleY)));
        this.setAttr('shadowOffsetX', offset.x * scaleX);
        this.setAttr('shadowOffsetY', offset.y * scaleY);
    }
}
class $a876609bfdb739fd$export$85eec7ef35542dce extends $a876609bfdb739fd$export$841858b892ce1f4c {
    constructor(canvas){
        super(canvas);
        this._context = canvas._canvas.getContext('2d', {
            willReadFrequently: true
        });
    }
    _fill(shape) {
        this.save();
        this.setAttr('fillStyle', shape.colorKey);
        shape._fillFuncHit(this);
        this.restore();
    }
    strokeShape(shape) {
        if (shape.hasHitStroke()) this._stroke(shape);
    }
    _stroke(shape) {
        if (shape.hasHitStroke()) {
            const strokeScaleEnabled = shape.getStrokeScaleEnabled();
            if (!strokeScaleEnabled) {
                this.save();
                var pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            var hitStrokeWidth = shape.hitStrokeWidth();
            var strokeWidth = hitStrokeWidth === 'auto' ? shape.strokeWidth() : hitStrokeWidth;
            this.setAttr('lineWidth', strokeWidth);
            this.setAttr('strokeStyle', shape.colorKey);
            shape._strokeFuncHit(this);
            if (!strokeScaleEnabled) this.restore();
        }
    }
}





var $2875393762565d65$var$_pixelRatio;
function $2875393762565d65$var$getDevicePixelRatio() {
    if ($2875393762565d65$var$_pixelRatio) return $2875393762565d65$var$_pixelRatio;
    var canvas = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).createCanvasElement();
    var context = canvas.getContext('2d');
    $2875393762565d65$var$_pixelRatio = function() {
        var devicePixelRatio = (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692)._global.devicePixelRatio || 1, backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
        return devicePixelRatio / backingStoreRatio;
    }();
    (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).releaseCanvas(canvas);
    return $2875393762565d65$var$_pixelRatio;
}
class $2875393762565d65$export$8d01c972ee8b14a9 {
    constructor(config){
        this.pixelRatio = 1;
        this.width = 0;
        this.height = 0;
        this.isCache = false;
        var conf = config || {};
        var pixelRatio = conf.pixelRatio || (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).pixelRatio || $2875393762565d65$var$getDevicePixelRatio();
        this.pixelRatio = pixelRatio;
        this._canvas = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).createCanvasElement();
        this._canvas.style.padding = '0';
        this._canvas.style.margin = '0';
        this._canvas.style.border = '0';
        this._canvas.style.background = 'transparent';
        this._canvas.style.position = 'absolute';
        this._canvas.style.top = '0';
        this._canvas.style.left = '0';
    }
    getContext() {
        return this.context;
    }
    getPixelRatio() {
        return this.pixelRatio;
    }
    setPixelRatio(pixelRatio) {
        var previousRatio = this.pixelRatio;
        this.pixelRatio = pixelRatio;
        this.setSize(this.getWidth() / previousRatio, this.getHeight() / previousRatio);
    }
    setWidth(width) {
        this.width = this._canvas.width = width * this.pixelRatio;
        this._canvas.style.width = width + 'px';
        var pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    setHeight(height) {
        this.height = this._canvas.height = height * this.pixelRatio;
        this._canvas.style.height = height + 'px';
        var pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    setSize(width, height) {
        this.setWidth(width || 0);
        this.setHeight(height || 0);
    }
    toDataURL(mimeType, quality) {
        try {
            return this._canvas.toDataURL(mimeType, quality);
        } catch (e) {
            try {
                return this._canvas.toDataURL();
            } catch (err) {
                (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).error('Unable to get data URL. ' + err.message + ' For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html.');
                return '';
            }
        }
    }
}
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($2875393762565d65$export$8d01c972ee8b14a9, 'pixelRatio', undefined, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
class $2875393762565d65$export$ee612225bd2e63be extends $2875393762565d65$export$8d01c972ee8b14a9 {
    constructor(config = {
        width: 0,
        height: 0
    }){
        super(config);
        this.context = new (0, $a876609bfdb739fd$export$576380cfa99ddf20)(this);
        this.setSize(config.width, config.height);
    }
}
class $2875393762565d65$export$43a2e1456e27dc84 extends $2875393762565d65$export$8d01c972ee8b14a9 {
    constructor(config = {
        width: 0,
        height: 0
    }){
        super(config);
        this.hitCanvas = true;
        this.context = new (0, $a876609bfdb739fd$export$85eec7ef35542dce)(this);
        this.setSize(config.width, config.height);
    }
}





const $e4e4f81e7d9ab51e$export$e34f1b340034d7f = {
    get isDragging () {
        var flag = false;
        $e4e4f81e7d9ab51e$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            if (elem.dragStatus === 'dragging') flag = true;
        });
        return flag;
    },
    justDragged: false,
    get node () {
        var node;
        $e4e4f81e7d9ab51e$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            node = elem.node;
        });
        return node;
    },
    _dragElements: new Map(),
    _drag (evt) {
        const nodesToFireEvents = [];
        $e4e4f81e7d9ab51e$export$e34f1b340034d7f._dragElements.forEach((elem, key)=>{
            const { node: node } = elem;
            const stage = node.getStage();
            stage.setPointersPositions(evt);
            if (elem.pointerId === undefined) elem.pointerId = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._getFirstPointerId(evt);
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            if (!pos) return;
            if (elem.dragStatus !== 'dragging') {
                var dragDistance = node.dragDistance();
                var distance = Math.max(Math.abs(pos.x - elem.startPointerPos.x), Math.abs(pos.y - elem.startPointerPos.y));
                if (distance < dragDistance) return;
                node.startDrag({
                    evt: evt
                });
                if (!node.isDragging()) return;
            }
            node._setDragPosition(evt, elem);
            nodesToFireEvents.push(node);
        });
        nodesToFireEvents.forEach((node)=>{
            node.fire('dragmove', {
                type: 'dragmove',
                target: node,
                evt: evt
            }, true);
        });
    },
    _endDragBefore (evt) {
        const drawNodes = [];
        $e4e4f81e7d9ab51e$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            const { node: node } = elem;
            const stage = node.getStage();
            if (evt) stage.setPointersPositions(evt);
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            if (!pos) return;
            if (elem.dragStatus === 'dragging' || elem.dragStatus === 'stopped') {
                $e4e4f81e7d9ab51e$export$e34f1b340034d7f.justDragged = true;
                (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692)._mouseListenClick = false;
                (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692)._touchListenClick = false;
                (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692)._pointerListenClick = false;
                elem.dragStatus = 'stopped';
            }
            const drawNode = elem.node.getLayer() || elem.node instanceof (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692)['Stage'] && elem.node;
            if (drawNode && drawNodes.indexOf(drawNode) === -1) drawNodes.push(drawNode);
        });
        drawNodes.forEach((drawNode)=>{
            drawNode.draw();
        });
    },
    _endDragAfter (evt) {
        $e4e4f81e7d9ab51e$export$e34f1b340034d7f._dragElements.forEach((elem, key)=>{
            if (elem.dragStatus === 'stopped') elem.node.fire('dragend', {
                type: 'dragend',
                target: elem.node,
                evt: evt
            }, true);
            if (elem.dragStatus !== 'dragging') $e4e4f81e7d9ab51e$export$e34f1b340034d7f._dragElements.delete(key);
        });
    }
};
if ((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).isBrowser) {
    window.addEventListener('mouseup', $e4e4f81e7d9ab51e$export$e34f1b340034d7f._endDragBefore, true);
    window.addEventListener('touchend', $e4e4f81e7d9ab51e$export$e34f1b340034d7f._endDragBefore, true);
    window.addEventListener('mousemove', $e4e4f81e7d9ab51e$export$e34f1b340034d7f._drag);
    window.addEventListener('touchmove', $e4e4f81e7d9ab51e$export$e34f1b340034d7f._drag);
    window.addEventListener('mouseup', $e4e4f81e7d9ab51e$export$e34f1b340034d7f._endDragAfter, false);
    window.addEventListener('touchend', $e4e4f81e7d9ab51e$export$e34f1b340034d7f._endDragAfter, false);
}



var $8cc6866a67050653$var$ABSOLUTE_OPACITY = 'absoluteOpacity', $8cc6866a67050653$var$ALL_LISTENERS = 'allEventListeners', $8cc6866a67050653$var$ABSOLUTE_TRANSFORM = 'absoluteTransform', $8cc6866a67050653$var$ABSOLUTE_SCALE = 'absoluteScale', $8cc6866a67050653$var$CANVAS = 'canvas', $8cc6866a67050653$var$CHANGE = 'Change', $8cc6866a67050653$var$CHILDREN = 'children', $8cc6866a67050653$var$KONVA = 'konva', $8cc6866a67050653$var$LISTENING = 'listening', $8cc6866a67050653$var$MOUSEENTER = 'mouseenter', $8cc6866a67050653$var$MOUSELEAVE = 'mouseleave', $8cc6866a67050653$var$NAME = 'name', $8cc6866a67050653$var$SET = 'set', $8cc6866a67050653$var$SHAPE = 'Shape', $8cc6866a67050653$var$SPACE = ' ', $8cc6866a67050653$var$STAGE = 'stage', $8cc6866a67050653$var$TRANSFORM = 'transform', $8cc6866a67050653$var$UPPER_STAGE = 'Stage', $8cc6866a67050653$var$VISIBLE = 'visible', $8cc6866a67050653$var$TRANSFORM_CHANGE_STR = [
    'xChange.konva',
    'yChange.konva',
    'scaleXChange.konva',
    'scaleYChange.konva',
    'skewXChange.konva',
    'skewYChange.konva',
    'rotationChange.konva',
    'offsetXChange.konva',
    'offsetYChange.konva',
    'transformsEnabledChange.konva'
].join($8cc6866a67050653$var$SPACE);
let $8cc6866a67050653$var$idCounter = 1;
class $8cc6866a67050653$export$85c928794f8d04d4 {
    constructor(config){
        this._id = $8cc6866a67050653$var$idCounter++;
        this.eventListeners = {};
        this.attrs = {};
        this.index = 0;
        this._allEventListeners = null;
        this.parent = null;
        this._cache = new Map();
        this._attachedDepsListeners = new Map();
        this._lastPos = null;
        this._batchingTransformChange = false;
        this._needClearTransformCache = false;
        this._filterUpToDate = false;
        this._isUnderCache = false;
        this._dragEventId = null;
        this._shouldFireChangeEvents = false;
        this.setAttrs(config);
        this._shouldFireChangeEvents = true;
    }
    hasChildren() {
        return false;
    }
    _clearCache(attr) {
        if ((attr === $8cc6866a67050653$var$TRANSFORM || attr === $8cc6866a67050653$var$ABSOLUTE_TRANSFORM) && this._cache.get(attr)) this._cache.get(attr).dirty = true;
        else if (attr) this._cache.delete(attr);
        else this._cache.clear();
    }
    _getCache(attr, privateGetter) {
        var cache = this._cache.get(attr);
        var isTransform = attr === $8cc6866a67050653$var$TRANSFORM || attr === $8cc6866a67050653$var$ABSOLUTE_TRANSFORM;
        var invalid = cache === undefined || isTransform && cache.dirty === true;
        if (invalid) {
            cache = privateGetter.call(this);
            this._cache.set(attr, cache);
        }
        return cache;
    }
    _calculate(name, deps, getter) {
        if (!this._attachedDepsListeners.get(name)) {
            const depsString = deps.map((dep)=>dep + 'Change.konva').join($8cc6866a67050653$var$SPACE);
            this.on(depsString, ()=>{
                this._clearCache(name);
            });
            this._attachedDepsListeners.set(name, true);
        }
        return this._getCache(name, getter);
    }
    _getCanvasCache() {
        return this._cache.get($8cc6866a67050653$var$CANVAS);
    }
    _clearSelfAndDescendantCache(attr) {
        this._clearCache(attr);
        if (attr === $8cc6866a67050653$var$ABSOLUTE_TRANSFORM) this.fire('absoluteTransformChange');
    }
    clearCache() {
        if (this._cache.has($8cc6866a67050653$var$CANVAS)) {
            const { scene: scene, filter: filter, hit: hit } = this._cache.get($8cc6866a67050653$var$CANVAS);
            (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).releaseCanvas(scene, filter, hit);
            this._cache.delete($8cc6866a67050653$var$CANVAS);
        }
        this._clearSelfAndDescendantCache();
        this._requestDraw();
        return this;
    }
    cache(config) {
        var conf = config || {};
        var rect = {};
        if (conf.x === undefined || conf.y === undefined || conf.width === undefined || conf.height === undefined) rect = this.getClientRect({
            skipTransform: true,
            relativeTo: this.getParent()
        });
        var width = Math.ceil(conf.width || rect.width), height = Math.ceil(conf.height || rect.height), pixelRatio = conf.pixelRatio, x = conf.x === undefined ? Math.floor(rect.x) : conf.x, y = conf.y === undefined ? Math.floor(rect.y) : conf.y, offset = conf.offset || 0, drawBorder = conf.drawBorder || false, hitCanvasPixelRatio = conf.hitCanvasPixelRatio || 1;
        if (!width || !height) {
            (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).error('Can not cache the node. Width or height of the node equals 0. Caching is skipped.');
            return;
        }
        width += offset * 2 + 1;
        height += offset * 2 + 1;
        x -= offset;
        y -= offset;
        var cachedSceneCanvas = new (0, $2875393762565d65$export$ee612225bd2e63be)({
            pixelRatio: pixelRatio,
            width: width,
            height: height
        }), cachedFilterCanvas = new (0, $2875393762565d65$export$ee612225bd2e63be)({
            pixelRatio: pixelRatio,
            width: 0,
            height: 0
        }), cachedHitCanvas = new (0, $2875393762565d65$export$43a2e1456e27dc84)({
            pixelRatio: hitCanvasPixelRatio,
            width: width,
            height: height
        }), sceneContext = cachedSceneCanvas.getContext(), hitContext = cachedHitCanvas.getContext();
        cachedHitCanvas.isCache = true;
        cachedSceneCanvas.isCache = true;
        this._cache.delete($8cc6866a67050653$var$CANVAS);
        this._filterUpToDate = false;
        if (conf.imageSmoothingEnabled === false) {
            cachedSceneCanvas.getContext()._context.imageSmoothingEnabled = false;
            cachedFilterCanvas.getContext()._context.imageSmoothingEnabled = false;
        }
        sceneContext.save();
        hitContext.save();
        sceneContext.translate(-x, -y);
        hitContext.translate(-x, -y);
        this._isUnderCache = true;
        this._clearSelfAndDescendantCache($8cc6866a67050653$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($8cc6866a67050653$var$ABSOLUTE_SCALE);
        this.drawScene(cachedSceneCanvas, this);
        this.drawHit(cachedHitCanvas, this);
        this._isUnderCache = false;
        sceneContext.restore();
        hitContext.restore();
        if (drawBorder) {
            sceneContext.save();
            sceneContext.beginPath();
            sceneContext.rect(0, 0, width, height);
            sceneContext.closePath();
            sceneContext.setAttr('strokeStyle', 'red');
            sceneContext.setAttr('lineWidth', 5);
            sceneContext.stroke();
            sceneContext.restore();
        }
        this._cache.set($8cc6866a67050653$var$CANVAS, {
            scene: cachedSceneCanvas,
            filter: cachedFilterCanvas,
            hit: cachedHitCanvas,
            x: x,
            y: y
        });
        this._requestDraw();
        return this;
    }
    isCached() {
        return this._cache.has($8cc6866a67050653$var$CANVAS);
    }
    getClientRect(config) {
        throw new Error('abstract "getClientRect" method call');
    }
    _transformedRect(rect, top) {
        var points = [
            {
                x: rect.x,
                y: rect.y
            },
            {
                x: rect.x + rect.width,
                y: rect.y
            },
            {
                x: rect.x + rect.width,
                y: rect.y + rect.height
            },
            {
                x: rect.x,
                y: rect.y + rect.height
            }
        ];
        var minX, minY, maxX, maxY;
        var trans = this.getAbsoluteTransform(top);
        points.forEach(function(point) {
            var transformed = trans.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    _drawCachedSceneCanvas(context) {
        context.save();
        context._applyOpacity(this);
        context._applyGlobalCompositeOperation(this);
        const canvasCache = this._getCanvasCache();
        context.translate(canvasCache.x, canvasCache.y);
        var cacheCanvas = this._getCachedSceneCanvas();
        var ratio = cacheCanvas.pixelRatio;
        context.drawImage(cacheCanvas._canvas, 0, 0, cacheCanvas.width / ratio, cacheCanvas.height / ratio);
        context.restore();
    }
    _drawCachedHitCanvas(context) {
        var canvasCache = this._getCanvasCache(), hitCanvas = canvasCache.hit;
        context.save();
        context.translate(canvasCache.x, canvasCache.y);
        context.drawImage(hitCanvas._canvas, 0, 0, hitCanvas.width / hitCanvas.pixelRatio, hitCanvas.height / hitCanvas.pixelRatio);
        context.restore();
    }
    _getCachedSceneCanvas() {
        var filters = this.filters(), cachedCanvas = this._getCanvasCache(), sceneCanvas = cachedCanvas.scene, filterCanvas = cachedCanvas.filter, filterContext = filterCanvas.getContext(), len, imageData, n, filter;
        if (filters) {
            if (!this._filterUpToDate) {
                var ratio = sceneCanvas.pixelRatio;
                filterCanvas.setSize(sceneCanvas.width / sceneCanvas.pixelRatio, sceneCanvas.height / sceneCanvas.pixelRatio);
                try {
                    len = filters.length;
                    filterContext.clear();
                    filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
                    imageData = filterContext.getImageData(0, 0, filterCanvas.getWidth(), filterCanvas.getHeight());
                    for(n = 0; n < len; n++){
                        filter = filters[n];
                        if (typeof filter !== 'function') {
                            (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).error('Filter should be type of function, but got ' + typeof filter + ' instead. Please check correct filters');
                            continue;
                        }
                        filter.call(this, imageData);
                        filterContext.putImageData(imageData, 0, 0);
                    }
                } catch (e) {
                    (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).error('Unable to apply filter. ' + e.message + ' This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.');
                }
                this._filterUpToDate = true;
            }
            return filterCanvas;
        }
        return sceneCanvas;
    }
    on(evtStr, handler) {
        this._cache && this._cache.delete($8cc6866a67050653$var$ALL_LISTENERS);
        if (arguments.length === 3) return this._delegate.apply(this, arguments);
        var events = evtStr.split($8cc6866a67050653$var$SPACE), len = events.length, n, event, parts, baseEvent, name;
        for(n = 0; n < len; n++){
            event = events[n];
            parts = event.split('.');
            baseEvent = parts[0];
            name = parts[1] || '';
            if (!this.eventListeners[baseEvent]) this.eventListeners[baseEvent] = [];
            this.eventListeners[baseEvent].push({
                name: name,
                handler: handler
            });
        }
        return this;
    }
    off(evtStr, callback) {
        var events = (evtStr || '').split($8cc6866a67050653$var$SPACE), len = events.length, n, t, event, parts, baseEvent, name;
        this._cache && this._cache.delete($8cc6866a67050653$var$ALL_LISTENERS);
        if (!evtStr) for(t in this.eventListeners)this._off(t);
        for(n = 0; n < len; n++){
            event = events[n];
            parts = event.split('.');
            baseEvent = parts[0];
            name = parts[1];
            if (baseEvent) {
                if (this.eventListeners[baseEvent]) this._off(baseEvent, name, callback);
            } else for(t in this.eventListeners)this._off(t, name, callback);
        }
        return this;
    }
    dispatchEvent(evt) {
        var e = {
            target: this,
            type: evt.type,
            evt: evt
        };
        this.fire(evt.type, e);
        return this;
    }
    addEventListener(type, handler) {
        this.on(type, function(evt) {
            handler.call(this, evt.evt);
        });
        return this;
    }
    removeEventListener(type) {
        this.off(type);
        return this;
    }
    _delegate(event, selector, handler) {
        var stopNode = this;
        this.on(event, function(evt) {
            var targets = evt.target.findAncestors(selector, true, stopNode);
            for(var i = 0; i < targets.length; i++){
                evt = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).cloneObject(evt);
                evt.currentTarget = targets[i];
                handler.call(targets[i], evt);
            }
        });
    }
    remove() {
        if (this.isDragging()) this.stopDrag();
        (0, $e4e4f81e7d9ab51e$export$e34f1b340034d7f)._dragElements.delete(this._id);
        this._remove();
        return this;
    }
    _clearCaches() {
        this._clearSelfAndDescendantCache($8cc6866a67050653$var$ABSOLUTE_TRANSFORM);
        this._clearSelfAndDescendantCache($8cc6866a67050653$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($8cc6866a67050653$var$ABSOLUTE_SCALE);
        this._clearSelfAndDescendantCache($8cc6866a67050653$var$STAGE);
        this._clearSelfAndDescendantCache($8cc6866a67050653$var$VISIBLE);
        this._clearSelfAndDescendantCache($8cc6866a67050653$var$LISTENING);
    }
    _remove() {
        this._clearCaches();
        var parent = this.getParent();
        if (parent && parent.children) {
            parent.children.splice(this.index, 1);
            parent._setChildrenIndices();
            this.parent = null;
        }
    }
    destroy() {
        this.remove();
        this.clearCache();
        return this;
    }
    getAttr(attr) {
        var method = 'get' + (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._capitalize(attr);
        if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isFunction(this[method])) return this[method]();
        return this.attrs[attr];
    }
    getAncestors() {
        var parent = this.getParent(), ancestors = [];
        while(parent){
            ancestors.push(parent);
            parent = parent.getParent();
        }
        return ancestors;
    }
    getAttrs() {
        return this.attrs || {};
    }
    setAttrs(config) {
        this._batchTransformChanges(()=>{
            var key, method;
            if (!config) return this;
            for(key in config){
                if (key === $8cc6866a67050653$var$CHILDREN) continue;
                method = $8cc6866a67050653$var$SET + (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._capitalize(key);
                if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isFunction(this[method])) this[method](config[key]);
                else this._setAttr(key, config[key]);
            }
        });
        return this;
    }
    isListening() {
        return this._getCache($8cc6866a67050653$var$LISTENING, this._isListening);
    }
    _isListening(relativeTo) {
        const listening = this.listening();
        if (!listening) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isListening(relativeTo);
        else return true;
    }
    isVisible() {
        return this._getCache($8cc6866a67050653$var$VISIBLE, this._isVisible);
    }
    _isVisible(relativeTo) {
        const visible = this.visible();
        if (!visible) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isVisible(relativeTo);
        else return true;
    }
    shouldDrawHit(top, skipDragCheck = false) {
        if (top) return this._isVisible(top) && this._isListening(top);
        var layer = this.getLayer();
        var layerUnderDrag = false;
        (0, $e4e4f81e7d9ab51e$export$e34f1b340034d7f)._dragElements.forEach((elem)=>{
            if (elem.dragStatus !== 'dragging') return;
            else if (elem.node.nodeType === 'Stage') layerUnderDrag = true;
            else if (elem.node.getLayer() === layer) layerUnderDrag = true;
        });
        var dragSkip = !skipDragCheck && !(0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).hitOnDragEnabled && layerUnderDrag;
        return this.isListening() && this.isVisible() && !dragSkip;
    }
    show() {
        this.visible(true);
        return this;
    }
    hide() {
        this.visible(false);
        return this;
    }
    getZIndex() {
        return this.index || 0;
    }
    getAbsoluteZIndex() {
        var depth = this.getDepth(), that = this, index = 0, nodes, len, n, child;
        function addChildren(children) {
            nodes = [];
            len = children.length;
            for(n = 0; n < len; n++){
                child = children[n];
                index++;
                if (child.nodeType !== $8cc6866a67050653$var$SHAPE) nodes = nodes.concat(child.getChildren().slice());
                if (child._id === that._id) n = len;
            }
            if (nodes.length > 0 && nodes[0].getDepth() <= depth) addChildren(nodes);
        }
        if (that.nodeType !== $8cc6866a67050653$var$UPPER_STAGE) addChildren(that.getStage().getChildren());
        return index;
    }
    getDepth() {
        var depth = 0, parent = this.parent;
        while(parent){
            depth++;
            parent = parent.parent;
        }
        return depth;
    }
    _batchTransformChanges(func) {
        this._batchingTransformChange = true;
        func();
        this._batchingTransformChange = false;
        if (this._needClearTransformCache) {
            this._clearCache($8cc6866a67050653$var$TRANSFORM);
            this._clearSelfAndDescendantCache($8cc6866a67050653$var$ABSOLUTE_TRANSFORM);
        }
        this._needClearTransformCache = false;
    }
    setPosition(pos) {
        this._batchTransformChanges(()=>{
            this.x(pos.x);
            this.y(pos.y);
        });
        return this;
    }
    getPosition() {
        return {
            x: this.x(),
            y: this.y()
        };
    }
    getRelativePointerPosition() {
        if (!this.getStage()) return null;
        var pos = this.getStage().getPointerPosition();
        if (!pos) return null;
        var transform = this.getAbsoluteTransform().copy();
        transform.invert();
        return transform.point(pos);
    }
    getAbsolutePosition(top) {
        let haveCachedParent = false;
        let parent = this.parent;
        while(parent){
            if (parent.isCached()) {
                haveCachedParent = true;
                break;
            }
            parent = parent.parent;
        }
        if (haveCachedParent && !top) top = true;
        var absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(), absoluteTransform = new (0, $87c9acccd58fa09f$export$563a914cafbdc389)(), offset = this.offset();
        absoluteTransform.m = absoluteMatrix.slice();
        absoluteTransform.translate(offset.x, offset.y);
        return absoluteTransform.getTranslation();
    }
    setAbsolutePosition(pos) {
        var origTrans = this._clearTransform();
        this.attrs.x = origTrans.x;
        this.attrs.y = origTrans.y;
        delete origTrans.x;
        delete origTrans.y;
        this._clearCache($8cc6866a67050653$var$TRANSFORM);
        var it = this._getAbsoluteTransform().copy();
        it.invert();
        it.translate(pos.x, pos.y);
        pos = {
            x: this.attrs.x + it.getTranslation().x,
            y: this.attrs.y + it.getTranslation().y
        };
        this._setTransform(origTrans);
        this.setPosition({
            x: pos.x,
            y: pos.y
        });
        this._clearCache($8cc6866a67050653$var$TRANSFORM);
        this._clearSelfAndDescendantCache($8cc6866a67050653$var$ABSOLUTE_TRANSFORM);
        return this;
    }
    _setTransform(trans) {
        var key;
        for(key in trans)this.attrs[key] = trans[key];
    }
    _clearTransform() {
        var trans = {
            x: this.x(),
            y: this.y(),
            rotation: this.rotation(),
            scaleX: this.scaleX(),
            scaleY: this.scaleY(),
            offsetX: this.offsetX(),
            offsetY: this.offsetY(),
            skewX: this.skewX(),
            skewY: this.skewY()
        };
        this.attrs.x = 0;
        this.attrs.y = 0;
        this.attrs.rotation = 0;
        this.attrs.scaleX = 1;
        this.attrs.scaleY = 1;
        this.attrs.offsetX = 0;
        this.attrs.offsetY = 0;
        this.attrs.skewX = 0;
        this.attrs.skewY = 0;
        return trans;
    }
    move(change) {
        var changeX = change.x, changeY = change.y, x = this.x(), y = this.y();
        if (changeX !== undefined) x += changeX;
        if (changeY !== undefined) y += changeY;
        this.setPosition({
            x: x,
            y: y
        });
        return this;
    }
    _eachAncestorReverse(func, top) {
        var family = [], parent = this.getParent(), len, n;
        if (top && top._id === this._id) return;
        family.unshift(this);
        while(parent && (!top || parent._id !== top._id)){
            family.unshift(parent);
            parent = parent.parent;
        }
        len = family.length;
        for(n = 0; n < len; n++)func(family[n]);
    }
    rotate(theta) {
        this.rotation(this.rotation() + theta);
        return this;
    }
    moveToTop() {
        if (!this.parent) {
            (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('Node has no parent. moveToTop function is ignored.');
            return false;
        }
        var index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.push(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveUp() {
        if (!this.parent) {
            (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('Node has no parent. moveUp function is ignored.');
            return false;
        }
        var index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index + 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveDown() {
        if (!this.parent) {
            (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('Node has no parent. moveDown function is ignored.');
            return false;
        }
        var index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index - 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveToBottom() {
        if (!this.parent) {
            (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('Node has no parent. moveToBottom function is ignored.');
            return false;
        }
        var index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.unshift(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    setZIndex(zIndex) {
        if (!this.parent) {
            (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('Node has no parent. zIndex parameter is ignored.');
            return this;
        }
        if (zIndex < 0 || zIndex >= this.parent.children.length) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('Unexpected value ' + zIndex + ' for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to ' + (this.parent.children.length - 1) + '.');
        var index = this.index;
        this.parent.children.splice(index, 1);
        this.parent.children.splice(zIndex, 0, this);
        this.parent._setChildrenIndices();
        return this;
    }
    getAbsoluteOpacity() {
        return this._getCache($8cc6866a67050653$var$ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
    }
    _getAbsoluteOpacity() {
        var absOpacity = this.opacity();
        var parent = this.getParent();
        if (parent && !parent._isUnderCache) absOpacity *= parent.getAbsoluteOpacity();
        return absOpacity;
    }
    moveTo(newContainer) {
        if (this.getParent() !== newContainer) {
            this._remove();
            newContainer.add(this);
        }
        return this;
    }
    toObject() {
        var obj = {}, attrs = this.getAttrs(), key, val, getter, defaultValue, nonPlainObject;
        obj.attrs = {};
        for(key in attrs){
            val = attrs[key];
            nonPlainObject = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).isObject(val) && !(0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isPlainObject(val) && !(0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isArray(val);
            if (nonPlainObject) continue;
            getter = typeof this[key] === 'function' && this[key];
            delete attrs[key];
            defaultValue = getter ? getter.call(this) : null;
            attrs[key] = val;
            if (defaultValue !== val) obj.attrs[key] = val;
        }
        obj.className = this.getClassName();
        return (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._prepareToStringify(obj);
    }
    toJSON() {
        return JSON.stringify(this.toObject());
    }
    getParent() {
        return this.parent;
    }
    findAncestors(selector, includeSelf, stopNode) {
        var res = [];
        if (includeSelf && this._isMatch(selector)) res.push(this);
        var ancestor = this.parent;
        while(ancestor){
            if (ancestor === stopNode) return res;
            if (ancestor._isMatch(selector)) res.push(ancestor);
            ancestor = ancestor.parent;
        }
        return res;
    }
    isAncestorOf(node) {
        return false;
    }
    findAncestor(selector, includeSelf, stopNode) {
        return this.findAncestors(selector, includeSelf, stopNode)[0];
    }
    _isMatch(selector) {
        if (!selector) return false;
        if (typeof selector === 'function') return selector(this);
        var selectorArr = selector.replace(/ /g, '').split(','), len = selectorArr.length, n, sel;
        for(n = 0; n < len; n++){
            sel = selectorArr[n];
            if (!(0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).isValidSelector(sel)) {
                (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('Selector "' + sel + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".');
                (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".');
                (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('Konva is awesome, right?');
            }
            if (sel.charAt(0) === '#') {
                if (this.id() === sel.slice(1)) return true;
            } else if (sel.charAt(0) === '.') {
                if (this.hasName(sel.slice(1))) return true;
            } else if (this.className === sel || this.nodeType === sel) return true;
        }
        return false;
    }
    getLayer() {
        var parent = this.getParent();
        return parent ? parent.getLayer() : null;
    }
    getStage() {
        return this._getCache($8cc6866a67050653$var$STAGE, this._getStage);
    }
    _getStage() {
        var parent = this.getParent();
        if (parent) return parent.getStage();
        else return undefined;
    }
    fire(eventType, evt = {}, bubble) {
        evt.target = evt.target || this;
        if (bubble) this._fireAndBubble(eventType, evt);
        else this._fire(eventType, evt);
        return this;
    }
    getAbsoluteTransform(top) {
        if (top) return this._getAbsoluteTransform(top);
        else return this._getCache($8cc6866a67050653$var$ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
    }
    _getAbsoluteTransform(top) {
        var at;
        if (top) {
            at = new (0, $87c9acccd58fa09f$export$563a914cafbdc389)();
            this._eachAncestorReverse(function(node) {
                var transformsEnabled = node.transformsEnabled();
                if (transformsEnabled === 'all') at.multiply(node.getTransform());
                else if (transformsEnabled === 'position') at.translate(node.x() - node.offsetX(), node.y() - node.offsetY());
            }, top);
            return at;
        } else {
            at = this._cache.get($8cc6866a67050653$var$ABSOLUTE_TRANSFORM) || new (0, $87c9acccd58fa09f$export$563a914cafbdc389)();
            if (this.parent) this.parent.getAbsoluteTransform().copyInto(at);
            else at.reset();
            var transformsEnabled = this.transformsEnabled();
            if (transformsEnabled === 'all') at.multiply(this.getTransform());
            else if (transformsEnabled === 'position') {
                const x = this.attrs.x || 0;
                const y = this.attrs.y || 0;
                const offsetX = this.attrs.offsetX || 0;
                const offsetY = this.attrs.offsetY || 0;
                at.translate(x - offsetX, y - offsetY);
            }
            at.dirty = false;
            return at;
        }
    }
    getAbsoluteScale(top) {
        var parent = this;
        while(parent){
            if (parent._isUnderCache) top = parent;
            parent = parent.getParent();
        }
        const transform = this.getAbsoluteTransform(top);
        const attrs = transform.decompose();
        return {
            x: attrs.scaleX,
            y: attrs.scaleY
        };
    }
    getAbsoluteRotation() {
        return this.getAbsoluteTransform().decompose().rotation;
    }
    getTransform() {
        return this._getCache($8cc6866a67050653$var$TRANSFORM, this._getTransform);
    }
    _getTransform() {
        var _a, _b;
        var m = this._cache.get($8cc6866a67050653$var$TRANSFORM) || new (0, $87c9acccd58fa09f$export$563a914cafbdc389)();
        m.reset();
        var x = this.x(), y = this.y(), rotation = (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).getAngle(this.rotation()), scaleX = (_a = this.attrs.scaleX) !== null && _a !== void 0 ? _a : 1, scaleY = (_b = this.attrs.scaleY) !== null && _b !== void 0 ? _b : 1, skewX = this.attrs.skewX || 0, skewY = this.attrs.skewY || 0, offsetX = this.attrs.offsetX || 0, offsetY = this.attrs.offsetY || 0;
        if (x !== 0 || y !== 0) m.translate(x, y);
        if (rotation !== 0) m.rotate(rotation);
        if (skewX !== 0 || skewY !== 0) m.skew(skewX, skewY);
        if (scaleX !== 1 || scaleY !== 1) m.scale(scaleX, scaleY);
        if (offsetX !== 0 || offsetY !== 0) m.translate(-1 * offsetX, -1 * offsetY);
        m.dirty = false;
        return m;
    }
    clone(obj) {
        var attrs = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).cloneObject(this.attrs), key, allListeners, len, n, listener;
        for(key in obj)attrs[key] = obj[key];
        var node = new this.constructor(attrs);
        for(key in this.eventListeners){
            allListeners = this.eventListeners[key];
            len = allListeners.length;
            for(n = 0; n < len; n++){
                listener = allListeners[n];
                if (listener.name.indexOf($8cc6866a67050653$var$KONVA) < 0) {
                    if (!node.eventListeners[key]) node.eventListeners[key] = [];
                    node.eventListeners[key].push(listener);
                }
            }
        }
        return node;
    }
    _toKonvaCanvas(config) {
        config = config || {};
        var box = this.getClientRect();
        var stage = this.getStage(), x = config.x !== undefined ? config.x : Math.floor(box.x), y = config.y !== undefined ? config.y : Math.floor(box.y), pixelRatio = config.pixelRatio || 1, canvas = new (0, $2875393762565d65$export$ee612225bd2e63be)({
            width: config.width || Math.ceil(box.width) || (stage ? stage.width() : 0),
            height: config.height || Math.ceil(box.height) || (stage ? stage.height() : 0),
            pixelRatio: pixelRatio
        }), context = canvas.getContext();
        if (config.imageSmoothingEnabled === false) context._context.imageSmoothingEnabled = false;
        context.save();
        if (x || y) context.translate(-1 * x, -1 * y);
        this.drawScene(canvas);
        context.restore();
        return canvas;
    }
    toCanvas(config) {
        return this._toKonvaCanvas(config)._canvas;
    }
    toDataURL(config) {
        config = config || {};
        var mimeType = config.mimeType || null, quality = config.quality || null;
        var url = this._toKonvaCanvas(config).toDataURL(mimeType, quality);
        if (config.callback) config.callback(url);
        return url;
    }
    toImage(config) {
        return new Promise((resolve, reject)=>{
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback) delete config.callback;
                (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._urlToImage(this.toDataURL(config), function(img) {
                    resolve(img);
                    callback === null || callback === void 0 || callback(img);
                });
            } catch (err) {
                reject(err);
            }
        });
    }
    toBlob(config) {
        return new Promise((resolve, reject)=>{
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback) delete config.callback;
                this.toCanvas(config).toBlob((blob)=>{
                    resolve(blob);
                    callback === null || callback === void 0 || callback(blob);
                });
            } catch (err) {
                reject(err);
            }
        });
    }
    setSize(size) {
        this.width(size.width);
        this.height(size.height);
        return this;
    }
    getSize() {
        return {
            width: this.width(),
            height: this.height()
        };
    }
    getClassName() {
        return this.className || this.nodeType;
    }
    getType() {
        return this.nodeType;
    }
    getDragDistance() {
        if (this.attrs.dragDistance !== undefined) return this.attrs.dragDistance;
        else if (this.parent) return this.parent.getDragDistance();
        else return (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).dragDistance;
    }
    _off(type, name, callback) {
        var evtListeners = this.eventListeners[type], i, evtName, handler;
        for(i = 0; i < evtListeners.length; i++){
            evtName = evtListeners[i].name;
            handler = evtListeners[i].handler;
            if ((evtName !== 'konva' || name === 'konva') && (!name || evtName === name) && (!callback || callback === handler)) {
                evtListeners.splice(i, 1);
                if (evtListeners.length === 0) {
                    delete this.eventListeners[type];
                    break;
                }
                i--;
            }
        }
    }
    _fireChangeEvent(attr, oldVal, newVal) {
        this._fire(attr + $8cc6866a67050653$var$CHANGE, {
            oldVal: oldVal,
            newVal: newVal
        });
    }
    addName(name) {
        if (!this.hasName(name)) {
            var oldName = this.name();
            var newName = oldName ? oldName + ' ' + name : name;
            this.name(newName);
        }
        return this;
    }
    hasName(name) {
        if (!name) return false;
        const fullName = this.name();
        if (!fullName) return false;
        var names = (fullName || '').split(/\s/g);
        return names.indexOf(name) !== -1;
    }
    removeName(name) {
        var names = (this.name() || '').split(/\s/g);
        var index = names.indexOf(name);
        if (index !== -1) {
            names.splice(index, 1);
            this.name(names.join(' '));
        }
        return this;
    }
    setAttr(attr, val) {
        var func = this[$8cc6866a67050653$var$SET + (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._capitalize(attr)];
        if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isFunction(func)) func.call(this, val);
        else this._setAttr(attr, val);
        return this;
    }
    _requestDraw() {
        if ((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).autoDrawEnabled) {
            const drawNode = this.getLayer() || this.getStage();
            drawNode === null || drawNode === void 0 || drawNode.batchDraw();
        }
    }
    _setAttr(key, val) {
        var oldVal = this.attrs[key];
        if (oldVal === val && !(0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).isObject(val)) return;
        if (val === undefined || val === null) delete this.attrs[key];
        else this.attrs[key] = val;
        if (this._shouldFireChangeEvents) this._fireChangeEvent(key, oldVal, val);
        this._requestDraw();
    }
    _setComponentAttr(key, component, val) {
        var oldVal;
        if (val !== undefined) {
            oldVal = this.attrs[key];
            if (!oldVal) this.attrs[key] = this.getAttr(key);
            this.attrs[key][component] = val;
            this._fireChangeEvent(key, oldVal, val);
        }
    }
    _fireAndBubble(eventType, evt, compareShape) {
        if (evt && this.nodeType === $8cc6866a67050653$var$SHAPE) evt.target = this;
        var shouldStop = (eventType === $8cc6866a67050653$var$MOUSEENTER || eventType === $8cc6866a67050653$var$MOUSELEAVE) && (compareShape && (this === compareShape || this.isAncestorOf && this.isAncestorOf(compareShape)) || this.nodeType === 'Stage' && !compareShape);
        if (!shouldStop) {
            this._fire(eventType, evt);
            var stopBubble = (eventType === $8cc6866a67050653$var$MOUSEENTER || eventType === $8cc6866a67050653$var$MOUSELEAVE) && compareShape && compareShape.isAncestorOf && compareShape.isAncestorOf(this) && !compareShape.isAncestorOf(this.parent);
            if ((evt && !evt.cancelBubble || !evt) && this.parent && this.parent.isListening() && !stopBubble) {
                if (compareShape && compareShape.parent) this._fireAndBubble.call(this.parent, eventType, evt, compareShape);
                else this._fireAndBubble.call(this.parent, eventType, evt);
            }
        }
    }
    _getProtoListeners(eventType) {
        let listeners = this._cache.get($8cc6866a67050653$var$ALL_LISTENERS);
        if (!listeners) {
            listeners = {};
            let obj = Object.getPrototypeOf(this);
            while(obj){
                if (!obj.eventListeners) {
                    obj = Object.getPrototypeOf(obj);
                    continue;
                }
                for(var event in obj.eventListeners){
                    const newEvents = obj.eventListeners[event];
                    const oldEvents = listeners[event] || [];
                    listeners[event] = newEvents.concat(oldEvents);
                }
                obj = Object.getPrototypeOf(obj);
            }
            this._cache.set($8cc6866a67050653$var$ALL_LISTENERS, listeners);
        }
        return listeners[eventType];
    }
    _fire(eventType, evt) {
        evt = evt || {};
        evt.currentTarget = this;
        evt.type = eventType;
        const topListeners = this._getProtoListeners(eventType);
        if (topListeners) for(var i = 0; i < topListeners.length; i++)topListeners[i].handler.call(this, evt);
        const selfListeners = this.eventListeners[eventType];
        if (selfListeners) for(var i = 0; i < selfListeners.length; i++)selfListeners[i].handler.call(this, evt);
    }
    draw() {
        this.drawScene();
        this.drawHit();
        return this;
    }
    _createDragElement(evt) {
        var pointerId = evt ? evt.pointerId : undefined;
        var stage = this.getStage();
        var ap = this.getAbsolutePosition();
        var pos = stage._getPointerById(pointerId) || stage._changedPointerPositions[0] || ap;
        (0, $e4e4f81e7d9ab51e$export$e34f1b340034d7f)._dragElements.set(this._id, {
            node: this,
            startPointerPos: pos,
            offset: {
                x: pos.x - ap.x,
                y: pos.y - ap.y
            },
            dragStatus: 'ready',
            pointerId: pointerId
        });
    }
    startDrag(evt, bubbleEvent = true) {
        if (!(0, $e4e4f81e7d9ab51e$export$e34f1b340034d7f)._dragElements.has(this._id)) this._createDragElement(evt);
        const elem = (0, $e4e4f81e7d9ab51e$export$e34f1b340034d7f)._dragElements.get(this._id);
        elem.dragStatus = 'dragging';
        this.fire('dragstart', {
            type: 'dragstart',
            target: this,
            evt: evt && evt.evt
        }, bubbleEvent);
    }
    _setDragPosition(evt, elem) {
        const pos = this.getStage()._getPointerById(elem.pointerId);
        if (!pos) return;
        var newNodePos = {
            x: pos.x - elem.offset.x,
            y: pos.y - elem.offset.y
        };
        var dbf = this.dragBoundFunc();
        if (dbf !== undefined) {
            const bounded = dbf.call(this, newNodePos, evt);
            if (!bounded) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.');
            else newNodePos = bounded;
        }
        if (!this._lastPos || this._lastPos.x !== newNodePos.x || this._lastPos.y !== newNodePos.y) {
            this.setAbsolutePosition(newNodePos);
            this._requestDraw();
        }
        this._lastPos = newNodePos;
    }
    stopDrag(evt) {
        const elem = (0, $e4e4f81e7d9ab51e$export$e34f1b340034d7f)._dragElements.get(this._id);
        if (elem) elem.dragStatus = 'stopped';
        (0, $e4e4f81e7d9ab51e$export$e34f1b340034d7f)._endDragBefore(evt);
        (0, $e4e4f81e7d9ab51e$export$e34f1b340034d7f)._endDragAfter(evt);
    }
    setDraggable(draggable) {
        this._setAttr('draggable', draggable);
        this._dragChange();
    }
    isDragging() {
        const elem = (0, $e4e4f81e7d9ab51e$export$e34f1b340034d7f)._dragElements.get(this._id);
        return elem ? elem.dragStatus === 'dragging' : false;
    }
    _listenDrag() {
        this._dragCleanup();
        this.on('mousedown.konva touchstart.konva', function(evt) {
            var shouldCheckButton = evt.evt['button'] !== undefined;
            var canDrag = !shouldCheckButton || (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).dragButtons.indexOf(evt.evt['button']) >= 0;
            if (!canDrag) return;
            if (this.isDragging()) return;
            var hasDraggingChild = false;
            (0, $e4e4f81e7d9ab51e$export$e34f1b340034d7f)._dragElements.forEach((elem)=>{
                if (this.isAncestorOf(elem.node)) hasDraggingChild = true;
            });
            if (!hasDraggingChild) this._createDragElement(evt);
        });
    }
    _dragChange() {
        if (this.attrs.draggable) this._listenDrag();
        else {
            this._dragCleanup();
            var stage = this.getStage();
            if (!stage) return;
            const dragElement = (0, $e4e4f81e7d9ab51e$export$e34f1b340034d7f)._dragElements.get(this._id);
            const isDragging = dragElement && dragElement.dragStatus === 'dragging';
            const isReady = dragElement && dragElement.dragStatus === 'ready';
            if (isDragging) this.stopDrag();
            else if (isReady) (0, $e4e4f81e7d9ab51e$export$e34f1b340034d7f)._dragElements.delete(this._id);
        }
    }
    _dragCleanup() {
        this.off('mousedown.konva');
        this.off('touchstart.konva');
    }
    isClientRectOnScreen(margin = {
        x: 0,
        y: 0
    }) {
        const stage = this.getStage();
        if (!stage) return false;
        const screenRect = {
            x: -margin.x,
            y: -margin.y,
            width: stage.width() + 2 * margin.x,
            height: stage.height() + 2 * margin.y
        };
        return (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).haveIntersection(screenRect, this.getClientRect());
    }
    static create(data, container) {
        if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isString(data)) data = JSON.parse(data);
        return this._createNode(data, container);
    }
    static _createNode(obj, container) {
        var className = $8cc6866a67050653$export$85c928794f8d04d4.prototype.getClassName.call(obj), children = obj.children, no, len, n;
        if (container) obj.attrs.container = container;
        if (!(0, $e310d2d3cbfa4cef$export$b9f99057a3c7692)[className]) {
            (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('Can not find a node with class name "' + className + '". Fallback to "Shape".');
            className = 'Shape';
        }
        const Class = (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692)[className];
        no = new Class(obj.attrs);
        if (children) {
            len = children.length;
            for(n = 0; n < len; n++)no.add($8cc6866a67050653$export$85c928794f8d04d4._createNode(children[n]));
        }
        return no;
    }
}
$8cc6866a67050653$export$85c928794f8d04d4.prototype.nodeType = 'Node';
$8cc6866a67050653$export$85c928794f8d04d4.prototype._attrsAffectingSize = [];
$8cc6866a67050653$export$85c928794f8d04d4.prototype.eventListeners = {};
$8cc6866a67050653$export$85c928794f8d04d4.prototype.on.call($8cc6866a67050653$export$85c928794f8d04d4.prototype, $8cc6866a67050653$var$TRANSFORM_CHANGE_STR, function() {
    if (this._batchingTransformChange) {
        this._needClearTransformCache = true;
        return;
    }
    this._clearCache($8cc6866a67050653$var$TRANSFORM);
    this._clearSelfAndDescendantCache($8cc6866a67050653$var$ABSOLUTE_TRANSFORM);
});
$8cc6866a67050653$export$85c928794f8d04d4.prototype.on.call($8cc6866a67050653$export$85c928794f8d04d4.prototype, 'visibleChange.konva', function() {
    this._clearSelfAndDescendantCache($8cc6866a67050653$var$VISIBLE);
});
$8cc6866a67050653$export$85c928794f8d04d4.prototype.on.call($8cc6866a67050653$export$85c928794f8d04d4.prototype, 'listeningChange.konva', function() {
    this._clearSelfAndDescendantCache($8cc6866a67050653$var$LISTENING);
});
$8cc6866a67050653$export$85c928794f8d04d4.prototype.on.call($8cc6866a67050653$export$85c928794f8d04d4.prototype, 'opacityChange.konva', function() {
    this._clearSelfAndDescendantCache($8cc6866a67050653$var$ABSOLUTE_OPACITY);
});
const $8cc6866a67050653$var$addGetterSetter = (0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter;
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'zIndex');
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'absolutePosition');
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'position');
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'x', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'y', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'globalCompositeOperation', 'source-over', (0, $0e51c174430907a2$export$5837c5b6cc5b4d63)());
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'opacity', 1, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'name', '', (0, $0e51c174430907a2$export$5837c5b6cc5b4d63)());
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'id', '', (0, $0e51c174430907a2$export$5837c5b6cc5b4d63)());
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'rotation', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addComponentsGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'scale', [
    'x',
    'y'
]);
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'scaleX', 1, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'scaleY', 1, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addComponentsGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'skew', [
    'x',
    'y'
]);
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'skewX', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'skewY', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addComponentsGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'offset', [
    'x',
    'y'
]);
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'offsetX', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'offsetY', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'dragDistance', null, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'width', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'height', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'listening', true, (0, $0e51c174430907a2$export$147fc8b6cd20fda1)());
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'preventDefault', true, (0, $0e51c174430907a2$export$147fc8b6cd20fda1)());
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'filters', null, function(val) {
    this._filterUpToDate = false;
    return val;
});
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'visible', true, (0, $0e51c174430907a2$export$147fc8b6cd20fda1)());
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'transformsEnabled', 'all', (0, $0e51c174430907a2$export$5837c5b6cc5b4d63)());
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'size');
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'dragBoundFunc');
$8cc6866a67050653$var$addGetterSetter($8cc6866a67050653$export$85c928794f8d04d4, 'draggable', false, (0, $0e51c174430907a2$export$147fc8b6cd20fda1)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).backCompat($8cc6866a67050653$export$85c928794f8d04d4, {
    rotateDeg: 'rotate',
    setRotationDeg: 'setRotation',
    getRotationDeg: 'getRotation'
});





class $9f54aa5dda3991e2$export$42a852a2b6b56249 extends (0, $8cc6866a67050653$export$85c928794f8d04d4) {
    constructor(){
        super(...arguments);
        this.children = [];
    }
    getChildren(filterFunc) {
        if (!filterFunc) return this.children || [];
        const children = this.children || [];
        var results = [];
        children.forEach(function(child) {
            if (filterFunc(child)) results.push(child);
        });
        return results;
    }
    hasChildren() {
        return this.getChildren().length > 0;
    }
    removeChildren() {
        this.getChildren().forEach((child)=>{
            child.parent = null;
            child.index = 0;
            child.remove();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    destroyChildren() {
        this.getChildren().forEach((child)=>{
            child.parent = null;
            child.index = 0;
            child.destroy();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    add(...children) {
        if (children.length === 0) return this;
        if (children.length > 1) {
            for(var i = 0; i < children.length; i++)this.add(children[i]);
            return this;
        }
        const child = children[0];
        if (child.getParent()) {
            child.moveTo(this);
            return this;
        }
        this._validateAdd(child);
        child.index = this.getChildren().length;
        child.parent = this;
        child._clearCaches();
        this.getChildren().push(child);
        this._fire('add', {
            child: child
        });
        this._requestDraw();
        return this;
    }
    destroy() {
        if (this.hasChildren()) this.destroyChildren();
        super.destroy();
        return this;
    }
    find(selector) {
        return this._generalFind(selector, false);
    }
    findOne(selector) {
        var result = this._generalFind(selector, true);
        return result.length > 0 ? result[0] : undefined;
    }
    _generalFind(selector, findOne) {
        var retArr = [];
        this._descendants((node)=>{
            const valid = node._isMatch(selector);
            if (valid) retArr.push(node);
            if (valid && findOne) return true;
            return false;
        });
        return retArr;
    }
    _descendants(fn) {
        let shouldStop = false;
        const children = this.getChildren();
        for (const child of children){
            shouldStop = fn(child);
            if (shouldStop) return true;
            if (!child.hasChildren()) continue;
            shouldStop = child._descendants(fn);
            if (shouldStop) return true;
        }
        return false;
    }
    toObject() {
        var obj = (0, $8cc6866a67050653$export$85c928794f8d04d4).prototype.toObject.call(this);
        obj.children = [];
        this.getChildren().forEach((child)=>{
            obj.children.push(child.toObject());
        });
        return obj;
    }
    isAncestorOf(node) {
        var parent = node.getParent();
        while(parent){
            if (parent._id === this._id) return true;
            parent = parent.getParent();
        }
        return false;
    }
    clone(obj) {
        var node = (0, $8cc6866a67050653$export$85c928794f8d04d4).prototype.clone.call(this, obj);
        this.getChildren().forEach(function(no) {
            node.add(no.clone());
        });
        return node;
    }
    getAllIntersections(pos) {
        var arr = [];
        this.find('Shape').forEach(function(shape) {
            if (shape.isVisible() && shape.intersects(pos)) arr.push(shape);
        });
        return arr;
    }
    _clearSelfAndDescendantCache(attr) {
        var _a;
        super._clearSelfAndDescendantCache(attr);
        if (this.isCached()) return;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(node) {
            node._clearSelfAndDescendantCache(attr);
        });
    }
    _setChildrenIndices() {
        var _a;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child, n) {
            child.index = n;
        });
        this._requestDraw();
    }
    drawScene(can, top) {
        var layer = this.getLayer(), canvas = can || layer && layer.getCanvas(), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
        var caching = canvas && canvas.isCache;
        if (!this.isVisible() && !caching) return this;
        if (cachedSceneCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
        } else this._drawChildren('drawScene', canvas, top);
        return this;
    }
    drawHit(can, top) {
        if (!this.shouldDrawHit(top)) return this;
        var layer = this.getLayer(), canvas = can || layer && layer.hitCanvas, context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (cachedHitCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
        } else this._drawChildren('drawHit', canvas, top);
        return this;
    }
    _drawChildren(drawMethod, canvas, top) {
        var _a;
        var context = canvas && canvas.getContext(), clipWidth = this.clipWidth(), clipHeight = this.clipHeight(), clipFunc = this.clipFunc(), hasClip = clipWidth && clipHeight || clipFunc;
        const selfCache = top === this;
        if (hasClip) {
            context.save();
            var transform = this.getAbsoluteTransform(top);
            var m = transform.getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            context.beginPath();
            if (clipFunc) clipFunc.call(this, context, this);
            else {
                var clipX = this.clipX();
                var clipY = this.clipY();
                context.rect(clipX, clipY, clipWidth, clipHeight);
            }
            context.clip();
            m = transform.copy().invert().getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        }
        var hasComposition = !selfCache && this.globalCompositeOperation() !== 'source-over' && drawMethod === 'drawScene';
        if (hasComposition) {
            context.save();
            context._applyGlobalCompositeOperation(this);
        }
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            child[drawMethod](canvas, top);
        });
        if (hasComposition) context.restore();
        if (hasClip) context.restore();
    }
    getClientRect(config) {
        var _a;
        config = config || {};
        var skipTransform = config.skipTransform;
        var relativeTo = config.relativeTo;
        var minX, minY, maxX, maxY;
        var selfRect = {
            x: Infinity,
            y: Infinity,
            width: 0,
            height: 0
        };
        var that = this;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            if (!child.visible()) return;
            var rect = child.getClientRect({
                relativeTo: that,
                skipShadow: config.skipShadow,
                skipStroke: config.skipStroke
            });
            if (rect.width === 0 && rect.height === 0) return;
            if (minX === undefined) {
                minX = rect.x;
                minY = rect.y;
                maxX = rect.x + rect.width;
                maxY = rect.y + rect.height;
            } else {
                minX = Math.min(minX, rect.x);
                minY = Math.min(minY, rect.y);
                maxX = Math.max(maxX, rect.x + rect.width);
                maxY = Math.max(maxY, rect.y + rect.height);
            }
        });
        var shapes = this.find('Shape');
        var hasVisible = false;
        for(var i = 0; i < shapes.length; i++){
            var shape = shapes[i];
            if (shape._isVisible(this)) {
                hasVisible = true;
                break;
            }
        }
        if (hasVisible && minX !== undefined) selfRect = {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
        else selfRect = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        if (!skipTransform) return this._transformedRect(selfRect, relativeTo);
        return selfRect;
    }
}
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addComponentsGetterSetter($9f54aa5dda3991e2$export$42a852a2b6b56249, 'clip', [
    'x',
    'y',
    'width',
    'height'
]);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($9f54aa5dda3991e2$export$42a852a2b6b56249, 'clipX', undefined, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($9f54aa5dda3991e2$export$42a852a2b6b56249, 'clipY', undefined, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($9f54aa5dda3991e2$export$42a852a2b6b56249, 'clipWidth', undefined, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($9f54aa5dda3991e2$export$42a852a2b6b56249, 'clipHeight', undefined, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($9f54aa5dda3991e2$export$42a852a2b6b56249, 'clipFunc');









const $89e002c13bb8fc8c$var$Captures = new Map();
const $89e002c13bb8fc8c$var$SUPPORT_POINTER_EVENTS = (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692)._global['PointerEvent'] !== undefined;
function $89e002c13bb8fc8c$export$a55e3aaa85f15b00(pointerId) {
    return $89e002c13bb8fc8c$var$Captures.get(pointerId);
}
function $89e002c13bb8fc8c$export$c30017717ce2168e(evt) {
    return {
        evt: evt,
        pointerId: evt.pointerId
    };
}
function $89e002c13bb8fc8c$export$3b42bc7c43025bad(pointerId, shape) {
    return $89e002c13bb8fc8c$var$Captures.get(pointerId) === shape;
}
function $89e002c13bb8fc8c$export$1cab177b65f17c5a(pointerId, shape) {
    $89e002c13bb8fc8c$export$50f687f23c43e4d9(pointerId);
    const stage = shape.getStage();
    if (!stage) return;
    $89e002c13bb8fc8c$var$Captures.set(pointerId, shape);
    if ($89e002c13bb8fc8c$var$SUPPORT_POINTER_EVENTS) shape._fire('gotpointercapture', $89e002c13bb8fc8c$export$c30017717ce2168e(new PointerEvent('gotpointercapture')));
}
function $89e002c13bb8fc8c$export$50f687f23c43e4d9(pointerId, target) {
    const shape = $89e002c13bb8fc8c$var$Captures.get(pointerId);
    if (!shape) return;
    const stage = shape.getStage();
    stage && stage.content;
    $89e002c13bb8fc8c$var$Captures.delete(pointerId);
    if ($89e002c13bb8fc8c$var$SUPPORT_POINTER_EVENTS) shape._fire('lostpointercapture', $89e002c13bb8fc8c$export$c30017717ce2168e(new PointerEvent('lostpointercapture')));
}


var $37aa1e5267331116$var$STAGE = 'Stage', $37aa1e5267331116$var$STRING = 'string', $37aa1e5267331116$var$PX = 'px', $37aa1e5267331116$var$MOUSEOUT = 'mouseout', $37aa1e5267331116$var$MOUSELEAVE = 'mouseleave', $37aa1e5267331116$var$MOUSEOVER = 'mouseover', $37aa1e5267331116$var$MOUSEENTER = 'mouseenter', $37aa1e5267331116$var$MOUSEMOVE = 'mousemove', $37aa1e5267331116$var$MOUSEDOWN = 'mousedown', $37aa1e5267331116$var$MOUSEUP = 'mouseup', $37aa1e5267331116$var$POINTERMOVE = 'pointermove', $37aa1e5267331116$var$POINTERDOWN = 'pointerdown', $37aa1e5267331116$var$POINTERUP = 'pointerup', $37aa1e5267331116$var$POINTERCANCEL = 'pointercancel', $37aa1e5267331116$var$LOSTPOINTERCAPTURE = 'lostpointercapture', $37aa1e5267331116$var$POINTEROUT = 'pointerout', $37aa1e5267331116$var$POINTERLEAVE = 'pointerleave', $37aa1e5267331116$var$POINTEROVER = 'pointerover', $37aa1e5267331116$var$POINTERENTER = 'pointerenter', $37aa1e5267331116$var$CONTEXTMENU = 'contextmenu', $37aa1e5267331116$var$TOUCHSTART = 'touchstart', $37aa1e5267331116$var$TOUCHEND = 'touchend', $37aa1e5267331116$var$TOUCHMOVE = 'touchmove', $37aa1e5267331116$var$TOUCHCANCEL = 'touchcancel', $37aa1e5267331116$var$WHEEL = 'wheel', $37aa1e5267331116$var$MAX_LAYERS_NUMBER = 5, $37aa1e5267331116$var$EVENTS = [
    [
        $37aa1e5267331116$var$MOUSEENTER,
        '_pointerenter'
    ],
    [
        $37aa1e5267331116$var$MOUSEDOWN,
        '_pointerdown'
    ],
    [
        $37aa1e5267331116$var$MOUSEMOVE,
        '_pointermove'
    ],
    [
        $37aa1e5267331116$var$MOUSEUP,
        '_pointerup'
    ],
    [
        $37aa1e5267331116$var$MOUSELEAVE,
        '_pointerleave'
    ],
    [
        $37aa1e5267331116$var$TOUCHSTART,
        '_pointerdown'
    ],
    [
        $37aa1e5267331116$var$TOUCHMOVE,
        '_pointermove'
    ],
    [
        $37aa1e5267331116$var$TOUCHEND,
        '_pointerup'
    ],
    [
        $37aa1e5267331116$var$TOUCHCANCEL,
        '_pointercancel'
    ],
    [
        $37aa1e5267331116$var$MOUSEOVER,
        '_pointerover'
    ],
    [
        $37aa1e5267331116$var$WHEEL,
        '_wheel'
    ],
    [
        $37aa1e5267331116$var$CONTEXTMENU,
        '_contextmenu'
    ],
    [
        $37aa1e5267331116$var$POINTERDOWN,
        '_pointerdown'
    ],
    [
        $37aa1e5267331116$var$POINTERMOVE,
        '_pointermove'
    ],
    [
        $37aa1e5267331116$var$POINTERUP,
        '_pointerup'
    ],
    [
        $37aa1e5267331116$var$POINTERCANCEL,
        '_pointercancel'
    ],
    [
        $37aa1e5267331116$var$LOSTPOINTERCAPTURE,
        '_lostpointercapture'
    ]
];
const $37aa1e5267331116$var$EVENTS_MAP = {
    mouse: {
        [$37aa1e5267331116$var$POINTEROUT]: $37aa1e5267331116$var$MOUSEOUT,
        [$37aa1e5267331116$var$POINTERLEAVE]: $37aa1e5267331116$var$MOUSELEAVE,
        [$37aa1e5267331116$var$POINTEROVER]: $37aa1e5267331116$var$MOUSEOVER,
        [$37aa1e5267331116$var$POINTERENTER]: $37aa1e5267331116$var$MOUSEENTER,
        [$37aa1e5267331116$var$POINTERMOVE]: $37aa1e5267331116$var$MOUSEMOVE,
        [$37aa1e5267331116$var$POINTERDOWN]: $37aa1e5267331116$var$MOUSEDOWN,
        [$37aa1e5267331116$var$POINTERUP]: $37aa1e5267331116$var$MOUSEUP,
        [$37aa1e5267331116$var$POINTERCANCEL]: 'mousecancel',
        pointerclick: 'click',
        pointerdblclick: 'dblclick'
    },
    touch: {
        [$37aa1e5267331116$var$POINTEROUT]: 'touchout',
        [$37aa1e5267331116$var$POINTERLEAVE]: 'touchleave',
        [$37aa1e5267331116$var$POINTEROVER]: 'touchover',
        [$37aa1e5267331116$var$POINTERENTER]: 'touchenter',
        [$37aa1e5267331116$var$POINTERMOVE]: $37aa1e5267331116$var$TOUCHMOVE,
        [$37aa1e5267331116$var$POINTERDOWN]: $37aa1e5267331116$var$TOUCHSTART,
        [$37aa1e5267331116$var$POINTERUP]: $37aa1e5267331116$var$TOUCHEND,
        [$37aa1e5267331116$var$POINTERCANCEL]: $37aa1e5267331116$var$TOUCHCANCEL,
        pointerclick: 'tap',
        pointerdblclick: 'dbltap'
    },
    pointer: {
        [$37aa1e5267331116$var$POINTEROUT]: $37aa1e5267331116$var$POINTEROUT,
        [$37aa1e5267331116$var$POINTERLEAVE]: $37aa1e5267331116$var$POINTERLEAVE,
        [$37aa1e5267331116$var$POINTEROVER]: $37aa1e5267331116$var$POINTEROVER,
        [$37aa1e5267331116$var$POINTERENTER]: $37aa1e5267331116$var$POINTERENTER,
        [$37aa1e5267331116$var$POINTERMOVE]: $37aa1e5267331116$var$POINTERMOVE,
        [$37aa1e5267331116$var$POINTERDOWN]: $37aa1e5267331116$var$POINTERDOWN,
        [$37aa1e5267331116$var$POINTERUP]: $37aa1e5267331116$var$POINTERUP,
        [$37aa1e5267331116$var$POINTERCANCEL]: $37aa1e5267331116$var$POINTERCANCEL,
        pointerclick: 'pointerclick',
        pointerdblclick: 'pointerdblclick'
    }
};
const $37aa1e5267331116$var$getEventType = (type)=>{
    if (type.indexOf('pointer') >= 0) return 'pointer';
    if (type.indexOf('touch') >= 0) return 'touch';
    return 'mouse';
};
const $37aa1e5267331116$var$getEventsMap = (eventType)=>{
    const type = $37aa1e5267331116$var$getEventType(eventType);
    if (type === 'pointer') return (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).pointerEventsEnabled && $37aa1e5267331116$var$EVENTS_MAP.pointer;
    if (type === 'touch') return $37aa1e5267331116$var$EVENTS_MAP.touch;
    if (type === 'mouse') return $37aa1e5267331116$var$EVENTS_MAP.mouse;
};
function $37aa1e5267331116$var$checkNoClip(attrs = {}) {
    if (attrs.clipFunc || attrs.clipWidth || attrs.clipHeight) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('Stage does not support clipping. Please use clip for Layers or Groups.');
    return attrs;
}
const $37aa1e5267331116$var$NO_POINTERS_MESSAGE = `Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);`;
const $37aa1e5267331116$export$1bfcff8d7c4bf05 = [];
class $37aa1e5267331116$export$208cd1682bd0e4b6 extends (0, $9f54aa5dda3991e2$export$42a852a2b6b56249) {
    constructor(config){
        super($37aa1e5267331116$var$checkNoClip(config));
        this._pointerPositions = [];
        this._changedPointerPositions = [];
        this._buildDOM();
        this._bindContentEvents();
        $37aa1e5267331116$export$1bfcff8d7c4bf05.push(this);
        this.on('widthChange.konva heightChange.konva', this._resizeDOM);
        this.on('visibleChange.konva', this._checkVisibility);
        this.on('clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva', ()=>{
            $37aa1e5267331116$var$checkNoClip(this.attrs);
        });
        this._checkVisibility();
    }
    _validateAdd(child) {
        const isLayer = child.getType() === 'Layer';
        const isFastLayer = child.getType() === 'FastLayer';
        const valid = isLayer || isFastLayer;
        if (!valid) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).throw('You may only add layers to the stage.');
    }
    _checkVisibility() {
        if (!this.content) return;
        const style = this.visible() ? '' : 'none';
        this.content.style.display = style;
    }
    setContainer(container) {
        if (typeof container === $37aa1e5267331116$var$STRING) {
            if (container.charAt(0) === '.') {
                var className = container.slice(1);
                container = document.getElementsByClassName(className)[0];
            } else {
                var id;
                if (container.charAt(0) !== '#') id = container;
                else id = container.slice(1);
                container = document.getElementById(id);
            }
            if (!container) throw 'Can not find container in document with id ' + id;
        }
        this._setAttr('container', container);
        if (this.content) {
            if (this.content.parentElement) this.content.parentElement.removeChild(this.content);
            container.appendChild(this.content);
        }
        return this;
    }
    shouldDrawHit() {
        return true;
    }
    clear() {
        var layers = this.children, len = layers.length, n;
        for(n = 0; n < len; n++)layers[n].clear();
        return this;
    }
    clone(obj) {
        if (!obj) obj = {};
        obj.container = typeof document !== 'undefined' && document.createElement('div');
        return (0, $9f54aa5dda3991e2$export$42a852a2b6b56249).prototype.clone.call(this, obj);
    }
    destroy() {
        super.destroy();
        var content = this.content;
        if (content && (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isInDocument(content)) this.container().removeChild(content);
        var index = $37aa1e5267331116$export$1bfcff8d7c4bf05.indexOf(this);
        if (index > -1) $37aa1e5267331116$export$1bfcff8d7c4bf05.splice(index, 1);
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas);
        return this;
    }
    getPointerPosition() {
        const pos = this._pointerPositions[0] || this._changedPointerPositions[0];
        if (!pos) {
            (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn($37aa1e5267331116$var$NO_POINTERS_MESSAGE);
            return null;
        }
        return {
            x: pos.x,
            y: pos.y
        };
    }
    _getPointerById(id) {
        return this._pointerPositions.find((p)=>p.id === id);
    }
    getPointersPositions() {
        return this._pointerPositions;
    }
    getStage() {
        return this;
    }
    getContent() {
        return this.content;
    }
    _toKonvaCanvas(config) {
        config = config || {};
        config.x = config.x || 0;
        config.y = config.y || 0;
        config.width = config.width || this.width();
        config.height = config.height || this.height();
        var canvas = new (0, $2875393762565d65$export$ee612225bd2e63be)({
            width: config.width,
            height: config.height,
            pixelRatio: config.pixelRatio || 1
        });
        var _context = canvas.getContext()._context;
        var layers = this.children;
        if (config.x || config.y) _context.translate(-1 * config.x, -1 * config.y);
        layers.forEach(function(layer) {
            if (!layer.isVisible()) return;
            var layerCanvas = layer._toKonvaCanvas(config);
            _context.drawImage(layerCanvas._canvas, config.x, config.y, layerCanvas.getWidth() / layerCanvas.getPixelRatio(), layerCanvas.getHeight() / layerCanvas.getPixelRatio());
        });
        return canvas;
    }
    getIntersection(pos) {
        if (!pos) return null;
        var layers = this.children, len = layers.length, end = len - 1, n;
        for(n = end; n >= 0; n--){
            const shape = layers[n].getIntersection(pos);
            if (shape) return shape;
        }
        return null;
    }
    _resizeDOM() {
        var width = this.width();
        var height = this.height();
        if (this.content) {
            this.content.style.width = width + $37aa1e5267331116$var$PX;
            this.content.style.height = height + $37aa1e5267331116$var$PX;
        }
        this.bufferCanvas.setSize(width, height);
        this.bufferHitCanvas.setSize(width, height);
        this.children.forEach((layer)=>{
            layer.setSize({
                width: width,
                height: height
            });
            layer.draw();
        });
    }
    add(layer, ...rest) {
        if (arguments.length > 1) {
            for(var i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        super.add(layer);
        var length = this.children.length;
        if (length > $37aa1e5267331116$var$MAX_LAYERS_NUMBER) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('The stage has ' + length + ' layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group.');
        layer.setSize({
            width: this.width(),
            height: this.height()
        });
        layer.draw();
        if ((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).isBrowser) this.content.appendChild(layer.canvas._canvas);
        return this;
    }
    getParent() {
        return null;
    }
    getLayer() {
        return null;
    }
    hasPointerCapture(pointerId) {
        return $89e002c13bb8fc8c$export$3b42bc7c43025bad(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $89e002c13bb8fc8c$export$1cab177b65f17c5a(pointerId, this);
    }
    releaseCapture(pointerId) {
        $89e002c13bb8fc8c$export$50f687f23c43e4d9(pointerId, this);
    }
    getLayers() {
        return this.children;
    }
    _bindContentEvents() {
        if (!(0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).isBrowser) return;
        $37aa1e5267331116$var$EVENTS.forEach(([event, methodName])=>{
            this.content.addEventListener(event, (evt)=>{
                this[methodName](evt);
            }, {
                passive: false
            });
        });
    }
    _pointerenter(evt) {
        this.setPointersPositions(evt);
        const events = $37aa1e5267331116$var$getEventsMap(evt.type);
        this._fire(events.pointerenter, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointerover(evt) {
        this.setPointersPositions(evt);
        const events = $37aa1e5267331116$var$getEventsMap(evt.type);
        this._fire(events.pointerover, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _getTargetShape(evenType) {
        let shape = this[evenType + 'targetShape'];
        if (shape && !shape.getStage()) shape = null;
        return shape;
    }
    _pointerleave(evt) {
        const events = $37aa1e5267331116$var$getEventsMap(evt.type);
        const eventType = $37aa1e5267331116$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        var targetShape = this._getTargetShape(eventType);
        var eventsEnabled = !(0, $e4e4f81e7d9ab51e$export$e34f1b340034d7f).isDragging || (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).hitOnDragEnabled;
        if (targetShape && eventsEnabled) {
            targetShape._fireAndBubble(events.pointerout, {
                evt: evt
            });
            targetShape._fireAndBubble(events.pointerleave, {
                evt: evt
            });
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this[eventType + 'targetShape'] = null;
        } else if (eventsEnabled) {
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this._fire(events.pointerout, {
                evt: evt,
                target: this,
                currentTarget: this
            });
        }
        this.pointerPos = undefined;
        this._pointerPositions = [];
    }
    _pointerdown(evt) {
        const events = $37aa1e5267331116$var$getEventsMap(evt.type);
        const eventType = $37aa1e5267331116$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        var triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos)=>{
            var shape = this.getIntersection(pos);
            (0, $e4e4f81e7d9ab51e$export$e34f1b340034d7f).justDragged = false;
            (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692)['_' + eventType + 'ListenClick'] = true;
            const hasShape = shape && shape.isListening();
            if (!hasShape) return;
            if ((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).capturePointerEventsEnabled) shape.setPointerCapture(pos.id);
            this[eventType + 'ClickStartShape'] = shape;
            shape._fireAndBubble(events.pointerdown, {
                evt: evt,
                pointerId: pos.id
            });
            triggeredOnShape = true;
            const isTouch = evt.type.indexOf('touch') >= 0;
            if (shape.preventDefault() && evt.cancelable && isTouch) evt.preventDefault();
        });
        if (!triggeredOnShape) this._fire(events.pointerdown, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._pointerPositions[0].id
        });
    }
    _pointermove(evt) {
        const events = $37aa1e5267331116$var$getEventsMap(evt.type);
        const eventType = $37aa1e5267331116$var$getEventType(evt.type);
        if (!events) return;
        if ((0, $e4e4f81e7d9ab51e$export$e34f1b340034d7f).isDragging && (0, $e4e4f81e7d9ab51e$export$e34f1b340034d7f).node.preventDefault() && evt.cancelable) evt.preventDefault();
        this.setPointersPositions(evt);
        var eventsEnabled = !(0, $e4e4f81e7d9ab51e$export$e34f1b340034d7f).isDragging || (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).hitOnDragEnabled;
        if (!eventsEnabled) return;
        var processedShapesIds = {};
        let triggeredOnShape = false;
        var targetShape = this._getTargetShape(eventType);
        this._changedPointerPositions.forEach((pos)=>{
            const shape = $89e002c13bb8fc8c$export$a55e3aaa85f15b00(pos.id) || this.getIntersection(pos);
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            var differentTarget = targetShape !== shape;
            if (differentTarget && targetShape) {
                targetShape._fireAndBubble(events.pointerout, Object.assign({}, event), shape);
                targetShape._fireAndBubble(events.pointerleave, Object.assign({}, event), shape);
            }
            if (shape) {
                if (processedShapesIds[shape._id]) return;
                processedShapesIds[shape._id] = true;
            }
            if (shape && shape.isListening()) {
                triggeredOnShape = true;
                if (differentTarget) {
                    shape._fireAndBubble(events.pointerover, Object.assign({}, event), targetShape);
                    shape._fireAndBubble(events.pointerenter, Object.assign({}, event), targetShape);
                    this[eventType + 'targetShape'] = shape;
                }
                shape._fireAndBubble(events.pointermove, Object.assign({}, event));
            } else if (targetShape) {
                this._fire(events.pointerover, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                this[eventType + 'targetShape'] = null;
            }
        });
        if (!triggeredOnShape) this._fire(events.pointermove, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
    }
    _pointerup(evt) {
        const events = $37aa1e5267331116$var$getEventsMap(evt.type);
        const eventType = $37aa1e5267331116$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        const clickStartShape = this[eventType + 'ClickStartShape'];
        const clickEndShape = this[eventType + 'ClickEndShape'];
        var processedShapesIds = {};
        let triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos)=>{
            const shape = $89e002c13bb8fc8c$export$a55e3aaa85f15b00(pos.id) || this.getIntersection(pos);
            if (shape) {
                shape.releaseCapture(pos.id);
                if (processedShapesIds[shape._id]) return;
                processedShapesIds[shape._id] = true;
            }
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            let fireDblClick = false;
            if ((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692)['_' + eventType + 'InDblClickWindow']) {
                fireDblClick = true;
                clearTimeout(this[eventType + 'DblTimeout']);
            } else if (!(0, $e4e4f81e7d9ab51e$export$e34f1b340034d7f).justDragged) {
                (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692)['_' + eventType + 'InDblClickWindow'] = true;
                clearTimeout(this[eventType + 'DblTimeout']);
            }
            this[eventType + 'DblTimeout'] = setTimeout(function() {
                (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692)['_' + eventType + 'InDblClickWindow'] = false;
            }, (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).dblClickWindow);
            if (shape && shape.isListening()) {
                triggeredOnShape = true;
                this[eventType + 'ClickEndShape'] = shape;
                shape._fireAndBubble(events.pointerup, Object.assign({}, event));
                if ((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692)['_' + eventType + 'ListenClick'] && clickStartShape && clickStartShape === shape) {
                    shape._fireAndBubble(events.pointerclick, Object.assign({}, event));
                    if (fireDblClick && clickEndShape && clickEndShape === shape) shape._fireAndBubble(events.pointerdblclick, Object.assign({}, event));
                }
            } else {
                this[eventType + 'ClickEndShape'] = null;
                if ((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692)['_' + eventType + 'ListenClick']) this._fire(events.pointerclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                if (fireDblClick) this._fire(events.pointerdblclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
            }
        });
        if (!triggeredOnShape) this._fire(events.pointerup, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
        (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692)['_' + eventType + 'ListenClick'] = false;
        if (evt.cancelable && eventType !== 'touch') evt.preventDefault();
    }
    _contextmenu(evt) {
        this.setPointersPositions(evt);
        var shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($37aa1e5267331116$var$CONTEXTMENU, {
            evt: evt
        });
        else this._fire($37aa1e5267331116$var$CONTEXTMENU, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _wheel(evt) {
        this.setPointersPositions(evt);
        var shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($37aa1e5267331116$var$WHEEL, {
            evt: evt
        });
        else this._fire($37aa1e5267331116$var$WHEEL, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointercancel(evt) {
        this.setPointersPositions(evt);
        const shape = $89e002c13bb8fc8c$export$a55e3aaa85f15b00(evt.pointerId) || this.getIntersection(this.getPointerPosition());
        if (shape) shape._fireAndBubble($37aa1e5267331116$var$POINTERUP, $89e002c13bb8fc8c$export$c30017717ce2168e(evt));
        $89e002c13bb8fc8c$export$50f687f23c43e4d9(evt.pointerId);
    }
    _lostpointercapture(evt) {
        $89e002c13bb8fc8c$export$50f687f23c43e4d9(evt.pointerId);
    }
    setPointersPositions(evt) {
        var contentPosition = this._getContentPosition(), x = null, y = null;
        evt = evt ? evt : window.event;
        if (evt.touches !== undefined) {
            this._pointerPositions = [];
            this._changedPointerPositions = [];
            Array.prototype.forEach.call(evt.touches, (touch)=>{
                this._pointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
            Array.prototype.forEach.call(evt.changedTouches || evt.touches, (touch)=>{
                this._changedPointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
        } else {
            x = (evt.clientX - contentPosition.left) / contentPosition.scaleX;
            y = (evt.clientY - contentPosition.top) / contentPosition.scaleY;
            this.pointerPos = {
                x: x,
                y: y
            };
            this._pointerPositions = [
                {
                    x: x,
                    y: y,
                    id: (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._getFirstPointerId(evt)
                }
            ];
            this._changedPointerPositions = [
                {
                    x: x,
                    y: y,
                    id: (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._getFirstPointerId(evt)
                }
            ];
        }
    }
    _setPointerPosition(evt) {
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.');
        this.setPointersPositions(evt);
    }
    _getContentPosition() {
        if (!this.content || !this.content.getBoundingClientRect) return {
            top: 0,
            left: 0,
            scaleX: 1,
            scaleY: 1
        };
        var rect = this.content.getBoundingClientRect();
        return {
            top: rect.top,
            left: rect.left,
            scaleX: rect.width / this.content.clientWidth || 1,
            scaleY: rect.height / this.content.clientHeight || 1
        };
    }
    _buildDOM() {
        this.bufferCanvas = new (0, $2875393762565d65$export$ee612225bd2e63be)({
            width: this.width(),
            height: this.height()
        });
        this.bufferHitCanvas = new (0, $2875393762565d65$export$43a2e1456e27dc84)({
            pixelRatio: 1,
            width: this.width(),
            height: this.height()
        });
        if (!(0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).isBrowser) return;
        var container = this.container();
        if (!container) throw 'Stage has no container. A container is required.';
        container.innerHTML = '';
        this.content = document.createElement('div');
        this.content.style.position = 'relative';
        this.content.style.userSelect = 'none';
        this.content.className = 'konvajs-content';
        this.content.setAttribute('role', 'presentation');
        container.appendChild(this.content);
        this._resizeDOM();
    }
    cache() {
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.');
        return this;
    }
    clearCache() {
        return this;
    }
    batchDraw() {
        this.getChildren().forEach(function(layer) {
            layer.batchDraw();
        });
        return this;
    }
}
$37aa1e5267331116$export$208cd1682bd0e4b6.prototype.nodeType = $37aa1e5267331116$var$STAGE;
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($37aa1e5267331116$export$208cd1682bd0e4b6);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($37aa1e5267331116$export$208cd1682bd0e4b6, 'container');














var $83649c293dd1d496$var$HAS_SHADOW = 'hasShadow';
var $83649c293dd1d496$var$SHADOW_RGBA = 'shadowRGBA';
var $83649c293dd1d496$var$patternImage = 'patternImage';
var $83649c293dd1d496$var$linearGradient = 'linearGradient';
var $83649c293dd1d496$var$radialGradient = 'radialGradient';
let $83649c293dd1d496$var$dummyContext;
function $83649c293dd1d496$var$getDummyContext() {
    if ($83649c293dd1d496$var$dummyContext) return $83649c293dd1d496$var$dummyContext;
    $83649c293dd1d496$var$dummyContext = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).createCanvasElement().getContext('2d');
    return $83649c293dd1d496$var$dummyContext;
}
const $83649c293dd1d496$export$4ff7fc6f1af248b5 = {};
function $83649c293dd1d496$var$_fillFunc(context) {
    context.fill();
}
function $83649c293dd1d496$var$_strokeFunc(context) {
    context.stroke();
}
function $83649c293dd1d496$var$_fillFuncHit(context) {
    context.fill();
}
function $83649c293dd1d496$var$_strokeFuncHit(context) {
    context.stroke();
}
function $83649c293dd1d496$var$_clearHasShadowCache() {
    this._clearCache($83649c293dd1d496$var$HAS_SHADOW);
}
function $83649c293dd1d496$var$_clearGetShadowRGBACache() {
    this._clearCache($83649c293dd1d496$var$SHADOW_RGBA);
}
function $83649c293dd1d496$var$_clearFillPatternCache() {
    this._clearCache($83649c293dd1d496$var$patternImage);
}
function $83649c293dd1d496$var$_clearLinearGradientCache() {
    this._clearCache($83649c293dd1d496$var$linearGradient);
}
function $83649c293dd1d496$var$_clearRadialGradientCache() {
    this._clearCache($83649c293dd1d496$var$radialGradient);
}
class $83649c293dd1d496$export$6428a7f2611ef1fa extends (0, $8cc6866a67050653$export$85c928794f8d04d4) {
    constructor(config){
        super(config);
        let key;
        while(true){
            key = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).getRandomColor();
            if (key && !(key in $83649c293dd1d496$export$4ff7fc6f1af248b5)) break;
        }
        this.colorKey = key;
        $83649c293dd1d496$export$4ff7fc6f1af248b5[key] = this;
    }
    getContext() {
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('shape.getContext() method is deprecated. Please do not use it.');
        return this.getLayer().getContext();
    }
    getCanvas() {
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('shape.getCanvas() method is deprecated. Please do not use it.');
        return this.getLayer().getCanvas();
    }
    getSceneFunc() {
        return this.attrs.sceneFunc || this['_sceneFunc'];
    }
    getHitFunc() {
        return this.attrs.hitFunc || this['_hitFunc'];
    }
    hasShadow() {
        return this._getCache($83649c293dd1d496$var$HAS_SHADOW, this._hasShadow);
    }
    _hasShadow() {
        return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
    }
    _getFillPattern() {
        return this._getCache($83649c293dd1d496$var$patternImage, this.__getFillPattern);
    }
    __getFillPattern() {
        if (this.fillPatternImage()) {
            var ctx = $83649c293dd1d496$var$getDummyContext();
            const pattern = ctx.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || 'repeat');
            if (pattern && pattern.setTransform) {
                const tr = new (0, $87c9acccd58fa09f$export$563a914cafbdc389)();
                tr.translate(this.fillPatternX(), this.fillPatternY());
                tr.rotate((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).getAngle(this.fillPatternRotation()));
                tr.scale(this.fillPatternScaleX(), this.fillPatternScaleY());
                tr.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
                const m = tr.getMatrix();
                const matrix = typeof DOMMatrix === 'undefined' ? {
                    a: m[0],
                    b: m[1],
                    c: m[2],
                    d: m[3],
                    e: m[4],
                    f: m[5]
                } : new DOMMatrix(m);
                pattern.setTransform(matrix);
            }
            return pattern;
        }
    }
    _getLinearGradient() {
        return this._getCache($83649c293dd1d496$var$linearGradient, this.__getLinearGradient);
    }
    __getLinearGradient() {
        var colorStops = this.fillLinearGradientColorStops();
        if (colorStops) {
            var ctx = $83649c293dd1d496$var$getDummyContext();
            var start = this.fillLinearGradientStartPoint();
            var end = this.fillLinearGradientEndPoint();
            var grd = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
            for(var n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    _getRadialGradient() {
        return this._getCache($83649c293dd1d496$var$radialGradient, this.__getRadialGradient);
    }
    __getRadialGradient() {
        var colorStops = this.fillRadialGradientColorStops();
        if (colorStops) {
            var ctx = $83649c293dd1d496$var$getDummyContext();
            var start = this.fillRadialGradientStartPoint();
            var end = this.fillRadialGradientEndPoint();
            var grd = ctx.createRadialGradient(start.x, start.y, this.fillRadialGradientStartRadius(), end.x, end.y, this.fillRadialGradientEndRadius());
            for(var n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    getShadowRGBA() {
        return this._getCache($83649c293dd1d496$var$SHADOW_RGBA, this._getShadowRGBA);
    }
    _getShadowRGBA() {
        if (!this.hasShadow()) return;
        var rgba = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).colorToRGBA(this.shadowColor());
        if (rgba) return 'rgba(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ',' + rgba.a * (this.shadowOpacity() || 1) + ')';
    }
    hasFill() {
        return this._calculate('hasFill', [
            'fillEnabled',
            'fill',
            'fillPatternImage',
            'fillLinearGradientColorStops',
            'fillRadialGradientColorStops'
        ], ()=>{
            return this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops());
        });
    }
    hasStroke() {
        return this._calculate('hasStroke', [
            'strokeEnabled',
            'strokeWidth',
            'stroke',
            'strokeLinearGradientColorStops'
        ], ()=>{
            return this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops());
        });
    }
    hasHitStroke() {
        const width = this.hitStrokeWidth();
        if (width === 'auto') return this.hasStroke();
        return this.strokeEnabled() && !!width;
    }
    intersects(point) {
        var stage = this.getStage(), bufferHitCanvas = stage.bufferHitCanvas, p;
        bufferHitCanvas.getContext().clear();
        this.drawHit(bufferHitCanvas, null, true);
        p = bufferHitCanvas.context.getImageData(Math.round(point.x), Math.round(point.y), 1, 1).data;
        return p[3] > 0;
    }
    destroy() {
        (0, $8cc6866a67050653$export$85c928794f8d04d4).prototype.destroy.call(this);
        delete $83649c293dd1d496$export$4ff7fc6f1af248b5[this.colorKey];
        delete this.colorKey;
        return this;
    }
    _useBufferCanvas(forceFill) {
        var _a;
        if (!this.getStage()) return false;
        const perfectDrawEnabled = (_a = this.attrs.perfectDrawEnabled) !== null && _a !== void 0 ? _a : true;
        if (!perfectDrawEnabled) return false;
        const hasFill = forceFill || this.hasFill();
        const hasStroke = this.hasStroke();
        const isTransparent = this.getAbsoluteOpacity() !== 1;
        if (hasFill && hasStroke && isTransparent) return true;
        const hasShadow = this.hasShadow();
        const strokeForShadow = this.shadowForStrokeEnabled();
        if (hasFill && hasStroke && hasShadow && strokeForShadow) return true;
        return false;
    }
    setStrokeHitEnabled(val) {
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead.');
        if (val) this.hitStrokeWidth('auto');
        else this.hitStrokeWidth(0);
    }
    getStrokeHitEnabled() {
        if (this.hitStrokeWidth() === 0) return false;
        else return true;
    }
    getSelfRect() {
        var size = this.size();
        return {
            x: this._centroid ? -size.width / 2 : 0,
            y: this._centroid ? -size.height / 2 : 0,
            width: size.width,
            height: size.height
        };
    }
    getClientRect(config = {}) {
        const skipTransform = config.skipTransform;
        const relativeTo = config.relativeTo;
        const fillRect = this.getSelfRect();
        const applyStroke = !config.skipStroke && this.hasStroke();
        const strokeWidth = applyStroke && this.strokeWidth() || 0;
        const fillAndStrokeWidth = fillRect.width + strokeWidth;
        const fillAndStrokeHeight = fillRect.height + strokeWidth;
        const applyShadow = !config.skipShadow && this.hasShadow();
        const shadowOffsetX = applyShadow ? this.shadowOffsetX() : 0;
        const shadowOffsetY = applyShadow ? this.shadowOffsetY() : 0;
        const preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
        const preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);
        const blurRadius = applyShadow && this.shadowBlur() || 0;
        const width = preWidth + blurRadius * 2;
        const height = preHeight + blurRadius * 2;
        const rect = {
            width: width,
            height: height,
            x: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetX, 0) + fillRect.x,
            y: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetY, 0) + fillRect.y
        };
        if (!skipTransform) return this._transformedRect(rect, relativeTo);
        return rect;
    }
    drawScene(can, top) {
        var layer = this.getLayer(), canvas = can || layer.getCanvas(), context = canvas.getContext(), cachedCanvas = this._getCanvasCache(), drawFunc = this.getSceneFunc(), hasShadow = this.hasShadow(), stage, bufferCanvas, bufferContext;
        var skipBuffer = canvas.isCache;
        var cachingSelf = top === this;
        if (!this.isVisible() && !cachingSelf) return this;
        if (cachedCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        if (this._useBufferCanvas() && !skipBuffer) {
            stage = this.getStage();
            bufferCanvas = stage.bufferCanvas;
            bufferContext = bufferCanvas.getContext();
            bufferContext.clear();
            bufferContext.save();
            bufferContext._applyLineJoin(this);
            var o = this.getAbsoluteTransform(top).getMatrix();
            bufferContext.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
            drawFunc.call(this, bufferContext, this);
            bufferContext.restore();
            var ratio = bufferCanvas.pixelRatio;
            if (hasShadow) context._applyShadow(this);
            context._applyOpacity(this);
            context._applyGlobalCompositeOperation(this);
            context.drawImage(bufferCanvas._canvas, 0, 0, bufferCanvas.width / ratio, bufferCanvas.height / ratio);
        } else {
            context._applyLineJoin(this);
            if (!cachingSelf) {
                var o = this.getAbsoluteTransform(top).getMatrix();
                context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
                context._applyOpacity(this);
                context._applyGlobalCompositeOperation(this);
            }
            if (hasShadow) context._applyShadow(this);
            drawFunc.call(this, context, this);
        }
        context.restore();
        return this;
    }
    drawHit(can, top, skipDragCheck = false) {
        if (!this.shouldDrawHit(top, skipDragCheck)) return this;
        var layer = this.getLayer(), canvas = can || layer.hitCanvas, context = canvas && canvas.getContext(), drawFunc = this.hitFunc() || this.sceneFunc(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (!this.colorKey) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()');
        if (cachedHitCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        context._applyLineJoin(this);
        const selfCache = this === top;
        if (!selfCache) {
            var o = this.getAbsoluteTransform(top).getMatrix();
            context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
        }
        drawFunc.call(this, context, this);
        context.restore();
        return this;
    }
    drawHitFromCache(alphaThreshold = 0) {
        var cachedCanvas = this._getCanvasCache(), sceneCanvas = this._getCachedSceneCanvas(), hitCanvas = cachedCanvas.hit, hitContext = hitCanvas.getContext(), hitWidth = hitCanvas.getWidth(), hitHeight = hitCanvas.getHeight(), hitImageData, hitData, len, rgbColorKey, i, alpha;
        hitContext.clear();
        hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);
        try {
            hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
            hitData = hitImageData.data;
            len = hitData.length;
            rgbColorKey = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._hexToRgb(this.colorKey);
            for(i = 0; i < len; i += 4){
                alpha = hitData[i + 3];
                if (alpha > alphaThreshold) {
                    hitData[i] = rgbColorKey.r;
                    hitData[i + 1] = rgbColorKey.g;
                    hitData[i + 2] = rgbColorKey.b;
                    hitData[i + 3] = 255;
                } else hitData[i + 3] = 0;
            }
            hitContext.putImageData(hitImageData, 0, 0);
        } catch (e) {
            (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).error('Unable to draw hit graph from cached scene canvas. ' + e.message);
        }
        return this;
    }
    hasPointerCapture(pointerId) {
        return $89e002c13bb8fc8c$export$3b42bc7c43025bad(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $89e002c13bb8fc8c$export$1cab177b65f17c5a(pointerId, this);
    }
    releaseCapture(pointerId) {
        $89e002c13bb8fc8c$export$50f687f23c43e4d9(pointerId, this);
    }
}
$83649c293dd1d496$export$6428a7f2611ef1fa.prototype._fillFunc = $83649c293dd1d496$var$_fillFunc;
$83649c293dd1d496$export$6428a7f2611ef1fa.prototype._strokeFunc = $83649c293dd1d496$var$_strokeFunc;
$83649c293dd1d496$export$6428a7f2611ef1fa.prototype._fillFuncHit = $83649c293dd1d496$var$_fillFuncHit;
$83649c293dd1d496$export$6428a7f2611ef1fa.prototype._strokeFuncHit = $83649c293dd1d496$var$_strokeFuncHit;
$83649c293dd1d496$export$6428a7f2611ef1fa.prototype._centroid = false;
$83649c293dd1d496$export$6428a7f2611ef1fa.prototype.nodeType = 'Shape';
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($83649c293dd1d496$export$6428a7f2611ef1fa);
$83649c293dd1d496$export$6428a7f2611ef1fa.prototype.eventListeners = {};
$83649c293dd1d496$export$6428a7f2611ef1fa.prototype.on.call($83649c293dd1d496$export$6428a7f2611ef1fa.prototype, 'shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', $83649c293dd1d496$var$_clearHasShadowCache);
$83649c293dd1d496$export$6428a7f2611ef1fa.prototype.on.call($83649c293dd1d496$export$6428a7f2611ef1fa.prototype, 'shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', $83649c293dd1d496$var$_clearGetShadowRGBACache);
$83649c293dd1d496$export$6428a7f2611ef1fa.prototype.on.call($83649c293dd1d496$export$6428a7f2611ef1fa.prototype, 'fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva', $83649c293dd1d496$var$_clearFillPatternCache);
$83649c293dd1d496$export$6428a7f2611ef1fa.prototype.on.call($83649c293dd1d496$export$6428a7f2611ef1fa.prototype, 'fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva', $83649c293dd1d496$var$_clearLinearGradientCache);
$83649c293dd1d496$export$6428a7f2611ef1fa.prototype.on.call($83649c293dd1d496$export$6428a7f2611ef1fa.prototype, 'fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva', $83649c293dd1d496$var$_clearRadialGradientCache);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'stroke', undefined, (0, $0e51c174430907a2$export$9c72f966a828cc68)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'strokeWidth', 2, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillAfterStrokeEnabled', false);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'hitStrokeWidth', 'auto', (0, $0e51c174430907a2$export$3b7df2720ef33404)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'strokeHitEnabled', true, (0, $0e51c174430907a2$export$147fc8b6cd20fda1)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'perfectDrawEnabled', true, (0, $0e51c174430907a2$export$147fc8b6cd20fda1)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'shadowForStrokeEnabled', true, (0, $0e51c174430907a2$export$147fc8b6cd20fda1)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'lineJoin');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'lineCap');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'sceneFunc');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'hitFunc');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'dash');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'dashOffset', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'shadowColor', undefined, (0, $0e51c174430907a2$export$5837c5b6cc5b4d63)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'shadowBlur', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'shadowOpacity', 1, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addComponentsGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'shadowOffset', [
    'x',
    'y'
]);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'shadowOffsetX', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'shadowOffsetY', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillPatternImage');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fill', undefined, (0, $0e51c174430907a2$export$9c72f966a828cc68)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillPatternX', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillPatternY', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillLinearGradientColorStops');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'strokeLinearGradientColorStops');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillRadialGradientStartRadius', 0);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillRadialGradientEndRadius', 0);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillRadialGradientColorStops');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillPatternRepeat', 'repeat');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillEnabled', true);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'strokeEnabled', true);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'shadowEnabled', true);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'dashEnabled', true);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'strokeScaleEnabled', true);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillPriority', 'color');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addComponentsGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillPatternOffset', [
    'x',
    'y'
]);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillPatternOffsetX', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillPatternOffsetY', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addComponentsGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillPatternScale', [
    'x',
    'y'
]);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillPatternScaleX', 1, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillPatternScaleY', 1, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addComponentsGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillLinearGradientStartPoint', [
    'x',
    'y'
]);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addComponentsGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'strokeLinearGradientStartPoint', [
    'x',
    'y'
]);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillLinearGradientStartPointX', 0);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'strokeLinearGradientStartPointX', 0);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillLinearGradientStartPointY', 0);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'strokeLinearGradientStartPointY', 0);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addComponentsGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillLinearGradientEndPoint', [
    'x',
    'y'
]);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addComponentsGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'strokeLinearGradientEndPoint', [
    'x',
    'y'
]);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillLinearGradientEndPointX', 0);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'strokeLinearGradientEndPointX', 0);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillLinearGradientEndPointY', 0);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'strokeLinearGradientEndPointY', 0);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addComponentsGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillRadialGradientStartPoint', [
    'x',
    'y'
]);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillRadialGradientStartPointX', 0);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillRadialGradientStartPointY', 0);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addComponentsGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillRadialGradientEndPoint', [
    'x',
    'y'
]);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillRadialGradientEndPointX', 0);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillRadialGradientEndPointY', 0);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($83649c293dd1d496$export$6428a7f2611ef1fa, 'fillPatternRotation', 0);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).backCompat($83649c293dd1d496$export$6428a7f2611ef1fa, {
    dashArray: 'dash',
    getDashArray: 'getDash',
    setDashArray: 'getDash',
    drawFunc: 'sceneFunc',
    getDrawFunc: 'getSceneFunc',
    setDrawFunc: 'setSceneFunc',
    drawHitFunc: 'hitFunc',
    getDrawHitFunc: 'getHitFunc',
    setDrawHitFunc: 'setHitFunc'
});



var $2f09c14a87b5ab29$var$HASH = '#', $2f09c14a87b5ab29$var$BEFORE_DRAW = 'beforeDraw', $2f09c14a87b5ab29$var$DRAW = 'draw', $2f09c14a87b5ab29$var$INTERSECTION_OFFSETS = [
    {
        x: 0,
        y: 0
    },
    {
        x: -1,
        y: -1
    },
    {
        x: 1,
        y: -1
    },
    {
        x: 1,
        y: 1
    },
    {
        x: -1,
        y: 1
    }
], $2f09c14a87b5ab29$var$INTERSECTION_OFFSETS_LEN = $2f09c14a87b5ab29$var$INTERSECTION_OFFSETS.length;
class $2f09c14a87b5ab29$export$936d0764594b6eb3 extends (0, $9f54aa5dda3991e2$export$42a852a2b6b56249) {
    constructor(config){
        super(config);
        this.canvas = new (0, $2875393762565d65$export$ee612225bd2e63be)();
        this.hitCanvas = new (0, $2875393762565d65$export$43a2e1456e27dc84)({
            pixelRatio: 1
        });
        this._waitingForDraw = false;
        this.on('visibleChange.konva', this._checkVisibility);
        this._checkVisibility();
        this.on('imageSmoothingEnabledChange.konva', this._setSmoothEnabled);
        this._setSmoothEnabled();
    }
    createPNGStream() {
        const c = this.canvas._canvas;
        return c.createPNGStream();
    }
    getCanvas() {
        return this.canvas;
    }
    getNativeCanvasElement() {
        return this.canvas._canvas;
    }
    getHitCanvas() {
        return this.hitCanvas;
    }
    getContext() {
        return this.getCanvas().getContext();
    }
    clear(bounds) {
        this.getContext().clear(bounds);
        this.getHitCanvas().getContext().clear(bounds);
        return this;
    }
    setZIndex(index) {
        super.setZIndex(index);
        var stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            if (index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[index + 1].getCanvas()._canvas);
            else stage.content.appendChild(this.getNativeCanvasElement());
        }
        return this;
    }
    moveToTop() {
        (0, $8cc6866a67050653$export$85c928794f8d04d4).prototype.moveToTop.call(this);
        var stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            stage.content.appendChild(this.getNativeCanvasElement());
        }
        return true;
    }
    moveUp() {
        var moved = (0, $8cc6866a67050653$export$85c928794f8d04d4).prototype.moveUp.call(this);
        if (!moved) return false;
        var stage = this.getStage();
        if (!stage || !stage.content) return false;
        stage.content.removeChild(this.getNativeCanvasElement());
        if (this.index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[this.index + 1].getCanvas()._canvas);
        else stage.content.appendChild(this.getNativeCanvasElement());
        return true;
    }
    moveDown() {
        if ((0, $8cc6866a67050653$export$85c928794f8d04d4).prototype.moveDown.call(this)) {
            var stage = this.getStage();
            if (stage) {
                var children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[this.index + 1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    moveToBottom() {
        if ((0, $8cc6866a67050653$export$85c928794f8d04d4).prototype.moveToBottom.call(this)) {
            var stage = this.getStage();
            if (stage) {
                var children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    getLayer() {
        return this;
    }
    remove() {
        var _canvas = this.getNativeCanvasElement();
        (0, $8cc6866a67050653$export$85c928794f8d04d4).prototype.remove.call(this);
        if (_canvas && _canvas.parentNode && (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isInDocument(_canvas)) _canvas.parentNode.removeChild(_canvas);
        return this;
    }
    getStage() {
        return this.parent;
    }
    setSize({ width: width, height: height }) {
        this.canvas.setSize(width, height);
        this.hitCanvas.setSize(width, height);
        this._setSmoothEnabled();
        return this;
    }
    _validateAdd(child) {
        var type = child.getType();
        if (type !== 'Group' && type !== 'Shape') (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).throw('You may only add groups and shapes to a layer.');
    }
    _toKonvaCanvas(config) {
        config = config || {};
        config.width = config.width || this.getWidth();
        config.height = config.height || this.getHeight();
        config.x = config.x !== undefined ? config.x : this.x();
        config.y = config.y !== undefined ? config.y : this.y();
        return (0, $8cc6866a67050653$export$85c928794f8d04d4).prototype._toKonvaCanvas.call(this, config);
    }
    _checkVisibility() {
        const visible = this.visible();
        if (visible) this.canvas._canvas.style.display = 'block';
        else this.canvas._canvas.style.display = 'none';
    }
    _setSmoothEnabled() {
        this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    }
    getWidth() {
        if (this.parent) return this.parent.width();
    }
    setWidth() {
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    }
    getHeight() {
        if (this.parent) return this.parent.height();
    }
    setHeight() {
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    }
    batchDraw() {
        if (!this._waitingForDraw) {
            this._waitingForDraw = true;
            (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).requestAnimFrame(()=>{
                this.draw();
                this._waitingForDraw = false;
            });
        }
        return this;
    }
    getIntersection(pos) {
        if (!this.isListening() || !this.isVisible()) return null;
        var spiralSearchDistance = 1;
        var continueSearch = false;
        while(true){
            for(let i = 0; i < $2f09c14a87b5ab29$var$INTERSECTION_OFFSETS_LEN; i++){
                const intersectionOffset = $2f09c14a87b5ab29$var$INTERSECTION_OFFSETS[i];
                const obj = this._getIntersection({
                    x: pos.x + intersectionOffset.x * spiralSearchDistance,
                    y: pos.y + intersectionOffset.y * spiralSearchDistance
                });
                const shape = obj.shape;
                if (shape) return shape;
                continueSearch = !!obj.antialiased;
                if (!obj.antialiased) break;
            }
            if (continueSearch) spiralSearchDistance += 1;
            else return null;
        }
    }
    _getIntersection(pos) {
        const ratio = this.hitCanvas.pixelRatio;
        const p = this.hitCanvas.context.getImageData(Math.round(pos.x * ratio), Math.round(pos.y * ratio), 1, 1).data;
        const p3 = p[3];
        if (p3 === 255) {
            const colorKey = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._rgbToHex(p[0], p[1], p[2]);
            const shape = (0, $83649c293dd1d496$export$4ff7fc6f1af248b5)[$2f09c14a87b5ab29$var$HASH + colorKey];
            if (shape) return {
                shape: shape
            };
            return {
                antialiased: true
            };
        } else if (p3 > 0) return {
            antialiased: true
        };
        return {};
    }
    drawScene(can, top) {
        var layer = this.getLayer(), canvas = can || layer && layer.getCanvas();
        this._fire($2f09c14a87b5ab29$var$BEFORE_DRAW, {
            node: this
        });
        if (this.clearBeforeDraw()) canvas.getContext().clear();
        (0, $9f54aa5dda3991e2$export$42a852a2b6b56249).prototype.drawScene.call(this, canvas, top);
        this._fire($2f09c14a87b5ab29$var$DRAW, {
            node: this
        });
        return this;
    }
    drawHit(can, top) {
        var layer = this.getLayer(), canvas = can || layer && layer.hitCanvas;
        if (layer && layer.clearBeforeDraw()) layer.getHitCanvas().getContext().clear();
        (0, $9f54aa5dda3991e2$export$42a852a2b6b56249).prototype.drawHit.call(this, canvas, top);
        return this;
    }
    enableHitGraph() {
        this.hitGraphEnabled(true);
        return this;
    }
    disableHitGraph() {
        this.hitGraphEnabled(false);
        return this;
    }
    setHitGraphEnabled(val) {
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
        this.listening(val);
    }
    getHitGraphEnabled(val) {
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
        return this.listening();
    }
    toggleHitCanvas() {
        if (!this.parent || !this.parent['content']) return;
        var parent = this.parent;
        var added = !!this.hitCanvas._canvas.parentNode;
        if (added) parent.content.removeChild(this.hitCanvas._canvas);
        else parent.content.appendChild(this.hitCanvas._canvas);
    }
    destroy() {
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas);
        return super.destroy();
    }
}
$2f09c14a87b5ab29$export$936d0764594b6eb3.prototype.nodeType = 'Layer';
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($2f09c14a87b5ab29$export$936d0764594b6eb3);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($2f09c14a87b5ab29$export$936d0764594b6eb3, 'imageSmoothingEnabled', true);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($2f09c14a87b5ab29$export$936d0764594b6eb3, 'clearBeforeDraw', true);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($2f09c14a87b5ab29$export$936d0764594b6eb3, 'hitGraphEnabled', true, (0, $0e51c174430907a2$export$147fc8b6cd20fda1)());





class $fe83f0ffc52fbfa2$export$92d64f29192d1118 extends (0, $2f09c14a87b5ab29$export$936d0764594b6eb3) {
    constructor(attrs){
        super(attrs);
        this.listening(false);
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    }
}
$fe83f0ffc52fbfa2$export$92d64f29192d1118.prototype.nodeType = 'FastLayer';
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($fe83f0ffc52fbfa2$export$92d64f29192d1118);





class $436734b80159e85f$export$eb2fcfdbd7ba97d4 extends (0, $9f54aa5dda3991e2$export$42a852a2b6b56249) {
    _validateAdd(child) {
        var type = child.getType();
        if (type !== 'Group' && type !== 'Shape') (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).throw('You may only add groups and shapes to groups.');
    }
}
$436734b80159e85f$export$eb2fcfdbd7ba97d4.prototype.nodeType = 'Group';
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($436734b80159e85f$export$eb2fcfdbd7ba97d4);






var $a9b955fe6a1c7aff$var$now = function() {
    if ((0, $e310d2d3cbfa4cef$export$442f1a04865e4790).performance && (0, $e310d2d3cbfa4cef$export$442f1a04865e4790).performance.now) return function() {
        return (0, $e310d2d3cbfa4cef$export$442f1a04865e4790).performance.now();
    };
    return function() {
        return new Date().getTime();
    };
}();
class $a9b955fe6a1c7aff$export$c35d437ae5945fcd {
    constructor(func, layers){
        this.id = $a9b955fe6a1c7aff$export$c35d437ae5945fcd.animIdCounter++;
        this.frame = {
            time: 0,
            timeDiff: 0,
            lastTime: $a9b955fe6a1c7aff$var$now(),
            frameRate: 0
        };
        this.func = func;
        this.setLayers(layers);
    }
    setLayers(layers) {
        var lays = [];
        if (!layers) lays = [];
        else if (layers.length > 0) lays = layers;
        else lays = [
            layers
        ];
        this.layers = lays;
        return this;
    }
    getLayers() {
        return this.layers;
    }
    addLayer(layer) {
        var layers = this.layers, len = layers.length, n;
        for(n = 0; n < len; n++){
            if (layers[n]._id === layer._id) return false;
        }
        this.layers.push(layer);
        return true;
    }
    isRunning() {
        var a = $a9b955fe6a1c7aff$export$c35d437ae5945fcd, animations = a.animations, len = animations.length, n;
        for(n = 0; n < len; n++){
            if (animations[n].id === this.id) return true;
        }
        return false;
    }
    start() {
        this.stop();
        this.frame.timeDiff = 0;
        this.frame.lastTime = $a9b955fe6a1c7aff$var$now();
        $a9b955fe6a1c7aff$export$c35d437ae5945fcd._addAnimation(this);
        return this;
    }
    stop() {
        $a9b955fe6a1c7aff$export$c35d437ae5945fcd._removeAnimation(this);
        return this;
    }
    _updateFrameObject(time) {
        this.frame.timeDiff = time - this.frame.lastTime;
        this.frame.lastTime = time;
        this.frame.time += this.frame.timeDiff;
        this.frame.frameRate = 1000 / this.frame.timeDiff;
    }
    static _addAnimation(anim) {
        this.animations.push(anim);
        this._handleAnimation();
    }
    static _removeAnimation(anim) {
        var id = anim.id, animations = this.animations, len = animations.length, n;
        for(n = 0; n < len; n++)if (animations[n].id === id) {
            this.animations.splice(n, 1);
            break;
        }
    }
    static _runFrames() {
        var layerHash = {}, animations = this.animations, anim, layers, func, n, i, layersLen, layer, key, needRedraw;
        for(n = 0; n < animations.length; n++){
            anim = animations[n];
            layers = anim.layers;
            func = anim.func;
            anim._updateFrameObject($a9b955fe6a1c7aff$var$now());
            layersLen = layers.length;
            if (func) needRedraw = func.call(anim, anim.frame) !== false;
            else needRedraw = true;
            if (!needRedraw) continue;
            for(i = 0; i < layersLen; i++){
                layer = layers[i];
                if (layer._id !== undefined) layerHash[layer._id] = layer;
            }
        }
        for(key in layerHash){
            if (!layerHash.hasOwnProperty(key)) continue;
            layerHash[key].batchDraw();
        }
    }
    static _animationLoop() {
        var Anim = $a9b955fe6a1c7aff$export$c35d437ae5945fcd;
        if (Anim.animations.length) {
            Anim._runFrames();
            (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).requestAnimFrame(Anim._animationLoop);
        } else Anim.animRunning = false;
    }
    static _handleAnimation() {
        if (!this.animRunning) {
            this.animRunning = true;
            (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).requestAnimFrame(this._animationLoop);
        }
    }
}
$a9b955fe6a1c7aff$export$c35d437ae5945fcd.animations = [];
$a9b955fe6a1c7aff$export$c35d437ae5945fcd.animIdCounter = 0;
$a9b955fe6a1c7aff$export$c35d437ae5945fcd.animRunning = false;






var $80cfd44d9d58fca9$var$blacklist = {
    node: 1,
    duration: 1,
    easing: 1,
    onFinish: 1,
    yoyo: 1
}, $80cfd44d9d58fca9$var$PAUSED = 1, $80cfd44d9d58fca9$var$PLAYING = 2, $80cfd44d9d58fca9$var$REVERSING = 3, $80cfd44d9d58fca9$var$idCounter = 0, $80cfd44d9d58fca9$var$colorAttrs = [
    'fill',
    'stroke',
    'shadowColor'
];
class $80cfd44d9d58fca9$var$TweenEngine {
    constructor(prop, propFunc, func, begin, finish, duration, yoyo){
        this.prop = prop;
        this.propFunc = propFunc;
        this.begin = begin;
        this._pos = begin;
        this.duration = duration;
        this._change = 0;
        this.prevPos = 0;
        this.yoyo = yoyo;
        this._time = 0;
        this._position = 0;
        this._startTime = 0;
        this._finish = 0;
        this.func = func;
        this._change = finish - this.begin;
        this.pause();
    }
    fire(str) {
        var handler = this[str];
        if (handler) handler();
    }
    setTime(t) {
        if (t > this.duration) {
            if (this.yoyo) {
                this._time = this.duration;
                this.reverse();
            } else this.finish();
        } else if (t < 0) {
            if (this.yoyo) {
                this._time = 0;
                this.play();
            } else this.reset();
        } else {
            this._time = t;
            this.update();
        }
    }
    getTime() {
        return this._time;
    }
    setPosition(p) {
        this.prevPos = this._pos;
        this.propFunc(p);
        this._pos = p;
    }
    getPosition(t) {
        if (t === undefined) t = this._time;
        return this.func(t, this.begin, this._change, this.duration);
    }
    play() {
        this.state = $80cfd44d9d58fca9$var$PLAYING;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire('onPlay');
    }
    reverse() {
        this.state = $80cfd44d9d58fca9$var$REVERSING;
        this._time = this.duration - this._time;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire('onReverse');
    }
    seek(t) {
        this.pause();
        this._time = t;
        this.update();
        this.fire('onSeek');
    }
    reset() {
        this.pause();
        this._time = 0;
        this.update();
        this.fire('onReset');
    }
    finish() {
        this.pause();
        this._time = this.duration;
        this.update();
        this.fire('onFinish');
    }
    update() {
        this.setPosition(this.getPosition(this._time));
        this.fire('onUpdate');
    }
    onEnterFrame() {
        var t = this.getTimer() - this._startTime;
        if (this.state === $80cfd44d9d58fca9$var$PLAYING) this.setTime(t);
        else if (this.state === $80cfd44d9d58fca9$var$REVERSING) this.setTime(this.duration - t);
    }
    pause() {
        this.state = $80cfd44d9d58fca9$var$PAUSED;
        this.fire('onPause');
    }
    getTimer() {
        return new Date().getTime();
    }
}
class $80cfd44d9d58fca9$export$208a41d6b4e37b97 {
    constructor(config){
        var that = this, node = config.node, nodeId = node._id, duration, easing = config.easing || $80cfd44d9d58fca9$export$ade85cc9682adcc5.Linear, yoyo = !!config.yoyo, key;
        if (typeof config.duration === 'undefined') duration = 0.3;
        else if (config.duration === 0) duration = 0.001;
        else duration = config.duration;
        this.node = node;
        this._id = $80cfd44d9d58fca9$var$idCounter++;
        var layers = node.getLayer() || (node instanceof (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692)['Stage'] ? node.getLayers() : null);
        if (!layers) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).error('Tween constructor have `node` that is not in a layer. Please add node into layer first.');
        this.anim = new (0, $a9b955fe6a1c7aff$export$c35d437ae5945fcd)(function() {
            that.tween.onEnterFrame();
        }, layers);
        this.tween = new $80cfd44d9d58fca9$var$TweenEngine(key, function(i) {
            that._tweenFunc(i);
        }, easing, 0, 1, duration * 1000, yoyo);
        this._addListeners();
        if (!$80cfd44d9d58fca9$export$208a41d6b4e37b97.attrs[nodeId]) $80cfd44d9d58fca9$export$208a41d6b4e37b97.attrs[nodeId] = {};
        if (!$80cfd44d9d58fca9$export$208a41d6b4e37b97.attrs[nodeId][this._id]) $80cfd44d9d58fca9$export$208a41d6b4e37b97.attrs[nodeId][this._id] = {};
        if (!$80cfd44d9d58fca9$export$208a41d6b4e37b97.tweens[nodeId]) $80cfd44d9d58fca9$export$208a41d6b4e37b97.tweens[nodeId] = {};
        for(key in config)if ($80cfd44d9d58fca9$var$blacklist[key] === undefined) this._addAttr(key, config[key]);
        this.reset();
        this.onFinish = config.onFinish;
        this.onReset = config.onReset;
        this.onUpdate = config.onUpdate;
    }
    _addAttr(key, end) {
        var node = this.node, nodeId = node._id, start, diff, tweenId, n, len, trueEnd, trueStart, endRGBA;
        tweenId = $80cfd44d9d58fca9$export$208a41d6b4e37b97.tweens[nodeId][key];
        if (tweenId) delete $80cfd44d9d58fca9$export$208a41d6b4e37b97.attrs[nodeId][tweenId][key];
        start = node.getAttr(key);
        if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isArray(end)) {
            diff = [];
            len = Math.max(end.length, start.length);
            if (key === 'points' && end.length !== start.length) {
                if (end.length > start.length) {
                    trueStart = start;
                    start = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._prepareArrayForTween(start, end, node.closed());
                } else {
                    trueEnd = end;
                    end = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._prepareArrayForTween(end, start, node.closed());
                }
            }
            if (key.indexOf('fill') === 0) {
                for(n = 0; n < len; n++)if (n % 2 === 0) diff.push(end[n] - start[n]);
                else {
                    var startRGBA = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).colorToRGBA(start[n]);
                    endRGBA = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).colorToRGBA(end[n]);
                    start[n] = startRGBA;
                    diff.push({
                        r: endRGBA.r - startRGBA.r,
                        g: endRGBA.g - startRGBA.g,
                        b: endRGBA.b - startRGBA.b,
                        a: endRGBA.a - startRGBA.a
                    });
                }
            } else for(n = 0; n < len; n++)diff.push(end[n] - start[n]);
        } else if ($80cfd44d9d58fca9$var$colorAttrs.indexOf(key) !== -1) {
            start = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).colorToRGBA(start);
            endRGBA = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).colorToRGBA(end);
            diff = {
                r: endRGBA.r - start.r,
                g: endRGBA.g - start.g,
                b: endRGBA.b - start.b,
                a: endRGBA.a - start.a
            };
        } else diff = end - start;
        $80cfd44d9d58fca9$export$208a41d6b4e37b97.attrs[nodeId][this._id][key] = {
            start: start,
            diff: diff,
            end: end,
            trueEnd: trueEnd,
            trueStart: trueStart
        };
        $80cfd44d9d58fca9$export$208a41d6b4e37b97.tweens[nodeId][key] = this._id;
    }
    _tweenFunc(i) {
        var node = this.node, attrs = $80cfd44d9d58fca9$export$208a41d6b4e37b97.attrs[node._id][this._id], key, attr, start, diff, newVal, n, len, end;
        for(key in attrs){
            attr = attrs[key];
            start = attr.start;
            diff = attr.diff;
            end = attr.end;
            if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isArray(start)) {
                newVal = [];
                len = Math.max(start.length, end.length);
                if (key.indexOf('fill') === 0) {
                    for(n = 0; n < len; n++)if (n % 2 === 0) newVal.push((start[n] || 0) + diff[n] * i);
                    else newVal.push('rgba(' + Math.round(start[n].r + diff[n].r * i) + ',' + Math.round(start[n].g + diff[n].g * i) + ',' + Math.round(start[n].b + diff[n].b * i) + ',' + (start[n].a + diff[n].a * i) + ')');
                } else for(n = 0; n < len; n++)newVal.push((start[n] || 0) + diff[n] * i);
            } else if ($80cfd44d9d58fca9$var$colorAttrs.indexOf(key) !== -1) newVal = 'rgba(' + Math.round(start.r + diff.r * i) + ',' + Math.round(start.g + diff.g * i) + ',' + Math.round(start.b + diff.b * i) + ',' + (start.a + diff.a * i) + ')';
            else newVal = start + diff * i;
            node.setAttr(key, newVal);
        }
    }
    _addListeners() {
        this.tween.onPlay = ()=>{
            this.anim.start();
        };
        this.tween.onReverse = ()=>{
            this.anim.start();
        };
        this.tween.onPause = ()=>{
            this.anim.stop();
        };
        this.tween.onFinish = ()=>{
            var node = this.node;
            var attrs = $80cfd44d9d58fca9$export$208a41d6b4e37b97.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueEnd) node.setAttr('points', attrs.points.trueEnd);
            if (this.onFinish) this.onFinish.call(this);
        };
        this.tween.onReset = ()=>{
            var node = this.node;
            var attrs = $80cfd44d9d58fca9$export$208a41d6b4e37b97.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueStart) node.points(attrs.points.trueStart);
            if (this.onReset) this.onReset();
        };
        this.tween.onUpdate = ()=>{
            if (this.onUpdate) this.onUpdate.call(this);
        };
    }
    play() {
        this.tween.play();
        return this;
    }
    reverse() {
        this.tween.reverse();
        return this;
    }
    reset() {
        this.tween.reset();
        return this;
    }
    seek(t) {
        this.tween.seek(t * 1000);
        return this;
    }
    pause() {
        this.tween.pause();
        return this;
    }
    finish() {
        this.tween.finish();
        return this;
    }
    destroy() {
        var nodeId = this.node._id, thisId = this._id, attrs = $80cfd44d9d58fca9$export$208a41d6b4e37b97.tweens[nodeId], key;
        this.pause();
        for(key in attrs)delete $80cfd44d9d58fca9$export$208a41d6b4e37b97.tweens[nodeId][key];
        delete $80cfd44d9d58fca9$export$208a41d6b4e37b97.attrs[nodeId][thisId];
    }
}
$80cfd44d9d58fca9$export$208a41d6b4e37b97.attrs = {};
$80cfd44d9d58fca9$export$208a41d6b4e37b97.tweens = {};
(0, $8cc6866a67050653$export$85c928794f8d04d4).prototype.to = function(params) {
    var onFinish = params.onFinish;
    params.node = this;
    params.onFinish = function() {
        this.destroy();
        if (onFinish) onFinish();
    };
    var tween = new $80cfd44d9d58fca9$export$208a41d6b4e37b97(params);
    tween.play();
};
const $80cfd44d9d58fca9$export$ade85cc9682adcc5 = {
    BackEaseIn (t, b, c, d) {
        var s = 1.70158;
        return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
    BackEaseOut (t, b, c, d) {
        var s = 1.70158;
        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    },
    BackEaseInOut (t, b, c, d) {
        var s = 1.70158;
        if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
        return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    },
    ElasticEaseIn (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    },
    ElasticEaseOut (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
    },
    ElasticEaseInOut (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) return b;
        if ((t /= d / 2) === 2) return b + c;
        if (!p) p = d * (0.3 * 1.5);
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
    },
    BounceEaseOut (t, b, c, d) {
        if ((t /= d) < 1 / 2.75) return c * (7.5625 * t * t) + b;
        else if (t < 2 / 2.75) return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
        else if (t < 2.5 / 2.75) return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
        else return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
    },
    BounceEaseIn (t, b, c, d) {
        return c - $80cfd44d9d58fca9$export$ade85cc9682adcc5.BounceEaseOut(d - t, 0, c, d) + b;
    },
    BounceEaseInOut (t, b, c, d) {
        if (t < d / 2) return $80cfd44d9d58fca9$export$ade85cc9682adcc5.BounceEaseIn(t * 2, 0, c, d) * 0.5 + b;
        else return $80cfd44d9d58fca9$export$ade85cc9682adcc5.BounceEaseOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
    },
    EaseIn (t, b, c, d) {
        return c * (t /= d) * t + b;
    },
    EaseOut (t, b, c, d) {
        return -c * (t /= d) * (t - 2) + b;
    },
    EaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t + b;
        return -c / 2 * (--t * (t - 2) - 1) + b;
    },
    StrongEaseIn (t, b, c, d) {
        return c * (t /= d) * t * t * t * t + b;
    },
    StrongEaseOut (t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    StrongEaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    },
    Linear (t, b, c, d) {
        return c * t / d + b;
    }
};




const $9c82b2654798ec55$export$b9f99057a3c7692 = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._assign((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692), {
    Util: $87c9acccd58fa09f$export$f8f26dd395d7e1bd,
    Transform: $87c9acccd58fa09f$export$563a914cafbdc389,
    Node: $8cc6866a67050653$export$85c928794f8d04d4,
    Container: $9f54aa5dda3991e2$export$42a852a2b6b56249,
    Stage: $37aa1e5267331116$export$208cd1682bd0e4b6,
    stages: $37aa1e5267331116$export$1bfcff8d7c4bf05,
    Layer: $2f09c14a87b5ab29$export$936d0764594b6eb3,
    FastLayer: $fe83f0ffc52fbfa2$export$92d64f29192d1118,
    Group: $436734b80159e85f$export$eb2fcfdbd7ba97d4,
    DD: $e4e4f81e7d9ab51e$export$e34f1b340034d7f,
    Shape: $83649c293dd1d496$export$6428a7f2611ef1fa,
    shapes: $83649c293dd1d496$export$4ff7fc6f1af248b5,
    Animation: $a9b955fe6a1c7aff$export$c35d437ae5945fcd,
    Tween: $80cfd44d9d58fca9$export$208a41d6b4e37b97,
    Easings: $80cfd44d9d58fca9$export$ade85cc9682adcc5,
    Context: $a876609bfdb739fd$export$841858b892ce1f4c,
    Canvas: $2875393762565d65$export$8d01c972ee8b14a9
});
var $9c82b2654798ec55$export$2e2bcd8739ae039 = $9c82b2654798ec55$export$b9f99057a3c7692;






class $82230a9698c5d3c4$export$6ef80ffb606dd232 extends (0, $83649c293dd1d496$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var angle = (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).getAngle(this.angle()), clockwise = this.clockwise();
        context.beginPath();
        context.arc(0, 0, this.outerRadius(), 0, angle, clockwise);
        context.arc(0, 0, this.innerRadius(), angle, 0, !clockwise);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
    getSelfRect() {
        const innerRadius = this.innerRadius();
        const outerRadius = this.outerRadius();
        const clockwise = this.clockwise();
        const angle = (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).getAngle(clockwise ? 360 - this.angle() : this.angle());
        const boundLeftRatio = Math.cos(Math.min(angle, Math.PI));
        const boundRightRatio = 1;
        const boundTopRatio = Math.sin(Math.min(Math.max(Math.PI, angle), 3 * Math.PI / 2));
        const boundBottomRatio = Math.sin(Math.min(angle, Math.PI / 2));
        const boundLeft = boundLeftRatio * (boundLeftRatio > 0 ? innerRadius : outerRadius);
        const boundRight = boundRightRatio * (boundRightRatio > 0 ? outerRadius : innerRadius);
        const boundTop = boundTopRatio * (boundTopRatio > 0 ? innerRadius : outerRadius);
        const boundBottom = boundBottomRatio * (boundBottomRatio > 0 ? outerRadius : innerRadius);
        return {
            x: boundLeft,
            y: clockwise ? -1 * boundBottom : boundTop,
            width: boundRight - boundLeft,
            height: boundBottom - boundTop
        };
    }
}
$82230a9698c5d3c4$export$6ef80ffb606dd232.prototype._centroid = true;
$82230a9698c5d3c4$export$6ef80ffb606dd232.prototype.className = 'Arc';
$82230a9698c5d3c4$export$6ef80ffb606dd232.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius'
];
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($82230a9698c5d3c4$export$6ef80ffb606dd232);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($82230a9698c5d3c4$export$6ef80ffb606dd232, 'innerRadius', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($82230a9698c5d3c4$export$6ef80ffb606dd232, 'outerRadius', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($82230a9698c5d3c4$export$6ef80ffb606dd232, 'angle', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($82230a9698c5d3c4$export$6ef80ffb606dd232, 'clockwise', false, (0, $0e51c174430907a2$export$147fc8b6cd20fda1)());







function $0f0d3262ac6f36e9$var$getControlPoints(x0, y0, x1, y1, x2, y2, t) {
    var d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)), d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)), fa = t * d01 / (d01 + d12), fb = t * d12 / (d01 + d12), p1x = x1 - fa * (x2 - x0), p1y = y1 - fa * (y2 - y0), p2x = x1 + fb * (x2 - x0), p2y = y1 + fb * (y2 - y0);
    return [
        p1x,
        p1y,
        p2x,
        p2y
    ];
}
function $0f0d3262ac6f36e9$var$expandPoints(p, tension) {
    var len = p.length, allPoints = [], n, cp;
    for(n = 2; n < len - 2; n += 2){
        cp = $0f0d3262ac6f36e9$var$getControlPoints(p[n - 2], p[n - 1], p[n], p[n + 1], p[n + 2], p[n + 3], tension);
        if (isNaN(cp[0])) continue;
        allPoints.push(cp[0]);
        allPoints.push(cp[1]);
        allPoints.push(p[n]);
        allPoints.push(p[n + 1]);
        allPoints.push(cp[2]);
        allPoints.push(cp[3]);
    }
    return allPoints;
}
class $0f0d3262ac6f36e9$export$17d680238e50603e extends (0, $83649c293dd1d496$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this.on('pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva', function() {
            this._clearCache('tensionPoints');
        });
    }
    _sceneFunc(context) {
        var points = this.points(), length = points.length, tension = this.tension(), closed = this.closed(), bezier = this.bezier(), tp, len, n;
        if (!length) return;
        context.beginPath();
        context.moveTo(points[0], points[1]);
        if (tension !== 0 && length > 4) {
            tp = this.getTensionPoints();
            len = tp.length;
            n = closed ? 0 : 4;
            if (!closed) context.quadraticCurveTo(tp[0], tp[1], tp[2], tp[3]);
            while(n < len - 2)context.bezierCurveTo(tp[n++], tp[n++], tp[n++], tp[n++], tp[n++], tp[n++]);
            if (!closed) context.quadraticCurveTo(tp[len - 2], tp[len - 1], points[length - 2], points[length - 1]);
        } else if (bezier) {
            n = 2;
            while(n < length)context.bezierCurveTo(points[n++], points[n++], points[n++], points[n++], points[n++], points[n++]);
        } else for(n = 2; n < length; n += 2)context.lineTo(points[n], points[n + 1]);
        if (closed) {
            context.closePath();
            context.fillStrokeShape(this);
        } else context.strokeShape(this);
    }
    getTensionPoints() {
        return this._getCache('tensionPoints', this._getTensionPoints);
    }
    _getTensionPoints() {
        if (this.closed()) return this._getTensionPointsClosed();
        else return $0f0d3262ac6f36e9$var$expandPoints(this.points(), this.tension());
    }
    _getTensionPointsClosed() {
        var p = this.points(), len = p.length, tension = this.tension(), firstControlPoints = $0f0d3262ac6f36e9$var$getControlPoints(p[len - 2], p[len - 1], p[0], p[1], p[2], p[3], tension), lastControlPoints = $0f0d3262ac6f36e9$var$getControlPoints(p[len - 4], p[len - 3], p[len - 2], p[len - 1], p[0], p[1], tension), middle = $0f0d3262ac6f36e9$var$expandPoints(p, tension), tp = [
            firstControlPoints[2],
            firstControlPoints[3]
        ].concat(middle).concat([
            lastControlPoints[0],
            lastControlPoints[1],
            p[len - 2],
            p[len - 1],
            lastControlPoints[2],
            lastControlPoints[3],
            firstControlPoints[0],
            firstControlPoints[1],
            p[0],
            p[1]
        ]);
        return tp;
    }
    getWidth() {
        return this.getSelfRect().width;
    }
    getHeight() {
        return this.getSelfRect().height;
    }
    getSelfRect() {
        var points = this.points();
        if (points.length < 4) return {
            x: points[0] || 0,
            y: points[1] || 0,
            width: 0,
            height: 0
        };
        if (this.tension() !== 0) points = [
            points[0],
            points[1],
            ...this._getTensionPoints(),
            points[points.length - 2],
            points[points.length - 1]
        ];
        else points = this.points();
        var minX = points[0];
        var maxX = points[0];
        var minY = points[1];
        var maxY = points[1];
        var x, y;
        for(var i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
}
$0f0d3262ac6f36e9$export$17d680238e50603e.prototype.className = 'Line';
$0f0d3262ac6f36e9$export$17d680238e50603e.prototype._attrsAffectingSize = [
    'points',
    'bezier',
    'tension'
];
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($0f0d3262ac6f36e9$export$17d680238e50603e);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($0f0d3262ac6f36e9$export$17d680238e50603e, 'closed', false);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($0f0d3262ac6f36e9$export$17d680238e50603e, 'bezier', false);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($0f0d3262ac6f36e9$export$17d680238e50603e, 'tension', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($0f0d3262ac6f36e9$export$17d680238e50603e, 'points', [], (0, $0e51c174430907a2$export$42b6f8f340e9a165)());







class $a87b11181a0f7921$export$4b2950bdac9b6ee9 extends (0, $83649c293dd1d496$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this.dataArray = [];
        this.pathLength = 0;
        this.dataArray = $a87b11181a0f7921$export$4b2950bdac9b6ee9.parsePathData(this.data());
        this.pathLength = 0;
        for(var i = 0; i < this.dataArray.length; ++i)this.pathLength += this.dataArray[i].pathLength;
        this.on('dataChange.konva', function() {
            this.dataArray = $a87b11181a0f7921$export$4b2950bdac9b6ee9.parsePathData(this.data());
            this.pathLength = 0;
            for(var i = 0; i < this.dataArray.length; ++i)this.pathLength += this.dataArray[i].pathLength;
        });
    }
    _sceneFunc(context) {
        var ca = this.dataArray;
        context.beginPath();
        var isClosed = false;
        for(var n = 0; n < ca.length; n++){
            var c = ca[n].command;
            var p = ca[n].points;
            switch(c){
                case 'L':
                    context.lineTo(p[0], p[1]);
                    break;
                case 'M':
                    context.moveTo(p[0], p[1]);
                    break;
                case 'C':
                    context.bezierCurveTo(p[0], p[1], p[2], p[3], p[4], p[5]);
                    break;
                case 'Q':
                    context.quadraticCurveTo(p[0], p[1], p[2], p[3]);
                    break;
                case 'A':
                    var cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6], fs = p[7];
                    var r = rx > ry ? rx : ry;
                    var scaleX = rx > ry ? 1 : rx / ry;
                    var scaleY = rx > ry ? ry / rx : 1;
                    context.translate(cx, cy);
                    context.rotate(psi);
                    context.scale(scaleX, scaleY);
                    context.arc(0, 0, r, theta, theta + dTheta, 1 - fs);
                    context.scale(1 / scaleX, 1 / scaleY);
                    context.rotate(-psi);
                    context.translate(-cx, -cy);
                    break;
                case 'z':
                    isClosed = true;
                    context.closePath();
                    break;
            }
        }
        if (!isClosed && !this.hasFill()) context.strokeShape(this);
        else context.fillStrokeShape(this);
    }
    getSelfRect() {
        var points = [];
        this.dataArray.forEach(function(data) {
            if (data.command === 'A') {
                var start = data.points[4];
                var dTheta = data.points[5];
                var end = data.points[4] + dTheta;
                var inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                if (dTheta < 0) for(let t = start - inc; t > end; t -= inc){
                    const point = $a87b11181a0f7921$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                    points.push(point.x, point.y);
                }
                else for(let t = start + inc; t < end; t += inc){
                    const point = $a87b11181a0f7921$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                    points.push(point.x, point.y);
                }
            } else if (data.command === 'C') for(let t = 0.0; t <= 1; t += 0.01){
                const point = $a87b11181a0f7921$export$4b2950bdac9b6ee9.getPointOnCubicBezier(t, data.start.x, data.start.y, data.points[0], data.points[1], data.points[2], data.points[3], data.points[4], data.points[5]);
                points.push(point.x, point.y);
            }
            else points = points.concat(data.points);
        });
        var minX = points[0];
        var maxX = points[0];
        var minY = points[1];
        var maxY = points[1];
        var x, y;
        for(var i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            if (!isNaN(x)) {
                minX = Math.min(minX, x);
                maxX = Math.max(maxX, x);
            }
            if (!isNaN(y)) {
                minY = Math.min(minY, y);
                maxY = Math.max(maxY, y);
            }
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    getLength() {
        return this.pathLength;
    }
    getPointAtLength(length) {
        var point, i = 0, ii = this.dataArray.length;
        if (!ii) return null;
        while(i < ii && length > this.dataArray[i].pathLength){
            length -= this.dataArray[i].pathLength;
            ++i;
        }
        if (i === ii) {
            point = this.dataArray[i - 1].points.slice(-2);
            return {
                x: point[0],
                y: point[1]
            };
        }
        if (length < 0.01) {
            point = this.dataArray[i].points.slice(0, 2);
            return {
                x: point[0],
                y: point[1]
            };
        }
        var cp = this.dataArray[i];
        var p = cp.points;
        switch(cp.command){
            case 'L':
                return $a87b11181a0f7921$export$4b2950bdac9b6ee9.getPointOnLine(length, cp.start.x, cp.start.y, p[0], p[1]);
            case 'C':
                return $a87b11181a0f7921$export$4b2950bdac9b6ee9.getPointOnCubicBezier(length / cp.pathLength, cp.start.x, cp.start.y, p[0], p[1], p[2], p[3], p[4], p[5]);
            case 'Q':
                return $a87b11181a0f7921$export$4b2950bdac9b6ee9.getPointOnQuadraticBezier(length / cp.pathLength, cp.start.x, cp.start.y, p[0], p[1], p[2], p[3]);
            case 'A':
                var cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6];
                theta += dTheta * length / cp.pathLength;
                return $a87b11181a0f7921$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi);
        }
        return null;
    }
    static getLineLength(x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    static getPointOnLine(dist, P1x, P1y, P2x, P2y, fromX, fromY) {
        if (fromX === undefined) fromX = P1x;
        if (fromY === undefined) fromY = P1y;
        var m = (P2y - P1y) / (P2x - P1x + 0.00000001);
        var run = Math.sqrt(dist * dist / (1 + m * m));
        if (P2x < P1x) run *= -1;
        var rise = m * run;
        var pt;
        if (P2x === P1x) pt = {
            x: fromX,
            y: fromY + rise
        };
        else if ((fromY - P1y) / (fromX - P1x + 0.00000001) === m) pt = {
            x: fromX + run,
            y: fromY + rise
        };
        else {
            var ix, iy;
            var len = this.getLineLength(P1x, P1y, P2x, P2y);
            var u = (fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y);
            u = u / (len * len);
            ix = P1x + u * (P2x - P1x);
            iy = P1y + u * (P2y - P1y);
            var pRise = this.getLineLength(fromX, fromY, ix, iy);
            var pRun = Math.sqrt(dist * dist - pRise * pRise);
            run = Math.sqrt(pRun * pRun / (1 + m * m));
            if (P2x < P1x) run *= -1;
            rise = m * run;
            pt = {
                x: ix + run,
                y: iy + rise
            };
        }
        return pt;
    }
    static getPointOnCubicBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y, P4x, P4y) {
        function CB1(t) {
            return t * t * t;
        }
        function CB2(t) {
            return 3 * t * t * (1 - t);
        }
        function CB3(t) {
            return 3 * t * (1 - t) * (1 - t);
        }
        function CB4(t) {
            return (1 - t) * (1 - t) * (1 - t);
        }
        var x = P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct);
        var y = P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnQuadraticBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y) {
        function QB1(t) {
            return t * t;
        }
        function QB2(t) {
            return 2 * t * (1 - t);
        }
        function QB3(t) {
            return (1 - t) * (1 - t);
        }
        var x = P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct);
        var y = P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
        var cosPsi = Math.cos(psi), sinPsi = Math.sin(psi);
        var pt = {
            x: rx * Math.cos(theta),
            y: ry * Math.sin(theta)
        };
        return {
            x: cx + (pt.x * cosPsi - pt.y * sinPsi),
            y: cy + (pt.x * sinPsi + pt.y * cosPsi)
        };
    }
    static parsePathData(data) {
        if (!data) return [];
        var cs = data;
        var cc = [
            'm',
            'M',
            'l',
            'L',
            'v',
            'V',
            'h',
            'H',
            'z',
            'Z',
            'c',
            'C',
            'q',
            'Q',
            't',
            'T',
            's',
            'S',
            'a',
            'A'
        ];
        cs = cs.replace(new RegExp(' ', 'g'), ',');
        for(var n = 0; n < cc.length; n++)cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
        var arr = cs.split('|');
        var ca = [];
        var coords = [];
        var cpx = 0;
        var cpy = 0;
        var re = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
        var match;
        for(n = 1; n < arr.length; n++){
            var str = arr[n];
            var c = str.charAt(0);
            str = str.slice(1);
            coords.length = 0;
            while(match = re.exec(str))coords.push(match[0]);
            var p = [];
            for(var j = 0, jlen = coords.length; j < jlen; j++){
                if (coords[j] === '00') {
                    p.push(0, 0);
                    continue;
                }
                var parsed = parseFloat(coords[j]);
                if (!isNaN(parsed)) p.push(parsed);
                else p.push(0);
            }
            while(p.length > 0){
                if (isNaN(p[0])) break;
                var cmd = null;
                var points = [];
                var startX = cpx, startY = cpy;
                var prevCmd, ctlPtx, ctlPty;
                var rx, ry, psi, fa, fs, x1, y1;
                switch(c){
                    case 'l':
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'L':
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'm':
                        var dx = p.shift();
                        var dy = p.shift();
                        cpx += dx;
                        cpy += dy;
                        cmd = 'M';
                        if (ca.length > 2 && ca[ca.length - 1].command === 'z') {
                            for(var idx = ca.length - 2; idx >= 0; idx--)if (ca[idx].command === 'M') {
                                cpx = ca[idx].points[0] + dx;
                                cpy = ca[idx].points[1] + dy;
                                break;
                            }
                        }
                        points.push(cpx, cpy);
                        c = 'l';
                        break;
                    case 'M':
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'M';
                        points.push(cpx, cpy);
                        c = 'L';
                        break;
                    case 'h':
                        cpx += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'H':
                        cpx = p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'v':
                        cpy += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'V':
                        cpy = p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'C':
                        points.push(p.shift(), p.shift(), p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'c':
                        points.push(cpx + p.shift(), cpy + p.shift(), cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 'S':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'C') {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 's':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'C') {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 'Q':
                        points.push(p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'q':
                        points.push(cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'Q';
                        points.push(cpx, cpy);
                        break;
                    case 'T':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'Q') {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'Q';
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 't':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'Q') {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'Q';
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 'A':
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'A';
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                    case 'a':
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'A';
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                }
                ca.push({
                    command: cmd || c,
                    points: points,
                    start: {
                        x: startX,
                        y: startY
                    },
                    pathLength: this.calcLength(startX, startY, cmd || c, points)
                });
            }
            if (c === 'z' || c === 'Z') ca.push({
                command: 'z',
                points: [],
                start: undefined,
                pathLength: 0
            });
        }
        return ca;
    }
    static calcLength(x, y, cmd, points) {
        var len, p1, p2, t;
        var path = $a87b11181a0f7921$export$4b2950bdac9b6ee9;
        switch(cmd){
            case 'L':
                return path.getLineLength(x, y, points[0], points[1]);
            case 'C':
                len = 0.0;
                p1 = path.getPointOnCubicBezier(0, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);
                for(t = 0.01; t <= 1; t += 0.01){
                    p2 = path.getPointOnCubicBezier(t, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                return len;
            case 'Q':
                len = 0.0;
                p1 = path.getPointOnQuadraticBezier(0, x, y, points[0], points[1], points[2], points[3]);
                for(t = 0.01; t <= 1; t += 0.01){
                    p2 = path.getPointOnQuadraticBezier(t, x, y, points[0], points[1], points[2], points[3]);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                return len;
            case 'A':
                len = 0.0;
                var start = points[4];
                var dTheta = points[5];
                var end = points[4] + dTheta;
                var inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                p1 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);
                if (dTheta < 0) for(t = start - inc; t > end; t -= inc){
                    p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                else for(t = start + inc; t < end; t += inc){
                    p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
                len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                return len;
        }
        return 0;
    }
    static convertEndpointToCenterParameterization(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg) {
        var psi = psiDeg * (Math.PI / 180.0);
        var xp = Math.cos(psi) * (x1 - x2) / 2.0 + Math.sin(psi) * (y1 - y2) / 2.0;
        var yp = -1 * Math.sin(psi) * (x1 - x2) / 2.0 + Math.cos(psi) * (y1 - y2) / 2.0;
        var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
        if (lambda > 1) {
            rx *= Math.sqrt(lambda);
            ry *= Math.sqrt(lambda);
        }
        var f = Math.sqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp)));
        if (fa === fs) f *= -1;
        if (isNaN(f)) f = 0;
        var cxp = f * rx * yp / ry;
        var cyp = f * -ry * xp / rx;
        var cx = (x1 + x2) / 2.0 + Math.cos(psi) * cxp - Math.sin(psi) * cyp;
        var cy = (y1 + y2) / 2.0 + Math.sin(psi) * cxp + Math.cos(psi) * cyp;
        var vMag = function(v) {
            return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
        };
        var vRatio = function(u, v) {
            return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
        };
        var vAngle = function(u, v) {
            return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
        };
        var theta = vAngle([
            1,
            0
        ], [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ]);
        var u = [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ];
        var v = [
            (-1 * xp - cxp) / rx,
            (-1 * yp - cyp) / ry
        ];
        var dTheta = vAngle(u, v);
        if (vRatio(u, v) <= -1) dTheta = Math.PI;
        if (vRatio(u, v) >= 1) dTheta = 0;
        if (fs === 0 && dTheta > 0) dTheta = dTheta - 2 * Math.PI;
        if (fs === 1 && dTheta < 0) dTheta = dTheta + 2 * Math.PI;
        return [
            cx,
            cy,
            rx,
            ry,
            theta,
            dTheta,
            psi,
            fs
        ];
    }
}
$a87b11181a0f7921$export$4b2950bdac9b6ee9.prototype.className = 'Path';
$a87b11181a0f7921$export$4b2950bdac9b6ee9.prototype._attrsAffectingSize = [
    'data'
];
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($a87b11181a0f7921$export$4b2950bdac9b6ee9);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($a87b11181a0f7921$export$4b2950bdac9b6ee9, 'data');


class $98b516c61ac16d08$export$21b07c8f274aebd5 extends (0, $0f0d3262ac6f36e9$export$17d680238e50603e) {
    _sceneFunc(ctx) {
        super._sceneFunc(ctx);
        var PI2 = Math.PI * 2;
        var points = this.points();
        var tp = points;
        var fromTension = this.tension() !== 0 && points.length > 4;
        if (fromTension) tp = this.getTensionPoints();
        var length = this.pointerLength();
        var n = points.length;
        var dx, dy;
        if (fromTension) {
            const lp = [
                tp[tp.length - 4],
                tp[tp.length - 3],
                tp[tp.length - 2],
                tp[tp.length - 1],
                points[n - 2],
                points[n - 1]
            ];
            const lastLength = (0, $a87b11181a0f7921$export$4b2950bdac9b6ee9).calcLength(tp[tp.length - 4], tp[tp.length - 3], 'C', lp);
            const previous = (0, $a87b11181a0f7921$export$4b2950bdac9b6ee9).getPointOnQuadraticBezier(Math.min(1, 1 - length / lastLength), lp[0], lp[1], lp[2], lp[3], lp[4], lp[5]);
            dx = points[n - 2] - previous.x;
            dy = points[n - 1] - previous.y;
        } else {
            dx = points[n - 2] - points[n - 4];
            dy = points[n - 1] - points[n - 3];
        }
        var radians = (Math.atan2(dy, dx) + PI2) % PI2;
        var width = this.pointerWidth();
        if (this.pointerAtEnding()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[n - 2], points[n - 1]);
            ctx.rotate(radians);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
        if (this.pointerAtBeginning()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[0], points[1]);
            if (fromTension) {
                dx = (tp[0] + tp[2]) / 2 - points[0];
                dy = (tp[1] + tp[3]) / 2 - points[1];
            } else {
                dx = points[2] - points[0];
                dy = points[3] - points[1];
            }
            ctx.rotate((Math.atan2(-dy, -dx) + PI2) % PI2);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
    }
    __fillStroke(ctx) {
        var isDashEnabled = this.dashEnabled();
        if (isDashEnabled) {
            this.attrs.dashEnabled = false;
            ctx.setLineDash([]);
        }
        ctx.fillStrokeShape(this);
        if (isDashEnabled) this.attrs.dashEnabled = true;
    }
    getSelfRect() {
        const lineRect = super.getSelfRect();
        const offset = this.pointerWidth() / 2;
        return {
            x: lineRect.x - offset,
            y: lineRect.y - offset,
            width: lineRect.width + offset * 2,
            height: lineRect.height + offset * 2
        };
    }
}
$98b516c61ac16d08$export$21b07c8f274aebd5.prototype.className = 'Arrow';
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($98b516c61ac16d08$export$21b07c8f274aebd5);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($98b516c61ac16d08$export$21b07c8f274aebd5, 'pointerLength', 10, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($98b516c61ac16d08$export$21b07c8f274aebd5, 'pointerWidth', 10, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($98b516c61ac16d08$export$21b07c8f274aebd5, 'pointerAtBeginning', false);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($98b516c61ac16d08$export$21b07c8f274aebd5, 'pointerAtEnding', true);






class $9d9aa146403da755$export$c89a927ffc67e6fa extends (0, $83649c293dd1d496$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        if (this.radius() !== width / 2) this.radius(width / 2);
    }
    setHeight(height) {
        if (this.radius() !== height / 2) this.radius(height / 2);
    }
}
$9d9aa146403da755$export$c89a927ffc67e6fa.prototype._centroid = true;
$9d9aa146403da755$export$c89a927ffc67e6fa.prototype.className = 'Circle';
$9d9aa146403da755$export$c89a927ffc67e6fa.prototype._attrsAffectingSize = [
    'radius'
];
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($9d9aa146403da755$export$c89a927ffc67e6fa);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($9d9aa146403da755$export$c89a927ffc67e6fa, 'radius', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());






class $493f13a63261025e$export$80b0269ab108fa11 extends (0, $83649c293dd1d496$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var rx = this.radiusX(), ry = this.radiusY();
        context.beginPath();
        context.save();
        if (rx !== ry) context.scale(1, ry / rx);
        context.arc(0, 0, rx, 0, Math.PI * 2, false);
        context.restore();
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radiusX() * 2;
    }
    getHeight() {
        return this.radiusY() * 2;
    }
    setWidth(width) {
        this.radiusX(width / 2);
    }
    setHeight(height) {
        this.radiusY(height / 2);
    }
}
$493f13a63261025e$export$80b0269ab108fa11.prototype.className = 'Ellipse';
$493f13a63261025e$export$80b0269ab108fa11.prototype._centroid = true;
$493f13a63261025e$export$80b0269ab108fa11.prototype._attrsAffectingSize = [
    'radiusX',
    'radiusY'
];
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($493f13a63261025e$export$80b0269ab108fa11);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addComponentsGetterSetter($493f13a63261025e$export$80b0269ab108fa11, 'radius', [
    'x',
    'y'
]);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($493f13a63261025e$export$80b0269ab108fa11, 'radiusX', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($493f13a63261025e$export$80b0269ab108fa11, 'radiusY', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());







class $15fc9fbddbc2b775$export$3e431a229df88919 extends (0, $83649c293dd1d496$export$6428a7f2611ef1fa) {
    constructor(attrs){
        super(attrs);
        this.on('imageChange.konva', ()=>{
            this._setImageLoad();
        });
        this._setImageLoad();
    }
    _setImageLoad() {
        const image = this.image();
        if (image && image.complete) return;
        if (image && image.readyState === 4) return;
        if (image && image['addEventListener']) image['addEventListener']('load', ()=>{
            this._requestDraw();
        });
    }
    _useBufferCanvas() {
        return super._useBufferCanvas(true);
    }
    _sceneFunc(context) {
        const width = this.getWidth();
        const height = this.getHeight();
        const cornerRadius = this.cornerRadius();
        const image = this.attrs.image;
        let params;
        if (image) {
            const cropWidth = this.attrs.cropWidth;
            const cropHeight = this.attrs.cropHeight;
            if (cropWidth && cropHeight) params = [
                image,
                this.cropX(),
                this.cropY(),
                cropWidth,
                cropHeight,
                0,
                0,
                width,
                height
            ];
            else params = [
                image,
                0,
                0,
                width,
                height
            ];
        }
        if (this.hasFill() || this.hasStroke() || cornerRadius) {
            context.beginPath();
            cornerRadius ? (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius) : context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (cornerRadius) context.clip();
            context.drawImage.apply(context, params);
        }
    }
    _hitFunc(context) {
        var width = this.width(), height = this.height(), cornerRadius = this.cornerRadius();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        var _a, _b;
        return (_a = this.attrs.width) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.width;
    }
    getHeight() {
        var _a, _b;
        return (_a = this.attrs.height) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.height;
    }
    static fromURL(url, callback, onError = null) {
        var img = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).createImageElement();
        img.onload = function() {
            var image = new $15fc9fbddbc2b775$export$3e431a229df88919({
                image: img
            });
            callback(image);
        };
        img.onerror = onError;
        img.crossOrigin = 'Anonymous';
        img.src = url;
    }
}
$15fc9fbddbc2b775$export$3e431a229df88919.prototype.className = 'Image';
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($15fc9fbddbc2b775$export$3e431a229df88919);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($15fc9fbddbc2b775$export$3e431a229df88919, 'cornerRadius', 0, (0, $0e51c174430907a2$export$7d4ab1842c1b264b)(4));
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($15fc9fbddbc2b775$export$3e431a229df88919, 'image');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addComponentsGetterSetter($15fc9fbddbc2b775$export$3e431a229df88919, 'crop', [
    'x',
    'y',
    'width',
    'height'
]);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($15fc9fbddbc2b775$export$3e431a229df88919, 'cropX', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($15fc9fbddbc2b775$export$3e431a229df88919, 'cropY', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($15fc9fbddbc2b775$export$3e431a229df88919, 'cropWidth', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($15fc9fbddbc2b775$export$3e431a229df88919, 'cropHeight', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());







var $49bd09d345e0d5e6$var$ATTR_CHANGE_LIST = [
    'fontFamily',
    'fontSize',
    'fontStyle',
    'padding',
    'lineHeight',
    'text',
    'width',
    'height',
    'pointerDirection',
    'pointerWidth',
    'pointerHeight'
], $49bd09d345e0d5e6$var$CHANGE_KONVA = 'Change.konva', $49bd09d345e0d5e6$var$NONE = 'none', $49bd09d345e0d5e6$var$UP = 'up', $49bd09d345e0d5e6$var$RIGHT = 'right', $49bd09d345e0d5e6$var$DOWN = 'down', $49bd09d345e0d5e6$var$LEFT = 'left', $49bd09d345e0d5e6$var$attrChangeListLen = $49bd09d345e0d5e6$var$ATTR_CHANGE_LIST.length;
class $49bd09d345e0d5e6$export$b04be29aa201d4f5 extends (0, $436734b80159e85f$export$eb2fcfdbd7ba97d4) {
    constructor(config){
        super(config);
        this.on('add.konva', function(evt) {
            this._addListeners(evt.child);
            this._sync();
        });
    }
    getText() {
        return this.find('Text')[0];
    }
    getTag() {
        return this.find('Tag')[0];
    }
    _addListeners(text) {
        var that = this, n;
        var func = function() {
            that._sync();
        };
        for(n = 0; n < $49bd09d345e0d5e6$var$attrChangeListLen; n++)text.on($49bd09d345e0d5e6$var$ATTR_CHANGE_LIST[n] + $49bd09d345e0d5e6$var$CHANGE_KONVA, func);
    }
    getWidth() {
        return this.getText().width();
    }
    getHeight() {
        return this.getText().height();
    }
    _sync() {
        var text = this.getText(), tag = this.getTag(), width, height, pointerDirection, pointerWidth, x, y, pointerHeight;
        if (text && tag) {
            width = text.width();
            height = text.height();
            pointerDirection = tag.pointerDirection();
            pointerWidth = tag.pointerWidth();
            pointerHeight = tag.pointerHeight();
            x = 0;
            y = 0;
            switch(pointerDirection){
                case $49bd09d345e0d5e6$var$UP:
                    x = width / 2;
                    y = -1 * pointerHeight;
                    break;
                case $49bd09d345e0d5e6$var$RIGHT:
                    x = width + pointerWidth;
                    y = height / 2;
                    break;
                case $49bd09d345e0d5e6$var$DOWN:
                    x = width / 2;
                    y = height + pointerHeight;
                    break;
                case $49bd09d345e0d5e6$var$LEFT:
                    x = -1 * pointerWidth;
                    y = height / 2;
                    break;
            }
            tag.setAttrs({
                x: -1 * x,
                y: -1 * y,
                width: width,
                height: height
            });
            text.setAttrs({
                x: -1 * x,
                y: -1 * y
            });
        }
    }
}
$49bd09d345e0d5e6$export$b04be29aa201d4f5.prototype.className = 'Label';
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($49bd09d345e0d5e6$export$b04be29aa201d4f5);
class $49bd09d345e0d5e6$export$3288d34c523a1192 extends (0, $83649c293dd1d496$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var width = this.width(), height = this.height(), pointerDirection = this.pointerDirection(), pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), cornerRadius = this.cornerRadius();
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === 'number') topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.beginPath();
        context.moveTo(topLeft, 0);
        if (pointerDirection === $49bd09d345e0d5e6$var$UP) {
            context.lineTo((width - pointerWidth) / 2, 0);
            context.lineTo(width / 2, -1 * pointerHeight);
            context.lineTo((width + pointerWidth) / 2, 0);
        }
        context.lineTo(width - topRight, 0);
        context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
        if (pointerDirection === $49bd09d345e0d5e6$var$RIGHT) {
            context.lineTo(width, (height - pointerHeight) / 2);
            context.lineTo(width + pointerWidth, height / 2);
            context.lineTo(width, (height + pointerHeight) / 2);
        }
        context.lineTo(width, height - bottomRight);
        context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        if (pointerDirection === $49bd09d345e0d5e6$var$DOWN) {
            context.lineTo((width + pointerWidth) / 2, height);
            context.lineTo(width / 2, height + pointerHeight);
            context.lineTo((width - pointerWidth) / 2, height);
        }
        context.lineTo(bottomLeft, height);
        context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        if (pointerDirection === $49bd09d345e0d5e6$var$LEFT) {
            context.lineTo(0, (height + pointerHeight) / 2);
            context.lineTo(-1 * pointerWidth, height / 2);
            context.lineTo(0, (height - pointerHeight) / 2);
        }
        context.lineTo(0, topLeft);
        context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getSelfRect() {
        var x = 0, y = 0, pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), direction = this.pointerDirection(), width = this.width(), height = this.height();
        if (direction === $49bd09d345e0d5e6$var$UP) {
            y -= pointerHeight;
            height += pointerHeight;
        } else if (direction === $49bd09d345e0d5e6$var$DOWN) height += pointerHeight;
        else if (direction === $49bd09d345e0d5e6$var$LEFT) {
            x -= pointerWidth * 1.5;
            width += pointerWidth;
        } else if (direction === $49bd09d345e0d5e6$var$RIGHT) width += pointerWidth * 1.5;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    }
}
$49bd09d345e0d5e6$export$3288d34c523a1192.prototype.className = 'Tag';
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($49bd09d345e0d5e6$export$3288d34c523a1192);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($49bd09d345e0d5e6$export$3288d34c523a1192, 'pointerDirection', $49bd09d345e0d5e6$var$NONE);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($49bd09d345e0d5e6$export$3288d34c523a1192, 'pointerWidth', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($49bd09d345e0d5e6$export$3288d34c523a1192, 'pointerHeight', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($49bd09d345e0d5e6$export$3288d34c523a1192, 'cornerRadius', 0, (0, $0e51c174430907a2$export$7d4ab1842c1b264b)(4));









class $0258dbc9803ecab0$export$c79fc6492f3af13d extends (0, $83649c293dd1d496$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var cornerRadius = this.cornerRadius(), width = this.width(), height = this.height();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
}
$0258dbc9803ecab0$export$c79fc6492f3af13d.prototype.className = 'Rect';
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($0258dbc9803ecab0$export$c79fc6492f3af13d);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($0258dbc9803ecab0$export$c79fc6492f3af13d, 'cornerRadius', 0, (0, $0e51c174430907a2$export$7d4ab1842c1b264b)(4));






class $74da23b272f77dc3$export$e2ee866164812ecd extends (0, $83649c293dd1d496$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const points = this._getPoints();
        context.beginPath();
        context.moveTo(points[0].x, points[0].y);
        for(var n = 1; n < points.length; n++)context.lineTo(points[n].x, points[n].y);
        context.closePath();
        context.fillStrokeShape(this);
    }
    _getPoints() {
        const sides = this.attrs.sides;
        const radius = this.attrs.radius || 0;
        const points = [];
        for(var n = 0; n < sides; n++)points.push({
            x: radius * Math.sin(n * 2 * Math.PI / sides),
            y: -1 * radius * Math.cos(n * 2 * Math.PI / sides)
        });
        return points;
    }
    getSelfRect() {
        const points = this._getPoints();
        var minX = points[0].x;
        var maxX = points[0].y;
        var minY = points[0].x;
        var maxY = points[0].y;
        points.forEach((point)=>{
            minX = Math.min(minX, point.x);
            maxX = Math.max(maxX, point.x);
            minY = Math.min(minY, point.y);
            maxY = Math.max(maxY, point.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
$74da23b272f77dc3$export$e2ee866164812ecd.prototype.className = 'RegularPolygon';
$74da23b272f77dc3$export$e2ee866164812ecd.prototype._centroid = true;
$74da23b272f77dc3$export$e2ee866164812ecd.prototype._attrsAffectingSize = [
    'radius'
];
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($74da23b272f77dc3$export$e2ee866164812ecd);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($74da23b272f77dc3$export$e2ee866164812ecd, 'radius', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($74da23b272f77dc3$export$e2ee866164812ecd, 'sides', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());






var $67ceece5cb9a9915$var$PIx2 = Math.PI * 2;
class $67ceece5cb9a9915$export$a6e3577650b6d6d7 extends (0, $83649c293dd1d496$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.innerRadius(), 0, $67ceece5cb9a9915$var$PIx2, false);
        context.moveTo(this.outerRadius(), 0);
        context.arc(0, 0, this.outerRadius(), $67ceece5cb9a9915$var$PIx2, 0, true);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
$67ceece5cb9a9915$export$a6e3577650b6d6d7.prototype.className = 'Ring';
$67ceece5cb9a9915$export$a6e3577650b6d6d7.prototype._centroid = true;
$67ceece5cb9a9915$export$a6e3577650b6d6d7.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius'
];
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($67ceece5cb9a9915$export$a6e3577650b6d6d7);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($67ceece5cb9a9915$export$a6e3577650b6d6d7, 'innerRadius', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($67ceece5cb9a9915$export$a6e3577650b6d6d7, 'outerRadius', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());







class $a10aa708bdcce0c0$export$3075603db8e6204c extends (0, $83649c293dd1d496$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this._updated = true;
        this.anim = new (0, $a9b955fe6a1c7aff$export$c35d437ae5945fcd)(()=>{
            var updated = this._updated;
            this._updated = false;
            return updated;
        });
        this.on('animationChange.konva', function() {
            this.frameIndex(0);
        });
        this.on('frameIndexChange.konva', function() {
            this._updated = true;
        });
        this.on('frameRateChange.konva', function() {
            if (!this.anim.isRunning()) return;
            clearInterval(this.interval);
            this._setInterval();
        });
    }
    _sceneFunc(context) {
        var anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), x = set[ix4 + 0], y = set[ix4 + 1], width = set[ix4 + 2], height = set[ix4 + 3], image = this.image();
        if (this.hasFill() || this.hasStroke()) {
            context.beginPath();
            context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (offsets) {
                var offset = offsets[anim], ix2 = index * 2;
                context.drawImage(image, x, y, width, height, offset[ix2 + 0], offset[ix2 + 1], width, height);
            } else context.drawImage(image, x, y, width, height, 0, 0, width, height);
        }
    }
    _hitFunc(context) {
        var anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), width = set[ix4 + 2], height = set[ix4 + 3];
        context.beginPath();
        if (offsets) {
            var offset = offsets[anim];
            var ix2 = index * 2;
            context.rect(offset[ix2 + 0], offset[ix2 + 1], width, height);
        } else context.rect(0, 0, width, height);
        context.closePath();
        context.fillShape(this);
    }
    _useBufferCanvas() {
        return super._useBufferCanvas(true);
    }
    _setInterval() {
        var that = this;
        this.interval = setInterval(function() {
            that._updateIndex();
        }, 1000 / this.frameRate());
    }
    start() {
        if (this.isRunning()) return;
        var layer = this.getLayer();
        this.anim.setLayers(layer);
        this._setInterval();
        this.anim.start();
    }
    stop() {
        this.anim.stop();
        clearInterval(this.interval);
    }
    isRunning() {
        return this.anim.isRunning();
    }
    _updateIndex() {
        var index = this.frameIndex(), animation = this.animation(), animations = this.animations(), anim = animations[animation], len = anim.length / 4;
        if (index < len - 1) this.frameIndex(index + 1);
        else this.frameIndex(0);
    }
}
$a10aa708bdcce0c0$export$3075603db8e6204c.prototype.className = 'Sprite';
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($a10aa708bdcce0c0$export$3075603db8e6204c);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($a10aa708bdcce0c0$export$3075603db8e6204c, 'animation');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($a10aa708bdcce0c0$export$3075603db8e6204c, 'animations');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($a10aa708bdcce0c0$export$3075603db8e6204c, 'frameOffsets');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($a10aa708bdcce0c0$export$3075603db8e6204c, 'image');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($a10aa708bdcce0c0$export$3075603db8e6204c, 'frameIndex', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($a10aa708bdcce0c0$export$3075603db8e6204c, 'frameRate', 17, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).backCompat($a10aa708bdcce0c0$export$3075603db8e6204c, {
    index: 'frameIndex',
    getIndex: 'getFrameIndex',
    setIndex: 'setFrameIndex'
});






class $b06f2eef1770a61e$export$1644ba17714857f1 extends (0, $83649c293dd1d496$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        var innerRadius = this.innerRadius(), outerRadius = this.outerRadius(), numPoints = this.numPoints();
        context.beginPath();
        context.moveTo(0, 0 - outerRadius);
        for(var n = 1; n < numPoints * 2; n++){
            var radius = n % 2 === 0 ? outerRadius : innerRadius;
            var x = radius * Math.sin(n * Math.PI / numPoints);
            var y = -1 * radius * Math.cos(n * Math.PI / numPoints);
            context.lineTo(x, y);
        }
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
$b06f2eef1770a61e$export$1644ba17714857f1.prototype.className = 'Star';
$b06f2eef1770a61e$export$1644ba17714857f1.prototype._centroid = true;
$b06f2eef1770a61e$export$1644ba17714857f1.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius'
];
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($b06f2eef1770a61e$export$1644ba17714857f1);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($b06f2eef1770a61e$export$1644ba17714857f1, 'numPoints', 5, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($b06f2eef1770a61e$export$1644ba17714857f1, 'innerRadius', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($b06f2eef1770a61e$export$1644ba17714857f1, 'outerRadius', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());







function $b7cb399147d124e6$export$b9ca061da17f2d30(string) {
    return Array.from(string);
}
var $b7cb399147d124e6$var$AUTO = 'auto', $b7cb399147d124e6$var$CENTER = 'center', $b7cb399147d124e6$var$JUSTIFY = 'justify', $b7cb399147d124e6$var$CHANGE_KONVA = 'Change.konva', $b7cb399147d124e6$var$CONTEXT_2D = '2d', $b7cb399147d124e6$var$DASH = '-', $b7cb399147d124e6$var$LEFT = 'left', $b7cb399147d124e6$var$TEXT = 'text', $b7cb399147d124e6$var$TEXT_UPPER = 'Text', $b7cb399147d124e6$var$TOP = 'top', $b7cb399147d124e6$var$BOTTOM = 'bottom', $b7cb399147d124e6$var$MIDDLE = 'middle', $b7cb399147d124e6$var$NORMAL = 'normal', $b7cb399147d124e6$var$PX_SPACE = 'px ', $b7cb399147d124e6$var$SPACE = ' ', $b7cb399147d124e6$var$RIGHT = 'right', $b7cb399147d124e6$var$WORD = 'word', $b7cb399147d124e6$var$CHAR = 'char', $b7cb399147d124e6$var$NONE = 'none', $b7cb399147d124e6$var$ELLIPSIS = "\u2026", $b7cb399147d124e6$var$ATTR_CHANGE_LIST = [
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontVariant',
    'padding',
    'align',
    'verticalAlign',
    'lineHeight',
    'text',
    'width',
    'height',
    'wrap',
    'ellipsis',
    'letterSpacing'
], $b7cb399147d124e6$var$attrChangeListLen = $b7cb399147d124e6$var$ATTR_CHANGE_LIST.length;
function $b7cb399147d124e6$var$normalizeFontFamily(fontFamily) {
    return fontFamily.split(',').map((family)=>{
        family = family.trim();
        const hasSpace = family.indexOf(' ') >= 0;
        const hasQuotes = family.indexOf('"') >= 0 || family.indexOf("'") >= 0;
        if (hasSpace && !hasQuotes) family = `"${family}"`;
        return family;
    }).join(', ');
}
var $b7cb399147d124e6$var$dummyContext;
function $b7cb399147d124e6$var$getDummyContext() {
    if ($b7cb399147d124e6$var$dummyContext) return $b7cb399147d124e6$var$dummyContext;
    $b7cb399147d124e6$var$dummyContext = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).createCanvasElement().getContext($b7cb399147d124e6$var$CONTEXT_2D);
    return $b7cb399147d124e6$var$dummyContext;
}
function $b7cb399147d124e6$var$_fillFunc(context) {
    context.fillText(this._partialText, this._partialTextX, this._partialTextY);
}
function $b7cb399147d124e6$var$_strokeFunc(context) {
    context.strokeText(this._partialText, this._partialTextX, this._partialTextY);
}
function $b7cb399147d124e6$var$checkDefaultFill(config) {
    config = config || {};
    if (!config.fillLinearGradientColorStops && !config.fillRadialGradientColorStops && !config.fillPatternImage) config.fill = config.fill || 'black';
    return config;
}
class $b7cb399147d124e6$export$5f1af8db9871e1d6 extends (0, $83649c293dd1d496$export$6428a7f2611ef1fa) {
    constructor(config){
        super($b7cb399147d124e6$var$checkDefaultFill(config));
        this._partialTextX = 0;
        this._partialTextY = 0;
        for(var n = 0; n < $b7cb399147d124e6$var$attrChangeListLen; n++)this.on($b7cb399147d124e6$var$ATTR_CHANGE_LIST[n] + $b7cb399147d124e6$var$CHANGE_KONVA, this._setTextData);
        this._setTextData();
    }
    _sceneFunc(context) {
        var textArr = this.textArr, textArrLen = textArr.length;
        if (!this.text()) return;
        var padding = this.padding(), fontSize = this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, verticalAlign = this.verticalAlign(), alignY = 0, align = this.align(), totalWidth = this.getWidth(), letterSpacing = this.letterSpacing(), fill = this.fill(), textDecoration = this.textDecoration(), shouldUnderline = textDecoration.indexOf('underline') !== -1, shouldLineThrough = textDecoration.indexOf('line-through') !== -1, n;
        var translateY = 0;
        var translateY = lineHeightPx / 2;
        var lineTranslateX = 0;
        var lineTranslateY = 0;
        context.setAttr('font', this._getContextFont());
        context.setAttr('textBaseline', $b7cb399147d124e6$var$MIDDLE);
        context.setAttr('textAlign', $b7cb399147d124e6$var$LEFT);
        if (verticalAlign === $b7cb399147d124e6$var$MIDDLE) alignY = (this.getHeight() - textArrLen * lineHeightPx - padding * 2) / 2;
        else if (verticalAlign === $b7cb399147d124e6$var$BOTTOM) alignY = this.getHeight() - textArrLen * lineHeightPx - padding * 2;
        context.translate(padding, alignY + padding);
        for(n = 0; n < textArrLen; n++){
            var lineTranslateX = 0;
            var lineTranslateY = 0;
            var obj = textArr[n], text = obj.text, width = obj.width, lastLine = obj.lastInParagraph, spacesNumber, oneWord, lineWidth;
            context.save();
            if (align === $b7cb399147d124e6$var$RIGHT) lineTranslateX += totalWidth - width - padding * 2;
            else if (align === $b7cb399147d124e6$var$CENTER) lineTranslateX += (totalWidth - width - padding * 2) / 2;
            if (shouldUnderline) {
                context.save();
                context.beginPath();
                context.moveTo(lineTranslateX, translateY + lineTranslateY + Math.round(fontSize / 2));
                spacesNumber = text.split(' ').length - 1;
                oneWord = spacesNumber === 0;
                lineWidth = align === $b7cb399147d124e6$var$JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
                context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY + Math.round(fontSize / 2));
                context.lineWidth = fontSize / 15;
                const gradient = this._getLinearGradient();
                context.strokeStyle = gradient || fill;
                context.stroke();
                context.restore();
            }
            if (shouldLineThrough) {
                context.save();
                context.beginPath();
                context.moveTo(lineTranslateX, translateY + lineTranslateY);
                spacesNumber = text.split(' ').length - 1;
                oneWord = spacesNumber === 0;
                lineWidth = align === $b7cb399147d124e6$var$JUSTIFY && lastLine && !oneWord ? totalWidth - padding * 2 : width;
                context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY);
                context.lineWidth = fontSize / 15;
                const gradient = this._getLinearGradient();
                context.strokeStyle = gradient || fill;
                context.stroke();
                context.restore();
            }
            if (letterSpacing !== 0 || align === $b7cb399147d124e6$var$JUSTIFY) {
                spacesNumber = text.split(' ').length - 1;
                var array = $b7cb399147d124e6$export$b9ca061da17f2d30(text);
                for(var li = 0; li < array.length; li++){
                    var letter = array[li];
                    if (letter === ' ' && !lastLine && align === $b7cb399147d124e6$var$JUSTIFY) lineTranslateX += (totalWidth - padding * 2 - width) / spacesNumber;
                    this._partialTextX = lineTranslateX;
                    this._partialTextY = translateY + lineTranslateY;
                    this._partialText = letter;
                    context.fillStrokeShape(this);
                    lineTranslateX += this.measureSize(letter).width + letterSpacing;
                }
            } else {
                this._partialTextX = lineTranslateX;
                this._partialTextY = translateY + lineTranslateY;
                this._partialText = text;
                context.fillStrokeShape(this);
            }
            context.restore();
            if (textArrLen > 1) translateY += lineHeightPx;
        }
    }
    _hitFunc(context) {
        var width = this.getWidth(), height = this.getHeight();
        context.beginPath();
        context.rect(0, 0, width, height);
        context.closePath();
        context.fillStrokeShape(this);
    }
    setText(text) {
        var str = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._isString(text) ? text : text === null || text === undefined ? '' : text + '';
        this._setAttr($b7cb399147d124e6$var$TEXT, str);
        return this;
    }
    getWidth() {
        var isAuto = this.attrs.width === $b7cb399147d124e6$var$AUTO || this.attrs.width === undefined;
        return isAuto ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
    }
    getHeight() {
        var isAuto = this.attrs.height === $b7cb399147d124e6$var$AUTO || this.attrs.height === undefined;
        return isAuto ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
        return this.textHeight;
    }
    measureSize(text) {
        var _context = $b7cb399147d124e6$var$getDummyContext(), fontSize = this.fontSize(), metrics;
        _context.save();
        _context.font = this._getContextFont();
        metrics = _context.measureText(text);
        _context.restore();
        return {
            width: metrics.width,
            height: fontSize
        };
    }
    _getContextFont() {
        return this.fontStyle() + $b7cb399147d124e6$var$SPACE + this.fontVariant() + $b7cb399147d124e6$var$SPACE + (this.fontSize() + $b7cb399147d124e6$var$PX_SPACE) + $b7cb399147d124e6$var$normalizeFontFamily(this.fontFamily());
    }
    _addTextLine(line) {
        const align = this.align();
        if (align === $b7cb399147d124e6$var$JUSTIFY) line = line.trim();
        var width = this._getTextWidth(line);
        return this.textArr.push({
            text: line,
            width: width,
            lastInParagraph: false
        });
    }
    _getTextWidth(text) {
        var letterSpacing = this.letterSpacing();
        var length = text.length;
        return $b7cb399147d124e6$var$getDummyContext().measureText(text).width + (length ? letterSpacing * (length - 1) : 0);
    }
    _setTextData() {
        var lines = this.text().split('\n'), fontSize = +this.fontSize(), textWidth = 0, lineHeightPx = this.lineHeight() * fontSize, width = this.attrs.width, height = this.attrs.height, fixedWidth = width !== $b7cb399147d124e6$var$AUTO && width !== undefined, fixedHeight = height !== $b7cb399147d124e6$var$AUTO && height !== undefined, padding = this.padding(), maxWidth = width - padding * 2, maxHeightPx = height - padding * 2, currentHeightPx = 0, wrap = this.wrap(), shouldWrap = wrap !== $b7cb399147d124e6$var$NONE, wrapAtWord = wrap !== $b7cb399147d124e6$var$CHAR && shouldWrap, shouldAddEllipsis = this.ellipsis();
        this.textArr = [];
        $b7cb399147d124e6$var$getDummyContext().font = this._getContextFont();
        var additionalWidth = shouldAddEllipsis ? this._getTextWidth($b7cb399147d124e6$var$ELLIPSIS) : 0;
        for(var i = 0, max = lines.length; i < max; ++i){
            var line = lines[i];
            var lineWidth = this._getTextWidth(line);
            if (fixedWidth && lineWidth > maxWidth) while(line.length > 0){
                var low = 0, high = line.length, match = '', matchWidth = 0;
                while(low < high){
                    var mid = low + high >>> 1, substr = line.slice(0, mid + 1), substrWidth = this._getTextWidth(substr) + additionalWidth;
                    if (substrWidth <= maxWidth) {
                        low = mid + 1;
                        match = substr;
                        matchWidth = substrWidth;
                    } else high = mid;
                }
                if (match) {
                    if (wrapAtWord) {
                        var wrapIndex;
                        var nextChar = line[match.length];
                        var nextIsSpaceOrDash = nextChar === $b7cb399147d124e6$var$SPACE || nextChar === $b7cb399147d124e6$var$DASH;
                        if (nextIsSpaceOrDash && matchWidth <= maxWidth) wrapIndex = match.length;
                        else wrapIndex = Math.max(match.lastIndexOf($b7cb399147d124e6$var$SPACE), match.lastIndexOf($b7cb399147d124e6$var$DASH)) + 1;
                        if (wrapIndex > 0) {
                            low = wrapIndex;
                            match = match.slice(0, low);
                            matchWidth = this._getTextWidth(match);
                        }
                    }
                    match = match.trimRight();
                    this._addTextLine(match);
                    textWidth = Math.max(textWidth, matchWidth);
                    currentHeightPx += lineHeightPx;
                    var shouldHandleEllipsis = this._shouldHandleEllipsis(currentHeightPx);
                    if (shouldHandleEllipsis) {
                        this._tryToAddEllipsisToLastLine();
                        break;
                    }
                    line = line.slice(low);
                    line = line.trimLeft();
                    if (line.length > 0) {
                        lineWidth = this._getTextWidth(line);
                        if (lineWidth <= maxWidth) {
                            this._addTextLine(line);
                            currentHeightPx += lineHeightPx;
                            textWidth = Math.max(textWidth, lineWidth);
                            break;
                        }
                    }
                } else break;
            }
            else {
                this._addTextLine(line);
                currentHeightPx += lineHeightPx;
                textWidth = Math.max(textWidth, lineWidth);
                if (this._shouldHandleEllipsis(currentHeightPx) && i < max - 1) this._tryToAddEllipsisToLastLine();
            }
            if (this.textArr[this.textArr.length - 1]) this.textArr[this.textArr.length - 1].lastInParagraph = true;
            if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) break;
        }
        this.textHeight = fontSize;
        this.textWidth = textWidth;
    }
    _shouldHandleEllipsis(currentHeightPx) {
        var fontSize = +this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, height = this.attrs.height, fixedHeight = height !== $b7cb399147d124e6$var$AUTO && height !== undefined, padding = this.padding(), maxHeightPx = height - padding * 2, wrap = this.wrap(), shouldWrap = wrap !== $b7cb399147d124e6$var$NONE;
        return !shouldWrap || fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx;
    }
    _tryToAddEllipsisToLastLine() {
        var width = this.attrs.width, fixedWidth = width !== $b7cb399147d124e6$var$AUTO && width !== undefined, padding = this.padding(), maxWidth = width - padding * 2, shouldAddEllipsis = this.ellipsis();
        var lastLine = this.textArr[this.textArr.length - 1];
        if (!lastLine || !shouldAddEllipsis) return;
        if (fixedWidth) {
            var haveSpace = this._getTextWidth(lastLine.text + $b7cb399147d124e6$var$ELLIPSIS) < maxWidth;
            if (!haveSpace) lastLine.text = lastLine.text.slice(0, lastLine.text.length - 3);
        }
        this.textArr.splice(this.textArr.length - 1, 1);
        this._addTextLine(lastLine.text + $b7cb399147d124e6$var$ELLIPSIS);
    }
    getStrokeScaleEnabled() {
        return true;
    }
}
$b7cb399147d124e6$export$5f1af8db9871e1d6.prototype._fillFunc = $b7cb399147d124e6$var$_fillFunc;
$b7cb399147d124e6$export$5f1af8db9871e1d6.prototype._strokeFunc = $b7cb399147d124e6$var$_strokeFunc;
$b7cb399147d124e6$export$5f1af8db9871e1d6.prototype.className = $b7cb399147d124e6$var$TEXT_UPPER;
$b7cb399147d124e6$export$5f1af8db9871e1d6.prototype._attrsAffectingSize = [
    'text',
    'fontSize',
    'padding',
    'wrap',
    'lineHeight',
    'letterSpacing'
];
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($b7cb399147d124e6$export$5f1af8db9871e1d6);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).overWriteSetter($b7cb399147d124e6$export$5f1af8db9871e1d6, 'width', (0, $0e51c174430907a2$export$3b7df2720ef33404)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).overWriteSetter($b7cb399147d124e6$export$5f1af8db9871e1d6, 'height', (0, $0e51c174430907a2$export$3b7df2720ef33404)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($b7cb399147d124e6$export$5f1af8db9871e1d6, 'fontFamily', 'Arial');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($b7cb399147d124e6$export$5f1af8db9871e1d6, 'fontSize', 12, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($b7cb399147d124e6$export$5f1af8db9871e1d6, 'fontStyle', $b7cb399147d124e6$var$NORMAL);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($b7cb399147d124e6$export$5f1af8db9871e1d6, 'fontVariant', $b7cb399147d124e6$var$NORMAL);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($b7cb399147d124e6$export$5f1af8db9871e1d6, 'padding', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($b7cb399147d124e6$export$5f1af8db9871e1d6, 'align', $b7cb399147d124e6$var$LEFT);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($b7cb399147d124e6$export$5f1af8db9871e1d6, 'verticalAlign', $b7cb399147d124e6$var$TOP);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($b7cb399147d124e6$export$5f1af8db9871e1d6, 'lineHeight', 1, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($b7cb399147d124e6$export$5f1af8db9871e1d6, 'wrap', $b7cb399147d124e6$var$WORD);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($b7cb399147d124e6$export$5f1af8db9871e1d6, 'ellipsis', false, (0, $0e51c174430907a2$export$147fc8b6cd20fda1)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($b7cb399147d124e6$export$5f1af8db9871e1d6, 'letterSpacing', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($b7cb399147d124e6$export$5f1af8db9871e1d6, 'text', '', (0, $0e51c174430907a2$export$5837c5b6cc5b4d63)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($b7cb399147d124e6$export$5f1af8db9871e1d6, 'textDecoration', '');









var $679d0dcb922e3736$var$EMPTY_STRING = '', $679d0dcb922e3736$var$NORMAL = 'normal';
function $679d0dcb922e3736$var$_fillFunc(context) {
    context.fillText(this.partialText, 0, 0);
}
function $679d0dcb922e3736$var$_strokeFunc(context) {
    context.strokeText(this.partialText, 0, 0);
}
class $679d0dcb922e3736$export$f7e34a95cc06fac7 extends (0, $83649c293dd1d496$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this.dummyCanvas = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).createCanvasElement();
        this.dataArray = [];
        this.dataArray = (0, $a87b11181a0f7921$export$4b2950bdac9b6ee9).parsePathData(this.attrs.data);
        this.on('dataChange.konva', function() {
            this.dataArray = (0, $a87b11181a0f7921$export$4b2950bdac9b6ee9).parsePathData(this.attrs.data);
            this._setTextData();
        });
        this.on('textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva', this._setTextData);
        this._setTextData();
    }
    _sceneFunc(context) {
        context.setAttr('font', this._getContextFont());
        context.setAttr('textBaseline', this.textBaseline());
        context.setAttr('textAlign', 'left');
        context.save();
        var textDecoration = this.textDecoration();
        var fill = this.fill();
        var fontSize = this.fontSize();
        var glyphInfo = this.glyphInfo;
        if (textDecoration === 'underline') context.beginPath();
        for(var i = 0; i < glyphInfo.length; i++){
            context.save();
            var p0 = glyphInfo[i].p0;
            context.translate(p0.x, p0.y);
            context.rotate(glyphInfo[i].rotation);
            this.partialText = glyphInfo[i].text;
            context.fillStrokeShape(this);
            if (textDecoration === 'underline') {
                if (i === 0) context.moveTo(0, fontSize / 2 + 1);
                context.lineTo(fontSize, fontSize / 2 + 1);
            }
            context.restore();
        }
        if (textDecoration === 'underline') {
            context.strokeStyle = fill;
            context.lineWidth = fontSize / 20;
            context.stroke();
        }
        context.restore();
    }
    _hitFunc(context) {
        context.beginPath();
        var glyphInfo = this.glyphInfo;
        if (glyphInfo.length >= 1) {
            var p0 = glyphInfo[0].p0;
            context.moveTo(p0.x, p0.y);
        }
        for(var i = 0; i < glyphInfo.length; i++){
            var p1 = glyphInfo[i].p1;
            context.lineTo(p1.x, p1.y);
        }
        context.setAttr('lineWidth', this.fontSize());
        context.setAttr('strokeStyle', this.colorKey);
        context.stroke();
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
        return this.textHeight;
    }
    setText(text) {
        return (0, $b7cb399147d124e6$export$5f1af8db9871e1d6).prototype.setText.call(this, text);
    }
    _getContextFont() {
        return (0, $b7cb399147d124e6$export$5f1af8db9871e1d6).prototype._getContextFont.call(this);
    }
    _getTextSize(text) {
        var dummyCanvas = this.dummyCanvas;
        var _context = dummyCanvas.getContext('2d');
        _context.save();
        _context.font = this._getContextFont();
        var metrics = _context.measureText(text);
        _context.restore();
        return {
            width: metrics.width,
            height: parseInt(this.attrs.fontSize, 10)
        };
    }
    _setTextData() {
        var that = this;
        var size = this._getTextSize(this.attrs.text);
        var letterSpacing = this.letterSpacing();
        var align = this.align();
        var kerningFunc = this.kerningFunc();
        this.textWidth = size.width;
        this.textHeight = size.height;
        var textFullWidth = Math.max(this.textWidth + ((this.attrs.text || '').length - 1) * letterSpacing, 0);
        this.glyphInfo = [];
        var fullPathWidth = 0;
        for(var l = 0; l < that.dataArray.length; l++)if (that.dataArray[l].pathLength > 0) fullPathWidth += that.dataArray[l].pathLength;
        var offset = 0;
        if (align === 'center') offset = Math.max(0, fullPathWidth / 2 - textFullWidth / 2);
        if (align === 'right') offset = Math.max(0, fullPathWidth - textFullWidth);
        var charArr = (0, $b7cb399147d124e6$export$b9ca061da17f2d30)(this.text());
        var spacesNumber = this.text().split(' ').length - 1;
        var p0, p1, pathCmd;
        var pIndex = -1;
        var currentT = 0;
        var getNextPathSegment = function() {
            currentT = 0;
            var pathData = that.dataArray;
            for(var j = pIndex + 1; j < pathData.length; j++){
                if (pathData[j].pathLength > 0) {
                    pIndex = j;
                    return pathData[j];
                } else if (pathData[j].command === 'M') p0 = {
                    x: pathData[j].points[0],
                    y: pathData[j].points[1]
                };
            }
            return {};
        };
        var findSegmentToFitCharacter = function(c) {
            var glyphWidth = that._getTextSize(c).width + letterSpacing;
            if (c === ' ' && align === 'justify') glyphWidth += (fullPathWidth - textFullWidth) / spacesNumber;
            var currLen = 0;
            var attempts = 0;
            p1 = undefined;
            while(Math.abs(glyphWidth - currLen) / glyphWidth > 0.01 && attempts < 20){
                attempts++;
                var cumulativePathLength = currLen;
                while(pathCmd === undefined){
                    pathCmd = getNextPathSegment();
                    if (pathCmd && cumulativePathLength + pathCmd.pathLength < glyphWidth) {
                        cumulativePathLength += pathCmd.pathLength;
                        pathCmd = undefined;
                    }
                }
                if (Object.keys(pathCmd).length === 0 || p0 === undefined) return undefined;
                var needNewSegment = false;
                switch(pathCmd.command){
                    case 'L':
                        if ((0, $a87b11181a0f7921$export$4b2950bdac9b6ee9).getLineLength(p0.x, p0.y, pathCmd.points[0], pathCmd.points[1]) > glyphWidth) p1 = (0, $a87b11181a0f7921$export$4b2950bdac9b6ee9).getPointOnLine(glyphWidth, p0.x, p0.y, pathCmd.points[0], pathCmd.points[1], p0.x, p0.y);
                        else pathCmd = undefined;
                        break;
                    case 'A':
                        var start = pathCmd.points[4];
                        var dTheta = pathCmd.points[5];
                        var end = pathCmd.points[4] + dTheta;
                        if (currentT === 0) currentT = start + 0.00000001;
                        else if (glyphWidth > currLen) currentT += Math.PI / 180.0 * dTheta / Math.abs(dTheta);
                        else currentT -= Math.PI / 360.0 * dTheta / Math.abs(dTheta);
                        if (dTheta < 0 && currentT < end || dTheta >= 0 && currentT > end) {
                            currentT = end;
                            needNewSegment = true;
                        }
                        p1 = (0, $a87b11181a0f7921$export$4b2950bdac9b6ee9).getPointOnEllipticalArc(pathCmd.points[0], pathCmd.points[1], pathCmd.points[2], pathCmd.points[3], currentT, pathCmd.points[6]);
                        break;
                    case 'C':
                        if (currentT === 0) {
                            if (glyphWidth > pathCmd.pathLength) currentT = 0.00000001;
                            else currentT = glyphWidth / pathCmd.pathLength;
                        } else if (glyphWidth > currLen) currentT += (glyphWidth - currLen) / pathCmd.pathLength / 2;
                        else currentT = Math.max(currentT - (currLen - glyphWidth) / pathCmd.pathLength / 2, 0);
                        if (currentT > 1.0) {
                            currentT = 1.0;
                            needNewSegment = true;
                        }
                        p1 = (0, $a87b11181a0f7921$export$4b2950bdac9b6ee9).getPointOnCubicBezier(currentT, pathCmd.start.x, pathCmd.start.y, pathCmd.points[0], pathCmd.points[1], pathCmd.points[2], pathCmd.points[3], pathCmd.points[4], pathCmd.points[5]);
                        break;
                    case 'Q':
                        if (currentT === 0) currentT = glyphWidth / pathCmd.pathLength;
                        else if (glyphWidth > currLen) currentT += (glyphWidth - currLen) / pathCmd.pathLength;
                        else currentT -= (currLen - glyphWidth) / pathCmd.pathLength;
                        if (currentT > 1.0) {
                            currentT = 1.0;
                            needNewSegment = true;
                        }
                        p1 = (0, $a87b11181a0f7921$export$4b2950bdac9b6ee9).getPointOnQuadraticBezier(currentT, pathCmd.start.x, pathCmd.start.y, pathCmd.points[0], pathCmd.points[1], pathCmd.points[2], pathCmd.points[3]);
                        break;
                }
                if (p1 !== undefined) currLen = (0, $a87b11181a0f7921$export$4b2950bdac9b6ee9).getLineLength(p0.x, p0.y, p1.x, p1.y);
                if (needNewSegment) {
                    needNewSegment = false;
                    pathCmd = undefined;
                }
            }
        };
        var testChar = 'C';
        var glyphWidth = that._getTextSize(testChar).width + letterSpacing;
        var lettersInOffset = offset / glyphWidth - 1;
        for(var k = 0; k < lettersInOffset; k++){
            findSegmentToFitCharacter(testChar);
            if (p0 === undefined || p1 === undefined) break;
            p0 = p1;
        }
        for(var i = 0; i < charArr.length; i++){
            findSegmentToFitCharacter(charArr[i]);
            if (p0 === undefined || p1 === undefined) break;
            var width = (0, $a87b11181a0f7921$export$4b2950bdac9b6ee9).getLineLength(p0.x, p0.y, p1.x, p1.y);
            var kern = 0;
            if (kerningFunc) try {
                kern = kerningFunc(charArr[i - 1], charArr[i]) * this.fontSize();
            } catch (e) {
                kern = 0;
            }
            p0.x += kern;
            p1.x += kern;
            this.textWidth += kern;
            var midpoint = (0, $a87b11181a0f7921$export$4b2950bdac9b6ee9).getPointOnLine(kern + width / 2.0, p0.x, p0.y, p1.x, p1.y);
            var rotation = Math.atan2(p1.y - p0.y, p1.x - p0.x);
            this.glyphInfo.push({
                transposeX: midpoint.x,
                transposeY: midpoint.y,
                text: charArr[i],
                rotation: rotation,
                p0: p0,
                p1: p1
            });
            p0 = p1;
        }
    }
    getSelfRect() {
        if (!this.glyphInfo.length) return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        var points = [];
        this.glyphInfo.forEach(function(info) {
            points.push(info.p0.x);
            points.push(info.p0.y);
            points.push(info.p1.x);
            points.push(info.p1.y);
        });
        var minX = points[0] || 0;
        var maxX = points[0] || 0;
        var minY = points[1] || 0;
        var maxY = points[1] || 0;
        var x, y;
        for(var i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        var fontSize = this.fontSize();
        return {
            x: minX - fontSize / 2,
            y: minY - fontSize / 2,
            width: maxX - minX + fontSize,
            height: maxY - minY + fontSize
        };
    }
    destroy() {
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).releaseCanvas(this.dummyCanvas);
        return super.destroy();
    }
}
$679d0dcb922e3736$export$f7e34a95cc06fac7.prototype._fillFunc = $679d0dcb922e3736$var$_fillFunc;
$679d0dcb922e3736$export$f7e34a95cc06fac7.prototype._strokeFunc = $679d0dcb922e3736$var$_strokeFunc;
$679d0dcb922e3736$export$f7e34a95cc06fac7.prototype._fillFuncHit = $679d0dcb922e3736$var$_fillFunc;
$679d0dcb922e3736$export$f7e34a95cc06fac7.prototype._strokeFuncHit = $679d0dcb922e3736$var$_strokeFunc;
$679d0dcb922e3736$export$f7e34a95cc06fac7.prototype.className = 'TextPath';
$679d0dcb922e3736$export$f7e34a95cc06fac7.prototype._attrsAffectingSize = [
    'text',
    'fontSize',
    'data'
];
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($679d0dcb922e3736$export$f7e34a95cc06fac7);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($679d0dcb922e3736$export$f7e34a95cc06fac7, 'data');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($679d0dcb922e3736$export$f7e34a95cc06fac7, 'fontFamily', 'Arial');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($679d0dcb922e3736$export$f7e34a95cc06fac7, 'fontSize', 12, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($679d0dcb922e3736$export$f7e34a95cc06fac7, 'fontStyle', $679d0dcb922e3736$var$NORMAL);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($679d0dcb922e3736$export$f7e34a95cc06fac7, 'align', 'left');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($679d0dcb922e3736$export$f7e34a95cc06fac7, 'letterSpacing', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($679d0dcb922e3736$export$f7e34a95cc06fac7, 'textBaseline', 'middle');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($679d0dcb922e3736$export$f7e34a95cc06fac7, 'fontVariant', $679d0dcb922e3736$var$NORMAL);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($679d0dcb922e3736$export$f7e34a95cc06fac7, 'text', $679d0dcb922e3736$var$EMPTY_STRING);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($679d0dcb922e3736$export$f7e34a95cc06fac7, 'textDecoration', null);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($679d0dcb922e3736$export$f7e34a95cc06fac7, 'kerningFunc', null);










var $017855c36dc6c47b$var$EVENTS_NAME = 'tr-konva';
var $017855c36dc6c47b$var$ATTR_CHANGE_LIST = [
    'resizeEnabledChange',
    'rotateAnchorOffsetChange',
    'rotateEnabledChange',
    'enabledAnchorsChange',
    'anchorSizeChange',
    'borderEnabledChange',
    'borderStrokeChange',
    'borderStrokeWidthChange',
    'borderDashChange',
    'anchorStrokeChange',
    'anchorStrokeWidthChange',
    'anchorFillChange',
    'anchorCornerRadiusChange',
    'ignoreStrokeChange'
].map((e)=>e + `.${$017855c36dc6c47b$var$EVENTS_NAME}`).join(' ');
var $017855c36dc6c47b$var$NODES_RECT = 'nodesRect';
var $017855c36dc6c47b$var$TRANSFORM_CHANGE_STR = [
    'widthChange',
    'heightChange',
    'scaleXChange',
    'scaleYChange',
    'skewXChange',
    'skewYChange',
    'rotationChange',
    'offsetXChange',
    'offsetYChange',
    'transformsEnabledChange',
    'strokeWidthChange'
];
var $017855c36dc6c47b$var$ANGLES = {
    'top-left': -45,
    'top-center': 0,
    'top-right': 45,
    'middle-right': -90,
    'middle-left': 90,
    'bottom-left': -135,
    'bottom-center': 180,
    'bottom-right': 135
};
const $017855c36dc6c47b$var$TOUCH_DEVICE = 'ontouchstart' in (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692)._global;
function $017855c36dc6c47b$var$getCursor(anchorName, rad) {
    if (anchorName === 'rotater') return 'crosshair';
    rad += (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).degToRad($017855c36dc6c47b$var$ANGLES[anchorName] || 0);
    var angle = ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).radToDeg(rad) % 360 + 360) % 360;
    if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._inRange(angle, 337.5, 360) || (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._inRange(angle, 0, 22.5)) return 'ns-resize';
    else if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._inRange(angle, 22.5, 67.5)) return 'nesw-resize';
    else if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._inRange(angle, 67.5, 112.5)) return 'ew-resize';
    else if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._inRange(angle, 112.5, 157.5)) return 'nwse-resize';
    else if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._inRange(angle, 157.5, 202.5)) return 'ns-resize';
    else if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._inRange(angle, 202.5, 247.5)) return 'nesw-resize';
    else if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._inRange(angle, 247.5, 292.5)) return 'ew-resize';
    else if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._inRange(angle, 292.5, 337.5)) return 'nwse-resize';
    else {
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).error('Transformer has unknown angle for cursor detection: ' + angle);
        return 'pointer';
    }
}
var $017855c36dc6c47b$var$ANCHORS_NAMES = [
    'top-left',
    'top-center',
    'top-right',
    'middle-right',
    'middle-left',
    'bottom-left',
    'bottom-center',
    'bottom-right'
];
var $017855c36dc6c47b$var$MAX_SAFE_INTEGER = 100000000;
function $017855c36dc6c47b$var$getCenter(shape) {
    return {
        x: shape.x + shape.width / 2 * Math.cos(shape.rotation) + shape.height / 2 * Math.sin(-shape.rotation),
        y: shape.y + shape.height / 2 * Math.cos(shape.rotation) + shape.width / 2 * Math.sin(shape.rotation)
    };
}
function $017855c36dc6c47b$var$rotateAroundPoint(shape, angleRad, point) {
    const x = point.x + (shape.x - point.x) * Math.cos(angleRad) - (shape.y - point.y) * Math.sin(angleRad);
    const y = point.y + (shape.x - point.x) * Math.sin(angleRad) + (shape.y - point.y) * Math.cos(angleRad);
    return Object.assign(Object.assign({}, shape), {
        rotation: shape.rotation + angleRad,
        x: x,
        y: y
    });
}
function $017855c36dc6c47b$var$rotateAroundCenter(shape, deltaRad) {
    const center = $017855c36dc6c47b$var$getCenter(shape);
    return $017855c36dc6c47b$var$rotateAroundPoint(shape, deltaRad, center);
}
function $017855c36dc6c47b$var$getSnap(snaps, newRotationRad, tol) {
    let snapped = newRotationRad;
    for(let i = 0; i < snaps.length; i++){
        const angle = (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).getAngle(snaps[i]);
        const absDiff = Math.abs(angle - newRotationRad) % (Math.PI * 2);
        const dif = Math.min(absDiff, Math.PI * 2 - absDiff);
        if (dif < tol) snapped = angle;
    }
    return snapped;
}
class $017855c36dc6c47b$export$f993aef960936087 extends (0, $436734b80159e85f$export$eb2fcfdbd7ba97d4) {
    constructor(config){
        super(config);
        this._transforming = false;
        this._createElements();
        this._handleMouseMove = this._handleMouseMove.bind(this);
        this._handleMouseUp = this._handleMouseUp.bind(this);
        this.update = this.update.bind(this);
        this.on($017855c36dc6c47b$var$ATTR_CHANGE_LIST, this.update);
        if (this.getNode()) this.update();
    }
    attachTo(node) {
        this.setNode(node);
        return this;
    }
    setNode(node) {
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead.');
        return this.setNodes([
            node
        ]);
    }
    getNode() {
        return this._nodes && this._nodes[0];
    }
    _getEventNamespace() {
        return $017855c36dc6c47b$var$EVENTS_NAME + this._id;
    }
    setNodes(nodes = []) {
        if (this._nodes && this._nodes.length) this.detach();
        const filteredNodes = nodes.filter((node)=>{
            if (node.isAncestorOf(this)) {
                (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).error('Konva.Transformer cannot be an a child of the node you are trying to attach');
                return false;
            }
            return true;
        });
        this._nodes = nodes = filteredNodes;
        if (nodes.length === 1 && this.useSingleNodeRotation()) this.rotation(nodes[0].getAbsoluteRotation());
        else this.rotation(0);
        this._nodes.forEach((node)=>{
            const onChange = ()=>{
                if (this.nodes().length === 1 && this.useSingleNodeRotation()) this.rotation(this.nodes()[0].getAbsoluteRotation());
                this._resetTransformCache();
                if (!this._transforming && !this.isDragging()) this.update();
            };
            const additionalEvents = node._attrsAffectingSize.map((prop)=>prop + 'Change.' + this._getEventNamespace()).join(' ');
            node.on(additionalEvents, onChange);
            node.on($017855c36dc6c47b$var$TRANSFORM_CHANGE_STR.map((e)=>e + `.${this._getEventNamespace()}`).join(' '), onChange);
            node.on(`absoluteTransformChange.${this._getEventNamespace()}`, onChange);
            this._proxyDrag(node);
        });
        this._resetTransformCache();
        var elementsCreated = !!this.findOne('.top-left');
        if (elementsCreated) this.update();
        return this;
    }
    _proxyDrag(node) {
        let lastPos;
        node.on(`dragstart.${this._getEventNamespace()}`, (e)=>{
            lastPos = node.getAbsolutePosition();
            if (!this.isDragging() && node !== this.findOne('.back')) this.startDrag(e, false);
        });
        node.on(`dragmove.${this._getEventNamespace()}`, (e)=>{
            if (!lastPos) return;
            const abs = node.getAbsolutePosition();
            const dx = abs.x - lastPos.x;
            const dy = abs.y - lastPos.y;
            this.nodes().forEach((otherNode)=>{
                if (otherNode === node) return;
                if (otherNode.isDragging()) return;
                const otherAbs = otherNode.getAbsolutePosition();
                otherNode.setAbsolutePosition({
                    x: otherAbs.x + dx,
                    y: otherAbs.y + dy
                });
                otherNode.startDrag(e);
            });
            lastPos = null;
        });
    }
    getNodes() {
        return this._nodes || [];
    }
    getActiveAnchor() {
        return this._movingAnchorName;
    }
    detach() {
        if (this._nodes) this._nodes.forEach((node)=>{
            node.off('.' + this._getEventNamespace());
        });
        this._nodes = [];
        this._resetTransformCache();
    }
    _resetTransformCache() {
        this._clearCache($017855c36dc6c47b$var$NODES_RECT);
        this._clearCache('transform');
        this._clearSelfAndDescendantCache('absoluteTransform');
    }
    _getNodeRect() {
        return this._getCache($017855c36dc6c47b$var$NODES_RECT, this.__getNodeRect);
    }
    __getNodeShape(node, rot = this.rotation(), relative) {
        var rect = node.getClientRect({
            skipTransform: true,
            skipShadow: true,
            skipStroke: this.ignoreStroke()
        });
        var absScale = node.getAbsoluteScale(relative);
        var absPos = node.getAbsolutePosition(relative);
        var dx = rect.x * absScale.x - node.offsetX() * absScale.x;
        var dy = rect.y * absScale.y - node.offsetY() * absScale.y;
        const rotation = ((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).getAngle(node.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2);
        const box = {
            x: absPos.x + dx * Math.cos(rotation) + dy * Math.sin(-rotation),
            y: absPos.y + dy * Math.cos(rotation) + dx * Math.sin(rotation),
            width: rect.width * absScale.x,
            height: rect.height * absScale.y,
            rotation: rotation
        };
        return $017855c36dc6c47b$var$rotateAroundPoint(box, -(0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).getAngle(rot), {
            x: 0,
            y: 0
        });
    }
    __getNodeRect() {
        var node = this.getNode();
        if (!node) return {
            x: -$017855c36dc6c47b$var$MAX_SAFE_INTEGER,
            y: -$017855c36dc6c47b$var$MAX_SAFE_INTEGER,
            width: 0,
            height: 0,
            rotation: 0
        };
        const totalPoints = [];
        this.nodes().map((node)=>{
            const box = node.getClientRect({
                skipTransform: true,
                skipShadow: true,
                skipStroke: this.ignoreStroke()
            });
            var points = [
                {
                    x: box.x,
                    y: box.y
                },
                {
                    x: box.x + box.width,
                    y: box.y
                },
                {
                    x: box.x + box.width,
                    y: box.y + box.height
                },
                {
                    x: box.x,
                    y: box.y + box.height
                }
            ];
            var trans = node.getAbsoluteTransform();
            points.forEach(function(point) {
                var transformed = trans.point(point);
                totalPoints.push(transformed);
            });
        });
        const tr = new (0, $87c9acccd58fa09f$export$563a914cafbdc389)();
        tr.rotate(-(0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).getAngle(this.rotation()));
        var minX, minY, maxX, maxY;
        totalPoints.forEach(function(point) {
            var transformed = tr.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        tr.invert();
        const p = tr.point({
            x: minX,
            y: minY
        });
        return {
            x: p.x,
            y: p.y,
            width: maxX - minX,
            height: maxY - minY,
            rotation: (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).getAngle(this.rotation())
        };
    }
    getX() {
        return this._getNodeRect().x;
    }
    getY() {
        return this._getNodeRect().y;
    }
    getWidth() {
        return this._getNodeRect().width;
    }
    getHeight() {
        return this._getNodeRect().height;
    }
    _createElements() {
        this._createBack();
        $017855c36dc6c47b$var$ANCHORS_NAMES.forEach((function(name) {
            this._createAnchor(name);
        }).bind(this));
        this._createAnchor('rotater');
    }
    _createAnchor(name) {
        var anchor = new (0, $0258dbc9803ecab0$export$c79fc6492f3af13d)({
            stroke: 'rgb(0, 161, 255)',
            fill: 'white',
            strokeWidth: 1,
            name: name + ' _anchor',
            dragDistance: 0,
            draggable: true,
            hitStrokeWidth: $017855c36dc6c47b$var$TOUCH_DEVICE ? 10 : 'auto'
        });
        var self = this;
        anchor.on('mousedown touchstart', function(e) {
            self._handleMouseDown(e);
        });
        anchor.on('dragstart', (e)=>{
            anchor.stopDrag();
            e.cancelBubble = true;
        });
        anchor.on('dragend', (e)=>{
            e.cancelBubble = true;
        });
        anchor.on('mouseenter', ()=>{
            var rad = (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).getAngle(this.rotation());
            var cursor = $017855c36dc6c47b$var$getCursor(name, rad);
            anchor.getStage().content && (anchor.getStage().content.style.cursor = cursor);
            this._cursorChange = true;
        });
        anchor.on('mouseout', ()=>{
            anchor.getStage().content && (anchor.getStage().content.style.cursor = '');
            this._cursorChange = false;
        });
        this.add(anchor);
    }
    _createBack() {
        var back = new (0, $83649c293dd1d496$export$6428a7f2611ef1fa)({
            name: 'back',
            width: 0,
            height: 0,
            draggable: true,
            sceneFunc (ctx) {
                var tr = this.getParent();
                var padding = tr.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, this.width() + padding * 2, this.height() + padding * 2);
                ctx.moveTo(this.width() / 2, -padding);
                if (tr.rotateEnabled()) ctx.lineTo(this.width() / 2, -tr.rotateAnchorOffset() * (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._sign(this.height()) - padding);
                ctx.fillStrokeShape(this);
            },
            hitFunc: (ctx, shape)=>{
                if (!this.shouldOverdrawWholeArea()) return;
                var padding = this.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
                ctx.fillStrokeShape(shape);
            }
        });
        this.add(back);
        this._proxyDrag(back);
        back.on('dragstart', (e)=>{
            e.cancelBubble = true;
        });
        back.on('dragmove', (e)=>{
            e.cancelBubble = true;
        });
        back.on('dragend', (e)=>{
            e.cancelBubble = true;
        });
        this.on('dragmove', (e)=>{
            this.update();
        });
    }
    _handleMouseDown(e) {
        this._movingAnchorName = e.target.name().split(' ')[0];
        var attrs = this._getNodeRect();
        var width = attrs.width;
        var height = attrs.height;
        var hypotenuse = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
        this.sin = Math.abs(height / hypotenuse);
        this.cos = Math.abs(width / hypotenuse);
        if (typeof window !== 'undefined') {
            window.addEventListener('mousemove', this._handleMouseMove);
            window.addEventListener('touchmove', this._handleMouseMove);
            window.addEventListener('mouseup', this._handleMouseUp, true);
            window.addEventListener('touchend', this._handleMouseUp, true);
        }
        this._transforming = true;
        var ap = e.target.getAbsolutePosition();
        var pos = e.target.getStage().getPointerPosition();
        this._anchorDragOffset = {
            x: pos.x - ap.x,
            y: pos.y - ap.y
        };
        this._fire('transformstart', {
            evt: e.evt,
            target: this.getNode()
        });
        this._nodes.forEach((target)=>{
            target._fire('transformstart', {
                evt: e.evt,
                target: target
            });
        });
    }
    _handleMouseMove(e) {
        var x, y, newHypotenuse;
        var anchorNode = this.findOne('.' + this._movingAnchorName);
        var stage = anchorNode.getStage();
        stage.setPointersPositions(e);
        const pp = stage.getPointerPosition();
        let newNodePos = {
            x: pp.x - this._anchorDragOffset.x,
            y: pp.y - this._anchorDragOffset.y
        };
        const oldAbs = anchorNode.getAbsolutePosition();
        if (this.anchorDragBoundFunc()) newNodePos = this.anchorDragBoundFunc()(oldAbs, newNodePos, e);
        anchorNode.setAbsolutePosition(newNodePos);
        const newAbs = anchorNode.getAbsolutePosition();
        if (oldAbs.x === newAbs.x && oldAbs.y === newAbs.y) return;
        if (this._movingAnchorName === 'rotater') {
            var attrs = this._getNodeRect();
            x = anchorNode.x() - attrs.width / 2;
            y = -anchorNode.y() + attrs.height / 2;
            let delta = Math.atan2(-y, x) + Math.PI / 2;
            if (attrs.height < 0) delta -= Math.PI;
            var oldRotation = (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).getAngle(this.rotation());
            const newRotation = oldRotation + delta;
            const tol = (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).getAngle(this.rotationSnapTolerance());
            const snappedRot = $017855c36dc6c47b$var$getSnap(this.rotationSnaps(), newRotation, tol);
            const diff = snappedRot - attrs.rotation;
            const shape = $017855c36dc6c47b$var$rotateAroundCenter(attrs, diff);
            this._fitNodesInto(shape, e);
            return;
        }
        var keepProportion = this.keepRatio() || e.shiftKey;
        var centeredScaling = this.centeredScaling() || e.altKey;
        if (this._movingAnchorName === 'top-left') {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.bottom-right').x(),
                    y: this.findOne('.bottom-right').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
                var reverseX = this.findOne('.top-left').x() > comparePoint.x ? -1 : 1;
                var reverseY = this.findOne('.top-left').y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.top-left').x(comparePoint.x - x);
                this.findOne('.top-left').y(comparePoint.y - y);
            }
        } else if (this._movingAnchorName === 'top-center') this.findOne('.top-left').y(anchorNode.y());
        else if (this._movingAnchorName === 'top-right') {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.bottom-left').x(),
                    y: this.findOne('.bottom-left').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
                var reverseX = this.findOne('.top-right').x() < comparePoint.x ? -1 : 1;
                var reverseY = this.findOne('.top-right').y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.top-right').x(comparePoint.x + x);
                this.findOne('.top-right').y(comparePoint.y - y);
            }
            var pos = anchorNode.position();
            this.findOne('.top-left').y(pos.y);
            this.findOne('.bottom-right').x(pos.x);
        } else if (this._movingAnchorName === 'middle-left') this.findOne('.top-left').x(anchorNode.x());
        else if (this._movingAnchorName === 'middle-right') this.findOne('.bottom-right').x(anchorNode.x());
        else if (this._movingAnchorName === 'bottom-left') {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.top-right').x(),
                    y: this.findOne('.top-right').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
                var reverseX = comparePoint.x < anchorNode.x() ? -1 : 1;
                var reverseY = anchorNode.y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                anchorNode.x(comparePoint.x - x);
                anchorNode.y(comparePoint.y + y);
            }
            pos = anchorNode.position();
            this.findOne('.top-left').x(pos.x);
            this.findOne('.bottom-right').y(pos.y);
        } else if (this._movingAnchorName === 'bottom-center') this.findOne('.bottom-right').y(anchorNode.y());
        else if (this._movingAnchorName === 'bottom-right') {
            if (keepProportion) {
                var comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne('.top-left').x(),
                    y: this.findOne('.top-left').y()
                };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
                var reverseX = this.findOne('.bottom-right').x() < comparePoint.x ? -1 : 1;
                var reverseY = this.findOne('.bottom-right').y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.bottom-right').x(comparePoint.x + x);
                this.findOne('.bottom-right').y(comparePoint.y + y);
            }
        } else console.error(new Error('Wrong position argument of selection resizer: ' + this._movingAnchorName));
        var centeredScaling = this.centeredScaling() || e.altKey;
        if (centeredScaling) {
            var topLeft = this.findOne('.top-left');
            var bottomRight = this.findOne('.bottom-right');
            var topOffsetX = topLeft.x();
            var topOffsetY = topLeft.y();
            var bottomOffsetX = this.getWidth() - bottomRight.x();
            var bottomOffsetY = this.getHeight() - bottomRight.y();
            bottomRight.move({
                x: -topOffsetX,
                y: -topOffsetY
            });
            topLeft.move({
                x: bottomOffsetX,
                y: bottomOffsetY
            });
        }
        var absPos = this.findOne('.top-left').getAbsolutePosition();
        x = absPos.x;
        y = absPos.y;
        var width = this.findOne('.bottom-right').x() - this.findOne('.top-left').x();
        var height = this.findOne('.bottom-right').y() - this.findOne('.top-left').y();
        this._fitNodesInto({
            x: x,
            y: y,
            width: width,
            height: height,
            rotation: (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).getAngle(this.rotation())
        }, e);
    }
    _handleMouseUp(e) {
        this._removeEvents(e);
    }
    getAbsoluteTransform() {
        return this.getTransform();
    }
    _removeEvents(e) {
        if (this._transforming) {
            this._transforming = false;
            if (typeof window !== 'undefined') {
                window.removeEventListener('mousemove', this._handleMouseMove);
                window.removeEventListener('touchmove', this._handleMouseMove);
                window.removeEventListener('mouseup', this._handleMouseUp, true);
                window.removeEventListener('touchend', this._handleMouseUp, true);
            }
            var node = this.getNode();
            this._fire('transformend', {
                evt: e,
                target: node
            });
            if (node) this._nodes.forEach((target)=>{
                target._fire('transformend', {
                    evt: e,
                    target: target
                });
            });
            this._movingAnchorName = null;
        }
    }
    _fitNodesInto(newAttrs, evt) {
        var oldAttrs = this._getNodeRect();
        const minSize = 1;
        if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._inRange(newAttrs.width, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        if ((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._inRange(newAttrs.height, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        const allowNegativeScale = this.flipEnabled();
        var t = new (0, $87c9acccd58fa09f$export$563a914cafbdc389)();
        t.rotate((0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).getAngle(this.rotation()));
        if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf('left') >= 0) {
            const offset = t.point({
                x: -this.padding() * 2,
                y: 0
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            newAttrs.width += this.padding() * 2;
            this._movingAnchorName = this._movingAnchorName.replace('left', 'right');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        } else if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf('right') >= 0) {
            const offset = t.point({
                x: this.padding() * 2,
                y: 0
            });
            this._movingAnchorName = this._movingAnchorName.replace('right', 'left');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.width += this.padding() * 2;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        }
        if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf('top') >= 0) {
            const offset = t.point({
                x: 0,
                y: -this.padding() * 2
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            this._movingAnchorName = this._movingAnchorName.replace('top', 'bottom');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        } else if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf('bottom') >= 0) {
            const offset = t.point({
                x: 0,
                y: this.padding() * 2
            });
            this._movingAnchorName = this._movingAnchorName.replace('bottom', 'top');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        }
        if (this.boundBoxFunc()) {
            const bounded = this.boundBoxFunc()(oldAttrs, newAttrs);
            if (bounded) newAttrs = bounded;
            else (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('boundBoxFunc returned falsy. You should return new bound rect from it!');
        }
        const baseSize = 10000000;
        const oldTr = new (0, $87c9acccd58fa09f$export$563a914cafbdc389)();
        oldTr.translate(oldAttrs.x, oldAttrs.y);
        oldTr.rotate(oldAttrs.rotation);
        oldTr.scale(oldAttrs.width / baseSize, oldAttrs.height / baseSize);
        const newTr = new (0, $87c9acccd58fa09f$export$563a914cafbdc389)();
        newTr.translate(newAttrs.x, newAttrs.y);
        newTr.rotate(newAttrs.rotation);
        newTr.scale(newAttrs.width / baseSize, newAttrs.height / baseSize);
        const delta = newTr.multiply(oldTr.invert());
        this._nodes.forEach((node)=>{
            var _a;
            const parentTransform = node.getParent().getAbsoluteTransform();
            const localTransform = node.getTransform().copy();
            localTransform.translate(node.offsetX(), node.offsetY());
            const newLocalTransform = new (0, $87c9acccd58fa09f$export$563a914cafbdc389)();
            newLocalTransform.multiply(parentTransform.copy().invert()).multiply(delta).multiply(parentTransform).multiply(localTransform);
            const attrs = newLocalTransform.decompose();
            node.setAttrs(attrs);
            this._fire('transform', {
                evt: evt,
                target: node
            });
            node._fire('transform', {
                evt: evt,
                target: node
            });
            (_a = node.getLayer()) === null || _a === void 0 || _a.batchDraw();
        });
        this.rotation((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._getRotation(newAttrs.rotation));
        this._resetTransformCache();
        this.update();
        this.getLayer().batchDraw();
    }
    forceUpdate() {
        this._resetTransformCache();
        this.update();
    }
    _batchChangeChild(selector, attrs) {
        const anchor = this.findOne(selector);
        anchor.setAttrs(attrs);
    }
    update() {
        var _a;
        var attrs = this._getNodeRect();
        this.rotation((0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._getRotation(attrs.rotation));
        var width = attrs.width;
        var height = attrs.height;
        var enabledAnchors = this.enabledAnchors();
        var resizeEnabled = this.resizeEnabled();
        var padding = this.padding();
        var anchorSize = this.anchorSize();
        this.find('._anchor').forEach((node)=>{
            node.setAttrs({
                width: anchorSize,
                height: anchorSize,
                offsetX: anchorSize / 2,
                offsetY: anchorSize / 2,
                stroke: this.anchorStroke(),
                strokeWidth: this.anchorStrokeWidth(),
                fill: this.anchorFill(),
                cornerRadius: this.anchorCornerRadius()
            });
        });
        this._batchChangeChild('.top-left', {
            x: 0,
            y: 0,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-left') >= 0
        });
        this._batchChangeChild('.top-center', {
            x: width / 2,
            y: 0,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-center') >= 0
        });
        this._batchChangeChild('.top-right', {
            x: width,
            y: 0,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-right') >= 0
        });
        this._batchChangeChild('.middle-left', {
            x: 0,
            y: height / 2,
            offsetX: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('middle-left') >= 0
        });
        this._batchChangeChild('.middle-right', {
            x: width,
            y: height / 2,
            offsetX: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('middle-right') >= 0
        });
        this._batchChangeChild('.bottom-left', {
            x: 0,
            y: height,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-left') >= 0
        });
        this._batchChangeChild('.bottom-center', {
            x: width / 2,
            y: height,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-center') >= 0
        });
        this._batchChangeChild('.bottom-right', {
            x: width,
            y: height,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-right') >= 0
        });
        this._batchChangeChild('.rotater', {
            x: width / 2,
            y: -this.rotateAnchorOffset() * (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd)._sign(height) - padding,
            visible: this.rotateEnabled()
        });
        this._batchChangeChild('.back', {
            width: width,
            height: height,
            visible: this.borderEnabled(),
            stroke: this.borderStroke(),
            strokeWidth: this.borderStrokeWidth(),
            dash: this.borderDash(),
            x: 0,
            y: 0
        });
        (_a = this.getLayer()) === null || _a === void 0 || _a.batchDraw();
    }
    isTransforming() {
        return this._transforming;
    }
    stopTransform() {
        if (this._transforming) {
            this._removeEvents();
            var anchorNode = this.findOne('.' + this._movingAnchorName);
            if (anchorNode) anchorNode.stopDrag();
        }
    }
    destroy() {
        if (this.getStage() && this._cursorChange) this.getStage().content && (this.getStage().content.style.cursor = '');
        (0, $436734b80159e85f$export$eb2fcfdbd7ba97d4).prototype.destroy.call(this);
        this.detach();
        this._removeEvents();
        return this;
    }
    toObject() {
        return (0, $8cc6866a67050653$export$85c928794f8d04d4).prototype.toObject.call(this);
    }
    clone(obj) {
        var node = (0, $8cc6866a67050653$export$85c928794f8d04d4).prototype.clone.call(this, obj);
        return node;
    }
    getClientRect() {
        if (this.nodes().length > 0) return super.getClientRect();
        else return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
}
function $017855c36dc6c47b$var$validateAnchors(val) {
    if (!(val instanceof Array)) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('enabledAnchors value should be an array');
    if (val instanceof Array) val.forEach(function(name) {
        if ($017855c36dc6c47b$var$ANCHORS_NAMES.indexOf(name) === -1) (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).warn('Unknown anchor name: ' + name + '. Available names are: ' + $017855c36dc6c47b$var$ANCHORS_NAMES.join(', '));
    });
    return val || [];
}
$017855c36dc6c47b$export$f993aef960936087.prototype.className = 'Transformer';
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($017855c36dc6c47b$export$f993aef960936087);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'enabledAnchors', $017855c36dc6c47b$var$ANCHORS_NAMES, $017855c36dc6c47b$var$validateAnchors);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'flipEnabled', true, (0, $0e51c174430907a2$export$147fc8b6cd20fda1)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'resizeEnabled', true);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'anchorSize', 10, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'rotateEnabled', true);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'rotationSnaps', []);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'rotateAnchorOffset', 50, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'rotationSnapTolerance', 5, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'borderEnabled', true);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'anchorStroke', 'rgb(0, 161, 255)');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'anchorStrokeWidth', 1, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'anchorFill', 'white');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'anchorCornerRadius', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'borderStroke', 'rgb(0, 161, 255)');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'borderStrokeWidth', 1, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'borderDash');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'keepRatio', true);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'centeredScaling', false);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'ignoreStroke', false);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'padding', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'node');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'nodes');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'boundBoxFunc');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'anchorDragBoundFunc');
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'shouldOverdrawWholeArea', false);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($017855c36dc6c47b$export$f993aef960936087, 'useSingleNodeRotation', true);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).backCompat($017855c36dc6c47b$export$f993aef960936087, {
    lineEnabled: 'borderEnabled',
    rotateHandlerOffset: 'rotateAnchorOffset',
    enabledHandlers: 'enabledAnchors'
});






class $e1f41bac20b13146$export$28718c7785907330 extends (0, $83649c293dd1d496$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.radius(), 0, (0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).getAngle(this.angle()), this.clockwise());
        context.lineTo(0, 0);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
$e1f41bac20b13146$export$28718c7785907330.prototype.className = 'Wedge';
$e1f41bac20b13146$export$28718c7785907330.prototype._centroid = true;
$e1f41bac20b13146$export$28718c7785907330.prototype._attrsAffectingSize = [
    'radius'
];
(0, $e310d2d3cbfa4cef$export$f7a70d87a5e829eb)($e1f41bac20b13146$export$28718c7785907330);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($e1f41bac20b13146$export$28718c7785907330, 'radius', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($e1f41bac20b13146$export$28718c7785907330, 'angle', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)());
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter($e1f41bac20b13146$export$28718c7785907330, 'clockwise', false);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).backCompat($e1f41bac20b13146$export$28718c7785907330, {
    angleDeg: 'angle',
    getAngleDeg: 'getAngle',
    setAngleDeg: 'setAngle'
});





function $a3d25db0935e059d$var$BlurStack() {
    this.r = 0;
    this.g = 0;
    this.b = 0;
    this.a = 0;
    this.next = null;
}
var $a3d25db0935e059d$var$mul_table = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
];
var $a3d25db0935e059d$var$shg_table = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
];
function $a3d25db0935e059d$var$filterGaussBlurRGBA(imageData, radius) {
    var pixels = imageData.data, width = imageData.width, height = imageData.height;
    var x, y, i, p, yp, yi, yw, r_sum, g_sum, b_sum, a_sum, r_out_sum, g_out_sum, b_out_sum, a_out_sum, r_in_sum, g_in_sum, b_in_sum, a_in_sum, pr, pg, pb, pa, rbs;
    var div = radius + radius + 1, widthMinus1 = width - 1, heightMinus1 = height - 1, radiusPlus1 = radius + 1, sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2, stackStart = new $a3d25db0935e059d$var$BlurStack(), stackEnd = null, stack = stackStart, stackIn = null, stackOut = null, mul_sum = $a3d25db0935e059d$var$mul_table[radius], shg_sum = $a3d25db0935e059d$var$shg_table[radius];
    for(i = 1; i < div; i++){
        stack = stack.next = new $a3d25db0935e059d$var$BlurStack();
        if (i === radiusPlus1) stackEnd = stack;
    }
    stack.next = stackStart;
    yw = yi = 0;
    for(y = 0; y < height; y++){
        r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for(i = 0; i < radiusPlus1; i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        for(i = 1; i < radiusPlus1; i++){
            p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
            r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[p + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[p + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
        }
        stackIn = stackStart;
        stackOut = stackEnd;
        for(x = 0; x < width; x++){
            pixels[yi + 3] = pa = a_sum * mul_sum >> shg_sum;
            if (pa !== 0) {
                pa = 255 / pa;
                pixels[yi] = (r_sum * mul_sum >> shg_sum) * pa;
                pixels[yi + 1] = (g_sum * mul_sum >> shg_sum) * pa;
                pixels[yi + 2] = (b_sum * mul_sum >> shg_sum) * pa;
            } else pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1) << 2;
            r_in_sum += stackIn.r = pixels[p];
            g_in_sum += stackIn.g = pixels[p + 1];
            b_in_sum += stackIn.b = pixels[p + 2];
            a_in_sum += stackIn.a = pixels[p + 3];
            r_sum += r_in_sum;
            g_sum += g_in_sum;
            b_sum += b_in_sum;
            a_sum += a_in_sum;
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += 4;
        }
        yw += width;
    }
    for(x = 0; x < width; x++){
        g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;
        yi = x << 2;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for(i = 0; i < radiusPlus1; i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        yp = width;
        for(i = 1; i <= radius; i++){
            yi = yp + x << 2;
            r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[yi + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
            if (i < heightMinus1) yp += width;
        }
        yi = x;
        stackIn = stackStart;
        stackOut = stackEnd;
        for(y = 0; y < height; y++){
            p = yi << 2;
            pixels[p + 3] = pa = a_sum * mul_sum >> shg_sum;
            if (pa > 0) {
                pa = 255 / pa;
                pixels[p] = (r_sum * mul_sum >> shg_sum) * pa;
                pixels[p + 1] = (g_sum * mul_sum >> shg_sum) * pa;
                pixels[p + 2] = (b_sum * mul_sum >> shg_sum) * pa;
            } else pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = x + ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width << 2;
            r_sum += r_in_sum += stackIn.r = pixels[p];
            g_sum += g_in_sum += stackIn.g = pixels[p + 1];
            b_sum += b_in_sum += stackIn.b = pixels[p + 2];
            a_sum += a_in_sum += stackIn.a = pixels[p + 3];
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += width;
        }
    }
}
const $a3d25db0935e059d$export$975a268f2c733e4 = function Blur(imageData) {
    var radius = Math.round(this.blurRadius());
    if (radius > 0) $a3d25db0935e059d$var$filterGaussBlurRGBA(imageData, radius);
};
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'blurRadius', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);





const $5ce3fd5bbfd185c3$export$a2d0d82739cac11f = function(imageData) {
    var brightness = this.brightness() * 255, data = imageData.data, len = data.length, i;
    for(i = 0; i < len; i += 4){
        data[i] += brightness;
        data[i + 1] += brightness;
        data[i + 2] += brightness;
    }
};
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'brightness', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);





const $d2b8119b283efc8f$export$656ae42051d0ca86 = function(imageData) {
    var adjust = Math.pow((this.contrast() + 100) / 100, 2);
    var data = imageData.data, nPixels = data.length, red = 150, green = 150, blue = 150, i;
    for(i = 0; i < nPixels; i += 4){
        red = data[i];
        green = data[i + 1];
        blue = data[i + 2];
        red /= 255;
        red -= 0.5;
        red *= adjust;
        red += 0.5;
        red *= 255;
        green /= 255;
        green -= 0.5;
        green *= adjust;
        green += 0.5;
        green *= 255;
        blue /= 255;
        blue -= 0.5;
        blue *= adjust;
        blue += 0.5;
        blue *= 255;
        red = red < 0 ? 0 : red > 255 ? 255 : red;
        green = green < 0 ? 0 : green > 255 ? 255 : green;
        blue = blue < 0 ? 0 : blue > 255 ? 255 : blue;
        data[i] = red;
        data[i + 1] = green;
        data[i + 2] = blue;
    }
};
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'contrast', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);






const $75280412dcd0604c$export$3c8699b389eb838 = function(imageData) {
    var strength = this.embossStrength() * 10, greyLevel = this.embossWhiteLevel() * 255, direction = this.embossDirection(), blend = this.embossBlend(), dirY = 0, dirX = 0, data = imageData.data, w = imageData.width, h = imageData.height, w4 = w * 4, y = h;
    switch(direction){
        case 'top-left':
            dirY = -1;
            dirX = -1;
            break;
        case 'top':
            dirY = -1;
            dirX = 0;
            break;
        case 'top-right':
            dirY = -1;
            dirX = 1;
            break;
        case 'right':
            dirY = 0;
            dirX = 1;
            break;
        case 'bottom-right':
            dirY = 1;
            dirX = 1;
            break;
        case 'bottom':
            dirY = 1;
            dirX = 0;
            break;
        case 'bottom-left':
            dirY = 1;
            dirX = -1;
            break;
        case 'left':
            dirY = 0;
            dirX = -1;
            break;
        default:
            (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).error('Unknown emboss direction: ' + direction);
    }
    do {
        var offsetY = (y - 1) * w4;
        var otherY = dirY;
        if (y + otherY < 1) otherY = 0;
        if (y + otherY > h) otherY = 0;
        var offsetYOther = (y - 1 + otherY) * w * 4;
        var x = w;
        do {
            var offset = offsetY + (x - 1) * 4;
            var otherX = dirX;
            if (x + otherX < 1) otherX = 0;
            if (x + otherX > w) otherX = 0;
            var offsetOther = offsetYOther + (x - 1 + otherX) * 4;
            var dR = data[offset] - data[offsetOther];
            var dG = data[offset + 1] - data[offsetOther + 1];
            var dB = data[offset + 2] - data[offsetOther + 2];
            var dif = dR;
            var absDif = dif > 0 ? dif : -dif;
            var absG = dG > 0 ? dG : -dG;
            var absB = dB > 0 ? dB : -dB;
            if (absG > absDif) dif = dG;
            if (absB > absDif) dif = dB;
            dif *= strength;
            if (blend) {
                var r = data[offset] + dif;
                var g = data[offset + 1] + dif;
                var b = data[offset + 2] + dif;
                data[offset] = r > 255 ? 255 : r < 0 ? 0 : r;
                data[offset + 1] = g > 255 ? 255 : g < 0 ? 0 : g;
                data[offset + 2] = b > 255 ? 255 : b < 0 ? 0 : b;
            } else {
                var grey = greyLevel - dif;
                if (grey < 0) grey = 0;
                else if (grey > 255) grey = 255;
                data[offset] = data[offset + 1] = data[offset + 2] = grey;
            }
        }while (--x);
    }while (--y);
};
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'embossStrength', 0.5, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'embossWhiteLevel', 0.5, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'embossDirection', 'top-left', null, (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'embossBlend', false, null, (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);





function $3a28acb863bcc893$var$remap(fromValue, fromMin, fromMax, toMin, toMax) {
    var fromRange = fromMax - fromMin, toRange = toMax - toMin, toValue;
    if (fromRange === 0) return toMin + toRange / 2;
    if (toRange === 0) return toMin;
    toValue = (fromValue - fromMin) / fromRange;
    toValue = toRange * toValue + toMin;
    return toValue;
}
const $3a28acb863bcc893$export$5cb8e8388f951d6f = function(imageData) {
    var data = imageData.data, nSubPixels = data.length, rMin = data[0], rMax = rMin, r, gMin = data[1], gMax = gMin, g, bMin = data[2], bMax = bMin, b, i;
    var enhanceAmount = this.enhance();
    if (enhanceAmount === 0) return;
    for(i = 0; i < nSubPixels; i += 4){
        r = data[i + 0];
        if (r < rMin) rMin = r;
        else if (r > rMax) rMax = r;
        g = data[i + 1];
        if (g < gMin) gMin = g;
        else if (g > gMax) gMax = g;
        b = data[i + 2];
        if (b < bMin) bMin = b;
        else if (b > bMax) bMax = b;
    }
    if (rMax === rMin) {
        rMax = 255;
        rMin = 0;
    }
    if (gMax === gMin) {
        gMax = 255;
        gMin = 0;
    }
    if (bMax === bMin) {
        bMax = 255;
        bMin = 0;
    }
    var rMid, rGoalMax, rGoalMin, gMid, gGoalMax, gGoalMin, bMid, bGoalMax, bGoalMin;
    if (enhanceAmount > 0) {
        rGoalMax = rMax + enhanceAmount * (255 - rMax);
        rGoalMin = rMin - enhanceAmount * (rMin - 0);
        gGoalMax = gMax + enhanceAmount * (255 - gMax);
        gGoalMin = gMin - enhanceAmount * (gMin - 0);
        bGoalMax = bMax + enhanceAmount * (255 - bMax);
        bGoalMin = bMin - enhanceAmount * (bMin - 0);
    } else {
        rMid = (rMax + rMin) * 0.5;
        rGoalMax = rMax + enhanceAmount * (rMax - rMid);
        rGoalMin = rMin + enhanceAmount * (rMin - rMid);
        gMid = (gMax + gMin) * 0.5;
        gGoalMax = gMax + enhanceAmount * (gMax - gMid);
        gGoalMin = gMin + enhanceAmount * (gMin - gMid);
        bMid = (bMax + bMin) * 0.5;
        bGoalMax = bMax + enhanceAmount * (bMax - bMid);
        bGoalMin = bMin + enhanceAmount * (bMin - bMid);
    }
    for(i = 0; i < nSubPixels; i += 4){
        data[i + 0] = $3a28acb863bcc893$var$remap(data[i + 0], rMin, rMax, rGoalMin, rGoalMax);
        data[i + 1] = $3a28acb863bcc893$var$remap(data[i + 1], gMin, gMax, gGoalMin, gGoalMax);
        data[i + 2] = $3a28acb863bcc893$var$remap(data[i + 2], bMin, bMax, bGoalMin, bGoalMax);
    }
};
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'enhance', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);


const $51a398d5fc3f337c$export$e2b0a794e83ca071 = function(imageData) {
    var data = imageData.data, len = data.length, i, brightness;
    for(i = 0; i < len; i += 4){
        brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
        data[i] = brightness;
        data[i + 1] = brightness;
        data[i + 2] = brightness;
    }
};





(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'hue', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'saturation', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'luminance', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);
const $9c1618458e722be2$export$46d8b0f9bc8f87a2 = function(imageData) {
    var data = imageData.data, nPixels = data.length, v = 1, s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, l = this.luminance() * 127, i;
    var vsu = v * s * Math.cos(h * Math.PI / 180), vsw = v * s * Math.sin(h * Math.PI / 180);
    var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    var br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    var r, g, b, a;
    for(i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b + l;
        data[i + 1] = gr * r + gg * g + gb * b + l;
        data[i + 2] = br * r + bg * g + bb * b + l;
        data[i + 3] = a;
    }
};





const $524c9ae71af8394a$export$d2edaecd208aed43 = function(imageData) {
    var data = imageData.data, nPixels = data.length, v = Math.pow(2, this.value()), s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, i;
    var vsu = v * s * Math.cos(h * Math.PI / 180), vsw = v * s * Math.sin(h * Math.PI / 180);
    var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    var br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    var r, g, b, a;
    for(i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b;
        data[i + 1] = gr * r + gg * g + gb * b;
        data[i + 2] = br * r + bg * g + bb * b;
        data[i + 3] = a;
    }
};
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'hue', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'saturation', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'value', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);


const $7da932dd80dbb972$export$1073348d81b17440 = function(imageData) {
    var data = imageData.data, len = data.length, i;
    for(i = 0; i < len; i += 4){
        data[i] = 255 - data[i];
        data[i + 1] = 255 - data[i + 1];
        data[i + 2] = 255 - data[i + 2];
    }
};






var $4f0f254b7704805c$var$ToPolar = function(src, dst, opt) {
    var srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2, i, x, y, r = 0, g = 0, b = 0, a = 0;
    var rad, rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    x = xSize - xMid;
    y = ySize - yMid;
    rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    var rSize = ySize, tSize = xSize, radius, theta;
    var conversion = 360 / tSize * Math.PI / 180, sin, cos;
    for(theta = 0; theta < tSize; theta += 1){
        sin = Math.sin(theta * conversion);
        cos = Math.cos(theta * conversion);
        for(radius = 0; radius < rSize; radius += 1){
            x = Math.floor(xMid + rMax * radius / rSize * cos);
            y = Math.floor(yMid + rMax * radius / rSize * sin);
            i = (y * xSize + x) * 4;
            r = srcPixels[i + 0];
            g = srcPixels[i + 1];
            b = srcPixels[i + 2];
            a = srcPixels[i + 3];
            i = (theta + radius * xSize) * 4;
            dstPixels[i + 0] = r;
            dstPixels[i + 1] = g;
            dstPixels[i + 2] = b;
            dstPixels[i + 3] = a;
        }
    }
};
var $4f0f254b7704805c$var$FromPolar = function(src, dst, opt) {
    var srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2, i, x, y, dx, dy, r = 0, g = 0, b = 0, a = 0;
    var rad, rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    x = xSize - xMid;
    y = ySize - yMid;
    rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    var rSize = ySize, tSize = xSize, radius, theta, phaseShift = opt.polarRotation || 0;
    var x1, y1;
    for(x = 0; x < xSize; x += 1)for(y = 0; y < ySize; y += 1){
        dx = x - xMid;
        dy = y - yMid;
        radius = Math.sqrt(dx * dx + dy * dy) * rSize / rMax;
        theta = (Math.atan2(dy, dx) * 180 / Math.PI + 360 + phaseShift) % 360;
        theta = theta * tSize / 360;
        x1 = Math.floor(theta);
        y1 = Math.floor(radius);
        i = (y1 * xSize + x1) * 4;
        r = srcPixels[i + 0];
        g = srcPixels[i + 1];
        b = srcPixels[i + 2];
        a = srcPixels[i + 3];
        i = (y * xSize + x) * 4;
        dstPixels[i + 0] = r;
        dstPixels[i + 1] = g;
        dstPixels[i + 2] = b;
        dstPixels[i + 3] = a;
    }
};
const $4f0f254b7704805c$export$e731e8a0fd067155 = function(imageData) {
    var xSize = imageData.width, ySize = imageData.height;
    var x, y, xoff, i, r, g, b, a, srcPos, dstPos;
    var power = Math.round(this.kaleidoscopePower());
    var angle = Math.round(this.kaleidoscopeAngle());
    var offset = Math.floor(xSize * (angle % 360) / 360);
    if (power < 1) return;
    var tempCanvas = (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).createCanvasElement();
    tempCanvas.width = xSize;
    tempCanvas.height = ySize;
    var scratchData = tempCanvas.getContext('2d').getImageData(0, 0, xSize, ySize);
    (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).releaseCanvas(tempCanvas);
    $4f0f254b7704805c$var$ToPolar(imageData, scratchData, {
        polarCenterX: xSize / 2,
        polarCenterY: ySize / 2
    });
    var minSectionSize = xSize / Math.pow(2, power);
    while(minSectionSize <= 8){
        minSectionSize = minSectionSize * 2;
        power -= 1;
    }
    minSectionSize = Math.ceil(minSectionSize);
    var sectionSize = minSectionSize;
    var xStart = 0, xEnd = sectionSize, xDelta = 1;
    if (offset + minSectionSize > xSize) {
        xStart = sectionSize;
        xEnd = 0;
        xDelta = -1;
    }
    for(y = 0; y < ySize; y += 1)for(x = xStart; x !== xEnd; x += xDelta){
        xoff = Math.round(x + offset) % xSize;
        srcPos = (xSize * y + xoff) * 4;
        r = scratchData.data[srcPos + 0];
        g = scratchData.data[srcPos + 1];
        b = scratchData.data[srcPos + 2];
        a = scratchData.data[srcPos + 3];
        dstPos = (xSize * y + x) * 4;
        scratchData.data[dstPos + 0] = r;
        scratchData.data[dstPos + 1] = g;
        scratchData.data[dstPos + 2] = b;
        scratchData.data[dstPos + 3] = a;
    }
    for(y = 0; y < ySize; y += 1){
        sectionSize = Math.floor(minSectionSize);
        for(i = 0; i < power; i += 1){
            for(x = 0; x < sectionSize + 1; x += 1){
                srcPos = (xSize * y + x) * 4;
                r = scratchData.data[srcPos + 0];
                g = scratchData.data[srcPos + 1];
                b = scratchData.data[srcPos + 2];
                a = scratchData.data[srcPos + 3];
                dstPos = (xSize * y + sectionSize * 2 - x - 1) * 4;
                scratchData.data[dstPos + 0] = r;
                scratchData.data[dstPos + 1] = g;
                scratchData.data[dstPos + 2] = b;
                scratchData.data[dstPos + 3] = a;
            }
            sectionSize *= 2;
        }
    }
    $4f0f254b7704805c$var$FromPolar(scratchData, imageData, {
        polarRotation: 0
    });
};
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'kaleidoscopePower', 2, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'kaleidoscopeAngle', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);





function $a487491b05168d5c$var$pixelAt(idata, x, y) {
    var idx = (y * idata.width + x) * 4;
    var d = [];
    d.push(idata.data[idx++], idata.data[idx++], idata.data[idx++], idata.data[idx++]);
    return d;
}
function $a487491b05168d5c$var$rgbDistance(p1, p2) {
    return Math.sqrt(Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2) + Math.pow(p1[2] - p2[2], 2));
}
function $a487491b05168d5c$var$rgbMean(pTab) {
    var m = [
        0,
        0,
        0
    ];
    for(var i = 0; i < pTab.length; i++){
        m[0] += pTab[i][0];
        m[1] += pTab[i][1];
        m[2] += pTab[i][2];
    }
    m[0] /= pTab.length;
    m[1] /= pTab.length;
    m[2] /= pTab.length;
    return m;
}
function $a487491b05168d5c$var$backgroundMask(idata, threshold) {
    var rgbv_no = $a487491b05168d5c$var$pixelAt(idata, 0, 0);
    var rgbv_ne = $a487491b05168d5c$var$pixelAt(idata, idata.width - 1, 0);
    var rgbv_so = $a487491b05168d5c$var$pixelAt(idata, 0, idata.height - 1);
    var rgbv_se = $a487491b05168d5c$var$pixelAt(idata, idata.width - 1, idata.height - 1);
    var thres = threshold || 10;
    if ($a487491b05168d5c$var$rgbDistance(rgbv_no, rgbv_ne) < thres && $a487491b05168d5c$var$rgbDistance(rgbv_ne, rgbv_se) < thres && $a487491b05168d5c$var$rgbDistance(rgbv_se, rgbv_so) < thres && $a487491b05168d5c$var$rgbDistance(rgbv_so, rgbv_no) < thres) {
        var mean = $a487491b05168d5c$var$rgbMean([
            rgbv_ne,
            rgbv_no,
            rgbv_se,
            rgbv_so
        ]);
        var mask = [];
        for(var i = 0; i < idata.width * idata.height; i++){
            var d = $a487491b05168d5c$var$rgbDistance(mean, [
                idata.data[i * 4],
                idata.data[i * 4 + 1],
                idata.data[i * 4 + 2]
            ]);
            mask[i] = d < thres ? 0 : 255;
        }
        return mask;
    }
}
function $a487491b05168d5c$var$applyMask(idata, mask) {
    for(var i = 0; i < idata.width * idata.height; i++)idata.data[4 * i + 3] = mask[i];
}
function $a487491b05168d5c$var$erodeMask(mask, sw, sh) {
    var weights = [
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1
    ];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);
    var maskResult = [];
    for(var y = 0; y < sh; y++)for(var x = 0; x < sw; x++){
        var so = y * sw + x;
        var a = 0;
        for(var cy = 0; cy < side; cy++)for(var cx = 0; cx < side; cx++){
            var scy = y + cy - halfSide;
            var scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                var srcOff = scy * sw + scx;
                var wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a === 2040 ? 255 : 0;
    }
    return maskResult;
}
function $a487491b05168d5c$var$dilateMask(mask, sw, sh) {
    var weights = [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);
    var maskResult = [];
    for(var y = 0; y < sh; y++)for(var x = 0; x < sw; x++){
        var so = y * sw + x;
        var a = 0;
        for(var cy = 0; cy < side; cy++)for(var cx = 0; cx < side; cx++){
            var scy = y + cy - halfSide;
            var scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                var srcOff = scy * sw + scx;
                var wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a >= 1020 ? 255 : 0;
    }
    return maskResult;
}
function $a487491b05168d5c$var$smoothEdgeMask(mask, sw, sh) {
    var weights = [
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9
    ];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);
    var maskResult = [];
    for(var y = 0; y < sh; y++)for(var x = 0; x < sw; x++){
        var so = y * sw + x;
        var a = 0;
        for(var cy = 0; cy < side; cy++)for(var cx = 0; cx < side; cx++){
            var scy = y + cy - halfSide;
            var scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                var srcOff = scy * sw + scx;
                var wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a;
    }
    return maskResult;
}
const $a487491b05168d5c$export$991dcf7284de63d = function(imageData) {
    var threshold = this.threshold(), mask = $a487491b05168d5c$var$backgroundMask(imageData, threshold);
    if (mask) {
        mask = $a487491b05168d5c$var$erodeMask(mask, imageData.width, imageData.height);
        mask = $a487491b05168d5c$var$dilateMask(mask, imageData.width, imageData.height);
        mask = $a487491b05168d5c$var$smoothEdgeMask(mask, imageData.width, imageData.height);
        $a487491b05168d5c$var$applyMask(imageData, mask);
    }
    return imageData;
};
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'threshold', 0, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);





const $ab261b6b36d7a308$export$484d33a0500a4ce1 = function(imageData) {
    var amount = this.noise() * 255, data = imageData.data, nPixels = data.length, half = amount / 2, i;
    for(i = 0; i < nPixels; i += 4){
        data[i + 0] += half - 2 * half * Math.random();
        data[i + 1] += half - 2 * half * Math.random();
        data[i + 2] += half - 2 * half * Math.random();
    }
};
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'noise', 0.2, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);






const $c8e9654103ac4b2a$export$63396595bf5aeaa7 = function(imageData) {
    var pixelSize = Math.ceil(this.pixelSize()), width = imageData.width, height = imageData.height, x, y, i, red, green, blue, alpha, nBinsX = Math.ceil(width / pixelSize), nBinsY = Math.ceil(height / pixelSize), xBinStart, xBinEnd, yBinStart, yBinEnd, xBin, yBin, pixelsInBin, data = imageData.data;
    if (pixelSize <= 0) {
        (0, $87c9acccd58fa09f$export$f8f26dd395d7e1bd).error('pixelSize value can not be <= 0');
        return;
    }
    for(xBin = 0; xBin < nBinsX; xBin += 1)for(yBin = 0; yBin < nBinsY; yBin += 1){
        red = 0;
        green = 0;
        blue = 0;
        alpha = 0;
        xBinStart = xBin * pixelSize;
        xBinEnd = xBinStart + pixelSize;
        yBinStart = yBin * pixelSize;
        yBinEnd = yBinStart + pixelSize;
        pixelsInBin = 0;
        for(x = xBinStart; x < xBinEnd; x += 1){
            if (x >= width) continue;
            for(y = yBinStart; y < yBinEnd; y += 1){
                if (y >= height) continue;
                i = (width * y + x) * 4;
                red += data[i + 0];
                green += data[i + 1];
                blue += data[i + 2];
                alpha += data[i + 3];
                pixelsInBin += 1;
            }
        }
        red = red / pixelsInBin;
        green = green / pixelsInBin;
        blue = blue / pixelsInBin;
        alpha = alpha / pixelsInBin;
        for(x = xBinStart; x < xBinEnd; x += 1){
            if (x >= width) continue;
            for(y = yBinStart; y < yBinEnd; y += 1){
                if (y >= height) continue;
                i = (width * y + x) * 4;
                data[i + 0] = red;
                data[i + 1] = green;
                data[i + 2] = blue;
                data[i + 3] = alpha;
            }
        }
    }
};
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'pixelSize', 8, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);





const $e6f4b70618051979$export$ccda2563bc5d1354 = function(imageData) {
    var levels = Math.round(this.levels() * 254) + 1, data = imageData.data, len = data.length, scale = 255 / levels, i;
    for(i = 0; i < len; i += 1)data[i] = Math.floor(data[i] / scale) * scale;
};
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'levels', 0.5, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);





const $8b69f1fb6c0b16e2$export$8f9ece5a47764b93 = function(imageData) {
    var data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), i, brightness;
    for(i = 0; i < nPixels; i += 4){
        brightness = (0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2]) / 255;
        data[i] = brightness * red;
        data[i + 1] = brightness * green;
        data[i + 2] = brightness * blue;
        data[i + 3] = data[i + 3];
    }
};
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'red', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'green', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'blue', 0, (0, $0e51c174430907a2$export$af51e4581c640b27), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);





const $7156ceb4c4597d19$export$f50470518fe8f14a = function(imageData) {
    var data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), alpha = this.alpha(), i, ia;
    for(i = 0; i < nPixels; i += 4){
        ia = 1 - alpha;
        data[i] = red * alpha + data[i] * ia;
        data[i + 1] = green * alpha + data[i + 1] * ia;
        data[i + 2] = blue * alpha + data[i + 2] * ia;
    }
};
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'red', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'green', 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'blue', 0, (0, $0e51c174430907a2$export$af51e4581c640b27), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'alpha', 1, function(val) {
    this._filterUpToDate = false;
    if (val > 1) return 1;
    else if (val < 0) return 0;
    else return val;
});


const $07b972a2eae4a8ef$export$1eeb4741c69006fa = function(imageData) {
    var data = imageData.data, nPixels = data.length, i, r, g, b;
    for(i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        data[i + 0] = Math.min(255, r * 0.393 + g * 0.769 + b * 0.189);
        data[i + 1] = Math.min(255, r * 0.349 + g * 0.686 + b * 0.168);
        data[i + 2] = Math.min(255, r * 0.272 + g * 0.534 + b * 0.131);
    }
};


const $682daf6661f36ef0$export$d60d51c3865bca60 = function(imageData) {
    var data = imageData.data, w = imageData.width, h = imageData.height, w4 = w * 4, y = h;
    do {
        var offsetY = (y - 1) * w4;
        var x = w;
        do {
            var offset = offsetY + (x - 1) * 4;
            var r = data[offset];
            var g = data[offset + 1];
            var b = data[offset + 2];
            if (r > 127) r = 255 - r;
            if (g > 127) g = 255 - g;
            if (b > 127) b = 255 - b;
            data[offset] = r;
            data[offset + 1] = g;
            data[offset + 2] = b;
        }while (--x);
    }while (--y);
};





const $27c5532815e63a9f$export$14f770b2ce0bb8ad = function(imageData) {
    var level = this.threshold() * 255, data = imageData.data, len = data.length, i;
    for(i = 0; i < len; i += 1)data[i] = data[i] < level ? 0 : 255;
};
(0, $765dacbd3f0ba182$export$8354032f3852ec50).addGetterSetter((0, $8cc6866a67050653$export$85c928794f8d04d4), 'threshold', 0.5, (0, $0e51c174430907a2$export$6b1205b9fbe7de2c)(), (0, $765dacbd3f0ba182$export$8354032f3852ec50).afterSetFilter);


const $132cd8b09b259eae$export$b9f99057a3c7692 = (0, $9c82b2654798ec55$export$b9f99057a3c7692).Util._assign((0, $9c82b2654798ec55$export$b9f99057a3c7692), {
    Arc: $82230a9698c5d3c4$export$6ef80ffb606dd232,
    Arrow: $98b516c61ac16d08$export$21b07c8f274aebd5,
    Circle: $9d9aa146403da755$export$c89a927ffc67e6fa,
    Ellipse: $493f13a63261025e$export$80b0269ab108fa11,
    Image: $15fc9fbddbc2b775$export$3e431a229df88919,
    Label: $49bd09d345e0d5e6$export$b04be29aa201d4f5,
    Tag: $49bd09d345e0d5e6$export$3288d34c523a1192,
    Line: $0f0d3262ac6f36e9$export$17d680238e50603e,
    Path: $a87b11181a0f7921$export$4b2950bdac9b6ee9,
    Rect: $0258dbc9803ecab0$export$c79fc6492f3af13d,
    RegularPolygon: $74da23b272f77dc3$export$e2ee866164812ecd,
    Ring: $67ceece5cb9a9915$export$a6e3577650b6d6d7,
    Sprite: $a10aa708bdcce0c0$export$3075603db8e6204c,
    Star: $b06f2eef1770a61e$export$1644ba17714857f1,
    Text: $b7cb399147d124e6$export$5f1af8db9871e1d6,
    TextPath: $679d0dcb922e3736$export$f7e34a95cc06fac7,
    Transformer: $017855c36dc6c47b$export$f993aef960936087,
    Wedge: $e1f41bac20b13146$export$28718c7785907330,
    Filters: {
        Blur: $a3d25db0935e059d$export$975a268f2c733e4,
        Brighten: $5ce3fd5bbfd185c3$export$a2d0d82739cac11f,
        Contrast: $d2b8119b283efc8f$export$656ae42051d0ca86,
        Emboss: $75280412dcd0604c$export$3c8699b389eb838,
        Enhance: $3a28acb863bcc893$export$5cb8e8388f951d6f,
        Grayscale: $51a398d5fc3f337c$export$e2b0a794e83ca071,
        HSL: $9c1618458e722be2$export$46d8b0f9bc8f87a2,
        HSV: $524c9ae71af8394a$export$d2edaecd208aed43,
        Invert: $7da932dd80dbb972$export$1073348d81b17440,
        Kaleidoscope: $4f0f254b7704805c$export$e731e8a0fd067155,
        Mask: $a487491b05168d5c$export$991dcf7284de63d,
        Noise: $ab261b6b36d7a308$export$484d33a0500a4ce1,
        Pixelate: $c8e9654103ac4b2a$export$63396595bf5aeaa7,
        Posterize: $e6f4b70618051979$export$ccda2563bc5d1354,
        RGB: $8b69f1fb6c0b16e2$export$8f9ece5a47764b93,
        RGBA: $7156ceb4c4597d19$export$f50470518fe8f14a,
        Sepia: $07b972a2eae4a8ef$export$1eeb4741c69006fa,
        Solarize: $682daf6661f36ef0$export$d60d51c3865bca60,
        Threshold: $27c5532815e63a9f$export$14f770b2ce0bb8ad
    }
});


var $22a302821a80fe9b$export$2e2bcd8739ae039 = (0, $132cd8b09b259eae$export$b9f99057a3c7692);


/**
 * Based on ReactArt.js
 * Copyright (c) 2017-present Lavrenov Anton.
 * All rights reserved.
 *
 * MIT
 */ 
var $9Cg25 = parcelRequire("9Cg25");

var $77f2f7b750eb6707$export$2e2bcd8739ae039 = (0, $9c82b2654798ec55$export$b9f99057a3c7692);


var $19bb1665b295b08c$exports = {};
'use strict';

$19bb1665b295b08c$exports = (parcelRequire("k8obU"));


var $fd02eb36c87a22cc$exports = {};

$parcel$export($fd02eb36c87a22cc$exports, "appendInitialChild", function () { return $fd02eb36c87a22cc$export$b1cefef778e97ee8; });
$parcel$export($fd02eb36c87a22cc$exports, "createInstance", function () { return $fd02eb36c87a22cc$export$99152e8d49ca4e7d; });
$parcel$export($fd02eb36c87a22cc$exports, "createTextInstance", function () { return $fd02eb36c87a22cc$export$d1ef805cf7083486; });
$parcel$export($fd02eb36c87a22cc$exports, "finalizeInitialChildren", function () { return $fd02eb36c87a22cc$export$7bb0b211bcb5abfd; });
$parcel$export($fd02eb36c87a22cc$exports, "getPublicInstance", function () { return $fd02eb36c87a22cc$export$d2475cc200518c86; });
$parcel$export($fd02eb36c87a22cc$exports, "prepareForCommit", function () { return $fd02eb36c87a22cc$export$ba5994afaabfdb0c; });
$parcel$export($fd02eb36c87a22cc$exports, "preparePortalMount", function () { return $fd02eb36c87a22cc$export$e15c8ecd0a0092b2; });
$parcel$export($fd02eb36c87a22cc$exports, "prepareUpdate", function () { return $fd02eb36c87a22cc$export$c885331d842f22b5; });
$parcel$export($fd02eb36c87a22cc$exports, "resetAfterCommit", function () { return $fd02eb36c87a22cc$export$683e88f306512aed; });
$parcel$export($fd02eb36c87a22cc$exports, "resetTextContent", function () { return $fd02eb36c87a22cc$export$2119d6fc5d6f51aa; });
$parcel$export($fd02eb36c87a22cc$exports, "shouldDeprioritizeSubtree", function () { return $fd02eb36c87a22cc$export$70ab89a99d11d186; });
$parcel$export($fd02eb36c87a22cc$exports, "getRootHostContext", function () { return $fd02eb36c87a22cc$export$dce2ca0b0f5feeb5; });
$parcel$export($fd02eb36c87a22cc$exports, "getChildHostContext", function () { return $fd02eb36c87a22cc$export$1236a84b6992d37a; });
$parcel$export($fd02eb36c87a22cc$exports, "scheduleTimeout", function () { return $fd02eb36c87a22cc$export$5f4d6617421d489b; });
$parcel$export($fd02eb36c87a22cc$exports, "cancelTimeout", function () { return $fd02eb36c87a22cc$export$f78ec70d8091ca88; });
$parcel$export($fd02eb36c87a22cc$exports, "noTimeout", function () { return $fd02eb36c87a22cc$export$78506abae4a4951d; });
$parcel$export($fd02eb36c87a22cc$exports, "shouldSetTextContent", function () { return $fd02eb36c87a22cc$export$c82139d6d374ec34; });
$parcel$export($fd02eb36c87a22cc$exports, "isPrimaryRenderer", function () { return $fd02eb36c87a22cc$export$a5fcb8abea5b71a4; });
$parcel$export($fd02eb36c87a22cc$exports, "warnsIfNotActing", function () { return $fd02eb36c87a22cc$export$2516db7323c01bd5; });
$parcel$export($fd02eb36c87a22cc$exports, "supportsMutation", function () { return $fd02eb36c87a22cc$export$20f97ad47f9ebeb; });
$parcel$export($fd02eb36c87a22cc$exports, "appendChild", function () { return $fd02eb36c87a22cc$export$1b8e57c9ea42f1d2; });
$parcel$export($fd02eb36c87a22cc$exports, "appendChildToContainer", function () { return $fd02eb36c87a22cc$export$5e391de19acdf645; });
$parcel$export($fd02eb36c87a22cc$exports, "insertBefore", function () { return $fd02eb36c87a22cc$export$86b68c7dbeb53c22; });
$parcel$export($fd02eb36c87a22cc$exports, "insertInContainerBefore", function () { return $fd02eb36c87a22cc$export$7ec3655259385e44; });
$parcel$export($fd02eb36c87a22cc$exports, "removeChild", function () { return $fd02eb36c87a22cc$export$7ae609f7af59e4f7; });
$parcel$export($fd02eb36c87a22cc$exports, "removeChildFromContainer", function () { return $fd02eb36c87a22cc$export$2e4ef5d75a473f1a; });
$parcel$export($fd02eb36c87a22cc$exports, "commitTextUpdate", function () { return $fd02eb36c87a22cc$export$50a92d0155bee474; });
$parcel$export($fd02eb36c87a22cc$exports, "commitMount", function () { return $fd02eb36c87a22cc$export$fe90794743fbfeb0; });
$parcel$export($fd02eb36c87a22cc$exports, "commitUpdate", function () { return $fd02eb36c87a22cc$export$fd8222818e57ec6; });
$parcel$export($fd02eb36c87a22cc$exports, "hideInstance", function () { return $fd02eb36c87a22cc$export$6db9fd2b8188b8b7; });
$parcel$export($fd02eb36c87a22cc$exports, "hideTextInstance", function () { return $fd02eb36c87a22cc$export$17ed9cbd9cb3aad2; });
$parcel$export($fd02eb36c87a22cc$exports, "unhideInstance", function () { return $fd02eb36c87a22cc$export$933e25c2090d1941; });
$parcel$export($fd02eb36c87a22cc$exports, "unhideTextInstance", function () { return $fd02eb36c87a22cc$export$8ff685cdcb7326ff; });
$parcel$export($fd02eb36c87a22cc$exports, "clearContainer", function () { return $fd02eb36c87a22cc$export$28e08eff11ac64f6; });
$parcel$export($fd02eb36c87a22cc$exports, "now", function () { return (parcelRequire("19fYw")).unstable_now; });
$parcel$export($fd02eb36c87a22cc$exports, "idlePriority", function () { return (parcelRequire("19fYw")).unstable_IdlePriority; });
$parcel$export($fd02eb36c87a22cc$exports, "run", function () { return (parcelRequire("19fYw")).unstable_runWithPriority; });


var $a943d52f2f5b9487$var$propsToSkip = {
    children: true,
    ref: true,
    key: true,
    style: true,
    forwardedRef: true,
    unstable_applyCache: true,
    unstable_applyDrawHitFromCache: true
};
var $a943d52f2f5b9487$var$zIndexWarningShowed = false;
var $a943d52f2f5b9487$var$dragWarningShowed = false;
var $a943d52f2f5b9487$export$3a20cc353cdae1b2 = '.react-konva-event';
var $a943d52f2f5b9487$var$useStrictMode = false;
function $a943d52f2f5b9487$export$5a38dcef855281ce(value) {
    $a943d52f2f5b9487$var$useStrictMode = value;
}
var $a943d52f2f5b9487$var$DRAGGABLE_WARNING = 'ReactKonva: You have a Konva node with draggable = true and position defined but no onDragMove or onDragEnd events are handled.\nPosition of a node will be changed during drag&drop, so you should update state of the react app as well.\nConsider to add onDragMove or onDragEnd events.\nFor more info see: https://github.com/konvajs/react-konva/issues/256\n';
var $a943d52f2f5b9487$var$Z_INDEX_WARNING = 'ReactKonva: You are using "zIndex" attribute for a Konva node.\nreact-konva may get confused with ordering. Just define correct order of elements in your render function of a component.\nFor more info see: https://github.com/konvajs/react-konva/issues/194\n';
var $a943d52f2f5b9487$var$EMPTY_PROPS = {};
function $a943d52f2f5b9487$export$25d4dd8d7c7a61f6(instance, props) {
    var oldProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $a943d52f2f5b9487$var$EMPTY_PROPS;
    if (props === oldProps) console.error('same props');
    // don't use zIndex in react-konva
    if (!$a943d52f2f5b9487$var$zIndexWarningShowed && 'zIndex' in props) {
        console.warn($a943d52f2f5b9487$var$Z_INDEX_WARNING);
        $a943d52f2f5b9487$var$zIndexWarningShowed = true;
    }
    // check correct draggable usage
    if (!$a943d52f2f5b9487$var$dragWarningShowed && props.draggable) {
        var hasPosition = props.x !== undefined || props.y !== undefined;
        var hasEvents = props.onDragEnd || props.onDragMove;
        if (hasPosition && !hasEvents) {
            console.warn($a943d52f2f5b9487$var$DRAGGABLE_WARNING);
            $a943d52f2f5b9487$var$dragWarningShowed = true;
        }
    }
    // check old props
    // we need to unset properties that are not in new props
    // and remove all events
    for(var key in oldProps){
        if ($a943d52f2f5b9487$var$propsToSkip[key]) continue;
        var isEvent = key.slice(0, 2) === 'on';
        var propChanged = oldProps[key] !== props[key];
        // if that is a changed event, we need to remvoe it
        if (isEvent && propChanged) {
            var eventName = key.substr(2).toLowerCase();
            if (eventName.substr(0, 7) === 'content') eventName = 'content' + eventName.substr(7, 1).toUpperCase() + eventName.substr(8);
            instance.off(eventName, oldProps[key]);
        }
        var toRemove = !props.hasOwnProperty(key);
        if (toRemove) instance.setAttr(key, undefined);
    }
    var strictUpdate = $a943d52f2f5b9487$var$useStrictMode || props._useStrictMode;
    var updatedProps = {};
    var hasUpdates = false;
    var newEvents = {};
    for(var key in props){
        if ($a943d52f2f5b9487$var$propsToSkip[key]) continue;
        var isEvent = key.slice(0, 2) === 'on';
        var toAdd = oldProps[key] !== props[key];
        if (isEvent && toAdd) {
            var eventName = key.substr(2).toLowerCase();
            if (eventName.substr(0, 7) === 'content') eventName = 'content' + eventName.substr(7, 1).toUpperCase() + eventName.substr(8);
            // check that event is not undefined
            if (props[key]) newEvents[eventName] = props[key];
        }
        if (!isEvent && (props[key] !== oldProps[key] || strictUpdate && props[key] !== instance.getAttr(key))) {
            hasUpdates = true;
            updatedProps[key] = props[key];
        }
    }
    if (hasUpdates) {
        instance.setAttrs(updatedProps);
        $a943d52f2f5b9487$export$8d64f55d8bab80d4(instance);
    }
    // subscribe to events AFTER we set attrs
    // we need it to fix https://github.com/konvajs/react-konva/issues/471
    // settings attrs may add events. Like "draggable: true" will add "mousedown" listener
    for(var eventName in newEvents)instance.on(eventName + $a943d52f2f5b9487$export$3a20cc353cdae1b2, newEvents[eventName]);
}
function $a943d52f2f5b9487$export$8d64f55d8bab80d4(node) {
    if (!(0, $e310d2d3cbfa4cef$export$b9f99057a3c7692).autoDrawEnabled) {
        var drawingNode = node.getLayer() || node.getStage();
        drawingNode && drawingNode.batchDraw();
    }
}



var $19fYw = parcelRequire("19fYw");
var $fd02eb36c87a22cc$var$NO_CONTEXT = {};
var $fd02eb36c87a22cc$var$UPDATE_SIGNAL = {};
// for react-spring capability
(0, $77f2f7b750eb6707$export$2e2bcd8739ae039).Node.prototype._applyProps = (0, $a943d52f2f5b9487$export$25d4dd8d7c7a61f6);
function $fd02eb36c87a22cc$export$b1cefef778e97ee8(parentInstance, child) {
    if (typeof child === 'string') {
        // Noop for string children of Text (eg <Text>foo</Text>)
        console.error('Do not use plain text as child of Konva.Node. You are using text: ' + child);
        return;
    }
    parentInstance.add(child);
    (0, $a943d52f2f5b9487$export$8d64f55d8bab80d4)(parentInstance);
}
function $fd02eb36c87a22cc$export$99152e8d49ca4e7d(type, props, internalInstanceHandle) {
    var NodeClass = (0, $77f2f7b750eb6707$export$2e2bcd8739ae039)[type];
    if (!NodeClass) {
        console.error('Konva has no node with the type ' + type + '. Group will be used instead. If you use minimal version of react-konva, just import required nodes into Konva: "import "konva/lib/shapes/' + type + '"  If you want to render DOM elements as part of canvas tree take a look into this demo: https://konvajs.github.io/docs/react/DOM_Portal.html');
        NodeClass = (0, $77f2f7b750eb6707$export$2e2bcd8739ae039).Group;
    }
    // we need to split props into events and non events
    // we we can pass non events into constructor directly
    // that way the performance should be better
    // we we apply change "applyNodeProps"
    // then it will trigger change events on first run
    // but we don't need them!
    var propsWithoutEvents = {};
    var propsWithOnlyEvents = {};
    for(var key in props){
        var isEvent = key.slice(0, 2) === 'on';
        if (isEvent) propsWithOnlyEvents[key] = props[key];
        else propsWithoutEvents[key] = props[key];
    }
    var instance = new NodeClass(propsWithoutEvents);
    (0, $a943d52f2f5b9487$export$25d4dd8d7c7a61f6)(instance, propsWithOnlyEvents);
    return instance;
}
function $fd02eb36c87a22cc$export$d1ef805cf7083486(text, rootContainerInstance, internalInstanceHandle) {
    console.error('Text components are not supported for now in ReactKonva. Your text is: "' + text + '"');
}
function $fd02eb36c87a22cc$export$7bb0b211bcb5abfd(domElement, type, props) {
    return false;
}
function $fd02eb36c87a22cc$export$d2475cc200518c86(instance) {
    return instance;
}
function $fd02eb36c87a22cc$export$ba5994afaabfdb0c() {
    return null;
}
function $fd02eb36c87a22cc$export$e15c8ecd0a0092b2() {
    return null;
}
function $fd02eb36c87a22cc$export$c885331d842f22b5(domElement, type, oldProps, newProps) {
    return $fd02eb36c87a22cc$var$UPDATE_SIGNAL;
}
function $fd02eb36c87a22cc$export$683e88f306512aed() {
// Noop
}
function $fd02eb36c87a22cc$export$2119d6fc5d6f51aa(domElement) {
// Noop
}
function $fd02eb36c87a22cc$export$70ab89a99d11d186(type, props) {
    return false;
}
function $fd02eb36c87a22cc$export$dce2ca0b0f5feeb5() {
    return $fd02eb36c87a22cc$var$NO_CONTEXT;
}
function $fd02eb36c87a22cc$export$1236a84b6992d37a() {
    return $fd02eb36c87a22cc$var$NO_CONTEXT;
}
var $fd02eb36c87a22cc$export$5f4d6617421d489b = setTimeout;
var $fd02eb36c87a22cc$export$f78ec70d8091ca88 = clearTimeout;
var $fd02eb36c87a22cc$export$78506abae4a4951d = -1;
function $fd02eb36c87a22cc$export$c82139d6d374ec34(type, props) {
    return false;
}
var $fd02eb36c87a22cc$export$a5fcb8abea5b71a4 = false;
var $fd02eb36c87a22cc$export$2516db7323c01bd5 = true;
var $fd02eb36c87a22cc$export$20f97ad47f9ebeb = true;
function $fd02eb36c87a22cc$export$1b8e57c9ea42f1d2(parentInstance, child) {
    if (child.parent === parentInstance) child.moveToTop();
    else parentInstance.add(child);
    (0, $a943d52f2f5b9487$export$8d64f55d8bab80d4)(parentInstance);
}
function $fd02eb36c87a22cc$export$5e391de19acdf645(parentInstance, child) {
    if (child.parent === parentInstance) child.moveToTop();
    else parentInstance.add(child);
    (0, $a943d52f2f5b9487$export$8d64f55d8bab80d4)(parentInstance);
}
function $fd02eb36c87a22cc$export$86b68c7dbeb53c22(parentInstance, child, beforeChild) {
    // child._remove() will not stop dragging
    // but child.remove() will stop it, but we don't need it
    // removing will reset zIndexes
    child._remove();
    parentInstance.add(child);
    child.setZIndex(beforeChild.getZIndex());
    (0, $a943d52f2f5b9487$export$8d64f55d8bab80d4)(parentInstance);
}
function $fd02eb36c87a22cc$export$7ec3655259385e44(parentInstance, child, beforeChild) {
    $fd02eb36c87a22cc$export$86b68c7dbeb53c22(parentInstance, child, beforeChild);
}
function $fd02eb36c87a22cc$export$7ae609f7af59e4f7(parentInstance, child) {
    child.destroy();
    child.off((0, $a943d52f2f5b9487$export$3a20cc353cdae1b2));
    (0, $a943d52f2f5b9487$export$8d64f55d8bab80d4)(parentInstance);
}
function $fd02eb36c87a22cc$export$2e4ef5d75a473f1a(parentInstance, child) {
    child.destroy();
    child.off((0, $a943d52f2f5b9487$export$3a20cc353cdae1b2));
    (0, $a943d52f2f5b9487$export$8d64f55d8bab80d4)(parentInstance);
}
function $fd02eb36c87a22cc$export$50a92d0155bee474(textInstance, oldText, newText) {
    console.error('Text components are not yet supported in ReactKonva. You text is: "' + newText + '"');
}
function $fd02eb36c87a22cc$export$fe90794743fbfeb0(instance, type, newProps) {
// Noop
}
function $fd02eb36c87a22cc$export$fd8222818e57ec6(instance, updatePayload, type, oldProps, newProps) {
    (0, $a943d52f2f5b9487$export$25d4dd8d7c7a61f6)(instance, newProps, oldProps);
}
function $fd02eb36c87a22cc$export$6db9fd2b8188b8b7(instance) {
    instance.hide();
    (0, $a943d52f2f5b9487$export$8d64f55d8bab80d4)(instance);
}
function $fd02eb36c87a22cc$export$17ed9cbd9cb3aad2(textInstance) {
// Noop
}
function $fd02eb36c87a22cc$export$933e25c2090d1941(instance, props) {
    if (props.visible == null || props.visible) instance.show();
}
function $fd02eb36c87a22cc$export$8ff685cdcb7326ff(textInstance, text) {
// Noop
}
function $fd02eb36c87a22cc$export$28e08eff11ac64f6(container) {
// Noop
}



'use strict';
var $79afca973e18ecdf$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $79afca973e18ecdf$var$usePrevious(value) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($9Cg25))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($9Cg25))).useLayoutEffect(function() {
        ref.current = value;
    });
    return ref.current;
}
var $79afca973e18ecdf$var$StageWrap = function StageWrap(props) {
    var container = (0, (/*@__PURE__*/$parcel$interopDefault($9Cg25))).useRef();
    var stage = (0, (/*@__PURE__*/$parcel$interopDefault($9Cg25))).useRef();
    var fiberRef = (0, (/*@__PURE__*/$parcel$interopDefault($9Cg25))).useRef();
    var oldProps = $79afca973e18ecdf$var$usePrevious(props);
    var _setRef = function _setRef(stage) {
        var forwardedRef = props.forwardedRef;
        if (!forwardedRef) return;
        if (typeof forwardedRef === 'function') forwardedRef(stage);
        else forwardedRef.current = stage;
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($9Cg25))).useLayoutEffect(function() {
        stage.current = new (0, $77f2f7b750eb6707$export$2e2bcd8739ae039).Stage({
            width: props.width,
            height: props.height,
            container: container.current
        });
        _setRef(stage.current);
        fiberRef.current = $79afca973e18ecdf$export$1998d71d1bc35390.createContainer(stage.current);
        $79afca973e18ecdf$export$1998d71d1bc35390.updateContainer(props.children, fiberRef.current);
        return function() {
            if (!(0, $77f2f7b750eb6707$export$2e2bcd8739ae039).isBrowser) return;
            _setRef(null);
            $79afca973e18ecdf$export$1998d71d1bc35390.updateContainer(null, fiberRef.current, null);
            stage.current.destroy();
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($9Cg25))).useLayoutEffect(function() {
        _setRef(stage.current);
        (0, $a943d52f2f5b9487$export$25d4dd8d7c7a61f6)(stage.current, props, oldProps);
        $79afca973e18ecdf$export$1998d71d1bc35390.updateContainer(props.children, fiberRef.current, null);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($9Cg25))).createElement('div', {
        ref: container,
        accessKey: props.accessKey,
        className: props.className,
        role: props.role,
        style: props.style,
        tabIndex: props.tabIndex,
        title: props.title
    });
};
var $79afca973e18ecdf$export$936d0764594b6eb3 = 'Layer';
var $79afca973e18ecdf$export$92d64f29192d1118 = 'FastLayer';
var $79afca973e18ecdf$export$eb2fcfdbd7ba97d4 = 'Group';
var $79afca973e18ecdf$export$b04be29aa201d4f5 = 'Label';
var $79afca973e18ecdf$export$c79fc6492f3af13d = 'Rect';
var $79afca973e18ecdf$export$c89a927ffc67e6fa = 'Circle';
var $79afca973e18ecdf$export$80b0269ab108fa11 = 'Ellipse';
var $79afca973e18ecdf$export$28718c7785907330 = 'Wedge';
var $79afca973e18ecdf$export$17d680238e50603e = 'Line';
var $79afca973e18ecdf$export$3075603db8e6204c = 'Sprite';
var $79afca973e18ecdf$export$3e431a229df88919 = 'Image';
var $79afca973e18ecdf$export$5f1af8db9871e1d6 = 'Text';
var $79afca973e18ecdf$export$f7e34a95cc06fac7 = 'TextPath';
var $79afca973e18ecdf$export$1644ba17714857f1 = 'Star';
var $79afca973e18ecdf$export$a6e3577650b6d6d7 = 'Ring';
var $79afca973e18ecdf$export$6ef80ffb606dd232 = 'Arc';
var $79afca973e18ecdf$export$3288d34c523a1192 = 'Tag';
var $79afca973e18ecdf$export$4b2950bdac9b6ee9 = 'Path';
var $79afca973e18ecdf$export$e2ee866164812ecd = 'RegularPolygon';
var $79afca973e18ecdf$export$21b07c8f274aebd5 = 'Arrow';
var $79afca973e18ecdf$export$6428a7f2611ef1fa = 'Shape';
var $79afca973e18ecdf$export$f993aef960936087 = 'Transformer';
var $79afca973e18ecdf$export$1998d71d1bc35390 = (0, (/*@__PURE__*/$parcel$interopDefault($19bb1665b295b08c$exports)))($fd02eb36c87a22cc$exports);
$79afca973e18ecdf$export$1998d71d1bc35390.injectIntoDevTools({
    findHostInstanceByFiber: function findHostInstanceByFiber() {
        return null;
    },
    bundleType: 0,
    version: (0, (/*@__PURE__*/$parcel$interopDefault($9Cg25))).version,
    rendererPackageName: 'react-konva'
});
var $79afca973e18ecdf$export$208cd1682bd0e4b6 = (0, (/*@__PURE__*/$parcel$interopDefault($9Cg25))).forwardRef(function(props, ref) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9Cg25))).createElement($79afca973e18ecdf$var$StageWrap, $79afca973e18ecdf$var$_extends({}, props, {
        forwardedRef: ref
    }));
});
var $79afca973e18ecdf$export$2e548393fba9b338 = (0, $a943d52f2f5b9487$export$5a38dcef855281ce);


'use strict';


const $01b00e73e7338f4f$var$dark = {
    fgColor: "white",
    bgColor: "#231F20"
};
const $01b00e73e7338f4f$var$light = {
    fgColor: "black",
    bgColor: "white"
};
const $01b00e73e7338f4f$export$1d8e462b9ec86de2 = {
    Dark: $01b00e73e7338f4f$var$dark,
    Light: $01b00e73e7338f4f$var$light
};


var $2854fa7f51e6b2e6$exports = {};
'use strict';
Object.defineProperty($2854fa7f51e6b2e6$exports, "__esModule", {
    value: true
});
$2854fa7f51e6b2e6$exports.changeDpiBlob = $2854fa7f51e6b2e6$var$changeDpiBlob;
$2854fa7f51e6b2e6$exports.changeDpiDataUrl = $2854fa7f51e6b2e6$var$changeDpiDataUrl;
function $2854fa7f51e6b2e6$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function $2854fa7f51e6b2e6$var$createPngDataTable() {
    /* Table of CRCs of all 8-bit messages. */ var crcTable = new Int32Array(256);
    for(var n = 0; n < 256; n++){
        var c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xedb88320 ^ c >>> 1 : c >>> 1;
        crcTable[n] = c;
    }
    return crcTable;
}
function $2854fa7f51e6b2e6$var$calcCrc(buf) {
    var c = -1;
    if (!$2854fa7f51e6b2e6$var$pngDataTable) $2854fa7f51e6b2e6$var$pngDataTable = $2854fa7f51e6b2e6$var$createPngDataTable();
    for(var n = 0; n < buf.length; n++)c = $2854fa7f51e6b2e6$var$pngDataTable[(c ^ buf[n]) & 0xFF] ^ c >>> 8;
    return c ^ -1;
}
var $2854fa7f51e6b2e6$var$pngDataTable = void 0;
var $2854fa7f51e6b2e6$var$PNG = 'image/png';
var $2854fa7f51e6b2e6$var$JPEG = 'image/jpeg';
// those are 3 possible signature of the physBlock in base64.
// the pHYs signature block is preceed by the 4 bytes of lenght. The length of
// the block is always 9 bytes. So a phys block has always this signature:
// 0 0 0 9 p H Y s.
// However the data64 encoding aligns we will always find one of those 3 strings.
// this allow us to find this particular occurence of the pHYs block without
// converting from b64 back to string
var $2854fa7f51e6b2e6$var$b64PhysSignature1 = 'AAlwSFlz';
var $2854fa7f51e6b2e6$var$b64PhysSignature2 = 'AAAJcEhZ';
var $2854fa7f51e6b2e6$var$b64PhysSignature3 = 'AAAACXBI';
var $2854fa7f51e6b2e6$var$_P = 'p'.charCodeAt(0);
var $2854fa7f51e6b2e6$var$_H = 'H'.charCodeAt(0);
var $2854fa7f51e6b2e6$var$_Y = 'Y'.charCodeAt(0);
var $2854fa7f51e6b2e6$var$_S = 's'.charCodeAt(0);
function $2854fa7f51e6b2e6$var$changeDpiBlob(blob, dpi) {
    // 33 bytes are ok for pngs and jpegs
    // to contain the information.
    var headerChunk = blob.slice(0, 33);
    return new Promise(function(resolve, reject) {
        var fileReader = new FileReader();
        fileReader.onload = function() {
            var dataArray = new Uint8Array(fileReader.result);
            var tail = blob.slice(33);
            var changedArray = $2854fa7f51e6b2e6$var$changeDpiOnArray(dataArray, dpi, blob.type);
            resolve(new Blob([
                changedArray,
                tail
            ], {
                type: blob.type
            }));
        };
        fileReader.readAsArrayBuffer(headerChunk);
    });
}
function $2854fa7f51e6b2e6$var$changeDpiDataUrl(base64Image, dpi) {
    var dataSplitted = base64Image.split(',');
    var format = dataSplitted[0];
    var body = dataSplitted[1];
    var type = void 0;
    var headerLength = void 0;
    var overwritepHYs = false;
    if (format.indexOf($2854fa7f51e6b2e6$var$PNG) !== -1) {
        type = $2854fa7f51e6b2e6$var$PNG;
        var b64Index = $2854fa7f51e6b2e6$var$detectPhysChunkFromDataUrl(body);
        // 28 bytes in dataUrl are 21bytes, length of phys chunk with everything inside.
        if (b64Index >= 0) {
            headerLength = Math.ceil((b64Index + 28) / 3) * 4;
            overwritepHYs = true;
        } else headerLength = 44;
    }
    if (format.indexOf($2854fa7f51e6b2e6$var$JPEG) !== -1) {
        type = $2854fa7f51e6b2e6$var$JPEG;
        headerLength = 24;
    }
    // 33 bytes are ok for pngs and jpegs
    // to contain the information.
    var stringHeader = body.substring(0, headerLength);
    var restOfData = body.substring(headerLength);
    var headerBytes = atob(stringHeader);
    var dataArray = new Uint8Array(headerBytes.length);
    for(var i = 0; i < dataArray.length; i++)dataArray[i] = headerBytes.charCodeAt(i);
    var finalArray = $2854fa7f51e6b2e6$var$changeDpiOnArray(dataArray, dpi, type, overwritepHYs);
    var base64Header = btoa(String.fromCharCode.apply(String, $2854fa7f51e6b2e6$var$_toConsumableArray(finalArray)));
    return [
        format,
        ',',
        base64Header,
        restOfData
    ].join('');
}
function $2854fa7f51e6b2e6$var$detectPhysChunkFromDataUrl(data) {
    var b64index = data.indexOf($2854fa7f51e6b2e6$var$b64PhysSignature1);
    if (b64index === -1) b64index = data.indexOf($2854fa7f51e6b2e6$var$b64PhysSignature2);
    if (b64index === -1) b64index = data.indexOf($2854fa7f51e6b2e6$var$b64PhysSignature3);
    // if b64index === -1 chunk is not found
    return b64index;
}
function $2854fa7f51e6b2e6$var$searchStartOfPhys(data) {
    var length = data.length - 1;
    // we check from the end since we cut the string in proximity of the header
    // the header is within 21 bytes from the end.
    for(var i = length; i >= 4; i--){
        if (data[i - 4] === 9 && data[i - 3] === $2854fa7f51e6b2e6$var$_P && data[i - 2] === $2854fa7f51e6b2e6$var$_H && data[i - 1] === $2854fa7f51e6b2e6$var$_Y && data[i] === $2854fa7f51e6b2e6$var$_S) return i - 3;
    }
}
function $2854fa7f51e6b2e6$var$changeDpiOnArray(dataArray, dpi, format, overwritepHYs) {
    if (format === $2854fa7f51e6b2e6$var$JPEG) {
        dataArray[13] = 1; // 1 pixel per inch or 2 pixel per cm
        dataArray[14] = dpi >> 8; // dpiX high byte
        dataArray[15] = dpi & 0xff; // dpiX low byte
        dataArray[16] = dpi >> 8; // dpiY high byte
        dataArray[17] = dpi & 0xff; // dpiY low byte
        return dataArray;
    }
    if (format === $2854fa7f51e6b2e6$var$PNG) {
        var physChunk = new Uint8Array(13);
        // chunk header pHYs
        // 9 bytes of data
        // 4 bytes of crc
        // this multiplication is because the standard is dpi per meter.
        dpi *= 39.3701;
        physChunk[0] = $2854fa7f51e6b2e6$var$_P;
        physChunk[1] = $2854fa7f51e6b2e6$var$_H;
        physChunk[2] = $2854fa7f51e6b2e6$var$_Y;
        physChunk[3] = $2854fa7f51e6b2e6$var$_S;
        physChunk[4] = dpi >>> 24; // dpiX highest byte
        physChunk[5] = dpi >>> 16; // dpiX veryhigh byte
        physChunk[6] = dpi >>> 8; // dpiX high byte
        physChunk[7] = dpi & 0xff; // dpiX low byte
        physChunk[8] = physChunk[4]; // dpiY highest byte
        physChunk[9] = physChunk[5]; // dpiY veryhigh byte
        physChunk[10] = physChunk[6]; // dpiY high byte
        physChunk[11] = physChunk[7]; // dpiY low byte
        physChunk[12] = 1; // dot per meter....
        var crc = $2854fa7f51e6b2e6$var$calcCrc(physChunk);
        var crcChunk = new Uint8Array(4);
        crcChunk[0] = crc >>> 24;
        crcChunk[1] = crc >>> 16;
        crcChunk[2] = crc >>> 8;
        crcChunk[3] = crc & 0xff;
        if (overwritepHYs) {
            var startingIndex = $2854fa7f51e6b2e6$var$searchStartOfPhys(dataArray);
            dataArray.set(physChunk, startingIndex);
            dataArray.set(crcChunk, startingIndex + 13);
            return dataArray;
        } else {
            // i need to give back an array of data that is divisible by 3 so that
            // dataurl encoding gives me integers, for luck this chunk is 17 + 4 = 21
            // if it was we could add a text chunk contaning some info, untill desired
            // length is met.
            // chunk structur 4 bytes for length is 9
            var chunkLength = new Uint8Array(4);
            chunkLength[0] = 0;
            chunkLength[1] = 0;
            chunkLength[2] = 0;
            chunkLength[3] = 9;
            var finalHeader = new Uint8Array(54);
            finalHeader.set(dataArray, 0);
            finalHeader.set(chunkLength, 33);
            finalHeader.set(physChunk, 37);
            finalHeader.set(crcChunk, 50);
            return finalHeader;
        }
    }
}


var $091b66e1681d4688$exports = {};
/* Web Font Loader v1.6.28 - (c) Adobe Systems, Google. License: Apache 2.0 */ (function() {
    function aa(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function ba(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var c = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(c, d);
                return a.apply(b, c);
            };
        }
        return function() {
            return a.apply(b, arguments);
        };
    }
    function p(a, b, c) {
        p = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? aa : ba;
        return p.apply(null, arguments);
    }
    var q = Date.now || function() {
        return +new Date;
    };
    function ca(a, b) {
        this.a = a;
        this.o = b || a;
        this.c = this.o.document;
    }
    var da = !!window.FontFace;
    function t(a, b, c, d) {
        b = a.c.createElement(b);
        if (c) for(var e in c)c.hasOwnProperty(e) && ("style" == e ? b.style.cssText = c[e] : b.setAttribute(e, c[e]));
        d && b.appendChild(a.c.createTextNode(d));
        return b;
    }
    function u(a, b, c) {
        a = a.c.getElementsByTagName(b)[0];
        a || (a = document.documentElement);
        a.insertBefore(c, a.lastChild);
    }
    function v(a) {
        a.parentNode && a.parentNode.removeChild(a);
    }
    function w(a, b, c) {
        b = b || [];
        c = c || [];
        for(var d = a.className.split(/\s+/), e = 0; e < b.length; e += 1){
            for(var f = !1, g = 0; g < d.length; g += 1)if (b[e] === d[g]) {
                f = !0;
                break;
            }
            f || d.push(b[e]);
        }
        b = [];
        for(e = 0; e < d.length; e += 1){
            f = !1;
            for(g = 0; g < c.length; g += 1)if (d[e] === c[g]) {
                f = !0;
                break;
            }
            f || b.push(d[e]);
        }
        a.className = b.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
    }
    function y(a, b) {
        for(var c = a.className.split(/\s+/), d = 0, e = c.length; d < e; d++)if (c[d] == b) return !0;
        return !1;
    }
    function ea(a) {
        return a.o.location.hostname || a.a.location.hostname;
    }
    function z(a, b, c) {
        function d() {
            m && e && f && (m(g), m = null);
        }
        b = t(a, "link", {
            rel: "stylesheet",
            href: b,
            media: "all"
        });
        var e = !1, f = !0, g = null, m = c || null;
        da ? (b.onload = function() {
            e = !0;
            d();
        }, b.onerror = function() {
            e = !0;
            g = Error("Stylesheet failed to load");
            d();
        }) : setTimeout(function() {
            e = !0;
            d();
        }, 0);
        u(a, "head", b);
    }
    function A(a, b, c, d) {
        var e = a.c.getElementsByTagName("head")[0];
        if (e) {
            var f = t(a, "script", {
                src: b
            }), g = !1;
            f.onload = f.onreadystatechange = function() {
                g || this.readyState && "loaded" != this.readyState && "complete" != this.readyState || (g = !0, c && c(null), f.onload = f.onreadystatechange = null, "HEAD" == f.parentNode.tagName && e.removeChild(f));
            };
            e.appendChild(f);
            setTimeout(function() {
                g || (g = !0, c && c(Error("Script load timeout")));
            }, d || 5E3);
            return f;
        }
        return null;
    }
    function B() {
        this.a = 0;
        this.c = null;
    }
    function C(a) {
        a.a++;
        return function() {
            a.a--;
            D(a);
        };
    }
    function E(a, b) {
        a.c = b;
        D(a);
    }
    function D(a) {
        0 == a.a && a.c && (a.c(), a.c = null);
    }
    function F(a) {
        this.a = a || "-";
    }
    F.prototype.c = function(a) {
        for(var b = [], c = 0; c < arguments.length; c++)b.push(arguments[c].replace(/[\W_]+/g, "").toLowerCase());
        return b.join(this.a);
    };
    function G(a, b) {
        this.c = a;
        this.f = 4;
        this.a = "n";
        var c = (b || "n4").match(/^([nio])([1-9])$/i);
        c && (this.a = c[1], this.f = parseInt(c[2], 10));
    }
    function fa(a) {
        return H(a) + " " + (a.f + "00") + " 300px " + I(a.c);
    }
    function I(a) {
        var b = [];
        a = a.split(/,\s*/);
        for(var c = 0; c < a.length; c++){
            var d = a[c].replace(/['"]/g, "");
            -1 != d.indexOf(" ") || /^\d/.test(d) ? b.push("'" + d + "'") : b.push(d);
        }
        return b.join(",");
    }
    function J(a) {
        return a.a + a.f;
    }
    function H(a) {
        var b = "normal";
        "o" === a.a ? b = "oblique" : "i" === a.a && (b = "italic");
        return b;
    }
    function ga(a) {
        var b = 4, c = "n", d = null;
        a && ((d = a.match(/(normal|oblique|italic)/i)) && d[1] && (c = d[1].substr(0, 1).toLowerCase()), (d = a.match(/([1-9]00|normal|bold)/i)) && d[1] && (/bold/i.test(d[1]) ? b = 7 : /[1-9]00/.test(d[1]) && (b = parseInt(d[1].substr(0, 1), 10))));
        return c + b;
    }
    function ha(a, b) {
        this.c = a;
        this.f = a.o.document.documentElement;
        this.h = b;
        this.a = new F("-");
        this.j = !1 !== b.events;
        this.g = !1 !== b.classes;
    }
    function ia(a) {
        a.g && w(a.f, [
            a.a.c("wf", "loading")
        ]);
        K(a, "loading");
    }
    function L(a) {
        if (a.g) {
            var b = y(a.f, a.a.c("wf", "active")), c = [], d = [
                a.a.c("wf", "loading")
            ];
            b || c.push(a.a.c("wf", "inactive"));
            w(a.f, c, d);
        }
        K(a, "inactive");
    }
    function K(a, b, c) {
        if (a.j && a.h[b]) {
            if (c) a.h[b](c.c, J(c));
            else a.h[b]();
        }
    }
    function ja() {
        this.c = {};
    }
    function ka(a, b, c) {
        var d = [], e;
        for(e in b)if (b.hasOwnProperty(e)) {
            var f = a.c[e];
            f && d.push(f(b[e], c));
        }
        return d;
    }
    function M(a, b) {
        this.c = a;
        this.f = b;
        this.a = t(this.c, "span", {
            "aria-hidden": "true"
        }, this.f);
    }
    function N(a) {
        u(a.c, "body", a.a);
    }
    function O(a) {
        return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + I(a.c) + ";" + ("font-style:" + H(a) + ";font-weight:" + (a.f + "00") + ";");
    }
    function P(a, b, c, d, e, f) {
        this.g = a;
        this.j = b;
        this.a = d;
        this.c = c;
        this.f = e || 3E3;
        this.h = f || void 0;
    }
    P.prototype.start = function() {
        var a = this.c.o.document, b = this, c = q(), d = new Promise(function(d, e) {
            function f() {
                q() - c >= b.f ? e() : a.fonts.load(fa(b.a), b.h).then(function(a) {
                    1 <= a.length ? d() : setTimeout(f, 25);
                }, function() {
                    e();
                });
            }
            f();
        }), e = null, f = new Promise(function(a, d) {
            e = setTimeout(d, b.f);
        });
        Promise.race([
            f,
            d
        ]).then(function() {
            e && (clearTimeout(e), e = null);
            b.g(b.a);
        }, function() {
            b.j(b.a);
        });
    };
    function Q(a, b, c, d, e, f, g) {
        this.v = a;
        this.B = b;
        this.c = c;
        this.a = d;
        this.s = g || "BESbswy";
        this.f = {};
        this.w = e || 3E3;
        this.u = f || null;
        this.m = this.j = this.h = this.g = null;
        this.g = new M(this.c, this.s);
        this.h = new M(this.c, this.s);
        this.j = new M(this.c, this.s);
        this.m = new M(this.c, this.s);
        a = new G(this.a.c + ",serif", J(this.a));
        a = O(a);
        this.g.a.style.cssText = a;
        a = new G(this.a.c + ",sans-serif", J(this.a));
        a = O(a);
        this.h.a.style.cssText = a;
        a = new G("serif", J(this.a));
        a = O(a);
        this.j.a.style.cssText = a;
        a = new G("sans-serif", J(this.a));
        a = O(a);
        this.m.a.style.cssText = a;
        N(this.g);
        N(this.h);
        N(this.j);
        N(this.m);
    }
    var R = {
        D: "serif",
        C: "sans-serif"
    }, S = null;
    function T() {
        if (null === S) {
            var a = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
            S = !!a && (536 > parseInt(a[1], 10) || 536 === parseInt(a[1], 10) && 11 >= parseInt(a[2], 10));
        }
        return S;
    }
    Q.prototype.start = function() {
        this.f.serif = this.j.a.offsetWidth;
        this.f["sans-serif"] = this.m.a.offsetWidth;
        this.A = q();
        U(this);
    };
    function la(a, b, c) {
        for(var d in R)if (R.hasOwnProperty(d) && b === a.f[R[d]] && c === a.f[R[d]]) return !0;
        return !1;
    }
    function U(a) {
        var b = a.g.a.offsetWidth, c = a.h.a.offsetWidth, d;
        (d = b === a.f.serif && c === a.f["sans-serif"]) || (d = T() && la(a, b, c));
        d ? q() - a.A >= a.w ? T() && la(a, b, c) && (null === a.u || a.u.hasOwnProperty(a.a.c)) ? V(a, a.v) : V(a, a.B) : ma(a) : V(a, a.v);
    }
    function ma(a) {
        setTimeout(p(function() {
            U(this);
        }, a), 50);
    }
    function V(a, b) {
        setTimeout(p(function() {
            v(this.g.a);
            v(this.h.a);
            v(this.j.a);
            v(this.m.a);
            b(this.a);
        }, a), 0);
    }
    function W(a, b, c) {
        this.c = a;
        this.a = b;
        this.f = 0;
        this.m = this.j = !1;
        this.s = c;
    }
    var X = null;
    W.prototype.g = function(a) {
        var b = this.a;
        b.g && w(b.f, [
            b.a.c("wf", a.c, J(a).toString(), "active")
        ], [
            b.a.c("wf", a.c, J(a).toString(), "loading"),
            b.a.c("wf", a.c, J(a).toString(), "inactive")
        ]);
        K(b, "fontactive", a);
        this.m = !0;
        na(this);
    };
    W.prototype.h = function(a) {
        var b = this.a;
        if (b.g) {
            var c = y(b.f, b.a.c("wf", a.c, J(a).toString(), "active")), d = [], e = [
                b.a.c("wf", a.c, J(a).toString(), "loading")
            ];
            c || d.push(b.a.c("wf", a.c, J(a).toString(), "inactive"));
            w(b.f, d, e);
        }
        K(b, "fontinactive", a);
        na(this);
    };
    function na(a) {
        0 == --a.f && a.j && (a.m ? (a = a.a, a.g && w(a.f, [
            a.a.c("wf", "active")
        ], [
            a.a.c("wf", "loading"),
            a.a.c("wf", "inactive")
        ]), K(a, "active")) : L(a.a));
    }
    function oa(a) {
        this.j = a;
        this.a = new ja;
        this.h = 0;
        this.f = this.g = !0;
    }
    oa.prototype.load = function(a) {
        this.c = new ca(this.j, a.context || this.j);
        this.g = !1 !== a.events;
        this.f = !1 !== a.classes;
        pa(this, new ha(this.c, a), a);
    };
    function qa(a, b, c, d, e) {
        var f = 0 == --a.h;
        (a.f || a.g) && setTimeout(function() {
            var a = e || null, m = d || null || {};
            if (0 === c.length && f) L(b.a);
            else {
                b.f += c.length;
                f && (b.j = f);
                var h, l = [];
                for(h = 0; h < c.length; h++){
                    var k = c[h], n = m[k.c], r = b.a, x = k;
                    r.g && w(r.f, [
                        r.a.c("wf", x.c, J(x).toString(), "loading")
                    ]);
                    K(r, "fontloading", x);
                    r = null;
                    if (null === X) {
                        if (window.FontFace) {
                            var x = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent), xa = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
                            X = x ? 42 < parseInt(x[1], 10) : xa ? !1 : !0;
                        } else X = !1;
                    }
                    X ? r = new P(p(b.g, b), p(b.h, b), b.c, k, b.s, n) : r = new Q(p(b.g, b), p(b.h, b), b.c, k, b.s, a, n);
                    l.push(r);
                }
                for(h = 0; h < l.length; h++)l[h].start();
            }
        }, 0);
    }
    function pa(a, b, c) {
        var d = [], e = c.timeout;
        ia(b);
        var d = ka(a.a, c, a.c), f = new W(a.c, b, e);
        a.h = d.length;
        b = 0;
        for(c = d.length; b < c; b++)d[b].load(function(b, d, c) {
            qa(a, f, b, d, c);
        });
    }
    function ra(a, b) {
        this.c = a;
        this.a = b;
    }
    ra.prototype.load = function(a) {
        function b() {
            if (f["__mti_fntLst" + d]) {
                var c = f["__mti_fntLst" + d](), e = [], h;
                if (c) for(var l = 0; l < c.length; l++){
                    var k = c[l].fontfamily;
                    void 0 != c[l].fontStyle && void 0 != c[l].fontWeight ? (h = c[l].fontStyle + c[l].fontWeight, e.push(new G(k, h))) : e.push(new G(k));
                }
                a(e);
            } else setTimeout(function() {
                b();
            }, 50);
        }
        var c = this, d = c.a.projectId, e = c.a.version;
        if (d) {
            var f = c.c.o;
            A(this.c, (c.a.api || "https://fast.fonts.net/jsapi") + "/" + d + ".js" + (e ? "?v=" + e : ""), function(e) {
                e ? a([]) : (f["__MonotypeConfiguration__" + d] = function() {
                    return c.a;
                }, b());
            }).id = "__MonotypeAPIScript__" + d;
        } else a([]);
    };
    function sa(a, b) {
        this.c = a;
        this.a = b;
    }
    sa.prototype.load = function(a) {
        var b, c, d = this.a.urls || [], e = this.a.families || [], f = this.a.testStrings || {}, g = new B;
        b = 0;
        for(c = d.length; b < c; b++)z(this.c, d[b], C(g));
        var m = [];
        b = 0;
        for(c = e.length; b < c; b++)if (d = e[b].split(":"), d[1]) for(var h = d[1].split(","), l = 0; l < h.length; l += 1)m.push(new G(d[0], h[l]));
        else m.push(new G(d[0]));
        E(g, function() {
            a(m, f);
        });
    };
    function ta(a, b) {
        a ? this.c = a : this.c = ua;
        this.a = [];
        this.f = [];
        this.g = b || "";
    }
    var ua = "https://fonts.googleapis.com/css";
    function va(a, b) {
        for(var c = b.length, d = 0; d < c; d++){
            var e = b[d].split(":");
            3 == e.length && a.f.push(e.pop());
            var f = "";
            2 == e.length && "" != e[1] && (f = ":");
            a.a.push(e.join(f));
        }
    }
    function wa(a) {
        if (0 == a.a.length) throw Error("No fonts to load!");
        if (-1 != a.c.indexOf("kit=")) return a.c;
        for(var b = a.a.length, c = [], d = 0; d < b; d++)c.push(a.a[d].replace(/ /g, "+"));
        b = a.c + "?family=" + c.join("%7C");
        0 < a.f.length && (b += "&subset=" + a.f.join(","));
        0 < a.g.length && (b += "&text=" + encodeURIComponent(a.g));
        return b;
    }
    function ya(a) {
        this.f = a;
        this.a = [];
        this.c = {};
    }
    var za = {
        latin: "BESbswy",
        "latin-ext": "\u00e7\u00f6\u00fc\u011f\u015f",
        cyrillic: "\u0439\u044f\u0416",
        greek: "\u03b1\u03b2\u03a3",
        khmer: "\u1780\u1781\u1782",
        Hanuman: "\u1780\u1781\u1782"
    }, Aa = {
        thin: "1",
        extralight: "2",
        "extra-light": "2",
        ultralight: "2",
        "ultra-light": "2",
        light: "3",
        regular: "4",
        book: "4",
        medium: "5",
        "semi-bold": "6",
        semibold: "6",
        "demi-bold": "6",
        demibold: "6",
        bold: "7",
        "extra-bold": "8",
        extrabold: "8",
        "ultra-bold": "8",
        ultrabold: "8",
        black: "9",
        heavy: "9",
        l: "3",
        r: "4",
        b: "7"
    }, Ba = {
        i: "i",
        italic: "i",
        n: "n",
        normal: "n"
    }, Ca = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
    function Da(a) {
        for(var b = a.f.length, c = 0; c < b; c++){
            var d = a.f[c].split(":"), e = d[0].replace(/\+/g, " "), f = [
                "n4"
            ];
            if (2 <= d.length) {
                var g;
                var m = d[1];
                g = [];
                if (m) for(var m = m.split(","), h = m.length, l = 0; l < h; l++){
                    var k;
                    k = m[l];
                    if (k.match(/^[\w-]+$/)) {
                        var n = Ca.exec(k.toLowerCase());
                        if (null == n) k = "";
                        else {
                            k = n[2];
                            k = null == k || "" == k ? "n" : Ba[k];
                            n = n[1];
                            if (null == n || "" == n) n = "4";
                            else var r = Aa[n], n = r ? r : isNaN(n) ? "4" : n.substr(0, 1);
                            k = [
                                k,
                                n
                            ].join("");
                        }
                    } else k = "";
                    k && g.push(k);
                }
                0 < g.length && (f = g);
                3 == d.length && (d = d[2], g = [], d = d ? d.split(",") : g, 0 < d.length && (d = za[d[0]]) && (a.c[e] = d));
            }
            a.c[e] || (d = za[e]) && (a.c[e] = d);
            for(d = 0; d < f.length; d += 1)a.a.push(new G(e, f[d]));
        }
    }
    function Ea(a, b) {
        this.c = a;
        this.a = b;
    }
    var Fa = {
        Arimo: !0,
        Cousine: !0,
        Tinos: !0
    };
    Ea.prototype.load = function(a) {
        var b = new B, c = this.c, d = new ta(this.a.api, this.a.text), e = this.a.families;
        va(d, e);
        var f = new ya(e);
        Da(f);
        z(c, wa(d), C(b));
        E(b, function() {
            a(f.a, f.c, Fa);
        });
    };
    function Ga(a, b) {
        this.c = a;
        this.a = b;
    }
    Ga.prototype.load = function(a) {
        var b = this.a.id, c = this.c.o;
        b ? A(this.c, (this.a.api || "https://use.typekit.net") + "/" + b + ".js", function(b) {
            if (b) a([]);
            else if (c.Typekit && c.Typekit.config && c.Typekit.config.fn) {
                b = c.Typekit.config.fn;
                for(var e = [], f = 0; f < b.length; f += 2)for(var g = b[f], m = b[f + 1], h = 0; h < m.length; h++)e.push(new G(g, m[h]));
                try {
                    c.Typekit.load({
                        events: !1,
                        classes: !1,
                        async: !0
                    });
                } catch (l) {}
                a(e);
            }
        }, 2E3) : a([]);
    };
    function Ha(a, b) {
        this.c = a;
        this.f = b;
        this.a = [];
    }
    Ha.prototype.load = function(a) {
        var b = this.f.id, c = this.c.o, d = this;
        b ? (c.__webfontfontdeckmodule__ || (c.__webfontfontdeckmodule__ = {}), c.__webfontfontdeckmodule__[b] = function(b, c) {
            for(var g = 0, m = c.fonts.length; g < m; ++g){
                var h = c.fonts[g];
                d.a.push(new G(h.name, ga("font-weight:" + h.weight + ";font-style:" + h.style)));
            }
            a(d.a);
        }, A(this.c, (this.f.api || "https://f.fontdeck.com/s/css/js/") + ea(this.c) + "/" + b + ".js", function(b) {
            b && a([]);
        })) : a([]);
    };
    var Y = new oa(window);
    Y.a.c.custom = function(a, b) {
        return new sa(b, a);
    };
    Y.a.c.fontdeck = function(a, b) {
        return new Ha(b, a);
    };
    Y.a.c.monotype = function(a, b) {
        return new ra(b, a);
    };
    Y.a.c.typekit = function(a, b) {
        return new Ga(b, a);
    };
    Y.a.c.google = function(a, b) {
        return new Ea(b, a);
    };
    var Z = {
        load: p(Y.load, Y)
    };
    "function" === typeof define && define.amd ? define(function() {
        return Z;
    }) : $091b66e1681d4688$exports ? $091b66e1681d4688$exports = Z : (window.WebFont = Z, window.WebFontConfig && Y.load(window.WebFontConfig));
})();


const $302b7e720a7a0200$var$PPM_FACTOR = 300 / 25.4;
var $170cd868c66a8850$exports = {};
$170cd868c66a8850$exports = $parcel$resolve("6vguH");


const $302b7e720a7a0200$var$MDLogoImage = new URL($170cd868c66a8850$exports).href;
function $302b7e720a7a0200$var$useLoadedImage(src) {
    const [loaded, setLoaded] = (0, $9Cg25.useState)(null);
    const [failed, setFailed] = (0, $9Cg25.useState)("");
    (0, $9Cg25.useEffect)(()=>{
        let cancelled = false;
        const image = new Image();
        image.crossOrigin = "anonymous";
        image.onload = ()=>{
            if (!cancelled) setLoaded({
                src: src,
                image: image
            });
        };
        image.onerror = ()=>{
            if (!cancelled) setFailed(src);
        };
        image.src = src;
        return ()=>{
            cancelled = true;
        };
    }, [
        src
    ]);
    return {
        image: loaded && loaded.src === src ? loaded.image : undefined,
        failed: failed === src
    };
}
function $302b7e720a7a0200$var$calculateCentering(containerHeight, elementHeight, yOffset = 0) {
    return (containerHeight - elementHeight) / 2 + yOffset;
}
const $302b7e720a7a0200$var$Meta = ({ artist: artist, album: album, year: year, color: color, fontSize: fontSize, lineHeight: lineHeight, containerHeight: containerHeight, yOffset: yOffset, margin: margin })=>{
    const metaContentHeight = lineHeight + lineHeight + fontSize;
    const y = $302b7e720a7a0200$var$calculateCentering(containerHeight, metaContentHeight, yOffset);
    return /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)((0, $79afca973e18ecdf$export$eb2fcfdbd7ba97d4), {
        y: y,
        children: [
            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)((0, $79afca973e18ecdf$export$5f1af8db9871e1d6), {
                fontSize: fontSize,
                text: album,
                fontFamily: "futura-pt-bold, Arial, sans-serif",
                fontVariant: "bold",
                fill: color,
                x: margin,
                y: 0,
                lineHeight: fontSize
            }),
            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)((0, $79afca973e18ecdf$export$5f1af8db9871e1d6), {
                fontSize: fontSize,
                text: artist,
                fontFamily: "futura-pt-bold, Arial, sans-serif",
                fontVariant: "bold",
                fill: color,
                x: margin,
                y: lineHeight,
                lineHeight: fontSize
            }),
            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)((0, $79afca973e18ecdf$export$5f1af8db9871e1d6), {
                fontSize: fontSize,
                text: year,
                fontFamily: "futura-pt-bold, Arial, sans-serif",
                fontVariant: "bold",
                fill: color,
                x: margin,
                y: lineHeight * 2,
                lineHeight: fontSize
            })
        ]
    });
};
const $302b7e720a7a0200$export$66d167152c83103b = ({ width: width, height: height, theme: theme = (0, $01b00e73e7338f4f$export$1d8e462b9ec86de2).Dark, leftMargin: leftMargin, headerHeight: headerHeight, fontSize: fontSize, lineHeight: lineHeight, metaContainerHeight: metaContainerHeight, meta: meta, uppercase: uppercase, onAddToSheet: onAddToSheet })=>{
    const ARROW_HEIGHT = 1.25;
    const ARROW_Y = $302b7e720a7a0200$var$calculateCentering(headerHeight, ARROW_HEIGHT, 0);
    const stage = (0, $9Cg25.useRef)(null);
    const [fontLoaded, setFontLoaded] = (0, $9Cg25.useState)(false);
    const [fontSettled, setFontSettled] = (0, $9Cg25.useState)(false);
    const [error, setError] = (0, $9Cg25.useState)("");
    const artwork = $302b7e720a7a0200$var$useLoadedImage(meta.artURL);
    const logo = $302b7e720a7a0200$var$useLoadedImage($302b7e720a7a0200$var$MDLogoImage);
    const ready = !!artwork.image && !!logo.image && fontSettled;
    const artScale = artwork.image ? width / Math.max(artwork.image.width, artwork.image.height) : 0;
    const artWidth = artwork.image ? artwork.image.width * artScale : 0;
    const artHeight = artwork.image ? artwork.image.height * artScale : 0;
    const logoWidth = logo.image ? logo.image.width / $302b7e720a7a0200$var$PPM_FACTOR : 0;
    const logoHeight = logo.image ? logo.image.height / $302b7e720a7a0200$var$PPM_FACTOR : 0;
    const snapshot = ()=>{
        if (!stage.current || !ready) throw new Error("Label is still loading.");
        stage.current.draw();
        return (0, $2854fa7f51e6b2e6$exports.changeDpiDataUrl)(stage.current.toDataURL(), 300);
    };
    const downloadArt = (e)=>{
        try {
            window.sa_event("download_art");
            e.currentTarget.download = `${meta.album}-label.png`;
            e.currentTarget.href = snapshot();
            setError("");
        } catch  {
            e.preventDefault();
            setError("Unable to export this label. Wait for it to load or try another artwork image.");
        }
    };
    const redraw = ()=>{
        if (!stage.current) return;
        window.sa_event("redraw_art");
        stage.current.draw();
    };
    (0, $9Cg25.useEffect)(()=>{
        let cancelled = false;
        // A blocked external font must never leave exports disabled indefinitely.
        const timer = window.setTimeout(()=>{
            if (!cancelled) setFontSettled(true);
        }, 3500);
        (0, (/*@__PURE__*/$parcel$interopDefault($091b66e1681d4688$exports))).load({
            typekit: {
                id: "elb5ydo"
            },
            active: ()=>{
                if (!cancelled) {
                    setFontLoaded(true);
                    setFontSettled(true);
                }
            },
            inactive: ()=>{
                if (!cancelled) setFontSettled(true);
            }
        });
        return ()=>{
            cancelled = true;
            window.clearTimeout(timer);
        };
    }, []);
    return /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)((0, $765b458b54c3e9e8$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)((0, $79afca973e18ecdf$export$208cd1682bd0e4b6), {
                ref: stage,
                width: width * $302b7e720a7a0200$var$PPM_FACTOR,
                height: height * $302b7e720a7a0200$var$PPM_FACTOR,
                scaleX: $302b7e720a7a0200$var$PPM_FACTOR,
                scaleY: $302b7e720a7a0200$var$PPM_FACTOR,
                children: [
                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)((0, $79afca973e18ecdf$export$936d0764594b6eb3), {
                        children: /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)((0, $79afca973e18ecdf$export$c79fc6492f3af13d), {
                            height: height,
                            width: width,
                            fill: theme.bgColor
                        })
                    }),
                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)((0, $79afca973e18ecdf$export$936d0764594b6eb3), {
                        children: [
                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)((0, $79afca973e18ecdf$export$17d680238e50603e), {
                                fill: theme.fgColor,
                                closed: true,
                                points: [
                                    leftMargin + ARROW_HEIGHT,
                                    ARROW_Y,
                                    leftMargin + ARROW_HEIGHT * 2,
                                    ARROW_Y + ARROW_HEIGHT,
                                    leftMargin,
                                    ARROW_Y + ARROW_HEIGHT
                                ]
                            }),
                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)((0, $79afca973e18ecdf$export$5f1af8db9871e1d6), {
                                offsetY: fontSize,
                                x: 5.5,
                                y: ARROW_HEIGHT + ARROW_Y,
                                fontSize: fontSize,
                                fontFamily: fontLoaded ? "futura-pt-bold" : "Arial, sans-serif",
                                fontVariant: "bold",
                                text: "INSERT THIS END",
                                fill: theme.fgColor,
                                lineHeight: fontSize
                            }),
                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)((0, $79afca973e18ecdf$export$3e431a229df88919), {
                                image: logo.image,
                                y: $302b7e720a7a0200$var$calculateCentering(headerHeight, logoHeight),
                                x: width - leftMargin - logoWidth,
                                width: logoWidth,
                                height: logoHeight
                            }),
                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)((0, $79afca973e18ecdf$export$3e431a229df88919), {
                                image: artwork.image,
                                height: artHeight,
                                width: artWidth,
                                x: $302b7e720a7a0200$var$calculateCentering(width, artWidth),
                                y: $302b7e720a7a0200$var$calculateCentering(width, artHeight, headerHeight)
                            }),
                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)($302b7e720a7a0200$var$Meta, {
                                album: uppercase ? meta.album.toUpperCase() : meta.album,
                                artist: uppercase ? meta.artist.toUpperCase() : meta.artist,
                                year: uppercase ? meta.year.toUpperCase() : meta.year,
                                color: theme.fgColor,
                                containerHeight: metaContainerHeight,
                                fontSize: fontSize,
                                lineHeight: lineHeight,
                                yOffset: width + headerHeight,
                                margin: leftMargin
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("a", {
                        className: `btn${!ready ? " disabled" : ""}`,
                        href: "#",
                        "aria-disabled": !ready,
                        onClick: downloadArt,
                        children: "download label"
                    }),
                    onAddToSheet && /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("button", {
                        type: "button",
                        className: "btn",
                        disabled: !ready,
                        onClick: ()=>{
                            try {
                                onAddToSheet({
                                    dataUrl: snapshot(),
                                    album: meta.album
                                });
                                setError("");
                            } catch  {
                                setError("Unable to add this label. Try another artwork image.");
                            }
                        },
                        children: "Add to A4 sheet"
                    }),
                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("button", {
                        type: "button",
                        className: "btn",
                        onClick: redraw,
                        children: "Redraw preview"
                    })
                ]
            }),
            !ready && !artwork.failed && !logo.failed && /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("p", {
                role: "status",
                children: "Preparing label\u2026"
            }),
            (artwork.failed || logo.failed) && /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("p", {
                role: "alert",
                children: "The label image could not be loaded. Please choose another artwork image or reload the page."
            }),
            error && /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("p", {
                role: "alert",
                children: error
            })
        ]
    });
};




var $9Cg25 = parcelRequire("9Cg25");

// Physical dimensions in millimetres; independent of screen pixels and PNG DPI.
const $7c192f8ab2e42cbf$export$fc6b1e9923bb7632 = 38;
const $7c192f8ab2e42cbf$export$507b37241cc637ae = 54;
const $7c192f8ab2e42cbf$export$554a887b34fd6575 = 210;
const $7c192f8ab2e42cbf$export$f0dc0fb2f85c4eea = 297;
const $7c192f8ab2e42cbf$export$2c5e8e2a846a3ec9 = 15;
const $7c192f8ab2e42cbf$export$7cb48edef243b45f = 5;
const $7c192f8ab2e42cbf$export$6a6dcc7e725abed4 = Math.floor(($7c192f8ab2e42cbf$export$554a887b34fd6575 - $7c192f8ab2e42cbf$export$2c5e8e2a846a3ec9 * 2 + $7c192f8ab2e42cbf$export$7cb48edef243b45f) / ($7c192f8ab2e42cbf$export$fc6b1e9923bb7632 + $7c192f8ab2e42cbf$export$7cb48edef243b45f));
const $7c192f8ab2e42cbf$export$9ecce7f637e2cef2 = Math.floor(($7c192f8ab2e42cbf$export$f0dc0fb2f85c4eea - $7c192f8ab2e42cbf$export$2c5e8e2a846a3ec9 * 2 + $7c192f8ab2e42cbf$export$7cb48edef243b45f) / ($7c192f8ab2e42cbf$export$507b37241cc637ae + $7c192f8ab2e42cbf$export$7cb48edef243b45f));
const $7c192f8ab2e42cbf$export$430074e37adedc00 = $7c192f8ab2e42cbf$export$6a6dcc7e725abed4 * $7c192f8ab2e42cbf$export$9ecce7f637e2cef2;
function $7c192f8ab2e42cbf$export$cd0ca4d7ba4b76b4(index) {
    return {
        left: $7c192f8ab2e42cbf$export$2c5e8e2a846a3ec9 + index % $7c192f8ab2e42cbf$export$6a6dcc7e725abed4 * ($7c192f8ab2e42cbf$export$fc6b1e9923bb7632 + $7c192f8ab2e42cbf$export$7cb48edef243b45f),
        top: $7c192f8ab2e42cbf$export$2c5e8e2a846a3ec9 + Math.floor(index / $7c192f8ab2e42cbf$export$6a6dcc7e725abed4) * ($7c192f8ab2e42cbf$export$507b37241cc637ae + $7c192f8ab2e42cbf$export$7cb48edef243b45f)
    };
}



const $d9377c2be705fdcb$export$f8db3319e269774b = ({ labels: labels, setLabels: setLabels })=>{
    const [guides, setGuides] = (0, $9Cg25.useState)(true);
    const [printing, setPrinting] = (0, $9Cg25.useState)(false);
    const [error, setError] = (0, $9Cg25.useState)("");
    const expanded = [];
    labels.forEach((label)=>{
        for(let i = 0; i < label.copies; i++)expanded.push(label);
    });
    const pages = [];
    for(let i = 0; i < expanded.length; i += (0, $7c192f8ab2e42cbf$export$430074e37adedc00))pages.push(expanded.slice(i, i + (0, $7c192f8ab2e42cbf$export$430074e37adedc00)));
    const renderPage = (page, pageIndex)=>/*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("div", {
            className: "a4-page",
            children: [
                page.map((label, index)=>{
                    const position = (0, $7c192f8ab2e42cbf$export$cd0ca4d7ba4b76b4)(index);
                    return /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("img", {
                        src: label.dataUrl,
                        alt: label.album || "Untitled label",
                        className: `sheet-label${guides ? " cut-guides" : ""}`,
                        style: {
                            left: `${position.left / (0, $7c192f8ab2e42cbf$export$554a887b34fd6575) * 100}%`,
                            top: `${position.top / (0, $7c192f8ab2e42cbf$export$f0dc0fb2f85c4eea) * 100}%`,
                            width: `${(0, $7c192f8ab2e42cbf$export$fc6b1e9923bb7632) / (0, $7c192f8ab2e42cbf$export$554a887b34fd6575) * 100}%`,
                            height: `${(0, $7c192f8ab2e42cbf$export$507b37241cc637ae) / (0, $7c192f8ab2e42cbf$export$f0dc0fb2f85c4eea) * 100}%`
                        }
                    }, `${label.id}-${index}`);
                }),
                /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("div", {
                    className: "scale-check",
                    children: "50 mm \u2014 check with a ruler"
                }),
                /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("span", {
                    className: "sheet-page-number",
                    children: [
                        "MDthings \xb7 ",
                        pageIndex + 1,
                        " / ",
                        pages.length
                    ]
                })
            ]
        }, pageIndex);
    const print = async ()=>{
        setPrinting(true);
        setError("");
        try {
            // Print only after all snapshot images in the print surface are decoded.
            const images = Array.from(document.querySelectorAll(".print-output img"));
            await Promise.all(images.map((image)=>image.decode()));
            window.print();
        } catch  {
            setError("The print images could not be loaded. Please try again.");
        } finally{
            setPrinting(false);
        }
    };
    return /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("section", {
        className: "print-sheet",
        "aria-labelledby": "print-heading",
        children: [
            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("h2", {
                id: "print-heading",
                children: "A4 print sheet"
            }),
            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("p", {
                children: "Add the current label above, then keep designing to mix different labels. Each addition is a snapshot, so later edits won\u2019t change labels already on the sheet."
            }),
            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("p", {
                className: "print-instructions",
                children: [
                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("strong", {
                        children: "Print settings:"
                    }),
                    " A4 (210 \xd7 297 mm), portrait, actual size / 100% scale. Turn off \u201Cfit to page\u201D and browser headers and footers. Labels are ",
                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("strong", {
                        children: "38 \xd7 54 mm"
                    }),
                    ", with 15 mm paper margins. Check the 50 mm ruler on a plain-paper test print and check your disc\u2019s label recess before cutting adhesive paper."
                ]
            }),
            labels.length === 0 ? /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("div", {
                className: "sheet-empty",
                children: "No labels yet. Use \u201CAdd to A4 sheet\u201D to start."
            }) : /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)((0, $765b458b54c3e9e8$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("ul", {
                        className: "sheet-queue",
                        children: labels.map((label)=>/*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("img", {
                                        src: label.dataUrl,
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("span", {
                                        className: "sheet-album",
                                        children: label.album || "Untitled label"
                                    }),
                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("label", {
                                        className: "sheet-copies",
                                        children: [
                                            "Copies",
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("input", {
                                                type: "number",
                                                min: "1",
                                                max: "100",
                                                step: "1",
                                                value: label.copies,
                                                "aria-label": `Copies of ${label.album || "untitled label"}`,
                                                onChange: (event)=>{
                                                    const copies = Math.max(1, Math.min(100, Math.floor(Number(event.currentTarget.value) || 1)));
                                                    setLabels((previous)=>previous.map((item)=>item.id === label.id ? {
                                                                ...item,
                                                                copies: copies
                                                            } : item));
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("button", {
                                        type: "button",
                                        className: "btn-flat",
                                        onClick: ()=>setLabels((previous)=>previous.filter((item)=>item.id !== label.id)),
                                        children: [
                                            "Remove",
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("span", {
                                                className: "sr-only",
                                                children: [
                                                    " ",
                                                    label.album
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, label.id))
                    }),
                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("div", {
                        className: "sheet-toolbar",
                        children: [
                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("input", {
                                        type: "checkbox",
                                        checked: guides,
                                        onChange: (event)=>setGuides(event.currentTarget.checked)
                                    }),
                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("span", {
                                        children: "Cutting guides"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("span", {
                                "aria-live": "polite",
                                children: [
                                    expanded.length,
                                    " label",
                                    expanded.length !== 1 ? "s" : "",
                                    " \xb7 ",
                                    pages.length,
                                    " A4 page",
                                    pages.length !== 1 ? "s" : ""
                                ]
                            }),
                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("button", {
                                type: "button",
                                className: "btn",
                                disabled: printing,
                                onClick: print,
                                children: printing ? "Preparing\u2026" : "Print A4 / Save as PDF"
                            }),
                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("button", {
                                type: "button",
                                className: "btn-flat",
                                onClick: ()=>setLabels([]),
                                children: "Clear sheet"
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("p", {
                        role: "alert",
                        children: error
                    }),
                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("p", {
                        className: "sheet-preview-caption",
                        children: [
                            "Sheet preview \xb7 ",
                            (0, $7c192f8ab2e42cbf$export$430074e37adedc00),
                            " labels per page \xb7 preview is not actual size"
                        ]
                    }),
                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("div", {
                        className: "sheet-previews",
                        children: pages.map(renderPage)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cc58425f8308e536$exports.createPortal)(/*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("div", {
                className: "print-output",
                children: pages.map(renderPage)
            }), document.body)
        ]
    });
};


var $b8bca0c68f2095cd$exports = {};
$b8bca0c68f2095cd$exports = $parcel$resolve("iH9av");


var $963807b3cca5500d$exports = {};
$963807b3cca5500d$exports = $parcel$resolve("leb6W");


var $780c2bab2fdaf9a0$exports = {};
$780c2bab2fdaf9a0$exports = $parcel$resolve("hDu9G");


var $1d79805af18242bb$exports = {};
$1d79805af18242bb$exports = $parcel$resolve("3o4gF");


var $c68bc8a1eee666b2$exports = {};
$c68bc8a1eee666b2$exports = $parcel$resolve("3Zviu");


var $cce51076a9f7fc54$exports = {};
$cce51076a9f7fc54$exports = $parcel$resolve("jM2pI");


var $a39d96e2ffed4ebf$exports = {};
$a39d96e2ffed4ebf$exports = $parcel$resolve("859BQ");


var $ca89d0320ef7f896$exports = {};
$ca89d0320ef7f896$exports = $parcel$resolve("fvf69");


var $50034971ce4048d7$exports = {};
$50034971ce4048d7$exports = $parcel$resolve("hk4s8");


var $e355eff9cd869e29$exports = {};
$e355eff9cd869e29$exports = $parcel$resolve("eu5oN");


var $ad69d4316ffa6a6b$exports = {};
$ad69d4316ffa6a6b$exports = $parcel$resolve("dY1tW");


var $3d9c5ea31329644d$exports = {};
$3d9c5ea31329644d$exports = $parcel$resolve("bh1uW");


const $75575860be523a01$export$d34f41cc438e4bab = [
    {
        artist: "glass beach",
        album: "the first glass beach album",
        year: "2019",
        artURL: new URL($b8bca0c68f2095cd$exports).href
    },
    {
        artist: "dogleg",
        album: "melee",
        year: "2020",
        artURL: new URL($963807b3cca5500d$exports).href
    },
    {
        artist: "origami angel",
        album: "somewhere city",
        year: "2019",
        artURL: new URL($780c2bab2fdaf9a0$exports).href
    },
    {
        artist: "\u9577\u8C37\u5DDD\u767D\u7D19",
        album: "\u8349\u6728\u840C\u52D5",
        year: "2018",
        artURL: new URL($1d79805af18242bb$exports).href
    },
    {
        artist: "my chemical romance",
        album: "three cheers for sweet revenge",
        year: "2004",
        artURL: new URL($c68bc8a1eee666b2$exports).href
    },
    {
        artist: "DV-i",
        album: "implementation",
        year: "2020",
        artURL: new URL($cce51076a9f7fc54$exports).href
    },
    {
        artist: "girls rituals",
        album: "crap shit",
        year: "2020",
        artURL: new URL($a39d96e2ffed4ebf$exports).href
    },
    {
        artist: "wowaka",
        album: "unhappy refrain",
        year: "2011",
        artURL: new URL($ca89d0320ef7f896$exports).href
    },
    {
        artist: "vylet pony",
        album: "cutiemarks",
        year: "2021",
        artURL: new URL($50034971ce4048d7$exports).href
    },
    {
        artist: "iglooghost",
        album: "Ne\u014D Wax Bloom",
        year: "2017",
        artURL: new URL($e355eff9cd869e29$exports).href
    },
    {
        artist: "Tyler, the Creator",
        album: "CALL ME IF YOU GET LOST",
        year: "2021",
        artURL: new URL($ad69d4316ffa6a6b$exports).href
    },
    {
        album: "ULTRAPOP",
        artist: "The Armed",
        year: "2021",
        artURL: new URL($3d9c5ea31329644d$exports).href
    }
];
function $75575860be523a01$export$bdef285c96428927() {
    return $75575860be523a01$export$d34f41cc438e4bab[Math.floor(Math.random() * $75575860be523a01$export$d34f41cc438e4bab.length)];
}



const $52e08e203310fcb5$export$86fbec116b87613f = ()=>{
    const [meta, setMeta] = (0, $9Cg25.useState)((0, $75575860be523a01$export$bdef285c96428927)());
    const [uppercase, setUppercase] = (0, $9Cg25.useState)(true);
    const [theme, setTheme] = (0, $9Cg25.useState)((0, $01b00e73e7338f4f$export$1d8e462b9ec86de2).Dark);
    const [labels, setLabels] = (0, $9Cg25.useState)([]);
    const [artFileName, setArtFileName] = (0, $9Cg25.useState)("");
    return /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("main", {
        className: "workspace",
        children: [
            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("section", {
                className: "editor-panel",
                "aria-labelledby": "editor-title",
                children: [
                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("div", {
                        className: "section-heading",
                        children: [
                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("p", {
                                        className: "eyebrow",
                                        children: "01 / MAKE A LABEL"
                                    }),
                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("h2", {
                                        id: "editor-title",
                                        children: "Your artwork"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("span", {
                                className: "status-note",
                                children: [
                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("i", {}),
                                    " LIVE PREVIEW"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("div", {
                        className: "preview-stage",
                        children: /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)((0, $302b7e720a7a0200$export$66d167152c83103b), {
                            width: 38,
                            height: 54,
                            theme: theme,
                            fontSize: 1.76,
                            headerHeight: 5,
                            leftMargin: 2,
                            lineHeight: 2.12,
                            metaContainerHeight: 11,
                            meta: meta,
                            uppercase: uppercase,
                            onAddToSheet: (label)=>setLabels((previous)=>[
                                        ...previous,
                                        {
                                            ...label,
                                            id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
                                            copies: 1
                                        }
                                    ])
                        })
                    }),
                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("div", {
                        className: "control-grid",
                        children: [
                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("div", {
                                className: "control-block metadata-controls",
                                children: [
                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("p", {
                                        className: "eyebrow",
                                        children: "LABEL DETAILS"
                                    }),
                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("label", {
                                        className: "field",
                                        children: [
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("span", {
                                                children: "Album"
                                            }),
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("input", {
                                                type: "text",
                                                value: meta.album,
                                                onChange: ({ currentTarget: currentTarget })=>setMeta({
                                                        ...meta,
                                                        album: currentTarget.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("label", {
                                        className: "field",
                                        children: [
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("span", {
                                                children: "Artist"
                                            }),
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("input", {
                                                type: "text",
                                                value: meta.artist,
                                                onChange: ({ currentTarget: currentTarget })=>setMeta({
                                                        ...meta,
                                                        artist: currentTarget.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("label", {
                                        className: "field",
                                        children: [
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("span", {
                                                children: "Year"
                                            }),
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("input", {
                                                type: "text",
                                                value: meta.year,
                                                onChange: ({ currentTarget: currentTarget })=>setMeta({
                                                        ...meta,
                                                        year: currentTarget.value
                                                    })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("div", {
                                className: "control-block appearance-controls",
                                children: [
                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("p", {
                                        className: "eyebrow",
                                        children: "FINISHING"
                                    }),
                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("label", {
                                        className: "upload-control",
                                        children: [
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("span", {
                                                className: "upload-title",
                                                children: "Album art"
                                            }),
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("span", {
                                                className: "upload-hint",
                                                children: "Square image, 500 px or wider"
                                            }),
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("input", {
                                                type: "file",
                                                accept: "image/*",
                                                onChange: ({ currentTarget: currentTarget })=>{
                                                    const file = currentTarget.files?.[0];
                                                    if (!file) return;
                                                    setArtFileName(file.name);
                                                    const reader = new FileReader();
                                                    reader.onload = ()=>{
                                                        if (typeof reader.result === "string") setMeta((previous)=>({
                                                                ...previous,
                                                                artURL: reader.result
                                                            }));
                                                    };
                                                    reader.readAsDataURL(file);
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("span", {
                                                className: "file-button",
                                                children: "Choose image"
                                            }),
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("span", {
                                                className: "file-name",
                                                children: artFileName || "No image selected"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("fieldset", {
                                        className: "choice-group",
                                        children: [
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("legend", {
                                                children: "Label theme"
                                            }),
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("label", {
                                                className: "choice",
                                                children: [
                                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("input", {
                                                        name: "theme",
                                                        value: "dark",
                                                        type: "radio",
                                                        checked: theme === (0, $01b00e73e7338f4f$export$1d8e462b9ec86de2).Dark,
                                                        onChange: ()=>setTheme((0, $01b00e73e7338f4f$export$1d8e462b9ec86de2).Dark)
                                                    }),
                                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("span", {
                                                        className: "choice-swatch swatch-dark"
                                                    }),
                                                    " Dark"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("label", {
                                                className: "choice",
                                                children: [
                                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("input", {
                                                        name: "theme",
                                                        value: "light",
                                                        type: "radio",
                                                        checked: theme === (0, $01b00e73e7338f4f$export$1d8e462b9ec86de2).Light,
                                                        onChange: ()=>setTheme((0, $01b00e73e7338f4f$export$1d8e462b9ec86de2).Light)
                                                    }),
                                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("span", {
                                                        className: "choice-swatch swatch-light"
                                                    }),
                                                    " Light"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsxs)("label", {
                                        className: "toggle-control",
                                        children: [
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("input", {
                                                type: "checkbox",
                                                role: "switch",
                                                checked: uppercase,
                                                onChange: ()=>setUppercase(!uppercase)
                                            }),
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("span", {
                                                className: "toggle-track",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("i", {})
                                            }),
                                            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("span", {
                                                children: "Use uppercase text"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)("section", {
                className: "sheet-section",
                "aria-label": "A4 print sheet",
                children: /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)((0, $d9377c2be705fdcb$export$f8db3319e269774b), {
                    labels: labels,
                    setLabels: setLabels
                })
            })
        ]
    });
};



var $5b4084ea9b427a9a$exports = {};
$5b4084ea9b427a9a$exports = $parcel$resolve("41n10");


navigator.serviceWorker.register($5b4084ea9b427a9a$exports);
const $4be0d0aac54e924d$var$rootElement = document.getElementById("root");
(0, $cc58425f8308e536$exports.render)(/*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)($9Cg25.StrictMode, {
    children: /*#__PURE__*/ (0, $765b458b54c3e9e8$exports.jsx)((0, $52e08e203310fcb5$export$86fbec116b87613f), {})
}), $4be0d0aac54e924d$var$rootElement);


//# sourceMappingURL=workspace.e608b4ec.js.map
